/**
 * Swiper 10.3.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 28, 2023
 */

var Swiper = (function () {
  "use strict"
  function e(e) {
    return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object
  }
  function t(s, a) {
    void 0 === s && (s = {}),
      void 0 === a && (a = {}),
      Object.keys(a).forEach((i) => {
        void 0 === s[i] ? (s[i] = a[i]) : e(a[i]) && e(s[i]) && Object.keys(a[i]).length > 0 && t(s[i], a[i])
      })
  }
  const s = {
    body: {},
    addEventListener() {},
    removeEventListener() {},
    activeElement: { blur() {}, nodeName: "" },
    querySelector: () => null,
    querySelectorAll: () => [],
    getElementById: () => null,
    createEvent: () => ({ initEvent() {} }),
    createElement: () => ({
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName: () => [],
    }),
    createElementNS: () => ({}),
    importNode: () => null,
    location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
  }
  function a() {
    const e = "undefined" != typeof document ? document : {}
    return t(e, s), e
  }
  const i = {
    document: s,
    navigator: { userAgent: "" },
    location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
    history: { replaceState() {}, pushState() {}, go() {}, back() {} },
    CustomEvent: function () {
      return this
    },
    addEventListener() {},
    removeEventListener() {},
    getComputedStyle: () => ({ getPropertyValue: () => "" }),
    Image() {},
    Date() {},
    screen: {},
    setTimeout() {},
    clearTimeout() {},
    matchMedia: () => ({}),
    requestAnimationFrame: (e) => ("undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0)),
    cancelAnimationFrame(e) {
      "undefined" != typeof setTimeout && clearTimeout(e)
    },
  }
  function r() {
    const e = "undefined" != typeof window ? window : {}
    return t(e, i), e
  }
  function n(e, t) {
    return void 0 === t && (t = 0), setTimeout(e, t)
  }
  function l() {
    return Date.now()
  }
  function o(e, t) {
    void 0 === t && (t = "x")
    const s = r()
    let a, i, n
    const l = (function (e) {
      const t = r()
      let s
      return (
        t.getComputedStyle && (s = t.getComputedStyle(e, null)),
        !s && e.currentStyle && (s = e.currentStyle),
        s || (s = e.style),
        s
      )
    })(e)
    return (
      s.WebKitCSSMatrix
        ? ((i = l.transform || l.webkitTransform),
          i.split(",").length > 6 &&
            (i = i
              .split(", ")
              .map((e) => e.replace(",", "."))
              .join(", ")),
          (n = new s.WebKitCSSMatrix("none" === i ? "" : i)))
        : ((n =
            l.MozTransform ||
            l.OTransform ||
            l.MsTransform ||
            l.msTransform ||
            l.transform ||
            l.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")),
          (a = n.toString().split(","))),
      "x" === t && (i = s.WebKitCSSMatrix ? n.m41 : 16 === a.length ? parseFloat(a[12]) : parseFloat(a[4])),
      "y" === t && (i = s.WebKitCSSMatrix ? n.m42 : 16 === a.length ? parseFloat(a[13]) : parseFloat(a[5])),
      i || 0
    )
  }
  function d(e) {
    return (
      "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1)
    )
  }
  function c() {
    const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
      t = ["__proto__", "constructor", "prototype"]
    for (let a = 1; a < arguments.length; a += 1) {
      const i = a < 0 || arguments.length <= a ? void 0 : arguments[a]
      if (
        null != i &&
        ((s = i),
        !("undefined" != typeof window && void 0 !== window.HTMLElement
          ? s instanceof HTMLElement
          : s && (1 === s.nodeType || 11 === s.nodeType)))
      ) {
        const s = Object.keys(Object(i)).filter((e) => t.indexOf(e) < 0)
        for (let t = 0, a = s.length; t < a; t += 1) {
          const a = s[t],
            r = Object.getOwnPropertyDescriptor(i, a)
          void 0 !== r &&
            r.enumerable &&
            (d(e[a]) && d(i[a])
              ? i[a].__swiper__
                ? (e[a] = i[a])
                : c(e[a], i[a])
              : !d(e[a]) && d(i[a])
                ? ((e[a] = {}), i[a].__swiper__ ? (e[a] = i[a]) : c(e[a], i[a]))
                : (e[a] = i[a]))
        }
      }
    }
    var s
    return e
  }
  function p(e, t, s) {
    e.style.setProperty(t, s)
  }
  function u(e) {
    let { swiper: t, targetPosition: s, side: a } = e
    const i = r(),
      n = -t.translate
    let l,
      o = null
    const d = t.params.speed
    ;(t.wrapperEl.style.scrollSnapType = "none"), i.cancelAnimationFrame(t.cssModeFrameID)
    const c = s > n ? "next" : "prev",
      p = (e, t) => ("next" === c && e >= t) || ("prev" === c && e <= t),
      u = () => {
        ;(l = new Date().getTime()), null === o && (o = l)
        const e = Math.max(Math.min((l - o) / d, 1), 0),
          r = 0.5 - Math.cos(e * Math.PI) / 2
        let c = n + r * (s - n)
        if ((p(c, s) && (c = s), t.wrapperEl.scrollTo({ [a]: c }), p(c, s)))
          return (
            (t.wrapperEl.style.overflow = "hidden"),
            (t.wrapperEl.style.scrollSnapType = ""),
            setTimeout(() => {
              ;(t.wrapperEl.style.overflow = ""), t.wrapperEl.scrollTo({ [a]: c })
            }),
            void i.cancelAnimationFrame(t.cssModeFrameID)
          )
        t.cssModeFrameID = i.requestAnimationFrame(u)
      }
    u()
  }
  function m(e) {
    return (
      e.querySelector(".swiper-slide-transform") ||
      (e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform")) ||
      e
    )
  }
  function h(e, t) {
    return void 0 === t && (t = ""), [...e.children].filter((e) => e.matches(t))
  }
  function f(e, t) {
    void 0 === t && (t = [])
    const s = document.createElement(e)
    return s.classList.add(...(Array.isArray(t) ? t : [t])), s
  }
  function g(e) {
    const t = r(),
      s = a(),
      i = e.getBoundingClientRect(),
      n = s.body,
      l = e.clientTop || n.clientTop || 0,
      o = e.clientLeft || n.clientLeft || 0,
      d = e === t ? t.scrollY : e.scrollTop,
      c = e === t ? t.scrollX : e.scrollLeft
    return { top: i.top + d - l, left: i.left + c - o }
  }
  function v(e, t) {
    return r().getComputedStyle(e, null).getPropertyValue(t)
  }
  function w(e) {
    let t,
      s = e
    if (s) {
      for (t = 0; null !== (s = s.previousSibling); ) 1 === s.nodeType && (t += 1)
      return t
    }
  }
  function b(e, t) {
    const s = []
    let a = e.parentElement
    for (; a; ) t ? a.matches(t) && s.push(a) : s.push(a), (a = a.parentElement)
    return s
  }
  function y(e, t) {
    t &&
      e.addEventListener("transitionend", function s(a) {
        a.target === e && (t.call(e, a), e.removeEventListener("transitionend", s))
      })
  }
  function E(e, t, s) {
    const a = r()
    return s
      ? e["width" === t ? "offsetWidth" : "offsetHeight"] +
          parseFloat(a.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-right" : "margin-top")) +
          parseFloat(a.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-left" : "margin-bottom"))
      : e.offsetWidth
  }
  let x, S, T
  function M() {
    return (
      x ||
        (x = (function () {
          const e = r(),
            t = a()
          return {
            smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
            touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
          }
        })()),
      x
    )
  }
  function C(e) {
    return (
      void 0 === e && (e = {}),
      S ||
        (S = (function (e) {
          let { userAgent: t } = void 0 === e ? {} : e
          const s = M(),
            a = r(),
            i = a.navigator.platform,
            n = t || a.navigator.userAgent,
            l = { ios: !1, android: !1 },
            o = a.screen.width,
            d = a.screen.height,
            c = n.match(/(Android);?[\s\/]+([\d.]+)?/)
          let p = n.match(/(iPad).*OS\s([\d_]+)/)
          const u = n.match(/(iPod)(.*OS\s([\d_]+))?/),
            m = !p && n.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
            h = "Win32" === i
          let f = "MacIntel" === i
          return (
            !p &&
              f &&
              s.touch &&
              [
                "1024x1366",
                "1366x1024",
                "834x1194",
                "1194x834",
                "834x1112",
                "1112x834",
                "768x1024",
                "1024x768",
                "820x1180",
                "1180x820",
                "810x1080",
                "1080x810",
              ].indexOf(`${o}x${d}`) >= 0 &&
              ((p = n.match(/(Version)\/([\d.]+)/)), p || (p = [0, 1, "13_0_0"]), (f = !1)),
            c && !h && ((l.os = "android"), (l.android = !0)),
            (p || m || u) && ((l.os = "ios"), (l.ios = !0)),
            l
          )
        })(e)),
      S
    )
  }
  function P() {
    return (
      T ||
        (T = (function () {
          const e = r()
          let t = !1
          function s() {
            const t = e.navigator.userAgent.toLowerCase()
            return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0
          }
          if (s()) {
            const s = String(e.navigator.userAgent)
            if (s.includes("Version/")) {
              const [e, a] = s
                .split("Version/")[1]
                .split(" ")[0]
                .split(".")
                .map((e) => Number(e))
              t = e < 16 || (16 === e && a < 2)
            }
          }
          return {
            isSafari: t || s(),
            needPerspectiveFix: t,
            isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent),
          }
        })()),
      T
    )
  }
  var L = {
    on(e, t, s) {
      const a = this
      if (!a.eventsListeners || a.destroyed) return a
      if ("function" != typeof t) return a
      const i = s ? "unshift" : "push"
      return (
        e.split(" ").forEach((e) => {
          a.eventsListeners[e] || (a.eventsListeners[e] = []), a.eventsListeners[e][i](t)
        }),
        a
      )
    },
    once(e, t, s) {
      const a = this
      if (!a.eventsListeners || a.destroyed) return a
      if ("function" != typeof t) return a
      function i() {
        a.off(e, i), i.__emitterProxy && delete i.__emitterProxy
        for (var s = arguments.length, r = new Array(s), n = 0; n < s; n++) r[n] = arguments[n]
        t.apply(a, r)
      }
      return (i.__emitterProxy = t), a.on(e, i, s)
    },
    onAny(e, t) {
      const s = this
      if (!s.eventsListeners || s.destroyed) return s
      if ("function" != typeof e) return s
      const a = t ? "unshift" : "push"
      return s.eventsAnyListeners.indexOf(e) < 0 && s.eventsAnyListeners[a](e), s
    },
    offAny(e) {
      const t = this
      if (!t.eventsListeners || t.destroyed) return t
      if (!t.eventsAnyListeners) return t
      const s = t.eventsAnyListeners.indexOf(e)
      return s >= 0 && t.eventsAnyListeners.splice(s, 1), t
    },
    off(e, t) {
      const s = this
      return !s.eventsListeners || s.destroyed
        ? s
        : s.eventsListeners
          ? (e.split(" ").forEach((e) => {
              void 0 === t
                ? (s.eventsListeners[e] = [])
                : s.eventsListeners[e] &&
                  s.eventsListeners[e].forEach((a, i) => {
                    ;(a === t || (a.__emitterProxy && a.__emitterProxy === t)) && s.eventsListeners[e].splice(i, 1)
                  })
            }),
            s)
          : s
    },
    emit() {
      const e = this
      if (!e.eventsListeners || e.destroyed) return e
      if (!e.eventsListeners) return e
      let t, s, a
      for (var i = arguments.length, r = new Array(i), n = 0; n < i; n++) r[n] = arguments[n]
      "string" == typeof r[0] || Array.isArray(r[0])
        ? ((t = r[0]), (s = r.slice(1, r.length)), (a = e))
        : ((t = r[0].events), (s = r[0].data), (a = r[0].context || e)),
        s.unshift(a)
      return (
        (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
          e.eventsAnyListeners &&
            e.eventsAnyListeners.length &&
            e.eventsAnyListeners.forEach((e) => {
              e.apply(a, [t, ...s])
            }),
            e.eventsListeners &&
              e.eventsListeners[t] &&
              e.eventsListeners[t].forEach((e) => {
                e.apply(a, s)
              })
        }),
        e
      )
    },
  }
  const z = (e, t) => {
      if (!e || e.destroyed || !e.params) return
      const s = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`)
      if (s) {
        let t = s.querySelector(`.${e.params.lazyPreloaderClass}`)
        !t &&
          e.isElement &&
          (s.shadowRoot
            ? (t = s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`))
            : requestAnimationFrame(() => {
                s.shadowRoot && ((t = s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`)), t && t.remove())
              })),
          t && t.remove()
      }
    },
    A = (e, t) => {
      if (!e.slides[t]) return
      const s = e.slides[t].querySelector('[loading="lazy"]')
      s && s.removeAttribute("loading")
    },
    $ = (e) => {
      if (!e || e.destroyed || !e.params) return
      let t = e.params.lazyPreloadPrevNext
      const s = e.slides.length
      if (!s || !t || t < 0) return
      t = Math.min(t, s)
      const a = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView),
        i = e.activeIndex
      if (e.params.grid && e.params.grid.rows > 1) {
        const s = i,
          r = [s - t]
        return (
          r.push(...Array.from({ length: t }).map((e, t) => s + a + t)),
          void e.slides.forEach((t, s) => {
            r.includes(t.column) && A(e, s)
          })
        )
      }
      const r = i + a - 1
      if (e.params.rewind || e.params.loop)
        for (let a = i - t; a <= r + t; a += 1) {
          const t = ((a % s) + s) % s
          ;(t < i || t > r) && A(e, t)
        }
      else for (let a = Math.max(i - t, 0); a <= Math.min(r + t, s - 1); a += 1) a !== i && (a > r || a < i) && A(e, a)
    }
  var I = {
    updateSize: function () {
      const e = this
      let t, s
      const a = e.el
      ;(t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : a.clientWidth),
        (s = void 0 !== e.params.height && null !== e.params.height ? e.params.height : a.clientHeight),
        (0 === t && e.isHorizontal()) ||
          (0 === s && e.isVertical()) ||
          ((t = t - parseInt(v(a, "padding-left") || 0, 10) - parseInt(v(a, "padding-right") || 0, 10)),
          (s = s - parseInt(v(a, "padding-top") || 0, 10) - parseInt(v(a, "padding-bottom") || 0, 10)),
          Number.isNaN(t) && (t = 0),
          Number.isNaN(s) && (s = 0),
          Object.assign(e, { width: t, height: s, size: e.isHorizontal() ? t : s }))
    },
    updateSlides: function () {
      const e = this
      function t(t) {
        return e.isHorizontal()
          ? t
          : {
              width: "height",
              "margin-top": "margin-left",
              "margin-bottom ": "margin-right",
              "margin-left": "margin-top",
              "margin-right": "margin-bottom",
              "padding-left": "padding-top",
              "padding-right": "padding-bottom",
              marginRight: "marginBottom",
            }[t]
      }
      function s(e, s) {
        return parseFloat(e.getPropertyValue(t(s)) || 0)
      }
      const a = e.params,
        { wrapperEl: i, slidesEl: r, size: n, rtlTranslate: l, wrongRTL: o } = e,
        d = e.virtual && a.virtual.enabled,
        c = d ? e.virtual.slides.length : e.slides.length,
        u = h(r, `.${e.params.slideClass}, swiper-slide`),
        m = d ? e.virtual.slides.length : u.length
      let f = []
      const g = [],
        w = []
      let b = a.slidesOffsetBefore
      "function" == typeof b && (b = a.slidesOffsetBefore.call(e))
      let y = a.slidesOffsetAfter
      "function" == typeof y && (y = a.slidesOffsetAfter.call(e))
      const x = e.snapGrid.length,
        S = e.slidesGrid.length
      let T = a.spaceBetween,
        M = -b,
        C = 0,
        P = 0
      if (void 0 === n) return
      "string" == typeof T && T.indexOf("%") >= 0
        ? (T = (parseFloat(T.replace("%", "")) / 100) * n)
        : "string" == typeof T && (T = parseFloat(T)),
        (e.virtualSize = -T),
        u.forEach((e) => {
          l ? (e.style.marginLeft = "") : (e.style.marginRight = ""),
            (e.style.marginBottom = ""),
            (e.style.marginTop = "")
        }),
        a.centeredSlides &&
          a.cssMode &&
          (p(i, "--swiper-centered-offset-before", ""), p(i, "--swiper-centered-offset-after", ""))
      const L = a.grid && a.grid.rows > 1 && e.grid
      let z
      L && e.grid.initSlides(m)
      const A =
        "auto" === a.slidesPerView &&
        a.breakpoints &&
        Object.keys(a.breakpoints).filter((e) => void 0 !== a.breakpoints[e].slidesPerView).length > 0
      for (let i = 0; i < m; i += 1) {
        let r
        if (((z = 0), u[i] && (r = u[i]), L && e.grid.updateSlide(i, r, m, t), !u[i] || "none" !== v(r, "display"))) {
          if ("auto" === a.slidesPerView) {
            A && (u[i].style[t("width")] = "")
            const n = getComputedStyle(r),
              l = r.style.transform,
              o = r.style.webkitTransform
            if ((l && (r.style.transform = "none"), o && (r.style.webkitTransform = "none"), a.roundLengths))
              z = e.isHorizontal() ? E(r, "width", !0) : E(r, "height", !0)
            else {
              const e = s(n, "width"),
                t = s(n, "padding-left"),
                a = s(n, "padding-right"),
                i = s(n, "margin-left"),
                l = s(n, "margin-right"),
                o = n.getPropertyValue("box-sizing")
              if (o && "border-box" === o) z = e + i + l
              else {
                const { clientWidth: s, offsetWidth: n } = r
                z = e + t + a + i + l + (n - s)
              }
            }
            l && (r.style.transform = l), o && (r.style.webkitTransform = o), a.roundLengths && (z = Math.floor(z))
          } else
            (z = (n - (a.slidesPerView - 1) * T) / a.slidesPerView),
              a.roundLengths && (z = Math.floor(z)),
              u[i] && (u[i].style[t("width")] = `${z}px`)
          u[i] && (u[i].swiperSlideSize = z),
            w.push(z),
            a.centeredSlides
              ? ((M = M + z / 2 + C / 2 + T),
                0 === C && 0 !== i && (M = M - n / 2 - T),
                0 === i && (M = M - n / 2 - T),
                Math.abs(M) < 0.001 && (M = 0),
                a.roundLengths && (M = Math.floor(M)),
                P % a.slidesPerGroup == 0 && f.push(M),
                g.push(M))
              : (a.roundLengths && (M = Math.floor(M)),
                (P - Math.min(e.params.slidesPerGroupSkip, P)) % e.params.slidesPerGroup == 0 && f.push(M),
                g.push(M),
                (M = M + z + T)),
            (e.virtualSize += z + T),
            (C = z),
            (P += 1)
        }
      }
      if (
        ((e.virtualSize = Math.max(e.virtualSize, n) + y),
        l && o && ("slide" === a.effect || "coverflow" === a.effect) && (i.style.width = `${e.virtualSize + T}px`),
        a.setWrapperSize && (i.style[t("width")] = `${e.virtualSize + T}px`),
        L && e.grid.updateWrapperSize(z, f, t),
        !a.centeredSlides)
      ) {
        const t = []
        for (let s = 0; s < f.length; s += 1) {
          let i = f[s]
          a.roundLengths && (i = Math.floor(i)), f[s] <= e.virtualSize - n && t.push(i)
        }
        ;(f = t), Math.floor(e.virtualSize - n) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - n)
      }
      if (d && a.loop) {
        const t = w[0] + T
        if (a.slidesPerGroup > 1) {
          const s = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / a.slidesPerGroup),
            i = t * a.slidesPerGroup
          for (let e = 0; e < s; e += 1) f.push(f[f.length - 1] + i)
        }
        for (let s = 0; s < e.virtual.slidesBefore + e.virtual.slidesAfter; s += 1)
          1 === a.slidesPerGroup && f.push(f[f.length - 1] + t), g.push(g[g.length - 1] + t), (e.virtualSize += t)
      }
      if ((0 === f.length && (f = [0]), 0 !== T)) {
        const s = e.isHorizontal() && l ? "marginLeft" : t("marginRight")
        u.filter((e, t) => !(a.cssMode && !a.loop) || t !== u.length - 1).forEach((e) => {
          e.style[s] = `${T}px`
        })
      }
      if (a.centeredSlides && a.centeredSlidesBounds) {
        let e = 0
        w.forEach((t) => {
          e += t + (T || 0)
        }),
          (e -= T)
        const t = e - n
        f = f.map((e) => (e <= 0 ? -b : e > t ? t + y : e))
      }
      if (a.centerInsufficientSlides) {
        let e = 0
        if (
          (w.forEach((t) => {
            e += t + (T || 0)
          }),
          (e -= T),
          e < n)
        ) {
          const t = (n - e) / 2
          f.forEach((e, s) => {
            f[s] = e - t
          }),
            g.forEach((e, s) => {
              g[s] = e + t
            })
        }
      }
      if (
        (Object.assign(e, { slides: u, snapGrid: f, slidesGrid: g, slidesSizesGrid: w }),
        a.centeredSlides && a.cssMode && !a.centeredSlidesBounds)
      ) {
        p(i, "--swiper-centered-offset-before", -f[0] + "px"),
          p(i, "--swiper-centered-offset-after", e.size / 2 - w[w.length - 1] / 2 + "px")
        const t = -e.snapGrid[0],
          s = -e.slidesGrid[0]
        ;(e.snapGrid = e.snapGrid.map((e) => e + t)), (e.slidesGrid = e.slidesGrid.map((e) => e + s))
      }
      if (
        (m !== c && e.emit("slidesLengthChange"),
        f.length !== x && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
        g.length !== S && e.emit("slidesGridLengthChange"),
        a.watchSlidesProgress && e.updateSlidesOffset(),
        !(d || a.cssMode || ("slide" !== a.effect && "fade" !== a.effect)))
      ) {
        const t = `${a.containerModifierClass}backface-hidden`,
          s = e.el.classList.contains(t)
        m <= a.maxBackfaceHiddenSlides ? s || e.el.classList.add(t) : s && e.el.classList.remove(t)
      }
    },
    updateAutoHeight: function (e) {
      const t = this,
        s = [],
        a = t.virtual && t.params.virtual.enabled
      let i,
        r = 0
      "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed)
      const n = (e) => (a ? t.slides[t.getSlideIndexByData(e)] : t.slides[e])
      if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
        if (t.params.centeredSlides)
          (t.visibleSlides || []).forEach((e) => {
            s.push(e)
          })
        else
          for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
            const e = t.activeIndex + i
            if (e > t.slides.length && !a) break
            s.push(n(e))
          }
      else s.push(n(t.activeIndex))
      for (i = 0; i < s.length; i += 1)
        if (void 0 !== s[i]) {
          const e = s[i].offsetHeight
          r = e > r ? e : r
        }
      ;(r || 0 === r) && (t.wrapperEl.style.height = `${r}px`)
    },
    updateSlidesOffset: function () {
      const e = this,
        t = e.slides,
        s = e.isElement ? (e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop) : 0
      for (let a = 0; a < t.length; a += 1)
        t[a].swiperSlideOffset = (e.isHorizontal() ? t[a].offsetLeft : t[a].offsetTop) - s - e.cssOverflowAdjustment()
    },
    updateSlidesProgress: function (e) {
      void 0 === e && (e = (this && this.translate) || 0)
      const t = this,
        s = t.params,
        { slides: a, rtlTranslate: i, snapGrid: r } = t
      if (0 === a.length) return
      void 0 === a[0].swiperSlideOffset && t.updateSlidesOffset()
      let n = -e
      i && (n = e),
        a.forEach((e) => {
          e.classList.remove(s.slideVisibleClass)
        }),
        (t.visibleSlidesIndexes = []),
        (t.visibleSlides = [])
      let l = s.spaceBetween
      "string" == typeof l && l.indexOf("%") >= 0
        ? (l = (parseFloat(l.replace("%", "")) / 100) * t.size)
        : "string" == typeof l && (l = parseFloat(l))
      for (let e = 0; e < a.length; e += 1) {
        const o = a[e]
        let d = o.swiperSlideOffset
        s.cssMode && s.centeredSlides && (d -= a[0].swiperSlideOffset)
        const c = (n + (s.centeredSlides ? t.minTranslate() : 0) - d) / (o.swiperSlideSize + l),
          p = (n - r[0] + (s.centeredSlides ? t.minTranslate() : 0) - d) / (o.swiperSlideSize + l),
          u = -(n - d),
          m = u + t.slidesSizesGrid[e]
        ;((u >= 0 && u < t.size - 1) || (m > 1 && m <= t.size) || (u <= 0 && m >= t.size)) &&
          (t.visibleSlides.push(o), t.visibleSlidesIndexes.push(e), a[e].classList.add(s.slideVisibleClass)),
          (o.progress = i ? -c : c),
          (o.originalProgress = i ? -p : p)
      }
    },
    updateProgress: function (e) {
      const t = this
      if (void 0 === e) {
        const s = t.rtlTranslate ? -1 : 1
        e = (t && t.translate && t.translate * s) || 0
      }
      const s = t.params,
        a = t.maxTranslate() - t.minTranslate()
      let { progress: i, isBeginning: r, isEnd: n, progressLoop: l } = t
      const o = r,
        d = n
      if (0 === a) (i = 0), (r = !0), (n = !0)
      else {
        i = (e - t.minTranslate()) / a
        const s = Math.abs(e - t.minTranslate()) < 1,
          l = Math.abs(e - t.maxTranslate()) < 1
        ;(r = s || i <= 0), (n = l || i >= 1), s && (i = 0), l && (i = 1)
      }
      if (s.loop) {
        const s = t.getSlideIndexByData(0),
          a = t.getSlideIndexByData(t.slides.length - 1),
          i = t.slidesGrid[s],
          r = t.slidesGrid[a],
          n = t.slidesGrid[t.slidesGrid.length - 1],
          o = Math.abs(e)
        ;(l = o >= i ? (o - i) / n : (o + n - r) / n), l > 1 && (l -= 1)
      }
      Object.assign(t, { progress: i, progressLoop: l, isBeginning: r, isEnd: n }),
        (s.watchSlidesProgress || (s.centeredSlides && s.autoHeight)) && t.updateSlidesProgress(e),
        r && !o && t.emit("reachBeginning toEdge"),
        n && !d && t.emit("reachEnd toEdge"),
        ((o && !r) || (d && !n)) && t.emit("fromEdge"),
        t.emit("progress", i)
    },
    updateSlidesClasses: function () {
      const e = this,
        { slides: t, params: s, slidesEl: a, activeIndex: i } = e,
        r = e.virtual && s.virtual.enabled,
        n = (e) => h(a, `.${s.slideClass}${e}, swiper-slide${e}`)[0]
      let l
      if (
        (t.forEach((e) => {
          e.classList.remove(s.slideActiveClass, s.slideNextClass, s.slidePrevClass)
        }),
        r)
      )
        if (s.loop) {
          let t = i - e.virtual.slidesBefore
          t < 0 && (t = e.virtual.slides.length + t),
            t >= e.virtual.slides.length && (t -= e.virtual.slides.length),
            (l = n(`[data-swiper-slide-index="${t}"]`))
        } else l = n(`[data-swiper-slide-index="${i}"]`)
      else l = t[i]
      if (l) {
        l.classList.add(s.slideActiveClass)
        let e = (function (e, t) {
          const s = []
          for (; e.nextElementSibling; ) {
            const a = e.nextElementSibling
            t ? a.matches(t) && s.push(a) : s.push(a), (e = a)
          }
          return s
        })(l, `.${s.slideClass}, swiper-slide`)[0]
        s.loop && !e && (e = t[0]), e && e.classList.add(s.slideNextClass)
        let a = (function (e, t) {
          const s = []
          for (; e.previousElementSibling; ) {
            const a = e.previousElementSibling
            t ? a.matches(t) && s.push(a) : s.push(a), (e = a)
          }
          return s
        })(l, `.${s.slideClass}, swiper-slide`)[0]
        s.loop && 0 === !a && (a = t[t.length - 1]), a && a.classList.add(s.slidePrevClass)
      }
      e.emitSlidesClasses()
    },
    updateActiveIndex: function (e) {
      const t = this,
        s = t.rtlTranslate ? t.translate : -t.translate,
        { snapGrid: a, params: i, activeIndex: r, realIndex: n, snapIndex: l } = t
      let o,
        d = e
      const c = (e) => {
        let s = e - t.virtual.slidesBefore
        return (
          s < 0 && (s = t.virtual.slides.length + s), s >= t.virtual.slides.length && (s -= t.virtual.slides.length), s
        )
      }
      if (
        (void 0 === d &&
          (d = (function (e) {
            const { slidesGrid: t, params: s } = e,
              a = e.rtlTranslate ? e.translate : -e.translate
            let i
            for (let e = 0; e < t.length; e += 1)
              void 0 !== t[e + 1]
                ? a >= t[e] && a < t[e + 1] - (t[e + 1] - t[e]) / 2
                  ? (i = e)
                  : a >= t[e] && a < t[e + 1] && (i = e + 1)
                : a >= t[e] && (i = e)
            return s.normalizeSlideIndex && (i < 0 || void 0 === i) && (i = 0), i
          })(t)),
        a.indexOf(s) >= 0)
      )
        o = a.indexOf(s)
      else {
        const e = Math.min(i.slidesPerGroupSkip, d)
        o = e + Math.floor((d - e) / i.slidesPerGroup)
      }
      if ((o >= a.length && (o = a.length - 1), d === r))
        return (
          o !== l && ((t.snapIndex = o), t.emit("snapIndexChange")),
          void (t.params.loop && t.virtual && t.params.virtual.enabled && (t.realIndex = c(d)))
        )
      let p
      ;(p =
        t.virtual && i.virtual.enabled && i.loop
          ? c(d)
          : t.slides[d]
            ? parseInt(t.slides[d].getAttribute("data-swiper-slide-index") || d, 10)
            : d),
        Object.assign(t, {
          previousSnapIndex: l,
          snapIndex: o,
          previousRealIndex: n,
          realIndex: p,
          previousIndex: r,
          activeIndex: d,
        }),
        t.initialized && $(t),
        t.emit("activeIndexChange"),
        t.emit("snapIndexChange"),
        (t.initialized || t.params.runCallbacksOnInit) && (n !== p && t.emit("realIndexChange"), t.emit("slideChange"))
    },
    updateClickedSlide: function (e, t) {
      const s = this,
        a = s.params
      let i = e.closest(`.${a.slideClass}, swiper-slide`)
      !i &&
        s.isElement &&
        t &&
        t.length > 1 &&
        t.includes(e) &&
        [...t.slice(t.indexOf(e) + 1, t.length)].forEach((e) => {
          !i && e.matches && e.matches(`.${a.slideClass}, swiper-slide`) && (i = e)
        })
      let r,
        n = !1
      if (i)
        for (let e = 0; e < s.slides.length; e += 1)
          if (s.slides[e] === i) {
            ;(n = !0), (r = e)
            break
          }
      if (!i || !n) return (s.clickedSlide = void 0), void (s.clickedIndex = void 0)
      ;(s.clickedSlide = i),
        s.virtual && s.params.virtual.enabled
          ? (s.clickedIndex = parseInt(i.getAttribute("data-swiper-slide-index"), 10))
          : (s.clickedIndex = r),
        a.slideToClickedSlide &&
          void 0 !== s.clickedIndex &&
          s.clickedIndex !== s.activeIndex &&
          s.slideToClickedSlide()
    },
  }
  var k = {
    getTranslate: function (e) {
      void 0 === e && (e = this.isHorizontal() ? "x" : "y")
      const { params: t, rtlTranslate: s, translate: a, wrapperEl: i } = this
      if (t.virtualTranslate) return s ? -a : a
      if (t.cssMode) return a
      let r = o(i, e)
      return (r += this.cssOverflowAdjustment()), s && (r = -r), r || 0
    },
    setTranslate: function (e, t) {
      const s = this,
        { rtlTranslate: a, params: i, wrapperEl: r, progress: n } = s
      let l,
        o = 0,
        d = 0
      s.isHorizontal() ? (o = a ? -e : e) : (d = e),
        i.roundLengths && ((o = Math.floor(o)), (d = Math.floor(d))),
        (s.previousTranslate = s.translate),
        (s.translate = s.isHorizontal() ? o : d),
        i.cssMode
          ? (r[s.isHorizontal() ? "scrollLeft" : "scrollTop"] = s.isHorizontal() ? -o : -d)
          : i.virtualTranslate ||
            (s.isHorizontal() ? (o -= s.cssOverflowAdjustment()) : (d -= s.cssOverflowAdjustment()),
            (r.style.transform = `translate3d(${o}px, ${d}px, 0px)`))
      const c = s.maxTranslate() - s.minTranslate()
      ;(l = 0 === c ? 0 : (e - s.minTranslate()) / c),
        l !== n && s.updateProgress(e),
        s.emit("setTranslate", s.translate, t)
    },
    minTranslate: function () {
      return -this.snapGrid[0]
    },
    maxTranslate: function () {
      return -this.snapGrid[this.snapGrid.length - 1]
    },
    translateTo: function (e, t, s, a, i) {
      void 0 === e && (e = 0),
        void 0 === t && (t = this.params.speed),
        void 0 === s && (s = !0),
        void 0 === a && (a = !0)
      const r = this,
        { params: n, wrapperEl: l } = r
      if (r.animating && n.preventInteractionOnTransition) return !1
      const o = r.minTranslate(),
        d = r.maxTranslate()
      let c
      if (((c = a && e > o ? o : a && e < d ? d : e), r.updateProgress(c), n.cssMode)) {
        const e = r.isHorizontal()
        if (0 === t) l[e ? "scrollLeft" : "scrollTop"] = -c
        else {
          if (!r.support.smoothScroll) return u({ swiper: r, targetPosition: -c, side: e ? "left" : "top" }), !0
          l.scrollTo({ [e ? "left" : "top"]: -c, behavior: "smooth" })
        }
        return !0
      }
      return (
        0 === t
          ? (r.setTransition(0),
            r.setTranslate(c),
            s && (r.emit("beforeTransitionStart", t, i), r.emit("transitionEnd")))
          : (r.setTransition(t),
            r.setTranslate(c),
            s && (r.emit("beforeTransitionStart", t, i), r.emit("transitionStart")),
            r.animating ||
              ((r.animating = !0),
              r.onTranslateToWrapperTransitionEnd ||
                (r.onTranslateToWrapperTransitionEnd = function (e) {
                  r &&
                    !r.destroyed &&
                    e.target === this &&
                    (r.wrapperEl.removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd),
                    (r.onTranslateToWrapperTransitionEnd = null),
                    delete r.onTranslateToWrapperTransitionEnd,
                    s && r.emit("transitionEnd"))
                }),
              r.wrapperEl.addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd))),
        !0
      )
    },
  }
  function O(e) {
    let { swiper: t, runCallbacks: s, direction: a, step: i } = e
    const { activeIndex: r, previousIndex: n } = t
    let l = a
    if ((l || (l = r > n ? "next" : r < n ? "prev" : "reset"), t.emit(`transition${i}`), s && r !== n)) {
      if ("reset" === l) return void t.emit(`slideResetTransition${i}`)
      t.emit(`slideChangeTransition${i}`),
        "next" === l ? t.emit(`slideNextTransition${i}`) : t.emit(`slidePrevTransition${i}`)
    }
  }
  var D = {
    slideTo: function (e, t, s, a, i) {
      void 0 === e && (e = 0),
        void 0 === t && (t = this.params.speed),
        void 0 === s && (s = !0),
        "string" == typeof e && (e = parseInt(e, 10))
      const r = this
      let n = e
      n < 0 && (n = 0)
      const {
        params: l,
        snapGrid: o,
        slidesGrid: d,
        previousIndex: c,
        activeIndex: p,
        rtlTranslate: m,
        wrapperEl: h,
        enabled: f,
      } = r
      if ((r.animating && l.preventInteractionOnTransition) || (!f && !a && !i)) return !1
      const g = Math.min(r.params.slidesPerGroupSkip, n)
      let v = g + Math.floor((n - g) / r.params.slidesPerGroup)
      v >= o.length && (v = o.length - 1)
      const w = -o[v]
      if (l.normalizeSlideIndex)
        for (let e = 0; e < d.length; e += 1) {
          const t = -Math.floor(100 * w),
            s = Math.floor(100 * d[e]),
            a = Math.floor(100 * d[e + 1])
          void 0 !== d[e + 1]
            ? t >= s && t < a - (a - s) / 2
              ? (n = e)
              : t >= s && t < a && (n = e + 1)
            : t >= s && (n = e)
        }
      if (r.initialized && n !== p) {
        if (
          !r.allowSlideNext &&
          (m ? w > r.translate && w > r.minTranslate() : w < r.translate && w < r.minTranslate())
        )
          return !1
        if (!r.allowSlidePrev && w > r.translate && w > r.maxTranslate() && (p || 0) !== n) return !1
      }
      let b
      if (
        (n !== (c || 0) && s && r.emit("beforeSlideChangeStart"),
        r.updateProgress(w),
        (b = n > p ? "next" : n < p ? "prev" : "reset"),
        (m && -w === r.translate) || (!m && w === r.translate))
      )
        return (
          r.updateActiveIndex(n),
          l.autoHeight && r.updateAutoHeight(),
          r.updateSlidesClasses(),
          "slide" !== l.effect && r.setTranslate(w),
          "reset" !== b && (r.transitionStart(s, b), r.transitionEnd(s, b)),
          !1
        )
      if (l.cssMode) {
        const e = r.isHorizontal(),
          s = m ? w : -w
        if (0 === t) {
          const t = r.virtual && r.params.virtual.enabled
          t && ((r.wrapperEl.style.scrollSnapType = "none"), (r._immediateVirtual = !0)),
            t && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0
              ? ((r._cssModeVirtualInitialSet = !0),
                requestAnimationFrame(() => {
                  h[e ? "scrollLeft" : "scrollTop"] = s
                }))
              : (h[e ? "scrollLeft" : "scrollTop"] = s),
            t &&
              requestAnimationFrame(() => {
                ;(r.wrapperEl.style.scrollSnapType = ""), (r._immediateVirtual = !1)
              })
        } else {
          if (!r.support.smoothScroll) return u({ swiper: r, targetPosition: s, side: e ? "left" : "top" }), !0
          h.scrollTo({ [e ? "left" : "top"]: s, behavior: "smooth" })
        }
        return !0
      }
      return (
        r.setTransition(t),
        r.setTranslate(w),
        r.updateActiveIndex(n),
        r.updateSlidesClasses(),
        r.emit("beforeTransitionStart", t, a),
        r.transitionStart(s, b),
        0 === t
          ? r.transitionEnd(s, b)
          : r.animating ||
            ((r.animating = !0),
            r.onSlideToWrapperTransitionEnd ||
              (r.onSlideToWrapperTransitionEnd = function (e) {
                r &&
                  !r.destroyed &&
                  e.target === this &&
                  (r.wrapperEl.removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd),
                  (r.onSlideToWrapperTransitionEnd = null),
                  delete r.onSlideToWrapperTransitionEnd,
                  r.transitionEnd(s, b))
              }),
            r.wrapperEl.addEventListener("transitionend", r.onSlideToWrapperTransitionEnd)),
        !0
      )
    },
    slideToLoop: function (e, t, s, a) {
      if (
        (void 0 === e && (e = 0),
        void 0 === t && (t = this.params.speed),
        void 0 === s && (s = !0),
        "string" == typeof e)
      ) {
        e = parseInt(e, 10)
      }
      const i = this
      let r = e
      return (
        i.params.loop &&
          (i.virtual && i.params.virtual.enabled ? (r += i.virtual.slidesBefore) : (r = i.getSlideIndexByData(r))),
        i.slideTo(r, t, s, a)
      )
    },
    slideNext: function (e, t, s) {
      void 0 === e && (e = this.params.speed), void 0 === t && (t = !0)
      const a = this,
        { enabled: i, params: r, animating: n } = a
      if (!i) return a
      let l = r.slidesPerGroup
      "auto" === r.slidesPerView &&
        1 === r.slidesPerGroup &&
        r.slidesPerGroupAuto &&
        (l = Math.max(a.slidesPerViewDynamic("current", !0), 1))
      const o = a.activeIndex < r.slidesPerGroupSkip ? 1 : l,
        d = a.virtual && r.virtual.enabled
      if (r.loop) {
        if (n && !d && r.loopPreventsSliding) return !1
        if (
          (a.loopFix({ direction: "next" }),
          (a._clientLeft = a.wrapperEl.clientLeft),
          a.activeIndex === a.slides.length - 1 && r.cssMode)
        )
          return (
            requestAnimationFrame(() => {
              a.slideTo(a.activeIndex + o, e, t, s)
            }),
            !0
          )
      }
      return r.rewind && a.isEnd ? a.slideTo(0, e, t, s) : a.slideTo(a.activeIndex + o, e, t, s)
    },
    slidePrev: function (e, t, s) {
      void 0 === e && (e = this.params.speed), void 0 === t && (t = !0)
      const a = this,
        { params: i, snapGrid: r, slidesGrid: n, rtlTranslate: l, enabled: o, animating: d } = a
      if (!o) return a
      const c = a.virtual && i.virtual.enabled
      if (i.loop) {
        if (d && !c && i.loopPreventsSliding) return !1
        a.loopFix({ direction: "prev" }), (a._clientLeft = a.wrapperEl.clientLeft)
      }
      function p(e) {
        return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
      }
      const u = p(l ? a.translate : -a.translate),
        m = r.map((e) => p(e))
      let h = r[m.indexOf(u) - 1]
      if (void 0 === h && i.cssMode) {
        let e
        r.forEach((t, s) => {
          u >= t && (e = s)
        }),
          void 0 !== e && (h = r[e > 0 ? e - 1 : e])
      }
      let f = 0
      if (
        (void 0 !== h &&
          ((f = n.indexOf(h)),
          f < 0 && (f = a.activeIndex - 1),
          "auto" === i.slidesPerView &&
            1 === i.slidesPerGroup &&
            i.slidesPerGroupAuto &&
            ((f = f - a.slidesPerViewDynamic("previous", !0) + 1), (f = Math.max(f, 0)))),
        i.rewind && a.isBeginning)
      ) {
        const i =
          a.params.virtual && a.params.virtual.enabled && a.virtual ? a.virtual.slides.length - 1 : a.slides.length - 1
        return a.slideTo(i, e, t, s)
      }
      return i.loop && 0 === a.activeIndex && i.cssMode
        ? (requestAnimationFrame(() => {
            a.slideTo(f, e, t, s)
          }),
          !0)
        : a.slideTo(f, e, t, s)
    },
    slideReset: function (e, t, s) {
      return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, s)
    },
    slideToClosest: function (e, t, s, a) {
      void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === a && (a = 0.5)
      const i = this
      let r = i.activeIndex
      const n = Math.min(i.params.slidesPerGroupSkip, r),
        l = n + Math.floor((r - n) / i.params.slidesPerGroup),
        o = i.rtlTranslate ? i.translate : -i.translate
      if (o >= i.snapGrid[l]) {
        const e = i.snapGrid[l]
        o - e > (i.snapGrid[l + 1] - e) * a && (r += i.params.slidesPerGroup)
      } else {
        const e = i.snapGrid[l - 1]
        o - e <= (i.snapGrid[l] - e) * a && (r -= i.params.slidesPerGroup)
      }
      return (r = Math.max(r, 0)), (r = Math.min(r, i.slidesGrid.length - 1)), i.slideTo(r, e, t, s)
    },
    slideToClickedSlide: function () {
      const e = this,
        { params: t, slidesEl: s } = e,
        a = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView
      let i,
        r = e.clickedIndex
      const l = e.isElement ? "swiper-slide" : `.${t.slideClass}`
      if (t.loop) {
        if (e.animating) return
        ;(i = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10)),
          t.centeredSlides
            ? r < e.loopedSlides - a / 2 || r > e.slides.length - e.loopedSlides + a / 2
              ? (e.loopFix(),
                (r = e.getSlideIndex(h(s, `${l}[data-swiper-slide-index="${i}"]`)[0])),
                n(() => {
                  e.slideTo(r)
                }))
              : e.slideTo(r)
            : r > e.slides.length - a
              ? (e.loopFix(),
                (r = e.getSlideIndex(h(s, `${l}[data-swiper-slide-index="${i}"]`)[0])),
                n(() => {
                  e.slideTo(r)
                }))
              : e.slideTo(r)
      } else e.slideTo(r)
    },
  }
  var G = {
    loopCreate: function (e) {
      const t = this,
        { params: s, slidesEl: a } = t
      if (!s.loop || (t.virtual && t.params.virtual.enabled)) return
      h(a, `.${s.slideClass}, swiper-slide`).forEach((e, t) => {
        e.setAttribute("data-swiper-slide-index", t)
      }),
        t.loopFix({ slideRealIndex: e, direction: s.centeredSlides ? void 0 : "next" })
    },
    loopFix: function (e) {
      let {
        slideRealIndex: t,
        slideTo: s = !0,
        direction: a,
        setTranslate: i,
        activeSlideIndex: r,
        byController: n,
        byMousewheel: l,
      } = void 0 === e ? {} : e
      const o = this
      if (!o.params.loop) return
      o.emit("beforeLoopFix")
      const { slides: d, allowSlidePrev: c, allowSlideNext: p, slidesEl: u, params: m } = o
      if (((o.allowSlidePrev = !0), (o.allowSlideNext = !0), o.virtual && m.virtual.enabled))
        return (
          s &&
            (m.centeredSlides || 0 !== o.snapIndex
              ? m.centeredSlides && o.snapIndex < m.slidesPerView
                ? o.slideTo(o.virtual.slides.length + o.snapIndex, 0, !1, !0)
                : o.snapIndex === o.snapGrid.length - 1 && o.slideTo(o.virtual.slidesBefore, 0, !1, !0)
              : o.slideTo(o.virtual.slides.length, 0, !1, !0)),
          (o.allowSlidePrev = c),
          (o.allowSlideNext = p),
          void o.emit("loopFix")
        )
      const h = "auto" === m.slidesPerView ? o.slidesPerViewDynamic() : Math.ceil(parseFloat(m.slidesPerView, 10))
      let f = m.loopedSlides || h
      f % m.slidesPerGroup != 0 && (f += m.slidesPerGroup - (f % m.slidesPerGroup)), (o.loopedSlides = f)
      const g = [],
        v = []
      let w = o.activeIndex
      void 0 === r
        ? (r = o.getSlideIndex(o.slides.filter((e) => e.classList.contains(m.slideActiveClass))[0]))
        : (w = r)
      const b = "next" === a || !a,
        y = "prev" === a || !a
      let E = 0,
        x = 0
      if (r < f) {
        E = Math.max(f - r, m.slidesPerGroup)
        for (let e = 0; e < f - r; e += 1) {
          const t = e - Math.floor(e / d.length) * d.length
          g.push(d.length - t - 1)
        }
      } else if (r > o.slides.length - 2 * f) {
        x = Math.max(r - (o.slides.length - 2 * f), m.slidesPerGroup)
        for (let e = 0; e < x; e += 1) {
          const t = e - Math.floor(e / d.length) * d.length
          v.push(t)
        }
      }
      if (
        (y &&
          g.forEach((e) => {
            ;(o.slides[e].swiperLoopMoveDOM = !0), u.prepend(o.slides[e]), (o.slides[e].swiperLoopMoveDOM = !1)
          }),
        b &&
          v.forEach((e) => {
            ;(o.slides[e].swiperLoopMoveDOM = !0), u.append(o.slides[e]), (o.slides[e].swiperLoopMoveDOM = !1)
          }),
        o.recalcSlides(),
        "auto" === m.slidesPerView && o.updateSlides(),
        m.watchSlidesProgress && o.updateSlidesOffset(),
        s)
      )
        if (g.length > 0 && y)
          if (void 0 === t) {
            const e = o.slidesGrid[w],
              t = o.slidesGrid[w + E] - e
            l
              ? o.setTranslate(o.translate - t)
              : (o.slideTo(w + E, 0, !1, !0),
                i &&
                  ((o.touches[o.isHorizontal() ? "startX" : "startY"] += t),
                  (o.touchEventsData.currentTranslate = o.translate)))
          } else i && (o.slideToLoop(t, 0, !1, !0), (o.touchEventsData.currentTranslate = o.translate))
        else if (v.length > 0 && b)
          if (void 0 === t) {
            const e = o.slidesGrid[w],
              t = o.slidesGrid[w - x] - e
            l
              ? o.setTranslate(o.translate - t)
              : (o.slideTo(w - x, 0, !1, !0),
                i &&
                  ((o.touches[o.isHorizontal() ? "startX" : "startY"] += t),
                  (o.touchEventsData.currentTranslate = o.translate)))
          } else o.slideToLoop(t, 0, !1, !0)
      if (((o.allowSlidePrev = c), (o.allowSlideNext = p), o.controller && o.controller.control && !n)) {
        const e = { slideRealIndex: t, direction: a, setTranslate: i, activeSlideIndex: r, byController: !0 }
        Array.isArray(o.controller.control)
          ? o.controller.control.forEach((t) => {
              !t.destroyed &&
                t.params.loop &&
                t.loopFix({ ...e, slideTo: t.params.slidesPerView === m.slidesPerView && s })
            })
          : o.controller.control instanceof o.constructor &&
            o.controller.control.params.loop &&
            o.controller.control.loopFix({
              ...e,
              slideTo: o.controller.control.params.slidesPerView === m.slidesPerView && s,
            })
      }
      o.emit("loopFix")
    },
    loopDestroy: function () {
      const e = this,
        { params: t, slidesEl: s } = e
      if (!t.loop || (e.virtual && e.params.virtual.enabled)) return
      e.recalcSlides()
      const a = []
      e.slides.forEach((e) => {
        const t = void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex
        a[t] = e
      }),
        e.slides.forEach((e) => {
          e.removeAttribute("data-swiper-slide-index")
        }),
        a.forEach((e) => {
          s.append(e)
        }),
        e.recalcSlides(),
        e.slideTo(e.realIndex, 0)
    },
  }
  function H(e) {
    const t = this,
      s = a(),
      i = r(),
      n = t.touchEventsData
    n.evCache.push(e)
    const { params: o, touches: d, enabled: c } = t
    if (!c) return
    if (!o.simulateTouch && "mouse" === e.pointerType) return
    if (t.animating && o.preventInteractionOnTransition) return
    !t.animating && o.cssMode && o.loop && t.loopFix()
    let p = e
    p.originalEvent && (p = p.originalEvent)
    let u = p.target
    if ("wrapper" === o.touchEventsTarget && !t.wrapperEl.contains(u)) return
    if ("which" in p && 3 === p.which) return
    if ("button" in p && p.button > 0) return
    if (n.isTouched && n.isMoved) return
    const m = !!o.noSwipingClass && "" !== o.noSwipingClass,
      h = e.composedPath ? e.composedPath() : e.path
    m && p.target && p.target.shadowRoot && h && (u = h[0])
    const f = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`,
      g = !(!p.target || !p.target.shadowRoot)
    if (
      o.noSwiping &&
      (g
        ? (function (e, t) {
            return (
              void 0 === t && (t = this),
              (function t(s) {
                if (!s || s === a() || s === r()) return null
                s.assignedSlot && (s = s.assignedSlot)
                const i = s.closest(e)
                return i || s.getRootNode ? i || t(s.getRootNode().host) : null
              })(t)
            )
          })(f, u)
        : u.closest(f))
    )
      return void (t.allowClick = !0)
    if (o.swipeHandler && !u.closest(o.swipeHandler)) return
    ;(d.currentX = p.pageX), (d.currentY = p.pageY)
    const v = d.currentX,
      w = d.currentY,
      b = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
      y = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold
    if (b && (v <= y || v >= i.innerWidth - y)) {
      if ("prevent" !== b) return
      e.preventDefault()
    }
    Object.assign(n, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }),
      (d.startX = v),
      (d.startY = w),
      (n.touchStartTime = l()),
      (t.allowClick = !0),
      t.updateSize(),
      (t.swipeDirection = void 0),
      o.threshold > 0 && (n.allowThresholdMove = !1)
    let E = !0
    u.matches(n.focusableElements) && ((E = !1), "SELECT" === u.nodeName && (n.isTouched = !1)),
      s.activeElement && s.activeElement.matches(n.focusableElements) && s.activeElement !== u && s.activeElement.blur()
    const x = E && t.allowTouchMove && o.touchStartPreventDefault
    ;(!o.touchStartForcePreventDefault && !x) || u.isContentEditable || p.preventDefault(),
      o.freeMode && o.freeMode.enabled && t.freeMode && t.animating && !o.cssMode && t.freeMode.onTouchStart(),
      t.emit("touchStart", p)
  }
  function X(e) {
    const t = a(),
      s = this,
      i = s.touchEventsData,
      { params: r, touches: n, rtlTranslate: o, enabled: d } = s
    if (!d) return
    if (!r.simulateTouch && "mouse" === e.pointerType) return
    let c = e
    if ((c.originalEvent && (c = c.originalEvent), !i.isTouched))
      return void (i.startMoving && i.isScrolling && s.emit("touchMoveOpposite", c))
    const p = i.evCache.findIndex((e) => e.pointerId === c.pointerId)
    p >= 0 && (i.evCache[p] = c)
    const u = i.evCache.length > 1 ? i.evCache[0] : c,
      m = u.pageX,
      h = u.pageY
    if (c.preventedByNestedSwiper) return (n.startX = m), void (n.startY = h)
    if (!s.allowTouchMove)
      return (
        c.target.matches(i.focusableElements) || (s.allowClick = !1),
        void (
          i.isTouched &&
          (Object.assign(n, {
            startX: m,
            startY: h,
            prevX: s.touches.currentX,
            prevY: s.touches.currentY,
            currentX: m,
            currentY: h,
          }),
          (i.touchStartTime = l()))
        )
      )
    if (r.touchReleaseOnEdges && !r.loop)
      if (s.isVertical()) {
        if ((h < n.startY && s.translate <= s.maxTranslate()) || (h > n.startY && s.translate >= s.minTranslate()))
          return (i.isTouched = !1), void (i.isMoved = !1)
      } else if ((m < n.startX && s.translate <= s.maxTranslate()) || (m > n.startX && s.translate >= s.minTranslate()))
        return
    if (t.activeElement && c.target === t.activeElement && c.target.matches(i.focusableElements))
      return (i.isMoved = !0), void (s.allowClick = !1)
    if ((i.allowTouchCallbacks && s.emit("touchMove", c), c.targetTouches && c.targetTouches.length > 1)) return
    ;(n.currentX = m), (n.currentY = h)
    const f = n.currentX - n.startX,
      g = n.currentY - n.startY
    if (s.params.threshold && Math.sqrt(f ** 2 + g ** 2) < s.params.threshold) return
    if (void 0 === i.isScrolling) {
      let e
      ;(s.isHorizontal() && n.currentY === n.startY) || (s.isVertical() && n.currentX === n.startX)
        ? (i.isScrolling = !1)
        : f * f + g * g >= 25 &&
          ((e = (180 * Math.atan2(Math.abs(g), Math.abs(f))) / Math.PI),
          (i.isScrolling = s.isHorizontal() ? e > r.touchAngle : 90 - e > r.touchAngle))
    }
    if (
      (i.isScrolling && s.emit("touchMoveOpposite", c),
      void 0 === i.startMoving && ((n.currentX === n.startX && n.currentY === n.startY) || (i.startMoving = !0)),
      i.isScrolling || (s.zoom && s.params.zoom && s.params.zoom.enabled && i.evCache.length > 1))
    )
      return void (i.isTouched = !1)
    if (!i.startMoving) return
    ;(s.allowClick = !1),
      !r.cssMode && c.cancelable && c.preventDefault(),
      r.touchMoveStopPropagation && !r.nested && c.stopPropagation()
    let v = s.isHorizontal() ? f : g,
      w = s.isHorizontal() ? n.currentX - n.previousX : n.currentY - n.previousY
    r.oneWayMovement && ((v = Math.abs(v) * (o ? 1 : -1)), (w = Math.abs(w) * (o ? 1 : -1))),
      (n.diff = v),
      (v *= r.touchRatio),
      o && ((v = -v), (w = -w))
    const b = s.touchesDirection
    ;(s.swipeDirection = v > 0 ? "prev" : "next"), (s.touchesDirection = w > 0 ? "prev" : "next")
    const y = s.params.loop && !r.cssMode,
      E = ("next" === s.swipeDirection && s.allowSlideNext) || ("prev" === s.swipeDirection && s.allowSlidePrev)
    if (!i.isMoved) {
      if (
        (y && E && s.loopFix({ direction: s.swipeDirection }),
        (i.startTranslate = s.getTranslate()),
        s.setTransition(0),
        s.animating)
      ) {
        const e = new window.CustomEvent("transitionend", { bubbles: !0, cancelable: !0 })
        s.wrapperEl.dispatchEvent(e)
      }
      ;(i.allowMomentumBounce = !1),
        !r.grabCursor || (!0 !== s.allowSlideNext && !0 !== s.allowSlidePrev) || s.setGrabCursor(!0),
        s.emit("sliderFirstMove", c)
    }
    let x
    i.isMoved &&
      b !== s.touchesDirection &&
      y &&
      E &&
      Math.abs(v) >= 1 &&
      (s.loopFix({ direction: s.swipeDirection, setTranslate: !0 }), (x = !0)),
      s.emit("sliderMove", c),
      (i.isMoved = !0),
      (i.currentTranslate = v + i.startTranslate)
    let S = !0,
      T = r.resistanceRatio
    if (
      (r.touchReleaseOnEdges && (T = 0),
      v > 0
        ? (y &&
            E &&
            !x &&
            i.currentTranslate > (r.centeredSlides ? s.minTranslate() - s.size / 2 : s.minTranslate()) &&
            s.loopFix({ direction: "prev", setTranslate: !0, activeSlideIndex: 0 }),
          i.currentTranslate > s.minTranslate() &&
            ((S = !1),
            r.resistance &&
              (i.currentTranslate = s.minTranslate() - 1 + (-s.minTranslate() + i.startTranslate + v) ** T)))
        : v < 0 &&
          (y &&
            E &&
            !x &&
            i.currentTranslate < (r.centeredSlides ? s.maxTranslate() + s.size / 2 : s.maxTranslate()) &&
            s.loopFix({
              direction: "next",
              setTranslate: !0,
              activeSlideIndex:
                s.slides.length -
                ("auto" === r.slidesPerView ? s.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10))),
            }),
          i.currentTranslate < s.maxTranslate() &&
            ((S = !1),
            r.resistance &&
              (i.currentTranslate = s.maxTranslate() + 1 - (s.maxTranslate() - i.startTranslate - v) ** T))),
      S && (c.preventedByNestedSwiper = !0),
      !s.allowSlideNext &&
        "next" === s.swipeDirection &&
        i.currentTranslate < i.startTranslate &&
        (i.currentTranslate = i.startTranslate),
      !s.allowSlidePrev &&
        "prev" === s.swipeDirection &&
        i.currentTranslate > i.startTranslate &&
        (i.currentTranslate = i.startTranslate),
      s.allowSlidePrev || s.allowSlideNext || (i.currentTranslate = i.startTranslate),
      r.threshold > 0)
    ) {
      if (!(Math.abs(v) > r.threshold || i.allowThresholdMove)) return void (i.currentTranslate = i.startTranslate)
      if (!i.allowThresholdMove)
        return (
          (i.allowThresholdMove = !0),
          (n.startX = n.currentX),
          (n.startY = n.currentY),
          (i.currentTranslate = i.startTranslate),
          void (n.diff = s.isHorizontal() ? n.currentX - n.startX : n.currentY - n.startY)
        )
    }
    r.followFinger &&
      !r.cssMode &&
      (((r.freeMode && r.freeMode.enabled && s.freeMode) || r.watchSlidesProgress) &&
        (s.updateActiveIndex(), s.updateSlidesClasses()),
      r.freeMode && r.freeMode.enabled && s.freeMode && s.freeMode.onTouchMove(),
      s.updateProgress(i.currentTranslate),
      s.setTranslate(i.currentTranslate))
  }
  function Y(e) {
    const t = this,
      s = t.touchEventsData,
      a = s.evCache.findIndex((t) => t.pointerId === e.pointerId)
    if (
      (a >= 0 && s.evCache.splice(a, 1),
      ["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(e.type))
    ) {
      if (!(["pointercancel", "contextmenu"].includes(e.type) && (t.browser.isSafari || t.browser.isWebView))) return
    }
    const { params: i, touches: r, rtlTranslate: o, slidesGrid: d, enabled: c } = t
    if (!c) return
    if (!i.simulateTouch && "mouse" === e.pointerType) return
    let p = e
    if (
      (p.originalEvent && (p = p.originalEvent),
      s.allowTouchCallbacks && t.emit("touchEnd", p),
      (s.allowTouchCallbacks = !1),
      !s.isTouched)
    )
      return s.isMoved && i.grabCursor && t.setGrabCursor(!1), (s.isMoved = !1), void (s.startMoving = !1)
    i.grabCursor &&
      s.isMoved &&
      s.isTouched &&
      (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
      t.setGrabCursor(!1)
    const u = l(),
      m = u - s.touchStartTime
    if (t.allowClick) {
      const e = p.path || (p.composedPath && p.composedPath())
      t.updateClickedSlide((e && e[0]) || p.target, e),
        t.emit("tap click", p),
        m < 300 && u - s.lastClickTime < 300 && t.emit("doubleTap doubleClick", p)
    }
    if (
      ((s.lastClickTime = l()),
      n(() => {
        t.destroyed || (t.allowClick = !0)
      }),
      !s.isTouched || !s.isMoved || !t.swipeDirection || 0 === r.diff || s.currentTranslate === s.startTranslate)
    )
      return (s.isTouched = !1), (s.isMoved = !1), void (s.startMoving = !1)
    let h
    if (
      ((s.isTouched = !1),
      (s.isMoved = !1),
      (s.startMoving = !1),
      (h = i.followFinger ? (o ? t.translate : -t.translate) : -s.currentTranslate),
      i.cssMode)
    )
      return
    if (i.freeMode && i.freeMode.enabled) return void t.freeMode.onTouchEnd({ currentPos: h })
    let f = 0,
      g = t.slidesSizesGrid[0]
    for (let e = 0; e < d.length; e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
      const t = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup
      void 0 !== d[e + t]
        ? h >= d[e] && h < d[e + t] && ((f = e), (g = d[e + t] - d[e]))
        : h >= d[e] && ((f = e), (g = d[d.length - 1] - d[d.length - 2]))
    }
    let v = null,
      w = null
    i.rewind &&
      (t.isBeginning
        ? (w = i.virtual && i.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1)
        : t.isEnd && (v = 0))
    const b = (h - d[f]) / g,
      y = f < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup
    if (m > i.longSwipesMs) {
      if (!i.longSwipes) return void t.slideTo(t.activeIndex)
      "next" === t.swipeDirection &&
        (b >= i.longSwipesRatio ? t.slideTo(i.rewind && t.isEnd ? v : f + y) : t.slideTo(f)),
        "prev" === t.swipeDirection &&
          (b > 1 - i.longSwipesRatio
            ? t.slideTo(f + y)
            : null !== w && b < 0 && Math.abs(b) > i.longSwipesRatio
              ? t.slideTo(w)
              : t.slideTo(f))
    } else {
      if (!i.shortSwipes) return void t.slideTo(t.activeIndex)
      t.navigation && (p.target === t.navigation.nextEl || p.target === t.navigation.prevEl)
        ? p.target === t.navigation.nextEl
          ? t.slideTo(f + y)
          : t.slideTo(f)
        : ("next" === t.swipeDirection && t.slideTo(null !== v ? v : f + y),
          "prev" === t.swipeDirection && t.slideTo(null !== w ? w : f))
    }
  }
  function N() {
    const e = this,
      { params: t, el: s } = e
    if (s && 0 === s.offsetWidth) return
    t.breakpoints && e.setBreakpoint()
    const { allowSlideNext: a, allowSlidePrev: i, snapGrid: r } = e,
      n = e.virtual && e.params.virtual.enabled
    ;(e.allowSlideNext = !0), (e.allowSlidePrev = !0), e.updateSize(), e.updateSlides(), e.updateSlidesClasses()
    const l = n && t.loop
    !("auto" === t.slidesPerView || t.slidesPerView > 1) || !e.isEnd || e.isBeginning || e.params.centeredSlides || l
      ? e.params.loop && !n
        ? e.slideToLoop(e.realIndex, 0, !1, !0)
        : e.slideTo(e.activeIndex, 0, !1, !0)
      : e.slideTo(e.slides.length - 1, 0, !1, !0),
      e.autoplay &&
        e.autoplay.running &&
        e.autoplay.paused &&
        (clearTimeout(e.autoplay.resizeTimeout),
        (e.autoplay.resizeTimeout = setTimeout(() => {
          e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume()
        }, 500))),
      (e.allowSlidePrev = i),
      (e.allowSlideNext = a),
      e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow()
  }
  function B(e) {
    const t = this
    t.enabled &&
      (t.allowClick ||
        (t.params.preventClicks && e.preventDefault(),
        t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())))
  }
  function R() {
    const e = this,
      { wrapperEl: t, rtlTranslate: s, enabled: a } = e
    if (!a) return
    let i
    ;(e.previousTranslate = e.translate),
      e.isHorizontal() ? (e.translate = -t.scrollLeft) : (e.translate = -t.scrollTop),
      0 === e.translate && (e.translate = 0),
      e.updateActiveIndex(),
      e.updateSlidesClasses()
    const r = e.maxTranslate() - e.minTranslate()
    ;(i = 0 === r ? 0 : (e.translate - e.minTranslate()) / r),
      i !== e.progress && e.updateProgress(s ? -e.translate : e.translate),
      e.emit("setTranslate", e.translate, !1)
  }
  function q(e) {
    const t = this
    z(t, e.target), t.params.cssMode || ("auto" !== t.params.slidesPerView && !t.params.autoHeight) || t.update()
  }
  let V = !1
  function F() {}
  const _ = (e, t) => {
    const s = a(),
      { params: i, el: r, wrapperEl: n, device: l } = e,
      o = !!i.nested,
      d = "on" === t ? "addEventListener" : "removeEventListener",
      c = t
    r[d]("pointerdown", e.onTouchStart, { passive: !1 }),
      s[d]("pointermove", e.onTouchMove, { passive: !1, capture: o }),
      s[d]("pointerup", e.onTouchEnd, { passive: !0 }),
      s[d]("pointercancel", e.onTouchEnd, { passive: !0 }),
      s[d]("pointerout", e.onTouchEnd, { passive: !0 }),
      s[d]("pointerleave", e.onTouchEnd, { passive: !0 }),
      s[d]("contextmenu", e.onTouchEnd, { passive: !0 }),
      (i.preventClicks || i.preventClicksPropagation) && r[d]("click", e.onClick, !0),
      i.cssMode && n[d]("scroll", e.onScroll),
      i.updateOnWindowResize
        ? e[c](l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", N, !0)
        : e[c]("observerUpdate", N, !0),
      r[d]("load", e.onLoad, { capture: !0 })
  }
  const j = (e, t) => e.grid && t.grid && t.grid.rows > 1
  var W = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopedSlides: null,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  }
  function U(e, t) {
    return function (s) {
      void 0 === s && (s = {})
      const a = Object.keys(s)[0],
        i = s[a]
      "object" == typeof i && null !== i
        ? (!0 === e[a] && (e[a] = { enabled: !0 }),
          "navigation" === a && e[a] && e[a].enabled && !e[a].prevEl && !e[a].nextEl && (e[a].auto = !0),
          ["pagination", "scrollbar"].indexOf(a) >= 0 && e[a] && e[a].enabled && !e[a].el && (e[a].auto = !0),
          a in e && "enabled" in i
            ? ("object" != typeof e[a] || "enabled" in e[a] || (e[a].enabled = !0),
              e[a] || (e[a] = { enabled: !1 }),
              c(t, s))
            : c(t, s))
        : c(t, s)
    }
  }
  const K = {
      eventsEmitter: L,
      update: I,
      translate: k,
      transition: {
        setTransition: function (e, t) {
          const s = this
          s.params.cssMode ||
            ((s.wrapperEl.style.transitionDuration = `${e}ms`),
            (s.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : "")),
            s.emit("setTransition", e, t)
        },
        transitionStart: function (e, t) {
          void 0 === e && (e = !0)
          const s = this,
            { params: a } = s
          a.cssMode ||
            (a.autoHeight && s.updateAutoHeight(), O({ swiper: s, runCallbacks: e, direction: t, step: "Start" }))
        },
        transitionEnd: function (e, t) {
          void 0 === e && (e = !0)
          const s = this,
            { params: a } = s
          ;(s.animating = !1),
            a.cssMode || (s.setTransition(0), O({ swiper: s, runCallbacks: e, direction: t, step: "End" }))
        },
      },
      slide: D,
      loop: G,
      grabCursor: {
        setGrabCursor: function (e) {
          const t = this
          if (!t.params.simulateTouch || (t.params.watchOverflow && t.isLocked) || t.params.cssMode) return
          const s = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl
          t.isElement && (t.__preventObserver__ = !0),
            (s.style.cursor = "move"),
            (s.style.cursor = e ? "grabbing" : "grab"),
            t.isElement &&
              requestAnimationFrame(() => {
                t.__preventObserver__ = !1
              })
        },
        unsetGrabCursor: function () {
          const e = this
          ;(e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e.isElement && (e.__preventObserver__ = !0),
            (e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = ""),
            e.isElement &&
              requestAnimationFrame(() => {
                e.__preventObserver__ = !1
              }))
        },
      },
      events: {
        attachEvents: function () {
          const e = this,
            t = a(),
            { params: s } = e
          ;(e.onTouchStart = H.bind(e)),
            (e.onTouchMove = X.bind(e)),
            (e.onTouchEnd = Y.bind(e)),
            s.cssMode && (e.onScroll = R.bind(e)),
            (e.onClick = B.bind(e)),
            (e.onLoad = q.bind(e)),
            V || (t.addEventListener("touchstart", F), (V = !0)),
            _(e, "on")
        },
        detachEvents: function () {
          _(this, "off")
        },
      },
      breakpoints: {
        setBreakpoint: function () {
          const e = this,
            { realIndex: t, initialized: s, params: a, el: i } = e,
            r = a.breakpoints
          if (!r || (r && 0 === Object.keys(r).length)) return
          const n = e.getBreakpoint(r, e.params.breakpointsBase, e.el)
          if (!n || e.currentBreakpoint === n) return
          const l = (n in r ? r[n] : void 0) || e.originalParams,
            o = j(e, a),
            d = j(e, l),
            p = a.enabled
          o && !d
            ? (i.classList.remove(`${a.containerModifierClass}grid`, `${a.containerModifierClass}grid-column`),
              e.emitContainerClasses())
            : !o &&
              d &&
              (i.classList.add(`${a.containerModifierClass}grid`),
              ((l.grid.fill && "column" === l.grid.fill) || (!l.grid.fill && "column" === a.grid.fill)) &&
                i.classList.add(`${a.containerModifierClass}grid-column`),
              e.emitContainerClasses()),
            ["navigation", "pagination", "scrollbar"].forEach((t) => {
              if (void 0 === l[t]) return
              const s = a[t] && a[t].enabled,
                i = l[t] && l[t].enabled
              s && !i && e[t].disable(), !s && i && e[t].enable()
            })
          const u = l.direction && l.direction !== a.direction,
            m = a.loop && (l.slidesPerView !== a.slidesPerView || u),
            h = a.loop
          u && s && e.changeDirection(), c(e.params, l)
          const f = e.params.enabled,
            g = e.params.loop
          Object.assign(e, {
            allowTouchMove: e.params.allowTouchMove,
            allowSlideNext: e.params.allowSlideNext,
            allowSlidePrev: e.params.allowSlidePrev,
          }),
            p && !f ? e.disable() : !p && f && e.enable(),
            (e.currentBreakpoint = n),
            e.emit("_beforeBreakpoint", l),
            s &&
              (m
                ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides())
                : !h && g
                  ? (e.loopCreate(t), e.updateSlides())
                  : h && !g && e.loopDestroy()),
            e.emit("breakpoint", l)
        },
        getBreakpoint: function (e, t, s) {
          if ((void 0 === t && (t = "window"), !e || ("container" === t && !s))) return
          let a = !1
          const i = r(),
            n = "window" === t ? i.innerHeight : s.clientHeight,
            l = Object.keys(e).map((e) => {
              if ("string" == typeof e && 0 === e.indexOf("@")) {
                const t = parseFloat(e.substr(1))
                return { value: n * t, point: e }
              }
              return { value: e, point: e }
            })
          l.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10))
          for (let e = 0; e < l.length; e += 1) {
            const { point: r, value: n } = l[e]
            "window" === t ? i.matchMedia(`(min-width: ${n}px)`).matches && (a = r) : n <= s.clientWidth && (a = r)
          }
          return a || "max"
        },
      },
      checkOverflow: {
        checkOverflow: function () {
          const e = this,
            { isLocked: t, params: s } = e,
            { slidesOffsetBefore: a } = s
          if (a) {
            const t = e.slides.length - 1,
              s = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * a
            e.isLocked = e.size > s
          } else e.isLocked = 1 === e.snapGrid.length
          !0 === s.allowSlideNext && (e.allowSlideNext = !e.isLocked),
            !0 === s.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
            t && t !== e.isLocked && (e.isEnd = !1),
            t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock")
        },
      },
      classes: {
        addClasses: function () {
          const e = this,
            { classNames: t, params: s, rtl: a, el: i, device: r } = e,
            n = (function (e, t) {
              const s = []
              return (
                e.forEach((e) => {
                  "object" == typeof e
                    ? Object.keys(e).forEach((a) => {
                        e[a] && s.push(t + a)
                      })
                    : "string" == typeof e && s.push(t + e)
                }),
                s
              )
            })(
              [
                "initialized",
                s.direction,
                { "free-mode": e.params.freeMode && s.freeMode.enabled },
                { autoheight: s.autoHeight },
                { rtl: a },
                { grid: s.grid && s.grid.rows > 1 },
                { "grid-column": s.grid && s.grid.rows > 1 && "column" === s.grid.fill },
                { android: r.android },
                { ios: r.ios },
                { "css-mode": s.cssMode },
                { centered: s.cssMode && s.centeredSlides },
                { "watch-progress": s.watchSlidesProgress },
              ],
              s.containerModifierClass,
            )
          t.push(...n), i.classList.add(...t), e.emitContainerClasses()
        },
        removeClasses: function () {
          const { el: e, classNames: t } = this
          e.classList.remove(...t), this.emitContainerClasses()
        },
      },
    },
    Z = {}
  class Q {
    constructor() {
      let e, t
      for (var s = arguments.length, i = new Array(s), r = 0; r < s; r++) i[r] = arguments[r]
      1 === i.length && i[0].constructor && "Object" === Object.prototype.toString.call(i[0]).slice(8, -1)
        ? (t = i[0])
        : ([e, t] = i),
        t || (t = {}),
        (t = c({}, t)),
        e && !t.el && (t.el = e)
      const n = a()
      if (t.el && "string" == typeof t.el && n.querySelectorAll(t.el).length > 1) {
        const e = []
        return (
          n.querySelectorAll(t.el).forEach((s) => {
            const a = c({}, t, { el: s })
            e.push(new Q(a))
          }),
          e
        )
      }
      const l = this
      ;(l.__swiper__ = !0),
        (l.support = M()),
        (l.device = C({ userAgent: t.userAgent })),
        (l.browser = P()),
        (l.eventsListeners = {}),
        (l.eventsAnyListeners = []),
        (l.modules = [...l.__modules__]),
        t.modules && Array.isArray(t.modules) && l.modules.push(...t.modules)
      const o = {}
      l.modules.forEach((e) => {
        e({
          params: t,
          swiper: l,
          extendParams: U(t, o),
          on: l.on.bind(l),
          once: l.once.bind(l),
          off: l.off.bind(l),
          emit: l.emit.bind(l),
        })
      })
      const d = c({}, W, o)
      return (
        (l.params = c({}, d, Z, t)),
        (l.originalParams = c({}, l.params)),
        (l.passedParams = c({}, t)),
        l.params &&
          l.params.on &&
          Object.keys(l.params.on).forEach((e) => {
            l.on(e, l.params.on[e])
          }),
        l.params && l.params.onAny && l.onAny(l.params.onAny),
        Object.assign(l, {
          enabled: l.params.enabled,
          el: e,
          classNames: [],
          slides: [],
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal: () => "horizontal" === l.params.direction,
          isVertical: () => "vertical" === l.params.direction,
          activeIndex: 0,
          realIndex: 0,
          isBeginning: !0,
          isEnd: !1,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: !1,
          cssOverflowAdjustment() {
            return Math.trunc(this.translate / 2 ** 23) * 2 ** 23
          },
          allowSlideNext: l.params.allowSlideNext,
          allowSlidePrev: l.params.allowSlidePrev,
          touchEventsData: {
            isTouched: void 0,
            isMoved: void 0,
            allowTouchCallbacks: void 0,
            touchStartTime: void 0,
            isScrolling: void 0,
            currentTranslate: void 0,
            startTranslate: void 0,
            allowThresholdMove: void 0,
            focusableElements: l.params.focusableElements,
            lastClickTime: 0,
            clickTimeout: void 0,
            velocities: [],
            allowMomentumBounce: void 0,
            startMoving: void 0,
            evCache: [],
          },
          allowClick: !0,
          allowTouchMove: l.params.allowTouchMove,
          touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
          imagesToLoad: [],
          imagesLoaded: 0,
        }),
        l.emit("_swiper"),
        l.params.init && l.init(),
        l
      )
    }
    getSlideIndex(e) {
      const { slidesEl: t, params: s } = this,
        a = w(h(t, `.${s.slideClass}, swiper-slide`)[0])
      return w(e) - a
    }
    getSlideIndexByData(e) {
      return this.getSlideIndex(this.slides.filter((t) => 1 * t.getAttribute("data-swiper-slide-index") === e)[0])
    }
    recalcSlides() {
      const { slidesEl: e, params: t } = this
      this.slides = h(e, `.${t.slideClass}, swiper-slide`)
    }
    enable() {
      const e = this
      e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"))
    }
    disable() {
      const e = this
      e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"))
    }
    setProgress(e, t) {
      const s = this
      e = Math.min(Math.max(e, 0), 1)
      const a = s.minTranslate(),
        i = (s.maxTranslate() - a) * e + a
      s.translateTo(i, void 0 === t ? 0 : t), s.updateActiveIndex(), s.updateSlidesClasses()
    }
    emitContainerClasses() {
      const e = this
      if (!e.params._emitClasses || !e.el) return
      const t = e.el.className
        .split(" ")
        .filter((t) => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass))
      e.emit("_containerClasses", t.join(" "))
    }
    getSlideClasses(e) {
      const t = this
      return t.destroyed
        ? ""
        : e.className
            .split(" ")
            .filter((e) => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass))
            .join(" ")
    }
    emitSlidesClasses() {
      const e = this
      if (!e.params._emitClasses || !e.el) return
      const t = []
      e.slides.forEach((s) => {
        const a = e.getSlideClasses(s)
        t.push({ slideEl: s, classNames: a }), e.emit("_slideClass", s, a)
      }),
        e.emit("_slideClasses", t)
    }
    slidesPerViewDynamic(e, t) {
      void 0 === e && (e = "current"), void 0 === t && (t = !1)
      const { params: s, slides: a, slidesGrid: i, slidesSizesGrid: r, size: n, activeIndex: l } = this
      let o = 1
      if ("number" == typeof s.slidesPerView) return s.slidesPerView
      if (s.centeredSlides) {
        let e,
          t = a[l] ? a[l].swiperSlideSize : 0
        for (let s = l + 1; s < a.length; s += 1)
          a[s] && !e && ((t += a[s].swiperSlideSize), (o += 1), t > n && (e = !0))
        for (let s = l - 1; s >= 0; s -= 1) a[s] && !e && ((t += a[s].swiperSlideSize), (o += 1), t > n && (e = !0))
      } else if ("current" === e)
        for (let e = l + 1; e < a.length; e += 1) {
          ;(t ? i[e] + r[e] - i[l] < n : i[e] - i[l] < n) && (o += 1)
        }
      else
        for (let e = l - 1; e >= 0; e -= 1) {
          i[l] - i[e] < n && (o += 1)
        }
      return o
    }
    update() {
      const e = this
      if (!e || e.destroyed) return
      const { snapGrid: t, params: s } = e
      function a() {
        const t = e.rtlTranslate ? -1 * e.translate : e.translate,
          s = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate())
        e.setTranslate(s), e.updateActiveIndex(), e.updateSlidesClasses()
      }
      let i
      if (
        (s.breakpoints && e.setBreakpoint(),
        [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t) => {
          t.complete && z(e, t)
        }),
        e.updateSize(),
        e.updateSlides(),
        e.updateProgress(),
        e.updateSlidesClasses(),
        s.freeMode && s.freeMode.enabled && !s.cssMode)
      )
        a(), s.autoHeight && e.updateAutoHeight()
      else {
        if (("auto" === s.slidesPerView || s.slidesPerView > 1) && e.isEnd && !s.centeredSlides) {
          const t = e.virtual && s.virtual.enabled ? e.virtual.slides : e.slides
          i = e.slideTo(t.length - 1, 0, !1, !0)
        } else i = e.slideTo(e.activeIndex, 0, !1, !0)
        i || a()
      }
      s.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update")
    }
    changeDirection(e, t) {
      void 0 === t && (t = !0)
      const s = this,
        a = s.params.direction
      return (
        e || (e = "horizontal" === a ? "vertical" : "horizontal"),
        e === a ||
          ("horizontal" !== e && "vertical" !== e) ||
          (s.el.classList.remove(`${s.params.containerModifierClass}${a}`),
          s.el.classList.add(`${s.params.containerModifierClass}${e}`),
          s.emitContainerClasses(),
          (s.params.direction = e),
          s.slides.forEach((t) => {
            "vertical" === e ? (t.style.width = "") : (t.style.height = "")
          }),
          s.emit("changeDirection"),
          t && s.update()),
        s
      )
    }
    changeLanguageDirection(e) {
      const t = this
      ;(t.rtl && "rtl" === e) ||
        (!t.rtl && "ltr" === e) ||
        ((t.rtl = "rtl" === e),
        (t.rtlTranslate = "horizontal" === t.params.direction && t.rtl),
        t.rtl
          ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), (t.el.dir = "rtl"))
          : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), (t.el.dir = "ltr")),
        t.update())
    }
    mount(e) {
      const t = this
      if (t.mounted) return !0
      let s = e || t.params.el
      if (("string" == typeof s && (s = document.querySelector(s)), !s)) return !1
      ;(s.swiper = t),
        s.parentNode && s.parentNode.host && "SWIPER-CONTAINER" === s.parentNode.host.nodeName && (t.isElement = !0)
      const a = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`
      let i = (() => {
        if (s && s.shadowRoot && s.shadowRoot.querySelector) {
          return s.shadowRoot.querySelector(a())
        }
        return h(s, a())[0]
      })()
      return (
        !i &&
          t.params.createElements &&
          ((i = f("div", t.params.wrapperClass)),
          s.append(i),
          h(s, `.${t.params.slideClass}`).forEach((e) => {
            i.append(e)
          })),
        Object.assign(t, {
          el: s,
          wrapperEl: i,
          slidesEl: t.isElement && !s.parentNode.host.slideSlots ? s.parentNode.host : i,
          hostEl: t.isElement ? s.parentNode.host : s,
          mounted: !0,
          rtl: "rtl" === s.dir.toLowerCase() || "rtl" === v(s, "direction"),
          rtlTranslate:
            "horizontal" === t.params.direction && ("rtl" === s.dir.toLowerCase() || "rtl" === v(s, "direction")),
          wrongRTL: "-webkit-box" === v(i, "display"),
        }),
        !0
      )
    }
    init(e) {
      const t = this
      if (t.initialized) return t
      if (!1 === t.mount(e)) return t
      t.emit("beforeInit"),
        t.params.breakpoints && t.setBreakpoint(),
        t.addClasses(),
        t.updateSize(),
        t.updateSlides(),
        t.params.watchOverflow && t.checkOverflow(),
        t.params.grabCursor && t.enabled && t.setGrabCursor(),
        t.params.loop && t.virtual && t.params.virtual.enabled
          ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0)
          : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
        t.params.loop && t.loopCreate(),
        t.attachEvents()
      const s = [...t.el.querySelectorAll('[loading="lazy"]')]
      return (
        t.isElement && s.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
        s.forEach((e) => {
          e.complete
            ? z(t, e)
            : e.addEventListener("load", (e) => {
                z(t, e.target)
              })
        }),
        $(t),
        (t.initialized = !0),
        $(t),
        t.emit("init"),
        t.emit("afterInit"),
        t
      )
    }
    destroy(e, t) {
      void 0 === e && (e = !0), void 0 === t && (t = !0)
      const s = this,
        { params: a, el: i, wrapperEl: r, slides: n } = s
      return (
        void 0 === s.params ||
          s.destroyed ||
          (s.emit("beforeDestroy"),
          (s.initialized = !1),
          s.detachEvents(),
          a.loop && s.loopDestroy(),
          t &&
            (s.removeClasses(),
            i.removeAttribute("style"),
            r.removeAttribute("style"),
            n &&
              n.length &&
              n.forEach((e) => {
                e.classList.remove(a.slideVisibleClass, a.slideActiveClass, a.slideNextClass, a.slidePrevClass),
                  e.removeAttribute("style"),
                  e.removeAttribute("data-swiper-slide-index")
              })),
          s.emit("destroy"),
          Object.keys(s.eventsListeners).forEach((e) => {
            s.off(e)
          }),
          !1 !== e &&
            ((s.el.swiper = null),
            (function (e) {
              const t = e
              Object.keys(t).forEach((e) => {
                try {
                  t[e] = null
                } catch (e) {}
                try {
                  delete t[e]
                } catch (e) {}
              })
            })(s)),
          (s.destroyed = !0)),
        null
      )
    }
    static extendDefaults(e) {
      c(Z, e)
    }
    static get extendedDefaults() {
      return Z
    }
    static get defaults() {
      return W
    }
    static installModule(e) {
      Q.prototype.__modules__ || (Q.prototype.__modules__ = [])
      const t = Q.prototype.__modules__
      "function" == typeof e && t.indexOf(e) < 0 && t.push(e)
    }
    static use(e) {
      return Array.isArray(e) ? (e.forEach((e) => Q.installModule(e)), Q) : (Q.installModule(e), Q)
    }
  }
  function J(e, t, s, a) {
    return (
      e.params.createElements &&
        Object.keys(a).forEach((i) => {
          if (!s[i] && !0 === s.auto) {
            let r = h(e.el, `.${a[i]}`)[0]
            r || ((r = f("div", a[i])), (r.className = a[i]), e.el.append(r)), (s[i] = r), (t[i] = r)
          }
        }),
      s
    )
  }
  function ee(e) {
    return (
      void 0 === e && (e = ""),
      `.${e
        .trim()
        .replace(/([\.:!+\/])/g, "\\$1")
        .replace(/ /g, ".")}`
    )
  }
  function te(e) {
    const t = this,
      { params: s, slidesEl: a } = t
    s.loop && t.loopDestroy()
    const i = (e) => {
      if ("string" == typeof e) {
        const t = document.createElement("div")
        ;(t.innerHTML = e), a.append(t.children[0]), (t.innerHTML = "")
      } else a.append(e)
    }
    if ("object" == typeof e && "length" in e) for (let t = 0; t < e.length; t += 1) e[t] && i(e[t])
    else i(e)
    t.recalcSlides(), s.loop && t.loopCreate(), (s.observer && !t.isElement) || t.update()
  }
  function se(e) {
    const t = this,
      { params: s, activeIndex: a, slidesEl: i } = t
    s.loop && t.loopDestroy()
    let r = a + 1
    const n = (e) => {
      if ("string" == typeof e) {
        const t = document.createElement("div")
        ;(t.innerHTML = e), i.prepend(t.children[0]), (t.innerHTML = "")
      } else i.prepend(e)
    }
    if ("object" == typeof e && "length" in e) {
      for (let t = 0; t < e.length; t += 1) e[t] && n(e[t])
      r = a + e.length
    } else n(e)
    t.recalcSlides(), s.loop && t.loopCreate(), (s.observer && !t.isElement) || t.update(), t.slideTo(r, 0, !1)
  }
  function ae(e, t) {
    const s = this,
      { params: a, activeIndex: i, slidesEl: r } = s
    let n = i
    a.loop && ((n -= s.loopedSlides), s.loopDestroy(), s.recalcSlides())
    const l = s.slides.length
    if (e <= 0) return void s.prependSlide(t)
    if (e >= l) return void s.appendSlide(t)
    let o = n > e ? n + 1 : n
    const d = []
    for (let t = l - 1; t >= e; t -= 1) {
      const e = s.slides[t]
      e.remove(), d.unshift(e)
    }
    if ("object" == typeof t && "length" in t) {
      for (let e = 0; e < t.length; e += 1) t[e] && r.append(t[e])
      o = n > e ? n + t.length : n
    } else r.append(t)
    for (let e = 0; e < d.length; e += 1) r.append(d[e])
    s.recalcSlides(),
      a.loop && s.loopCreate(),
      (a.observer && !s.isElement) || s.update(),
      a.loop ? s.slideTo(o + s.loopedSlides, 0, !1) : s.slideTo(o, 0, !1)
  }
  function ie(e) {
    const t = this,
      { params: s, activeIndex: a } = t
    let i = a
    s.loop && ((i -= t.loopedSlides), t.loopDestroy())
    let r,
      n = i
    if ("object" == typeof e && "length" in e) {
      for (let s = 0; s < e.length; s += 1) (r = e[s]), t.slides[r] && t.slides[r].remove(), r < n && (n -= 1)
      n = Math.max(n, 0)
    } else (r = e), t.slides[r] && t.slides[r].remove(), r < n && (n -= 1), (n = Math.max(n, 0))
    t.recalcSlides(),
      s.loop && t.loopCreate(),
      (s.observer && !t.isElement) || t.update(),
      s.loop ? t.slideTo(n + t.loopedSlides, 0, !1) : t.slideTo(n, 0, !1)
  }
  function re() {
    const e = this,
      t = []
    for (let s = 0; s < e.slides.length; s += 1) t.push(s)
    e.removeSlide(t)
  }
  function ne(e) {
    const {
      effect: t,
      swiper: s,
      on: a,
      setTranslate: i,
      setTransition: r,
      overwriteParams: n,
      perspective: l,
      recreateShadows: o,
      getEffectParams: d,
    } = e
    let c
    a("beforeInit", () => {
      if (s.params.effect !== t) return
      s.classNames.push(`${s.params.containerModifierClass}${t}`),
        l && l() && s.classNames.push(`${s.params.containerModifierClass}3d`)
      const e = n ? n() : {}
      Object.assign(s.params, e), Object.assign(s.originalParams, e)
    }),
      a("setTranslate", () => {
        s.params.effect === t && i()
      }),
      a("setTransition", (e, a) => {
        s.params.effect === t && r(a)
      }),
      a("transitionEnd", () => {
        if (s.params.effect === t && o) {
          if (!d || !d().slideShadows) return
          s.slides.forEach((e) => {
            e.querySelectorAll(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left",
            ).forEach((e) => e.remove())
          }),
            o()
        }
      }),
      a("virtualUpdate", () => {
        s.params.effect === t &&
          (s.slides.length || (c = !0),
          requestAnimationFrame(() => {
            c && s.slides && s.slides.length && (i(), (c = !1))
          }))
      })
  }
  function le(e, t) {
    const s = m(t)
    return s !== t && ((s.style.backfaceVisibility = "hidden"), (s.style["-webkit-backface-visibility"] = "hidden")), s
  }
  function oe(e) {
    let { swiper: t, duration: s, transformElements: a, allSlides: i } = e
    const { activeIndex: r } = t
    if (t.params.virtualTranslate && 0 !== s) {
      let e,
        s = !1
      ;(e = i
        ? a
        : a.filter((e) => {
            const s = e.classList.contains("swiper-slide-transform")
              ? ((e) => {
                  if (!e.parentElement) return t.slides.filter((t) => t.shadowRoot && t.shadowRoot === e.parentNode)[0]
                  return e.parentElement
                })(e)
              : e
            return t.getSlideIndex(s) === r
          })),
        e.forEach((e) => {
          y(e, () => {
            if (s) return
            if (!t || t.destroyed) return
            ;(s = !0), (t.animating = !1)
            const e = new window.CustomEvent("transitionend", { bubbles: !0, cancelable: !0 })
            t.wrapperEl.dispatchEvent(e)
          })
        })
    }
  }
  function de(e, t, s) {
    const a = `swiper-slide-shadow${s ? `-${s}` : ""}${e ? ` swiper-slide-shadow-${e}` : ""}`,
      i = m(t)
    let r = i.querySelector(`.${a.split(" ").join(".")}`)
    return r || ((r = f("div", a.split(" "))), i.append(r)), r
  }
  Object.keys(K).forEach((e) => {
    Object.keys(K[e]).forEach((t) => {
      Q.prototype[t] = K[e][t]
    })
  }),
    Q.use([
      function (e) {
        let { swiper: t, on: s, emit: a } = e
        const i = r()
        let n = null,
          l = null
        const o = () => {
            t && !t.destroyed && t.initialized && (a("beforeResize"), a("resize"))
          },
          d = () => {
            t && !t.destroyed && t.initialized && a("orientationchange")
          }
        s("init", () => {
          t.params.resizeObserver && void 0 !== i.ResizeObserver
            ? t &&
              !t.destroyed &&
              t.initialized &&
              ((n = new ResizeObserver((e) => {
                l = i.requestAnimationFrame(() => {
                  const { width: s, height: a } = t
                  let i = s,
                    r = a
                  e.forEach((e) => {
                    let { contentBoxSize: s, contentRect: a, target: n } = e
                    ;(n && n !== t.el) ||
                      ((i = a ? a.width : (s[0] || s).inlineSize), (r = a ? a.height : (s[0] || s).blockSize))
                  }),
                    (i === s && r === a) || o()
                })
              })),
              n.observe(t.el))
            : (i.addEventListener("resize", o), i.addEventListener("orientationchange", d))
        }),
          s("destroy", () => {
            l && i.cancelAnimationFrame(l),
              n && n.unobserve && t.el && (n.unobserve(t.el), (n = null)),
              i.removeEventListener("resize", o),
              i.removeEventListener("orientationchange", d)
          })
      },
      function (e) {
        let { swiper: t, extendParams: s, on: a, emit: i } = e
        const n = [],
          l = r(),
          o = function (e, s) {
            void 0 === s && (s = {})
            const a = new (l.MutationObserver || l.WebkitMutationObserver)((e) => {
              if (t.__preventObserver__) return
              if (1 === e.length) return void i("observerUpdate", e[0])
              const s = function () {
                i("observerUpdate", e[0])
              }
              l.requestAnimationFrame ? l.requestAnimationFrame(s) : l.setTimeout(s, 0)
            })
            a.observe(e, {
              attributes: void 0 === s.attributes || s.attributes,
              childList: void 0 === s.childList || s.childList,
              characterData: void 0 === s.characterData || s.characterData,
            }),
              n.push(a)
          }
        s({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          a("init", () => {
            if (t.params.observer) {
              if (t.params.observeParents) {
                const e = b(t.hostEl)
                for (let t = 0; t < e.length; t += 1) o(e[t])
              }
              o(t.hostEl, { childList: t.params.observeSlideChildren }), o(t.wrapperEl, { attributes: !1 })
            }
          }),
          a("destroy", () => {
            n.forEach((e) => {
              e.disconnect()
            }),
              n.splice(0, n.length)
          })
      },
    ])
  const ce = [
    function (e) {
      let t,
        { swiper: s, extendParams: i, on: r, emit: n } = e
      i({
        virtual: {
          enabled: !1,
          slides: [],
          cache: !0,
          renderSlide: null,
          renderExternal: null,
          renderExternalUpdate: !0,
          addSlidesBefore: 0,
          addSlidesAfter: 0,
        },
      })
      const l = a()
      s.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] }
      const o = l.createElement("div")
      function d(e, t) {
        const a = s.params.virtual
        if (a.cache && s.virtual.cache[t]) return s.virtual.cache[t]
        let i
        return (
          a.renderSlide
            ? ((i = a.renderSlide.call(s, e, t)), "string" == typeof i && ((o.innerHTML = i), (i = o.children[0])))
            : (i = s.isElement ? f("swiper-slide") : f("div", s.params.slideClass)),
          i.setAttribute("data-swiper-slide-index", t),
          a.renderSlide || (i.innerHTML = e),
          a.cache && (s.virtual.cache[t] = i),
          i
        )
      }
      function c(e) {
        const { slidesPerView: t, slidesPerGroup: a, centeredSlides: i, loop: r } = s.params,
          { addSlidesBefore: l, addSlidesAfter: o } = s.params.virtual,
          { from: c, to: p, slides: u, slidesGrid: m, offset: f } = s.virtual
        s.params.cssMode || s.updateActiveIndex()
        const g = s.activeIndex || 0
        let v, w, b
        ;(v = s.rtlTranslate ? "right" : s.isHorizontal() ? "left" : "top"),
          i
            ? ((w = Math.floor(t / 2) + a + o), (b = Math.floor(t / 2) + a + l))
            : ((w = t + (a - 1) + o), (b = (r ? t : a) + l))
        let y = g - b,
          E = g + w
        r || ((y = Math.max(y, 0)), (E = Math.min(E, u.length - 1)))
        let x = (s.slidesGrid[y] || 0) - (s.slidesGrid[0] || 0)
        function S() {
          s.updateSlides(), s.updateProgress(), s.updateSlidesClasses(), n("virtualUpdate")
        }
        if (
          (r && g >= b
            ? ((y -= b), i || (x += s.slidesGrid[0]))
            : r && g < b && ((y = -b), i && (x += s.slidesGrid[0])),
          Object.assign(s.virtual, {
            from: y,
            to: E,
            offset: x,
            slidesGrid: s.slidesGrid,
            slidesBefore: b,
            slidesAfter: w,
          }),
          c === y && p === E && !e)
        )
          return (
            s.slidesGrid !== m &&
              x !== f &&
              s.slides.forEach((e) => {
                e.style[v] = x - Math.abs(s.cssOverflowAdjustment()) + "px"
              }),
            s.updateProgress(),
            void n("virtualUpdate")
          )
        if (s.params.virtual.renderExternal)
          return (
            s.params.virtual.renderExternal.call(s, {
              offset: x,
              from: y,
              to: E,
              slides: (function () {
                const e = []
                for (let t = y; t <= E; t += 1) e.push(u[t])
                return e
              })(),
            }),
            void (s.params.virtual.renderExternalUpdate ? S() : n("virtualUpdate"))
          )
        const T = [],
          M = [],
          C = (e) => {
            let t = e
            return e < 0 ? (t = u.length + e) : t >= u.length && (t -= u.length), t
          }
        if (e)
          s.slides
            .filter((e) => e.matches(`.${s.params.slideClass}, swiper-slide`))
            .forEach((e) => {
              e.remove()
            })
        else
          for (let e = c; e <= p; e += 1)
            if (e < y || e > E) {
              const t = C(e)
              s.slides
                .filter((e) =>
                  e.matches(
                    `.${s.params.slideClass}[data-swiper-slide-index="${t}"], swiper-slide[data-swiper-slide-index="${t}"]`,
                  ),
                )
                .forEach((e) => {
                  e.remove()
                })
            }
        const P = r ? -u.length : 0,
          L = r ? 2 * u.length : u.length
        for (let t = P; t < L; t += 1)
          if (t >= y && t <= E) {
            const s = C(t)
            void 0 === p || e ? M.push(s) : (t > p && M.push(s), t < c && T.push(s))
          }
        if (
          (M.forEach((e) => {
            s.slidesEl.append(d(u[e], e))
          }),
          r)
        )
          for (let e = T.length - 1; e >= 0; e -= 1) {
            const t = T[e]
            s.slidesEl.prepend(d(u[t], t))
          }
        else
          T.sort((e, t) => t - e),
            T.forEach((e) => {
              s.slidesEl.prepend(d(u[e], e))
            })
        h(s.slidesEl, ".swiper-slide, swiper-slide").forEach((e) => {
          e.style[v] = x - Math.abs(s.cssOverflowAdjustment()) + "px"
        }),
          S()
      }
      r("beforeInit", () => {
        if (!s.params.virtual.enabled) return
        let e
        if (void 0 === s.passedParams.virtual.slides) {
          const t = [...s.slidesEl.children].filter((e) => e.matches(`.${s.params.slideClass}, swiper-slide`))
          t &&
            t.length &&
            ((s.virtual.slides = [...t]),
            (e = !0),
            t.forEach((e, t) => {
              e.setAttribute("data-swiper-slide-index", t), (s.virtual.cache[t] = e), e.remove()
            }))
        }
        e || (s.virtual.slides = s.params.virtual.slides),
          s.classNames.push(`${s.params.containerModifierClass}virtual`),
          (s.params.watchSlidesProgress = !0),
          (s.originalParams.watchSlidesProgress = !0),
          c()
      }),
        r("setTranslate", () => {
          s.params.virtual.enabled &&
            (s.params.cssMode && !s._immediateVirtual
              ? (clearTimeout(t),
                (t = setTimeout(() => {
                  c()
                }, 100)))
              : c())
        }),
        r("init update resize", () => {
          s.params.virtual.enabled && s.params.cssMode && p(s.wrapperEl, "--swiper-virtual-size", `${s.virtualSize}px`)
        }),
        Object.assign(s.virtual, {
          appendSlide: function (e) {
            if ("object" == typeof e && "length" in e)
              for (let t = 0; t < e.length; t += 1) e[t] && s.virtual.slides.push(e[t])
            else s.virtual.slides.push(e)
            c(!0)
          },
          prependSlide: function (e) {
            const t = s.activeIndex
            let a = t + 1,
              i = 1
            if (Array.isArray(e)) {
              for (let t = 0; t < e.length; t += 1) e[t] && s.virtual.slides.unshift(e[t])
              ;(a = t + e.length), (i = e.length)
            } else s.virtual.slides.unshift(e)
            if (s.params.virtual.cache) {
              const e = s.virtual.cache,
                t = {}
              Object.keys(e).forEach((s) => {
                const a = e[s],
                  r = a.getAttribute("data-swiper-slide-index")
                r && a.setAttribute("data-swiper-slide-index", parseInt(r, 10) + i), (t[parseInt(s, 10) + i] = a)
              }),
                (s.virtual.cache = t)
            }
            c(!0), s.slideTo(a, 0)
          },
          removeSlide: function (e) {
            if (null == e) return
            let t = s.activeIndex
            if (Array.isArray(e))
              for (let a = e.length - 1; a >= 0; a -= 1)
                s.params.virtual.cache &&
                  (delete s.virtual.cache[e[a]],
                  Object.keys(s.virtual.cache).forEach((t) => {
                    t > e &&
                      ((s.virtual.cache[t - 1] = s.virtual.cache[t]),
                      s.virtual.cache[t - 1].setAttribute("data-swiper-slide-index", t - 1),
                      delete s.virtual.cache[t])
                  })),
                  s.virtual.slides.splice(e[a], 1),
                  e[a] < t && (t -= 1),
                  (t = Math.max(t, 0))
            else
              s.params.virtual.cache &&
                (delete s.virtual.cache[e],
                Object.keys(s.virtual.cache).forEach((t) => {
                  t > e &&
                    ((s.virtual.cache[t - 1] = s.virtual.cache[t]),
                    s.virtual.cache[t - 1].setAttribute("data-swiper-slide-index", t - 1),
                    delete s.virtual.cache[t])
                })),
                s.virtual.slides.splice(e, 1),
                e < t && (t -= 1),
                (t = Math.max(t, 0))
            c(!0), s.slideTo(t, 0)
          },
          removeAllSlides: function () {
            ;(s.virtual.slides = []), s.params.virtual.cache && (s.virtual.cache = {}), c(!0), s.slideTo(0, 0)
          },
          update: c,
        })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i, emit: n } = e
      const l = a(),
        o = r()
      function d(e) {
        if (!t.enabled) return
        const { rtlTranslate: s } = t
        let a = e
        a.originalEvent && (a = a.originalEvent)
        const i = a.keyCode || a.charCode,
          r = t.params.keyboard.pageUpDown,
          d = r && 33 === i,
          c = r && 34 === i,
          p = 37 === i,
          u = 39 === i,
          m = 38 === i,
          h = 40 === i
        if (!t.allowSlideNext && ((t.isHorizontal() && u) || (t.isVertical() && h) || c)) return !1
        if (!t.allowSlidePrev && ((t.isHorizontal() && p) || (t.isVertical() && m) || d)) return !1
        if (
          !(
            a.shiftKey ||
            a.altKey ||
            a.ctrlKey ||
            a.metaKey ||
            (l.activeElement &&
              l.activeElement.nodeName &&
              ("input" === l.activeElement.nodeName.toLowerCase() ||
                "textarea" === l.activeElement.nodeName.toLowerCase()))
          )
        ) {
          if (t.params.keyboard.onlyInViewport && (d || c || p || u || m || h)) {
            let e = !1
            if (
              b(t.el, `.${t.params.slideClass}, swiper-slide`).length > 0 &&
              0 === b(t.el, `.${t.params.slideActiveClass}`).length
            )
              return
            const a = t.el,
              i = a.clientWidth,
              r = a.clientHeight,
              n = o.innerWidth,
              l = o.innerHeight,
              d = g(a)
            s && (d.left -= a.scrollLeft)
            const c = [
              [d.left, d.top],
              [d.left + i, d.top],
              [d.left, d.top + r],
              [d.left + i, d.top + r],
            ]
            for (let t = 0; t < c.length; t += 1) {
              const s = c[t]
              if (s[0] >= 0 && s[0] <= n && s[1] >= 0 && s[1] <= l) {
                if (0 === s[0] && 0 === s[1]) continue
                e = !0
              }
            }
            if (!e) return
          }
          t.isHorizontal()
            ? ((d || c || p || u) && (a.preventDefault ? a.preventDefault() : (a.returnValue = !1)),
              (((c || u) && !s) || ((d || p) && s)) && t.slideNext(),
              (((d || p) && !s) || ((c || u) && s)) && t.slidePrev())
            : ((d || c || m || h) && (a.preventDefault ? a.preventDefault() : (a.returnValue = !1)),
              (c || h) && t.slideNext(),
              (d || m) && t.slidePrev()),
            n("keyPress", i)
        }
      }
      function c() {
        t.keyboard.enabled || (l.addEventListener("keydown", d), (t.keyboard.enabled = !0))
      }
      function p() {
        t.keyboard.enabled && (l.removeEventListener("keydown", d), (t.keyboard.enabled = !1))
      }
      ;(t.keyboard = { enabled: !1 }),
        s({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }),
        i("init", () => {
          t.params.keyboard.enabled && c()
        }),
        i("destroy", () => {
          t.keyboard.enabled && p()
        }),
        Object.assign(t.keyboard, { enable: c, disable: p })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a, emit: i } = e
      const o = r()
      let d
      s({
        mousewheel: {
          enabled: !1,
          releaseOnEdges: !1,
          invert: !1,
          forceToAxis: !1,
          sensitivity: 1,
          eventsTarget: "container",
          thresholdDelta: null,
          thresholdTime: null,
          noMousewheelClass: "swiper-no-mousewheel",
        },
      }),
        (t.mousewheel = { enabled: !1 })
      let c,
        p = l()
      const u = []
      function m() {
        t.enabled && (t.mouseEntered = !0)
      }
      function h() {
        t.enabled && (t.mouseEntered = !1)
      }
      function f(e) {
        return (
          !(t.params.mousewheel.thresholdDelta && e.delta < t.params.mousewheel.thresholdDelta) &&
          !(t.params.mousewheel.thresholdTime && l() - p < t.params.mousewheel.thresholdTime) &&
          ((e.delta >= 6 && l() - p < 60) ||
            (e.direction < 0
              ? (t.isEnd && !t.params.loop) || t.animating || (t.slideNext(), i("scroll", e.raw))
              : (t.isBeginning && !t.params.loop) || t.animating || (t.slidePrev(), i("scroll", e.raw)),
            (p = new o.Date().getTime()),
            !1))
        )
      }
      function g(e) {
        let s = e,
          a = !0
        if (!t.enabled) return
        if (e.target.closest(`.${t.params.mousewheel.noMousewheelClass}`)) return
        const r = t.params.mousewheel
        t.params.cssMode && s.preventDefault()
        let o = t.el
        "container" !== t.params.mousewheel.eventsTarget &&
          (o = document.querySelector(t.params.mousewheel.eventsTarget))
        const p = o && o.contains(s.target)
        if (!t.mouseEntered && !p && !r.releaseOnEdges) return !0
        s.originalEvent && (s = s.originalEvent)
        let m = 0
        const h = t.rtlTranslate ? -1 : 1,
          g = (function (e) {
            let t = 0,
              s = 0,
              a = 0,
              i = 0
            return (
              "detail" in e && (s = e.detail),
              "wheelDelta" in e && (s = -e.wheelDelta / 120),
              "wheelDeltaY" in e && (s = -e.wheelDeltaY / 120),
              "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
              "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = s), (s = 0)),
              (a = 10 * t),
              (i = 10 * s),
              "deltaY" in e && (i = e.deltaY),
              "deltaX" in e && (a = e.deltaX),
              e.shiftKey && !a && ((a = i), (i = 0)),
              (a || i) && e.deltaMode && (1 === e.deltaMode ? ((a *= 40), (i *= 40)) : ((a *= 800), (i *= 800))),
              a && !t && (t = a < 1 ? -1 : 1),
              i && !s && (s = i < 1 ? -1 : 1),
              { spinX: t, spinY: s, pixelX: a, pixelY: i }
            )
          })(s)
        if (r.forceToAxis)
          if (t.isHorizontal()) {
            if (!(Math.abs(g.pixelX) > Math.abs(g.pixelY))) return !0
            m = -g.pixelX * h
          } else {
            if (!(Math.abs(g.pixelY) > Math.abs(g.pixelX))) return !0
            m = -g.pixelY
          }
        else m = Math.abs(g.pixelX) > Math.abs(g.pixelY) ? -g.pixelX * h : -g.pixelY
        if (0 === m) return !0
        r.invert && (m = -m)
        let v = t.getTranslate() + m * r.sensitivity
        if (
          (v >= t.minTranslate() && (v = t.minTranslate()),
          v <= t.maxTranslate() && (v = t.maxTranslate()),
          (a = !!t.params.loop || !(v === t.minTranslate() || v === t.maxTranslate())),
          a && t.params.nested && s.stopPropagation(),
          t.params.freeMode && t.params.freeMode.enabled)
        ) {
          const e = { time: l(), delta: Math.abs(m), direction: Math.sign(m) },
            a = c && e.time < c.time + 500 && e.delta <= c.delta && e.direction === c.direction
          if (!a) {
            c = void 0
            let l = t.getTranslate() + m * r.sensitivity
            const o = t.isBeginning,
              p = t.isEnd
            if (
              (l >= t.minTranslate() && (l = t.minTranslate()),
              l <= t.maxTranslate() && (l = t.maxTranslate()),
              t.setTransition(0),
              t.setTranslate(l),
              t.updateProgress(),
              t.updateActiveIndex(),
              t.updateSlidesClasses(),
              ((!o && t.isBeginning) || (!p && t.isEnd)) && t.updateSlidesClasses(),
              t.params.loop && t.loopFix({ direction: e.direction < 0 ? "next" : "prev", byMousewheel: !0 }),
              t.params.freeMode.sticky)
            ) {
              clearTimeout(d), (d = void 0), u.length >= 15 && u.shift()
              const s = u.length ? u[u.length - 1] : void 0,
                a = u[0]
              if ((u.push(e), s && (e.delta > s.delta || e.direction !== s.direction))) u.splice(0)
              else if (u.length >= 15 && e.time - a.time < 500 && a.delta - e.delta >= 1 && e.delta <= 6) {
                const s = m > 0 ? 0.8 : 0.2
                ;(c = e),
                  u.splice(0),
                  (d = n(() => {
                    t.slideToClosest(t.params.speed, !0, void 0, s)
                  }, 0))
              }
              d ||
                (d = n(() => {
                  ;(c = e), u.splice(0), t.slideToClosest(t.params.speed, !0, void 0, 0.5)
                }, 500))
            }
            if (
              (a || i("scroll", s),
              t.params.autoplay && t.params.autoplayDisableOnInteraction && t.autoplay.stop(),
              r.releaseOnEdges && (l === t.minTranslate() || l === t.maxTranslate()))
            )
              return !0
          }
        } else {
          const s = { time: l(), delta: Math.abs(m), direction: Math.sign(m), raw: e }
          u.length >= 2 && u.shift()
          const a = u.length ? u[u.length - 1] : void 0
          if (
            (u.push(s),
            a ? (s.direction !== a.direction || s.delta > a.delta || s.time > a.time + 150) && f(s) : f(s),
            (function (e) {
              const s = t.params.mousewheel
              if (e.direction < 0) {
                if (t.isEnd && !t.params.loop && s.releaseOnEdges) return !0
              } else if (t.isBeginning && !t.params.loop && s.releaseOnEdges) return !0
              return !1
            })(s))
          )
            return !0
        }
        return s.preventDefault ? s.preventDefault() : (s.returnValue = !1), !1
      }
      function v(e) {
        let s = t.el
        "container" !== t.params.mousewheel.eventsTarget &&
          (s = document.querySelector(t.params.mousewheel.eventsTarget)),
          s[e]("mouseenter", m),
          s[e]("mouseleave", h),
          s[e]("wheel", g)
      }
      function w() {
        return t.params.cssMode
          ? (t.wrapperEl.removeEventListener("wheel", g), !0)
          : !t.mousewheel.enabled && (v("addEventListener"), (t.mousewheel.enabled = !0), !0)
      }
      function b() {
        return t.params.cssMode
          ? (t.wrapperEl.addEventListener(event, g), !0)
          : !!t.mousewheel.enabled && (v("removeEventListener"), (t.mousewheel.enabled = !1), !0)
      }
      a("init", () => {
        !t.params.mousewheel.enabled && t.params.cssMode && b(), t.params.mousewheel.enabled && w()
      }),
        a("destroy", () => {
          t.params.cssMode && w(), t.mousewheel.enabled && b()
        }),
        Object.assign(t.mousewheel, { enable: w, disable: b })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a, emit: i } = e
      s({
        navigation: {
          nextEl: null,
          prevEl: null,
          hideOnClick: !1,
          disabledClass: "swiper-button-disabled",
          hiddenClass: "swiper-button-hidden",
          lockClass: "swiper-button-lock",
          navigationDisabledClass: "swiper-navigation-disabled",
        },
      }),
        (t.navigation = { nextEl: null, prevEl: null })
      const r = (e) => (Array.isArray(e) ? e : [e]).filter((e) => !!e)
      function n(e) {
        let s
        return e && "string" == typeof e && t.isElement && ((s = t.el.querySelector(e)), s)
          ? s
          : (e &&
              ("string" == typeof e && (s = [...document.querySelectorAll(e)]),
              t.params.uniqueNavElements &&
                "string" == typeof e &&
                s.length > 1 &&
                1 === t.el.querySelectorAll(e).length &&
                (s = t.el.querySelector(e))),
            e && !s ? e : s)
      }
      function l(e, s) {
        const a = t.params.navigation
        ;(e = r(e)).forEach((e) => {
          e &&
            (e.classList[s ? "add" : "remove"](...a.disabledClass.split(" ")),
            "BUTTON" === e.tagName && (e.disabled = s),
            t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](a.lockClass))
        })
      }
      function o() {
        const { nextEl: e, prevEl: s } = t.navigation
        if (t.params.loop) return l(s, !1), void l(e, !1)
        l(s, t.isBeginning && !t.params.rewind), l(e, t.isEnd && !t.params.rewind)
      }
      function d(e) {
        e.preventDefault(), (!t.isBeginning || t.params.loop || t.params.rewind) && (t.slidePrev(), i("navigationPrev"))
      }
      function c(e) {
        e.preventDefault(), (!t.isEnd || t.params.loop || t.params.rewind) && (t.slideNext(), i("navigationNext"))
      }
      function p() {
        const e = t.params.navigation
        if (
          ((t.params.navigation = J(t, t.originalParams.navigation, t.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev",
          })),
          !e.nextEl && !e.prevEl)
        )
          return
        let s = n(e.nextEl),
          a = n(e.prevEl)
        Object.assign(t.navigation, { nextEl: s, prevEl: a }), (s = r(s)), (a = r(a))
        const i = (s, a) => {
          s && s.addEventListener("click", "next" === a ? c : d),
            !t.enabled && s && s.classList.add(...e.lockClass.split(" "))
        }
        s.forEach((e) => i(e, "next")), a.forEach((e) => i(e, "prev"))
      }
      function u() {
        let { nextEl: e, prevEl: s } = t.navigation
        ;(e = r(e)), (s = r(s))
        const a = (e, s) => {
          e.removeEventListener("click", "next" === s ? c : d),
            e.classList.remove(...t.params.navigation.disabledClass.split(" "))
        }
        e.forEach((e) => a(e, "next")), s.forEach((e) => a(e, "prev"))
      }
      a("init", () => {
        !1 === t.params.navigation.enabled ? m() : (p(), o())
      }),
        a("toEdge fromEdge lock unlock", () => {
          o()
        }),
        a("destroy", () => {
          u()
        }),
        a("enable disable", () => {
          let { nextEl: e, prevEl: s } = t.navigation
          ;(e = r(e)),
            (s = r(s)),
            t.enabled
              ? o()
              : [...e, ...s].filter((e) => !!e).forEach((e) => e.classList.add(t.params.navigation.lockClass))
        }),
        a("click", (e, s) => {
          let { nextEl: a, prevEl: n } = t.navigation
          ;(a = r(a)), (n = r(n))
          const l = s.target
          if (t.params.navigation.hideOnClick && !n.includes(l) && !a.includes(l)) {
            if (
              t.pagination &&
              t.params.pagination &&
              t.params.pagination.clickable &&
              (t.pagination.el === l || t.pagination.el.contains(l))
            )
              return
            let e
            a.length
              ? (e = a[0].classList.contains(t.params.navigation.hiddenClass))
              : n.length && (e = n[0].classList.contains(t.params.navigation.hiddenClass)),
              i(!0 === e ? "navigationShow" : "navigationHide"),
              [...a, ...n].filter((e) => !!e).forEach((e) => e.classList.toggle(t.params.navigation.hiddenClass))
          }
        })
      const m = () => {
        t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")), u()
      }
      Object.assign(t.navigation, {
        enable: () => {
          t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")), p(), o()
        },
        disable: m,
        update: o,
        init: p,
        destroy: u,
      })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a, emit: i } = e
      const r = "swiper-pagination"
      let n
      s({
        pagination: {
          el: null,
          bulletElement: "span",
          clickable: !1,
          hideOnClick: !1,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: !1,
          type: "bullets",
          dynamicBullets: !1,
          dynamicMainBullets: 1,
          formatFractionCurrent: (e) => e,
          formatFractionTotal: (e) => e,
          bulletClass: `${r}-bullet`,
          bulletActiveClass: `${r}-bullet-active`,
          modifierClass: `${r}-`,
          currentClass: `${r}-current`,
          totalClass: `${r}-total`,
          hiddenClass: `${r}-hidden`,
          progressbarFillClass: `${r}-progressbar-fill`,
          progressbarOppositeClass: `${r}-progressbar-opposite`,
          clickableClass: `${r}-clickable`,
          lockClass: `${r}-lock`,
          horizontalClass: `${r}-horizontal`,
          verticalClass: `${r}-vertical`,
          paginationDisabledClass: `${r}-disabled`,
        },
      }),
        (t.pagination = { el: null, bullets: [] })
      let l = 0
      const o = (e) => (Array.isArray(e) ? e : [e]).filter((e) => !!e)
      function d() {
        return (
          !t.params.pagination.el ||
          !t.pagination.el ||
          (Array.isArray(t.pagination.el) && 0 === t.pagination.el.length)
        )
      }
      function c(e, s) {
        const { bulletActiveClass: a } = t.params.pagination
        e &&
          (e = e[("prev" === s ? "previous" : "next") + "ElementSibling"]) &&
          (e.classList.add(`${a}-${s}`),
          (e = e[("prev" === s ? "previous" : "next") + "ElementSibling"]) && e.classList.add(`${a}-${s}-${s}`))
      }
      function p(e) {
        const s = e.target.closest(ee(t.params.pagination.bulletClass))
        if (!s) return
        e.preventDefault()
        const a = w(s) * t.params.slidesPerGroup
        if (t.params.loop) {
          if (t.realIndex === a) return
          const e = t.realIndex,
            s = t.getSlideIndexByData(a),
            i = t.getSlideIndexByData(t.realIndex),
            r = (a) => {
              const i = t.activeIndex
              t.loopFix({ direction: a, activeSlideIndex: s, slideTo: !1 })
              i === t.activeIndex && t.slideToLoop(e, 0, !1, !0)
            }
          if (s > t.slides.length - t.loopedSlides) r(s > i ? "next" : "prev")
          else if (t.params.centeredSlides) {
            const e =
              "auto" === t.params.slidesPerView
                ? t.slidesPerViewDynamic()
                : Math.ceil(parseFloat(t.params.slidesPerView, 10))
            s < Math.floor(e / 2) && r("prev")
          }
          t.slideToLoop(a)
        } else t.slideTo(a)
      }
      function u() {
        const e = t.rtl,
          s = t.params.pagination
        if (d()) return
        let a,
          r,
          p = t.pagination.el
        p = o(p)
        const u = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
          m = t.params.loop ? Math.ceil(u / t.params.slidesPerGroup) : t.snapGrid.length
        if (
          (t.params.loop
            ? ((r = t.previousRealIndex || 0),
              (a = t.params.slidesPerGroup > 1 ? Math.floor(t.realIndex / t.params.slidesPerGroup) : t.realIndex))
            : void 0 !== t.snapIndex
              ? ((a = t.snapIndex), (r = t.previousSnapIndex))
              : ((r = t.previousIndex || 0), (a = t.activeIndex || 0)),
          "bullets" === s.type && t.pagination.bullets && t.pagination.bullets.length > 0)
        ) {
          const i = t.pagination.bullets
          let o, d, u
          if (
            (s.dynamicBullets &&
              ((n = E(i[0], t.isHorizontal() ? "width" : "height", !0)),
              p.forEach((e) => {
                e.style[t.isHorizontal() ? "width" : "height"] = n * (s.dynamicMainBullets + 4) + "px"
              }),
              s.dynamicMainBullets > 1 &&
                void 0 !== r &&
                ((l += a - (r || 0)), l > s.dynamicMainBullets - 1 ? (l = s.dynamicMainBullets - 1) : l < 0 && (l = 0)),
              (o = Math.max(a - l, 0)),
              (d = o + (Math.min(i.length, s.dynamicMainBullets) - 1)),
              (u = (d + o) / 2)),
            i.forEach((e) => {
              const t = [
                ...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((e) => `${s.bulletActiveClass}${e}`),
              ]
                .map((e) => ("string" == typeof e && e.includes(" ") ? e.split(" ") : e))
                .flat()
              e.classList.remove(...t)
            }),
            p.length > 1)
          )
            i.forEach((e) => {
              const i = w(e)
              i === a
                ? e.classList.add(...s.bulletActiveClass.split(" "))
                : t.isElement && e.setAttribute("part", "bullet"),
                s.dynamicBullets &&
                  (i >= o && i <= d && e.classList.add(...`${s.bulletActiveClass}-main`.split(" ")),
                  i === o && c(e, "prev"),
                  i === d && c(e, "next"))
            })
          else {
            const e = i[a]
            if (
              (e && e.classList.add(...s.bulletActiveClass.split(" ")),
              t.isElement &&
                i.forEach((e, t) => {
                  e.setAttribute("part", t === a ? "bullet-active" : "bullet")
                }),
              s.dynamicBullets)
            ) {
              const e = i[o],
                t = i[d]
              for (let e = o; e <= d; e += 1) i[e] && i[e].classList.add(...`${s.bulletActiveClass}-main`.split(" "))
              c(e, "prev"), c(t, "next")
            }
          }
          if (s.dynamicBullets) {
            const a = Math.min(i.length, s.dynamicMainBullets + 4),
              r = (n * a - n) / 2 - u * n,
              l = e ? "right" : "left"
            i.forEach((e) => {
              e.style[t.isHorizontal() ? l : "top"] = `${r}px`
            })
          }
        }
        p.forEach((e, r) => {
          if (
            ("fraction" === s.type &&
              (e.querySelectorAll(ee(s.currentClass)).forEach((e) => {
                e.textContent = s.formatFractionCurrent(a + 1)
              }),
              e.querySelectorAll(ee(s.totalClass)).forEach((e) => {
                e.textContent = s.formatFractionTotal(m)
              })),
            "progressbar" === s.type)
          ) {
            let i
            i = s.progressbarOpposite
              ? t.isHorizontal()
                ? "vertical"
                : "horizontal"
              : t.isHorizontal()
                ? "horizontal"
                : "vertical"
            const r = (a + 1) / m
            let n = 1,
              l = 1
            "horizontal" === i ? (n = r) : (l = r),
              e.querySelectorAll(ee(s.progressbarFillClass)).forEach((e) => {
                ;(e.style.transform = `translate3d(0,0,0) scaleX(${n}) scaleY(${l})`),
                  (e.style.transitionDuration = `${t.params.speed}ms`)
              })
          }
          "custom" === s.type && s.renderCustom
            ? ((e.innerHTML = s.renderCustom(t, a + 1, m)), 0 === r && i("paginationRender", e))
            : (0 === r && i("paginationRender", e), i("paginationUpdate", e)),
            t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](s.lockClass)
        })
      }
      function m() {
        const e = t.params.pagination
        if (d()) return
        const s = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length
        let a = t.pagination.el
        a = o(a)
        let r = ""
        if ("bullets" === e.type) {
          let a = t.params.loop ? Math.ceil(s / t.params.slidesPerGroup) : t.snapGrid.length
          t.params.freeMode && t.params.freeMode.enabled && a > s && (a = s)
          for (let s = 0; s < a; s += 1)
            e.renderBullet
              ? (r += e.renderBullet.call(t, s, e.bulletClass))
              : (r += `<${e.bulletElement} ${t.isElement ? 'part="bullet"' : ""} class="${e.bulletClass}"></${e.bulletElement}>`)
        }
        "fraction" === e.type &&
          (r = e.renderFraction
            ? e.renderFraction.call(t, e.currentClass, e.totalClass)
            : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
          "progressbar" === e.type &&
            (r = e.renderProgressbar
              ? e.renderProgressbar.call(t, e.progressbarFillClass)
              : `<span class="${e.progressbarFillClass}"></span>`),
          (t.pagination.bullets = []),
          a.forEach((s) => {
            "custom" !== e.type && (s.innerHTML = r || ""),
              "bullets" === e.type && t.pagination.bullets.push(...s.querySelectorAll(ee(e.bulletClass)))
          }),
          "custom" !== e.type && i("paginationRender", a[0])
      }
      function h() {
        t.params.pagination = J(t, t.originalParams.pagination, t.params.pagination, { el: "swiper-pagination" })
        const e = t.params.pagination
        if (!e.el) return
        let s
        "string" == typeof e.el && t.isElement && (s = t.el.querySelector(e.el)),
          s || "string" != typeof e.el || (s = [...document.querySelectorAll(e.el)]),
          s || (s = e.el),
          s &&
            0 !== s.length &&
            (t.params.uniqueNavElements &&
              "string" == typeof e.el &&
              Array.isArray(s) &&
              s.length > 1 &&
              ((s = [...t.el.querySelectorAll(e.el)]),
              s.length > 1 && (s = s.filter((e) => b(e, ".swiper")[0] === t.el)[0])),
            Array.isArray(s) && 1 === s.length && (s = s[0]),
            Object.assign(t.pagination, { el: s }),
            (s = o(s)),
            s.forEach((s) => {
              "bullets" === e.type && e.clickable && s.classList.add(...(e.clickableClass || "").split(" ")),
                s.classList.add(e.modifierClass + e.type),
                s.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
                "bullets" === e.type &&
                  e.dynamicBullets &&
                  (s.classList.add(`${e.modifierClass}${e.type}-dynamic`),
                  (l = 0),
                  e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
                "progressbar" === e.type && e.progressbarOpposite && s.classList.add(e.progressbarOppositeClass),
                e.clickable && s.addEventListener("click", p),
                t.enabled || s.classList.add(e.lockClass)
            }))
      }
      function f() {
        const e = t.params.pagination
        if (d()) return
        let s = t.pagination.el
        s &&
          ((s = o(s)),
          s.forEach((s) => {
            s.classList.remove(e.hiddenClass),
              s.classList.remove(e.modifierClass + e.type),
              s.classList.remove(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
              e.clickable &&
                (s.classList.remove(...(e.clickableClass || "").split(" ")), s.removeEventListener("click", p))
          })),
          t.pagination.bullets &&
            t.pagination.bullets.forEach((t) => t.classList.remove(...e.bulletActiveClass.split(" ")))
      }
      a("changeDirection", () => {
        if (!t.pagination || !t.pagination.el) return
        const e = t.params.pagination
        let { el: s } = t.pagination
        ;(s = o(s)),
          s.forEach((s) => {
            s.classList.remove(e.horizontalClass, e.verticalClass),
              s.classList.add(t.isHorizontal() ? e.horizontalClass : e.verticalClass)
          })
      }),
        a("init", () => {
          !1 === t.params.pagination.enabled ? g() : (h(), m(), u())
        }),
        a("activeIndexChange", () => {
          void 0 === t.snapIndex && u()
        }),
        a("snapIndexChange", () => {
          u()
        }),
        a("snapGridLengthChange", () => {
          m(), u()
        }),
        a("destroy", () => {
          f()
        }),
        a("enable disable", () => {
          let { el: e } = t.pagination
          e && ((e = o(e)), e.forEach((e) => e.classList[t.enabled ? "remove" : "add"](t.params.pagination.lockClass)))
        }),
        a("lock unlock", () => {
          u()
        }),
        a("click", (e, s) => {
          const a = s.target,
            r = o(t.pagination.el)
          if (
            t.params.pagination.el &&
            t.params.pagination.hideOnClick &&
            r &&
            r.length > 0 &&
            !a.classList.contains(t.params.pagination.bulletClass)
          ) {
            if (
              t.navigation &&
              ((t.navigation.nextEl && a === t.navigation.nextEl) || (t.navigation.prevEl && a === t.navigation.prevEl))
            )
              return
            const e = r[0].classList.contains(t.params.pagination.hiddenClass)
            i(!0 === e ? "paginationShow" : "paginationHide"),
              r.forEach((e) => e.classList.toggle(t.params.pagination.hiddenClass))
          }
        })
      const g = () => {
        t.el.classList.add(t.params.pagination.paginationDisabledClass)
        let { el: e } = t.pagination
        e && ((e = o(e)), e.forEach((e) => e.classList.add(t.params.pagination.paginationDisabledClass))), f()
      }
      Object.assign(t.pagination, {
        enable: () => {
          t.el.classList.remove(t.params.pagination.paginationDisabledClass)
          let { el: e } = t.pagination
          e && ((e = o(e)), e.forEach((e) => e.classList.remove(t.params.pagination.paginationDisabledClass))),
            h(),
            m(),
            u()
        },
        disable: g,
        render: m,
        update: u,
        init: h,
        destroy: f,
      })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i, emit: r } = e
      const l = a()
      let o,
        d,
        c,
        p,
        u = !1,
        m = null,
        h = null
      function v() {
        if (!t.params.scrollbar.el || !t.scrollbar.el) return
        const { scrollbar: e, rtlTranslate: s } = t,
          { dragEl: a, el: i } = e,
          r = t.params.scrollbar,
          n = t.params.loop ? t.progressLoop : t.progress
        let l = d,
          o = (c - d) * n
        s
          ? ((o = -o), o > 0 ? ((l = d - o), (o = 0)) : -o + d > c && (l = c + o))
          : o < 0
            ? ((l = d + o), (o = 0))
            : o + d > c && (l = c - o),
          t.isHorizontal()
            ? ((a.style.transform = `translate3d(${o}px, 0, 0)`), (a.style.width = `${l}px`))
            : ((a.style.transform = `translate3d(0px, ${o}px, 0)`), (a.style.height = `${l}px`)),
          r.hide &&
            (clearTimeout(m),
            (i.style.opacity = 1),
            (m = setTimeout(() => {
              ;(i.style.opacity = 0), (i.style.transitionDuration = "400ms")
            }, 1e3)))
      }
      function w() {
        if (!t.params.scrollbar.el || !t.scrollbar.el) return
        const { scrollbar: e } = t,
          { dragEl: s, el: a } = e
        ;(s.style.width = ""),
          (s.style.height = ""),
          (c = t.isHorizontal() ? a.offsetWidth : a.offsetHeight),
          (p = t.size / (t.virtualSize + t.params.slidesOffsetBefore - (t.params.centeredSlides ? t.snapGrid[0] : 0))),
          (d = "auto" === t.params.scrollbar.dragSize ? c * p : parseInt(t.params.scrollbar.dragSize, 10)),
          t.isHorizontal() ? (s.style.width = `${d}px`) : (s.style.height = `${d}px`),
          (a.style.display = p >= 1 ? "none" : ""),
          t.params.scrollbar.hide && (a.style.opacity = 0),
          t.params.watchOverflow &&
            t.enabled &&
            e.el.classList[t.isLocked ? "add" : "remove"](t.params.scrollbar.lockClass)
      }
      function b(e) {
        return t.isHorizontal() ? e.clientX : e.clientY
      }
      function y(e) {
        const { scrollbar: s, rtlTranslate: a } = t,
          { el: i } = s
        let r
        ;(r = (b(e) - g(i)[t.isHorizontal() ? "left" : "top"] - (null !== o ? o : d / 2)) / (c - d)),
          (r = Math.max(Math.min(r, 1), 0)),
          a && (r = 1 - r)
        const n = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * r
        t.updateProgress(n), t.setTranslate(n), t.updateActiveIndex(), t.updateSlidesClasses()
      }
      function E(e) {
        const s = t.params.scrollbar,
          { scrollbar: a, wrapperEl: i } = t,
          { el: n, dragEl: l } = a
        ;(u = !0),
          (o = e.target === l ? b(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null),
          e.preventDefault(),
          e.stopPropagation(),
          (i.style.transitionDuration = "100ms"),
          (l.style.transitionDuration = "100ms"),
          y(e),
          clearTimeout(h),
          (n.style.transitionDuration = "0ms"),
          s.hide && (n.style.opacity = 1),
          t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "none"),
          r("scrollbarDragStart", e)
      }
      function x(e) {
        const { scrollbar: s, wrapperEl: a } = t,
          { el: i, dragEl: n } = s
        u &&
          (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
          y(e),
          (a.style.transitionDuration = "0ms"),
          (i.style.transitionDuration = "0ms"),
          (n.style.transitionDuration = "0ms"),
          r("scrollbarDragMove", e))
      }
      function S(e) {
        const s = t.params.scrollbar,
          { scrollbar: a, wrapperEl: i } = t,
          { el: l } = a
        u &&
          ((u = !1),
          t.params.cssMode && ((t.wrapperEl.style["scroll-snap-type"] = ""), (i.style.transitionDuration = "")),
          s.hide &&
            (clearTimeout(h),
            (h = n(() => {
              ;(l.style.opacity = 0), (l.style.transitionDuration = "400ms")
            }, 1e3))),
          r("scrollbarDragEnd", e),
          s.snapOnRelease && t.slideToClosest())
      }
      function T(e) {
        const { scrollbar: s, params: a } = t,
          i = s.el
        if (!i) return
        const r = i,
          n = !!a.passiveListeners && { passive: !1, capture: !1 },
          o = !!a.passiveListeners && { passive: !0, capture: !1 }
        if (!r) return
        const d = "on" === e ? "addEventListener" : "removeEventListener"
        r[d]("pointerdown", E, n), l[d]("pointermove", x, n), l[d]("pointerup", S, o)
      }
      function M() {
        const { scrollbar: e, el: s } = t
        t.params.scrollbar = J(t, t.originalParams.scrollbar, t.params.scrollbar, { el: "swiper-scrollbar" })
        const a = t.params.scrollbar
        if (!a.el) return
        let i, r
        "string" == typeof a.el && t.isElement && (i = t.el.querySelector(a.el)),
          i || "string" != typeof a.el ? i || (i = a.el) : (i = l.querySelectorAll(a.el)),
          t.params.uniqueNavElements &&
            "string" == typeof a.el &&
            i.length > 1 &&
            1 === s.querySelectorAll(a.el).length &&
            (i = s.querySelector(a.el)),
          i.length > 0 && (i = i[0]),
          i.classList.add(t.isHorizontal() ? a.horizontalClass : a.verticalClass),
          i &&
            ((r = i.querySelector(`.${t.params.scrollbar.dragClass}`)),
            r || ((r = f("div", t.params.scrollbar.dragClass)), i.append(r))),
          Object.assign(e, { el: i, dragEl: r }),
          a.draggable && t.params.scrollbar.el && t.scrollbar.el && T("on"),
          i && i.classList[t.enabled ? "remove" : "add"](t.params.scrollbar.lockClass)
      }
      function C() {
        const e = t.params.scrollbar,
          s = t.scrollbar.el
        s && s.classList.remove(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
          t.params.scrollbar.el && t.scrollbar.el && T("off")
      }
      s({
        scrollbar: {
          el: null,
          dragSize: "auto",
          hide: !1,
          draggable: !1,
          snapOnRelease: !0,
          lockClass: "swiper-scrollbar-lock",
          dragClass: "swiper-scrollbar-drag",
          scrollbarDisabledClass: "swiper-scrollbar-disabled",
          horizontalClass: "swiper-scrollbar-horizontal",
          verticalClass: "swiper-scrollbar-vertical",
        },
      }),
        (t.scrollbar = { el: null, dragEl: null }),
        i("init", () => {
          !1 === t.params.scrollbar.enabled ? P() : (M(), w(), v())
        }),
        i("update resize observerUpdate lock unlock", () => {
          w()
        }),
        i("setTranslate", () => {
          v()
        }),
        i("setTransition", (e, s) => {
          !(function (e) {
            t.params.scrollbar.el && t.scrollbar.el && (t.scrollbar.dragEl.style.transitionDuration = `${e}ms`)
          })(s)
        }),
        i("enable disable", () => {
          const { el: e } = t.scrollbar
          e && e.classList[t.enabled ? "remove" : "add"](t.params.scrollbar.lockClass)
        }),
        i("destroy", () => {
          C()
        })
      const P = () => {
        t.el.classList.add(t.params.scrollbar.scrollbarDisabledClass),
          t.scrollbar.el && t.scrollbar.el.classList.add(t.params.scrollbar.scrollbarDisabledClass),
          C()
      }
      Object.assign(t.scrollbar, {
        enable: () => {
          t.el.classList.remove(t.params.scrollbar.scrollbarDisabledClass),
            t.scrollbar.el && t.scrollbar.el.classList.remove(t.params.scrollbar.scrollbarDisabledClass),
            M(),
            w(),
            v()
        },
        disable: P,
        updateSize: w,
        setTranslate: v,
        init: M,
        destroy: C,
      })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e
      s({ parallax: { enabled: !1 } })
      const i =
          "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]",
        r = (e, s) => {
          const { rtl: a } = t,
            i = a ? -1 : 1,
            r = e.getAttribute("data-swiper-parallax") || "0"
          let n = e.getAttribute("data-swiper-parallax-x"),
            l = e.getAttribute("data-swiper-parallax-y")
          const o = e.getAttribute("data-swiper-parallax-scale"),
            d = e.getAttribute("data-swiper-parallax-opacity"),
            c = e.getAttribute("data-swiper-parallax-rotate")
          if (
            (n || l ? ((n = n || "0"), (l = l || "0")) : t.isHorizontal() ? ((n = r), (l = "0")) : ((l = r), (n = "0")),
            (n = n.indexOf("%") >= 0 ? parseInt(n, 10) * s * i + "%" : n * s * i + "px"),
            (l = l.indexOf("%") >= 0 ? parseInt(l, 10) * s + "%" : l * s + "px"),
            null != d)
          ) {
            const t = d - (d - 1) * (1 - Math.abs(s))
            e.style.opacity = t
          }
          let p = `translate3d(${n}, ${l}, 0px)`
          if (null != o) {
            p += ` scale(${o - (o - 1) * (1 - Math.abs(s))})`
          }
          if (c && null != c) {
            p += ` rotate(${c * s * -1}deg)`
          }
          e.style.transform = p
        },
        n = () => {
          const { el: e, slides: s, progress: a, snapGrid: n, isElement: l } = t,
            o = h(e, i)
          t.isElement && o.push(...h(t.hostEl, i)),
            o.forEach((e) => {
              r(e, a)
            }),
            s.forEach((e, s) => {
              let l = e.progress
              t.params.slidesPerGroup > 1 &&
                "auto" !== t.params.slidesPerView &&
                (l += Math.ceil(s / 2) - a * (n.length - 1)),
                (l = Math.min(Math.max(l, -1), 1)),
                e.querySelectorAll(`${i}, [data-swiper-parallax-rotate]`).forEach((e) => {
                  r(e, l)
                })
            })
        }
      a("beforeInit", () => {
        t.params.parallax.enabled && ((t.params.watchSlidesProgress = !0), (t.originalParams.watchSlidesProgress = !0))
      }),
        a("init", () => {
          t.params.parallax.enabled && n()
        }),
        a("setTranslate", () => {
          t.params.parallax.enabled && n()
        }),
        a("setTransition", (e, s) => {
          t.params.parallax.enabled &&
            (function (e) {
              void 0 === e && (e = t.params.speed)
              const { el: s, hostEl: a } = t,
                r = [...s.querySelectorAll(i)]
              t.isElement && r.push(...a.querySelectorAll(i)),
                r.forEach((t) => {
                  let s = parseInt(t.getAttribute("data-swiper-parallax-duration"), 10) || e
                  0 === e && (s = 0), (t.style.transitionDuration = `${s}ms`)
                })
            })(s)
        })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a, emit: i } = e
      const n = r()
      s({
        zoom: {
          enabled: !1,
          maxRatio: 3,
          minRatio: 1,
          toggle: !0,
          containerClass: "swiper-zoom-container",
          zoomedSlideClass: "swiper-slide-zoomed",
        },
      }),
        (t.zoom = { enabled: !1 })
      let l,
        d,
        c = 1,
        p = !1
      const u = [],
        m = {
          originX: 0,
          originY: 0,
          slideEl: void 0,
          slideWidth: void 0,
          slideHeight: void 0,
          imageEl: void 0,
          imageWrapEl: void 0,
          maxRatio: 3,
        },
        f = {
          isTouched: void 0,
          isMoved: void 0,
          currentX: void 0,
          currentY: void 0,
          minX: void 0,
          minY: void 0,
          maxX: void 0,
          maxY: void 0,
          width: void 0,
          height: void 0,
          startX: void 0,
          startY: void 0,
          touchesStart: {},
          touchesCurrent: {},
        },
        v = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 }
      let w = 1
      function y() {
        if (u.length < 2) return 1
        const e = u[0].pageX,
          t = u[0].pageY,
          s = u[1].pageX,
          a = u[1].pageY
        return Math.sqrt((s - e) ** 2 + (a - t) ** 2)
      }
      function E(e) {
        const s = t.isElement ? "swiper-slide" : `.${t.params.slideClass}`
        return !!e.target.matches(s) || t.slides.filter((t) => t.contains(e.target)).length > 0
      }
      function x(e) {
        if (("mouse" === e.pointerType && u.splice(0, u.length), !E(e))) return
        const s = t.params.zoom
        if (((l = !1), (d = !1), u.push(e), !(u.length < 2))) {
          if (((l = !0), (m.scaleStart = y()), !m.slideEl)) {
            ;(m.slideEl = e.target.closest(`.${t.params.slideClass}, swiper-slide`)),
              m.slideEl || (m.slideEl = t.slides[t.activeIndex])
            let a = m.slideEl.querySelector(`.${s.containerClass}`)
            if (
              (a && (a = a.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),
              (m.imageEl = a),
              (m.imageWrapEl = a ? b(m.imageEl, `.${s.containerClass}`)[0] : void 0),
              !m.imageWrapEl)
            )
              return void (m.imageEl = void 0)
            m.maxRatio = m.imageWrapEl.getAttribute("data-swiper-zoom") || s.maxRatio
          }
          if (m.imageEl) {
            const [e, t] = (function () {
              if (u.length < 2) return { x: null, y: null }
              const e = m.imageEl.getBoundingClientRect()
              return [
                (u[0].pageX + (u[1].pageX - u[0].pageX) / 2 - e.x - n.scrollX) / c,
                (u[0].pageY + (u[1].pageY - u[0].pageY) / 2 - e.y - n.scrollY) / c,
              ]
            })()
            ;(m.originX = e), (m.originY = t), (m.imageEl.style.transitionDuration = "0ms")
          }
          p = !0
        }
      }
      function S(e) {
        if (!E(e)) return
        const s = t.params.zoom,
          a = t.zoom,
          i = u.findIndex((t) => t.pointerId === e.pointerId)
        i >= 0 && (u[i] = e),
          u.length < 2 ||
            ((d = !0),
            (m.scaleMove = y()),
            m.imageEl &&
              ((a.scale = (m.scaleMove / m.scaleStart) * c),
              a.scale > m.maxRatio && (a.scale = m.maxRatio - 1 + (a.scale - m.maxRatio + 1) ** 0.5),
              a.scale < s.minRatio && (a.scale = s.minRatio + 1 - (s.minRatio - a.scale + 1) ** 0.5),
              (m.imageEl.style.transform = `translate3d(0,0,0) scale(${a.scale})`)))
      }
      function T(e) {
        if (!E(e)) return
        if ("mouse" === e.pointerType && "pointerout" === e.type) return
        const s = t.params.zoom,
          a = t.zoom,
          i = u.findIndex((t) => t.pointerId === e.pointerId)
        i >= 0 && u.splice(i, 1),
          l &&
            d &&
            ((l = !1),
            (d = !1),
            m.imageEl &&
              ((a.scale = Math.max(Math.min(a.scale, m.maxRatio), s.minRatio)),
              (m.imageEl.style.transitionDuration = `${t.params.speed}ms`),
              (m.imageEl.style.transform = `translate3d(0,0,0) scale(${a.scale})`),
              (c = a.scale),
              (p = !1),
              a.scale > 1 && m.slideEl
                ? m.slideEl.classList.add(`${s.zoomedSlideClass}`)
                : a.scale <= 1 && m.slideEl && m.slideEl.classList.remove(`${s.zoomedSlideClass}`),
              1 === a.scale && ((m.originX = 0), (m.originY = 0), (m.slideEl = void 0))))
      }
      function M(e) {
        if (
          !E(e) ||
          !(function (e) {
            const s = `.${t.params.zoom.containerClass}`
            return (
              !!e.target.matches(s) || [...t.hostEl.querySelectorAll(s)].filter((t) => t.contains(e.target)).length > 0
            )
          })(e)
        )
          return
        const s = t.zoom
        if (!m.imageEl) return
        if (!f.isTouched || !m.slideEl) return
        f.isMoved ||
          ((f.width = m.imageEl.offsetWidth),
          (f.height = m.imageEl.offsetHeight),
          (f.startX = o(m.imageWrapEl, "x") || 0),
          (f.startY = o(m.imageWrapEl, "y") || 0),
          (m.slideWidth = m.slideEl.offsetWidth),
          (m.slideHeight = m.slideEl.offsetHeight),
          (m.imageWrapEl.style.transitionDuration = "0ms"))
        const a = f.width * s.scale,
          i = f.height * s.scale
        if (a < m.slideWidth && i < m.slideHeight) return
        ;(f.minX = Math.min(m.slideWidth / 2 - a / 2, 0)),
          (f.maxX = -f.minX),
          (f.minY = Math.min(m.slideHeight / 2 - i / 2, 0)),
          (f.maxY = -f.minY),
          (f.touchesCurrent.x = u.length > 0 ? u[0].pageX : e.pageX),
          (f.touchesCurrent.y = u.length > 0 ? u[0].pageY : e.pageY)
        if (
          (Math.max(Math.abs(f.touchesCurrent.x - f.touchesStart.x), Math.abs(f.touchesCurrent.y - f.touchesStart.y)) >
            5 && (t.allowClick = !1),
          !f.isMoved && !p)
        ) {
          if (
            t.isHorizontal() &&
            ((Math.floor(f.minX) === Math.floor(f.startX) && f.touchesCurrent.x < f.touchesStart.x) ||
              (Math.floor(f.maxX) === Math.floor(f.startX) && f.touchesCurrent.x > f.touchesStart.x))
          )
            return void (f.isTouched = !1)
          if (
            !t.isHorizontal() &&
            ((Math.floor(f.minY) === Math.floor(f.startY) && f.touchesCurrent.y < f.touchesStart.y) ||
              (Math.floor(f.maxY) === Math.floor(f.startY) && f.touchesCurrent.y > f.touchesStart.y))
          )
            return void (f.isTouched = !1)
        }
        e.cancelable && e.preventDefault(), e.stopPropagation(), (f.isMoved = !0)
        const r = (s.scale - c) / (m.maxRatio - t.params.zoom.minRatio),
          { originX: n, originY: l } = m
        ;(f.currentX = f.touchesCurrent.x - f.touchesStart.x + f.startX + r * (f.width - 2 * n)),
          (f.currentY = f.touchesCurrent.y - f.touchesStart.y + f.startY + r * (f.height - 2 * l)),
          f.currentX < f.minX && (f.currentX = f.minX + 1 - (f.minX - f.currentX + 1) ** 0.8),
          f.currentX > f.maxX && (f.currentX = f.maxX - 1 + (f.currentX - f.maxX + 1) ** 0.8),
          f.currentY < f.minY && (f.currentY = f.minY + 1 - (f.minY - f.currentY + 1) ** 0.8),
          f.currentY > f.maxY && (f.currentY = f.maxY - 1 + (f.currentY - f.maxY + 1) ** 0.8),
          v.prevPositionX || (v.prevPositionX = f.touchesCurrent.x),
          v.prevPositionY || (v.prevPositionY = f.touchesCurrent.y),
          v.prevTime || (v.prevTime = Date.now()),
          (v.x = (f.touchesCurrent.x - v.prevPositionX) / (Date.now() - v.prevTime) / 2),
          (v.y = (f.touchesCurrent.y - v.prevPositionY) / (Date.now() - v.prevTime) / 2),
          Math.abs(f.touchesCurrent.x - v.prevPositionX) < 2 && (v.x = 0),
          Math.abs(f.touchesCurrent.y - v.prevPositionY) < 2 && (v.y = 0),
          (v.prevPositionX = f.touchesCurrent.x),
          (v.prevPositionY = f.touchesCurrent.y),
          (v.prevTime = Date.now()),
          (m.imageWrapEl.style.transform = `translate3d(${f.currentX}px, ${f.currentY}px,0)`)
      }
      function C() {
        const e = t.zoom
        m.slideEl &&
          t.activeIndex !== t.slides.indexOf(m.slideEl) &&
          (m.imageEl && (m.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
          m.imageWrapEl && (m.imageWrapEl.style.transform = "translate3d(0,0,0)"),
          m.slideEl.classList.remove(`${t.params.zoom.zoomedSlideClass}`),
          (e.scale = 1),
          (c = 1),
          (m.slideEl = void 0),
          (m.imageEl = void 0),
          (m.imageWrapEl = void 0),
          (m.originX = 0),
          (m.originY = 0))
      }
      function P(e) {
        const s = t.zoom,
          a = t.params.zoom
        if (!m.slideEl) {
          e && e.target && (m.slideEl = e.target.closest(`.${t.params.slideClass}, swiper-slide`)),
            m.slideEl ||
              (t.params.virtual && t.params.virtual.enabled && t.virtual
                ? (m.slideEl = h(t.slidesEl, `.${t.params.slideActiveClass}`)[0])
                : (m.slideEl = t.slides[t.activeIndex]))
          let s = m.slideEl.querySelector(`.${a.containerClass}`)
          s && (s = s.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),
            (m.imageEl = s),
            (m.imageWrapEl = s ? b(m.imageEl, `.${a.containerClass}`)[0] : void 0)
        }
        if (!m.imageEl || !m.imageWrapEl) return
        let i, r, l, o, d, p, u, v, w, y, E, x, S, T, M, C, P, L
        t.params.cssMode && ((t.wrapperEl.style.overflow = "hidden"), (t.wrapperEl.style.touchAction = "none")),
          m.slideEl.classList.add(`${a.zoomedSlideClass}`),
          void 0 === f.touchesStart.x && e
            ? ((i = e.pageX), (r = e.pageY))
            : ((i = f.touchesStart.x), (r = f.touchesStart.y))
        const z = "number" == typeof e ? e : null
        1 === c && z && ((i = void 0), (r = void 0)),
          (s.scale = z || m.imageWrapEl.getAttribute("data-swiper-zoom") || a.maxRatio),
          (c = z || m.imageWrapEl.getAttribute("data-swiper-zoom") || a.maxRatio),
          !e || (1 === c && z)
            ? ((u = 0), (v = 0))
            : ((P = m.slideEl.offsetWidth),
              (L = m.slideEl.offsetHeight),
              (l = g(m.slideEl).left + n.scrollX),
              (o = g(m.slideEl).top + n.scrollY),
              (d = l + P / 2 - i),
              (p = o + L / 2 - r),
              (w = m.imageEl.offsetWidth),
              (y = m.imageEl.offsetHeight),
              (E = w * s.scale),
              (x = y * s.scale),
              (S = Math.min(P / 2 - E / 2, 0)),
              (T = Math.min(L / 2 - x / 2, 0)),
              (M = -S),
              (C = -T),
              (u = d * s.scale),
              (v = p * s.scale),
              u < S && (u = S),
              u > M && (u = M),
              v < T && (v = T),
              v > C && (v = C)),
          z && 1 === s.scale && ((m.originX = 0), (m.originY = 0)),
          (m.imageWrapEl.style.transitionDuration = "300ms"),
          (m.imageWrapEl.style.transform = `translate3d(${u}px, ${v}px,0)`),
          (m.imageEl.style.transitionDuration = "300ms"),
          (m.imageEl.style.transform = `translate3d(0,0,0) scale(${s.scale})`)
      }
      function L() {
        const e = t.zoom,
          s = t.params.zoom
        if (!m.slideEl) {
          t.params.virtual && t.params.virtual.enabled && t.virtual
            ? (m.slideEl = h(t.slidesEl, `.${t.params.slideActiveClass}`)[0])
            : (m.slideEl = t.slides[t.activeIndex])
          let e = m.slideEl.querySelector(`.${s.containerClass}`)
          e && (e = e.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),
            (m.imageEl = e),
            (m.imageWrapEl = e ? b(m.imageEl, `.${s.containerClass}`)[0] : void 0)
        }
        m.imageEl &&
          m.imageWrapEl &&
          (t.params.cssMode && ((t.wrapperEl.style.overflow = ""), (t.wrapperEl.style.touchAction = "")),
          (e.scale = 1),
          (c = 1),
          (m.imageWrapEl.style.transitionDuration = "300ms"),
          (m.imageWrapEl.style.transform = "translate3d(0,0,0)"),
          (m.imageEl.style.transitionDuration = "300ms"),
          (m.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
          m.slideEl.classList.remove(`${s.zoomedSlideClass}`),
          (m.slideEl = void 0),
          (m.originX = 0),
          (m.originY = 0))
      }
      function z(e) {
        const s = t.zoom
        s.scale && 1 !== s.scale ? L() : P(e)
      }
      function A() {
        return {
          passiveListener: !!t.params.passiveListeners && { passive: !0, capture: !1 },
          activeListenerWithCapture: !t.params.passiveListeners || { passive: !1, capture: !0 },
        }
      }
      function $() {
        const e = t.zoom
        if (e.enabled) return
        e.enabled = !0
        const { passiveListener: s, activeListenerWithCapture: a } = A()
        t.wrapperEl.addEventListener("pointerdown", x, s),
          t.wrapperEl.addEventListener("pointermove", S, a),
          ["pointerup", "pointercancel", "pointerout"].forEach((e) => {
            t.wrapperEl.addEventListener(e, T, s)
          }),
          t.wrapperEl.addEventListener("pointermove", M, a)
      }
      function I() {
        const e = t.zoom
        if (!e.enabled) return
        e.enabled = !1
        const { passiveListener: s, activeListenerWithCapture: a } = A()
        t.wrapperEl.removeEventListener("pointerdown", x, s),
          t.wrapperEl.removeEventListener("pointermove", S, a),
          ["pointerup", "pointercancel", "pointerout"].forEach((e) => {
            t.wrapperEl.removeEventListener(e, T, s)
          }),
          t.wrapperEl.removeEventListener("pointermove", M, a)
      }
      Object.defineProperty(t.zoom, "scale", {
        get: () => w,
        set(e) {
          if (w !== e) {
            const t = m.imageEl,
              s = m.slideEl
            i("zoomChange", e, t, s)
          }
          w = e
        },
      }),
        a("init", () => {
          t.params.zoom.enabled && $()
        }),
        a("destroy", () => {
          I()
        }),
        a("touchStart", (e, s) => {
          t.zoom.enabled &&
            (function (e) {
              const s = t.device
              if (!m.imageEl) return
              if (f.isTouched) return
              s.android && e.cancelable && e.preventDefault(), (f.isTouched = !0)
              const a = u.length > 0 ? u[0] : e
              ;(f.touchesStart.x = a.pageX), (f.touchesStart.y = a.pageY)
            })(s)
        }),
        a("touchEnd", (e, s) => {
          t.zoom.enabled &&
            (function () {
              const e = t.zoom
              if (!m.imageEl) return
              if (!f.isTouched || !f.isMoved) return (f.isTouched = !1), void (f.isMoved = !1)
              ;(f.isTouched = !1), (f.isMoved = !1)
              let s = 300,
                a = 300
              const i = v.x * s,
                r = f.currentX + i,
                n = v.y * a,
                l = f.currentY + n
              0 !== v.x && (s = Math.abs((r - f.currentX) / v.x)), 0 !== v.y && (a = Math.abs((l - f.currentY) / v.y))
              const o = Math.max(s, a)
              ;(f.currentX = r), (f.currentY = l)
              const d = f.width * e.scale,
                c = f.height * e.scale
              ;(f.minX = Math.min(m.slideWidth / 2 - d / 2, 0)),
                (f.maxX = -f.minX),
                (f.minY = Math.min(m.slideHeight / 2 - c / 2, 0)),
                (f.maxY = -f.minY),
                (f.currentX = Math.max(Math.min(f.currentX, f.maxX), f.minX)),
                (f.currentY = Math.max(Math.min(f.currentY, f.maxY), f.minY)),
                (m.imageWrapEl.style.transitionDuration = `${o}ms`),
                (m.imageWrapEl.style.transform = `translate3d(${f.currentX}px, ${f.currentY}px,0)`)
            })()
        }),
        a("doubleTap", (e, s) => {
          !t.animating && t.params.zoom.enabled && t.zoom.enabled && t.params.zoom.toggle && z(s)
        }),
        a("transitionEnd", () => {
          t.zoom.enabled && t.params.zoom.enabled && C()
        }),
        a("slideChange", () => {
          t.zoom.enabled && t.params.zoom.enabled && t.params.cssMode && C()
        }),
        Object.assign(t.zoom, { enable: $, disable: I, in: P, out: L, toggle: z })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e
      function i(e, t) {
        const s = (function () {
          let e, t, s
          return (a, i) => {
            for (t = -1, e = a.length; e - t > 1; ) (s = (e + t) >> 1), a[s] <= i ? (t = s) : (e = s)
            return e
          }
        })()
        let a, i
        return (
          (this.x = e),
          (this.y = t),
          (this.lastIndex = e.length - 1),
          (this.interpolate = function (e) {
            return e
              ? ((i = s(this.x, e)),
                (a = i - 1),
                ((e - this.x[a]) * (this.y[i] - this.y[a])) / (this.x[i] - this.x[a]) + this.y[a])
              : 0
          }),
          this
        )
      }
      function r() {
        t.controller.control && t.controller.spline && ((t.controller.spline = void 0), delete t.controller.spline)
      }
      s({ controller: { control: void 0, inverse: !1, by: "slide" } }),
        (t.controller = { control: void 0 }),
        a("beforeInit", () => {
          if (
            "undefined" != typeof window &&
            ("string" == typeof t.params.controller.control || t.params.controller.control instanceof HTMLElement)
          ) {
            const e = document.querySelector(t.params.controller.control)
            if (e && e.swiper) t.controller.control = e.swiper
            else if (e) {
              const s = (a) => {
                ;(t.controller.control = a.detail[0]), t.update(), e.removeEventListener("init", s)
              }
              e.addEventListener("init", s)
            }
          } else t.controller.control = t.params.controller.control
        }),
        a("update", () => {
          r()
        }),
        a("resize", () => {
          r()
        }),
        a("observerUpdate", () => {
          r()
        }),
        a("setTranslate", (e, s, a) => {
          t.controller.control && !t.controller.control.destroyed && t.controller.setTranslate(s, a)
        }),
        a("setTransition", (e, s, a) => {
          t.controller.control && !t.controller.control.destroyed && t.controller.setTransition(s, a)
        }),
        Object.assign(t.controller, {
          setTranslate: function (e, s) {
            const a = t.controller.control
            let r, n
            const l = t.constructor
            function o(e) {
              if (e.destroyed) return
              const s = t.rtlTranslate ? -t.translate : t.translate
              "slide" === t.params.controller.by &&
                (!(function (e) {
                  t.controller.spline = t.params.loop
                    ? new i(t.slidesGrid, e.slidesGrid)
                    : new i(t.snapGrid, e.snapGrid)
                })(e),
                (n = -t.controller.spline.interpolate(-s))),
                (n && "container" !== t.params.controller.by) ||
                  ((r = (e.maxTranslate() - e.minTranslate()) / (t.maxTranslate() - t.minTranslate())),
                  (!Number.isNaN(r) && Number.isFinite(r)) || (r = 1),
                  (n = (s - t.minTranslate()) * r + e.minTranslate())),
                t.params.controller.inverse && (n = e.maxTranslate() - n),
                e.updateProgress(n),
                e.setTranslate(n, t),
                e.updateActiveIndex(),
                e.updateSlidesClasses()
            }
            if (Array.isArray(a)) for (let e = 0; e < a.length; e += 1) a[e] !== s && a[e] instanceof l && o(a[e])
            else a instanceof l && s !== a && o(a)
          },
          setTransition: function (e, s) {
            const a = t.constructor,
              i = t.controller.control
            let r
            function l(s) {
              s.destroyed ||
                (s.setTransition(e, t),
                0 !== e &&
                  (s.transitionStart(),
                  s.params.autoHeight &&
                    n(() => {
                      s.updateAutoHeight()
                    }),
                  y(s.wrapperEl, () => {
                    i && s.transitionEnd()
                  })))
            }
            if (Array.isArray(i)) for (r = 0; r < i.length; r += 1) i[r] !== s && i[r] instanceof a && l(i[r])
            else i instanceof a && s !== i && l(i)
          },
        })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e
      s({
        a11y: {
          enabled: !0,
          notificationClass: "swiper-notification",
          prevSlideMessage: "Previous slide",
          nextSlideMessage: "Next slide",
          firstSlideMessage: "This is the first slide",
          lastSlideMessage: "This is the last slide",
          paginationBulletMessage: "Go to slide {{index}}",
          slideLabelMessage: "{{index}} / {{slidesLength}}",
          containerMessage: null,
          containerRoleDescriptionMessage: null,
          itemRoleDescriptionMessage: null,
          slideRole: "group",
          id: null,
        },
      }),
        (t.a11y = { clicked: !1 })
      let i = null
      function r(e) {
        const t = i
        0 !== t.length && ((t.innerHTML = ""), (t.innerHTML = e))
      }
      const n = (e) => (Array.isArray(e) ? e : [e]).filter((e) => !!e)
      function l(e) {
        ;(e = n(e)).forEach((e) => {
          e.setAttribute("tabIndex", "0")
        })
      }
      function o(e) {
        ;(e = n(e)).forEach((e) => {
          e.setAttribute("tabIndex", "-1")
        })
      }
      function d(e, t) {
        ;(e = n(e)).forEach((e) => {
          e.setAttribute("role", t)
        })
      }
      function c(e, t) {
        ;(e = n(e)).forEach((e) => {
          e.setAttribute("aria-roledescription", t)
        })
      }
      function p(e, t) {
        ;(e = n(e)).forEach((e) => {
          e.setAttribute("aria-label", t)
        })
      }
      function u(e) {
        ;(e = n(e)).forEach((e) => {
          e.setAttribute("aria-disabled", !0)
        })
      }
      function m(e) {
        ;(e = n(e)).forEach((e) => {
          e.setAttribute("aria-disabled", !1)
        })
      }
      function h(e) {
        if (13 !== e.keyCode && 32 !== e.keyCode) return
        const s = t.params.a11y,
          a = e.target
        ;(t.pagination &&
          t.pagination.el &&
          (a === t.pagination.el || t.pagination.el.contains(e.target)) &&
          !e.target.matches(ee(t.params.pagination.bulletClass))) ||
          (t.navigation &&
            t.navigation.nextEl &&
            a === t.navigation.nextEl &&
            ((t.isEnd && !t.params.loop) || t.slideNext(), t.isEnd ? r(s.lastSlideMessage) : r(s.nextSlideMessage)),
          t.navigation &&
            t.navigation.prevEl &&
            a === t.navigation.prevEl &&
            ((t.isBeginning && !t.params.loop) || t.slidePrev(),
            t.isBeginning ? r(s.firstSlideMessage) : r(s.prevSlideMessage)),
          t.pagination && a.matches(ee(t.params.pagination.bulletClass)) && a.click())
      }
      function g() {
        return t.pagination && t.pagination.bullets && t.pagination.bullets.length
      }
      function v() {
        return g() && t.params.pagination.clickable
      }
      const b = (e, t, s) => {
          l(e),
            "BUTTON" !== e.tagName && (d(e, "button"), e.addEventListener("keydown", h)),
            p(e, s),
            (function (e, t) {
              ;(e = n(e)).forEach((e) => {
                e.setAttribute("aria-controls", t)
              })
            })(e, t)
        },
        y = () => {
          t.a11y.clicked = !0
        },
        E = () => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              t.destroyed || (t.a11y.clicked = !1)
            })
          })
        },
        x = (e) => {
          if (t.a11y.clicked) return
          const s = e.target.closest(`.${t.params.slideClass}, swiper-slide`)
          if (!s || !t.slides.includes(s)) return
          const a = t.slides.indexOf(s) === t.activeIndex,
            i = t.params.watchSlidesProgress && t.visibleSlides && t.visibleSlides.includes(s)
          a ||
            i ||
            (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) ||
            (t.isHorizontal() ? (t.el.scrollLeft = 0) : (t.el.scrollTop = 0), t.slideTo(t.slides.indexOf(s), 0))
        },
        S = () => {
          const e = t.params.a11y
          e.itemRoleDescriptionMessage && c(t.slides, e.itemRoleDescriptionMessage),
            e.slideRole && d(t.slides, e.slideRole)
          const s = t.slides.length
          e.slideLabelMessage &&
            t.slides.forEach((a, i) => {
              const r = t.params.loop ? parseInt(a.getAttribute("data-swiper-slide-index"), 10) : i
              p(a, e.slideLabelMessage.replace(/\{\{index\}\}/, r + 1).replace(/\{\{slidesLength\}\}/, s))
            })
        },
        T = () => {
          const e = t.params.a11y
          t.el.append(i)
          const s = t.el
          e.containerRoleDescriptionMessage && c(s, e.containerRoleDescriptionMessage),
            e.containerMessage && p(s, e.containerMessage)
          const a = t.wrapperEl,
            r =
              e.id ||
              a.getAttribute("id") ||
              `swiper-wrapper-${((l = 16), void 0 === l && (l = 16), "x".repeat(l).replace(/x/g, () => Math.round(16 * Math.random()).toString(16)))}`
          var l
          const o = t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite"
          var d
          ;(d = r),
            n(a).forEach((e) => {
              e.setAttribute("id", d)
            }),
            (function (e, t) {
              ;(e = n(e)).forEach((e) => {
                e.setAttribute("aria-live", t)
              })
            })(a, o),
            S()
          let { nextEl: u, prevEl: m } = t.navigation ? t.navigation : {}
          if (
            ((u = n(u)),
            (m = n(m)),
            u && u.forEach((t) => b(t, r, e.nextSlideMessage)),
            m && m.forEach((t) => b(t, r, e.prevSlideMessage)),
            v())
          ) {
            ;(Array.isArray(t.pagination.el) ? t.pagination.el : [t.pagination.el]).forEach((e) => {
              e.addEventListener("keydown", h)
            })
          }
          t.el.addEventListener("focus", x, !0),
            t.el.addEventListener("pointerdown", y, !0),
            t.el.addEventListener("pointerup", E, !0)
        }
      a("beforeInit", () => {
        ;(i = f("span", t.params.a11y.notificationClass)),
          i.setAttribute("aria-live", "assertive"),
          i.setAttribute("aria-atomic", "true")
      }),
        a("afterInit", () => {
          t.params.a11y.enabled && T()
        }),
        a("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
          t.params.a11y.enabled && S()
        }),
        a("fromEdge toEdge afterInit lock unlock", () => {
          t.params.a11y.enabled &&
            (function () {
              if (t.params.loop || t.params.rewind || !t.navigation) return
              const { nextEl: e, prevEl: s } = t.navigation
              s && (t.isBeginning ? (u(s), o(s)) : (m(s), l(s))), e && (t.isEnd ? (u(e), o(e)) : (m(e), l(e)))
            })()
        }),
        a("paginationUpdate", () => {
          t.params.a11y.enabled &&
            (function () {
              const e = t.params.a11y
              g() &&
                t.pagination.bullets.forEach((s) => {
                  t.params.pagination.clickable &&
                    (l(s),
                    t.params.pagination.renderBullet ||
                      (d(s, "button"), p(s, e.paginationBulletMessage.replace(/\{\{index\}\}/, w(s) + 1)))),
                    s.matches(ee(t.params.pagination.bulletActiveClass))
                      ? s.setAttribute("aria-current", "true")
                      : s.removeAttribute("aria-current")
                })
            })()
        }),
        a("destroy", () => {
          t.params.a11y.enabled &&
            (function () {
              i && i.remove()
              let { nextEl: e, prevEl: s } = t.navigation ? t.navigation : {}
              ;(e = n(e)),
                (s = n(s)),
                e && e.forEach((e) => e.removeEventListener("keydown", h)),
                s && s.forEach((e) => e.removeEventListener("keydown", h)),
                v() &&
                  (Array.isArray(t.pagination.el) ? t.pagination.el : [t.pagination.el]).forEach((e) => {
                    e.removeEventListener("keydown", h)
                  })
              t.el.removeEventListener("focus", x, !0),
                t.el.removeEventListener("pointerdown", y, !0),
                t.el.removeEventListener("pointerup", E, !0)
            })()
        })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e
      s({ history: { enabled: !1, root: "", replaceState: !1, key: "slides", keepQuery: !1 } })
      let i = !1,
        n = {}
      const l = (e) =>
          e
            .toString()
            .replace(/\s+/g, "-")
            .replace(/[^\w-]+/g, "")
            .replace(/--+/g, "-")
            .replace(/^-+/, "")
            .replace(/-+$/, ""),
        o = (e) => {
          const t = r()
          let s
          s = e ? new URL(e) : t.location
          const a = s.pathname
              .slice(1)
              .split("/")
              .filter((e) => "" !== e),
            i = a.length
          return { key: a[i - 2], value: a[i - 1] }
        },
        d = (e, s) => {
          const a = r()
          if (!i || !t.params.history.enabled) return
          let n
          n = t.params.url ? new URL(t.params.url) : a.location
          const o = t.slides[s]
          let d = l(o.getAttribute("data-history"))
          if (t.params.history.root.length > 0) {
            let s = t.params.history.root
            "/" === s[s.length - 1] && (s = s.slice(0, s.length - 1)), (d = `${s}/${e ? `${e}/` : ""}${d}`)
          } else n.pathname.includes(e) || (d = `${e ? `${e}/` : ""}${d}`)
          t.params.history.keepQuery && (d += n.search)
          const c = a.history.state
          ;(c && c.value === d) ||
            (t.params.history.replaceState
              ? a.history.replaceState({ value: d }, null, d)
              : a.history.pushState({ value: d }, null, d))
        },
        c = (e, s, a) => {
          if (s)
            for (let i = 0, r = t.slides.length; i < r; i += 1) {
              const r = t.slides[i]
              if (l(r.getAttribute("data-history")) === s) {
                const s = t.getSlideIndex(r)
                t.slideTo(s, e, a)
              }
            }
          else t.slideTo(0, e, a)
        },
        p = () => {
          ;(n = o(t.params.url)), c(t.params.speed, n.value, !1)
        }
      a("init", () => {
        t.params.history.enabled &&
          (() => {
            const e = r()
            if (t.params.history) {
              if (!e.history || !e.history.pushState)
                return (t.params.history.enabled = !1), void (t.params.hashNavigation.enabled = !0)
              ;(i = !0),
                (n = o(t.params.url)),
                n.key || n.value
                  ? (c(0, n.value, t.params.runCallbacksOnInit),
                    t.params.history.replaceState || e.addEventListener("popstate", p))
                  : t.params.history.replaceState || e.addEventListener("popstate", p)
            }
          })()
      }),
        a("destroy", () => {
          t.params.history.enabled &&
            (() => {
              const e = r()
              t.params.history.replaceState || e.removeEventListener("popstate", p)
            })()
        }),
        a("transitionEnd _freeModeNoMomentumRelease", () => {
          i && d(t.params.history.key, t.activeIndex)
        }),
        a("slideChange", () => {
          i && t.params.cssMode && d(t.params.history.key, t.activeIndex)
        })
    },
    function (e) {
      let { swiper: t, extendParams: s, emit: i, on: n } = e,
        l = !1
      const o = a(),
        d = r()
      s({
        hashNavigation: {
          enabled: !1,
          replaceState: !1,
          watchState: !1,
          getSlideIndex(e, s) {
            if (t.virtual && t.params.virtual.enabled) {
              const e = t.slides.filter((e) => e.getAttribute("data-hash") === s)[0]
              if (!e) return 0
              return parseInt(e.getAttribute("data-swiper-slide-index"), 10)
            }
            return t.getSlideIndex(
              h(t.slidesEl, `.${t.params.slideClass}[data-hash="${s}"], swiper-slide[data-hash="${s}"]`)[0],
            )
          },
        },
      })
      const c = () => {
          i("hashChange")
          const e = o.location.hash.replace("#", ""),
            s =
              t.virtual && t.params.virtual.enabled
                ? t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`)
                : t.slides[t.activeIndex]
          if (e !== (s ? s.getAttribute("data-hash") : "")) {
            const s = t.params.hashNavigation.getSlideIndex(t, e)
            if (void 0 === s || Number.isNaN(s)) return
            t.slideTo(s)
          }
        },
        p = () => {
          if (!l || !t.params.hashNavigation.enabled) return
          const e =
              t.virtual && t.params.virtual.enabled
                ? t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`)
                : t.slides[t.activeIndex],
            s = e ? e.getAttribute("data-hash") || e.getAttribute("data-history") : ""
          t.params.hashNavigation.replaceState && d.history && d.history.replaceState
            ? (d.history.replaceState(null, null, `#${s}` || ""), i("hashSet"))
            : ((o.location.hash = s || ""), i("hashSet"))
        }
      n("init", () => {
        t.params.hashNavigation.enabled &&
          (() => {
            if (!t.params.hashNavigation.enabled || (t.params.history && t.params.history.enabled)) return
            l = !0
            const e = o.location.hash.replace("#", "")
            if (e) {
              const s = 0,
                a = t.params.hashNavigation.getSlideIndex(t, e)
              t.slideTo(a || 0, s, t.params.runCallbacksOnInit, !0)
            }
            t.params.hashNavigation.watchState && d.addEventListener("hashchange", c)
          })()
      }),
        n("destroy", () => {
          t.params.hashNavigation.enabled &&
            t.params.hashNavigation.watchState &&
            d.removeEventListener("hashchange", c)
        }),
        n("transitionEnd _freeModeNoMomentumRelease", () => {
          l && p()
        }),
        n("slideChange", () => {
          l && t.params.cssMode && p()
        })
    },
    function (e) {
      let t,
        s,
        { swiper: i, extendParams: r, on: n, emit: l, params: o } = e
      ;(i.autoplay = { running: !1, paused: !1, timeLeft: 0 }),
        r({
          autoplay: {
            enabled: !1,
            delay: 3e3,
            waitForTransition: !0,
            disableOnInteraction: !0,
            stopOnLastSlide: !1,
            reverseDirection: !1,
            pauseOnMouseEnter: !1,
          },
        })
      let d,
        c,
        p,
        u,
        m,
        h,
        f,
        g = o && o.autoplay ? o.autoplay.delay : 3e3,
        v = o && o.autoplay ? o.autoplay.delay : 3e3,
        w = new Date().getTime
      function b(e) {
        i &&
          !i.destroyed &&
          i.wrapperEl &&
          e.target === i.wrapperEl &&
          (i.wrapperEl.removeEventListener("transitionend", b), M())
      }
      const y = () => {
          if (i.destroyed || !i.autoplay.running) return
          i.autoplay.paused ? (c = !0) : c && ((v = d), (c = !1))
          const e = i.autoplay.paused ? d : w + v - new Date().getTime()
          ;(i.autoplay.timeLeft = e),
            l("autoplayTimeLeft", e, e / g),
            (s = requestAnimationFrame(() => {
              y()
            }))
        },
        E = (e) => {
          if (i.destroyed || !i.autoplay.running) return
          cancelAnimationFrame(s), y()
          let a = void 0 === e ? i.params.autoplay.delay : e
          ;(g = i.params.autoplay.delay), (v = i.params.autoplay.delay)
          const r = (() => {
            let e
            if (
              ((e =
                i.virtual && i.params.virtual.enabled
                  ? i.slides.filter((e) => e.classList.contains("swiper-slide-active"))[0]
                  : i.slides[i.activeIndex]),
              !e)
            )
              return
            return parseInt(e.getAttribute("data-swiper-autoplay"), 10)
          })()
          !Number.isNaN(r) && r > 0 && void 0 === e && ((a = r), (g = r), (v = r)), (d = a)
          const n = i.params.speed,
            o = () => {
              i &&
                !i.destroyed &&
                (i.params.autoplay.reverseDirection
                  ? !i.isBeginning || i.params.loop || i.params.rewind
                    ? (i.slidePrev(n, !0, !0), l("autoplay"))
                    : i.params.autoplay.stopOnLastSlide || (i.slideTo(i.slides.length - 1, n, !0, !0), l("autoplay"))
                  : !i.isEnd || i.params.loop || i.params.rewind
                    ? (i.slideNext(n, !0, !0), l("autoplay"))
                    : i.params.autoplay.stopOnLastSlide || (i.slideTo(0, n, !0, !0), l("autoplay")),
                i.params.cssMode &&
                  ((w = new Date().getTime()),
                  requestAnimationFrame(() => {
                    E()
                  })))
            }
          return (
            a > 0
              ? (clearTimeout(t),
                (t = setTimeout(() => {
                  o()
                }, a)))
              : requestAnimationFrame(() => {
                  o()
                }),
            a
          )
        },
        x = () => {
          ;(i.autoplay.running = !0), E(), l("autoplayStart")
        },
        S = () => {
          ;(i.autoplay.running = !1), clearTimeout(t), cancelAnimationFrame(s), l("autoplayStop")
        },
        T = (e, s) => {
          if (i.destroyed || !i.autoplay.running) return
          clearTimeout(t), e || (f = !0)
          const a = () => {
            l("autoplayPause"),
              i.params.autoplay.waitForTransition ? i.wrapperEl.addEventListener("transitionend", b) : M()
          }
          if (((i.autoplay.paused = !0), s)) return h && (d = i.params.autoplay.delay), (h = !1), void a()
          const r = d || i.params.autoplay.delay
          ;(d = r - (new Date().getTime() - w)), (i.isEnd && d < 0 && !i.params.loop) || (d < 0 && (d = 0), a())
        },
        M = () => {
          ;(i.isEnd && d < 0 && !i.params.loop) ||
            i.destroyed ||
            !i.autoplay.running ||
            ((w = new Date().getTime()), f ? ((f = !1), E(d)) : E(), (i.autoplay.paused = !1), l("autoplayResume"))
        },
        C = () => {
          if (i.destroyed || !i.autoplay.running) return
          const e = a()
          "hidden" === e.visibilityState && ((f = !0), T(!0)), "visible" === e.visibilityState && M()
        },
        P = (e) => {
          "mouse" === e.pointerType && ((f = !0), i.animating || i.autoplay.paused || T(!0))
        },
        L = (e) => {
          "mouse" === e.pointerType && i.autoplay.paused && M()
        }
      n("init", () => {
        i.params.autoplay.enabled &&
          (i.params.autoplay.pauseOnMouseEnter &&
            (i.el.addEventListener("pointerenter", P), i.el.addEventListener("pointerleave", L)),
          a().addEventListener("visibilitychange", C),
          (w = new Date().getTime()),
          x())
      }),
        n("destroy", () => {
          i.el.removeEventListener("pointerenter", P),
            i.el.removeEventListener("pointerleave", L),
            a().removeEventListener("visibilitychange", C),
            i.autoplay.running && S()
        }),
        n("beforeTransitionStart", (e, t, s) => {
          !i.destroyed && i.autoplay.running && (s || !i.params.autoplay.disableOnInteraction ? T(!0, !0) : S())
        }),
        n("sliderFirstMove", () => {
          !i.destroyed &&
            i.autoplay.running &&
            (i.params.autoplay.disableOnInteraction
              ? S()
              : ((p = !0),
                (u = !1),
                (f = !1),
                (m = setTimeout(() => {
                  ;(f = !0), (u = !0), T(!0)
                }, 200))))
        }),
        n("touchEnd", () => {
          if (!i.destroyed && i.autoplay.running && p) {
            if ((clearTimeout(m), clearTimeout(t), i.params.autoplay.disableOnInteraction))
              return (u = !1), void (p = !1)
            u && i.params.cssMode && M(), (u = !1), (p = !1)
          }
        }),
        n("slideChange", () => {
          !i.destroyed && i.autoplay.running && (h = !0)
        }),
        Object.assign(i.autoplay, { start: x, stop: S, pause: T, resume: M })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e
      s({
        thumbs: {
          swiper: null,
          multipleActiveThumbs: !0,
          autoScrollOffset: 0,
          slideThumbActiveClass: "swiper-slide-thumb-active",
          thumbsContainerClass: "swiper-thumbs",
        },
      })
      let r = !1,
        n = !1
      function l() {
        const e = t.thumbs.swiper
        if (!e || e.destroyed) return
        const s = e.clickedIndex,
          a = e.clickedSlide
        if (a && a.classList.contains(t.params.thumbs.slideThumbActiveClass)) return
        if (null == s) return
        let i
        ;(i = e.params.loop ? parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : s),
          t.params.loop ? t.slideToLoop(i) : t.slideTo(i)
      }
      function o() {
        const { thumbs: e } = t.params
        if (r) return !1
        r = !0
        const s = t.constructor
        if (e.swiper instanceof s)
          (t.thumbs.swiper = e.swiper),
            Object.assign(t.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
            Object.assign(t.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
            t.thumbs.swiper.update()
        else if (d(e.swiper)) {
          const a = Object.assign({}, e.swiper)
          Object.assign(a, { watchSlidesProgress: !0, slideToClickedSlide: !1 }), (t.thumbs.swiper = new s(a)), (n = !0)
        }
        return t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass), t.thumbs.swiper.on("tap", l), !0
      }
      function c(e) {
        const s = t.thumbs.swiper
        if (!s || s.destroyed) return
        const a = "auto" === s.params.slidesPerView ? s.slidesPerViewDynamic() : s.params.slidesPerView
        let i = 1
        const r = t.params.thumbs.slideThumbActiveClass
        if (
          (t.params.slidesPerView > 1 && !t.params.centeredSlides && (i = t.params.slidesPerView),
          t.params.thumbs.multipleActiveThumbs || (i = 1),
          (i = Math.floor(i)),
          s.slides.forEach((e) => e.classList.remove(r)),
          s.params.loop || (s.params.virtual && s.params.virtual.enabled))
        )
          for (let e = 0; e < i; e += 1)
            h(s.slidesEl, `[data-swiper-slide-index="${t.realIndex + e}"]`).forEach((e) => {
              e.classList.add(r)
            })
        else for (let e = 0; e < i; e += 1) s.slides[t.realIndex + e] && s.slides[t.realIndex + e].classList.add(r)
        const n = t.params.thumbs.autoScrollOffset,
          l = n && !s.params.loop
        if (t.realIndex !== s.realIndex || l) {
          const i = s.activeIndex
          let r, o
          if (s.params.loop) {
            const e = s.slides.filter((e) => e.getAttribute("data-swiper-slide-index") === `${t.realIndex}`)[0]
            ;(r = s.slides.indexOf(e)), (o = t.activeIndex > t.previousIndex ? "next" : "prev")
          } else (r = t.realIndex), (o = r > t.previousIndex ? "next" : "prev")
          l && (r += "next" === o ? n : -1 * n),
            s.visibleSlidesIndexes &&
              s.visibleSlidesIndexes.indexOf(r) < 0 &&
              (s.params.centeredSlides
                ? (r = r > i ? r - Math.floor(a / 2) + 1 : r + Math.floor(a / 2) - 1)
                : r > i && s.params.slidesPerGroup,
              s.slideTo(r, e ? 0 : void 0))
        }
      }
      ;(t.thumbs = { swiper: null }),
        i("beforeInit", () => {
          const { thumbs: e } = t.params
          if (e && e.swiper)
            if ("string" == typeof e.swiper || e.swiper instanceof HTMLElement) {
              const s = a(),
                i = () => {
                  const a = "string" == typeof e.swiper ? s.querySelector(e.swiper) : e.swiper
                  if (a && a.swiper) (e.swiper = a.swiper), o(), c(!0)
                  else if (a) {
                    const s = (i) => {
                      ;(e.swiper = i.detail[0]),
                        a.removeEventListener("init", s),
                        o(),
                        c(!0),
                        e.swiper.update(),
                        t.update()
                    }
                    a.addEventListener("init", s)
                  }
                  return a
                },
                r = () => {
                  if (t.destroyed) return
                  i() || requestAnimationFrame(r)
                }
              requestAnimationFrame(r)
            } else o(), c(!0)
        }),
        i("slideChange update resize observerUpdate", () => {
          c()
        }),
        i("setTransition", (e, s) => {
          const a = t.thumbs.swiper
          a && !a.destroyed && a.setTransition(s)
        }),
        i("beforeDestroy", () => {
          const e = t.thumbs.swiper
          e && !e.destroyed && n && e.destroy()
        }),
        Object.assign(t.thumbs, { init: o, update: c })
    },
    function (e) {
      let { swiper: t, extendParams: s, emit: a, once: i } = e
      s({
        freeMode: {
          enabled: !1,
          momentum: !0,
          momentumRatio: 1,
          momentumBounce: !0,
          momentumBounceRatio: 1,
          momentumVelocityRatio: 1,
          sticky: !1,
          minimumVelocity: 0.02,
        },
      }),
        Object.assign(t, {
          freeMode: {
            onTouchStart: function () {
              if (t.params.cssMode) return
              const e = t.getTranslate()
              t.setTranslate(e),
                t.setTransition(0),
                (t.touchEventsData.velocities.length = 0),
                t.freeMode.onTouchEnd({ currentPos: t.rtl ? t.translate : -t.translate })
            },
            onTouchMove: function () {
              if (t.params.cssMode) return
              const { touchEventsData: e, touches: s } = t
              0 === e.velocities.length &&
                e.velocities.push({ position: s[t.isHorizontal() ? "startX" : "startY"], time: e.touchStartTime }),
                e.velocities.push({ position: s[t.isHorizontal() ? "currentX" : "currentY"], time: l() })
            },
            onTouchEnd: function (e) {
              let { currentPos: s } = e
              if (t.params.cssMode) return
              const { params: r, wrapperEl: n, rtlTranslate: o, snapGrid: d, touchEventsData: c } = t,
                p = l() - c.touchStartTime
              if (s < -t.minTranslate()) t.slideTo(t.activeIndex)
              else if (s > -t.maxTranslate())
                t.slides.length < d.length ? t.slideTo(d.length - 1) : t.slideTo(t.slides.length - 1)
              else {
                if (r.freeMode.momentum) {
                  if (c.velocities.length > 1) {
                    const e = c.velocities.pop(),
                      s = c.velocities.pop(),
                      a = e.position - s.position,
                      i = e.time - s.time
                    ;(t.velocity = a / i),
                      (t.velocity /= 2),
                      Math.abs(t.velocity) < r.freeMode.minimumVelocity && (t.velocity = 0),
                      (i > 150 || l() - e.time > 300) && (t.velocity = 0)
                  } else t.velocity = 0
                  ;(t.velocity *= r.freeMode.momentumVelocityRatio), (c.velocities.length = 0)
                  let e = 1e3 * r.freeMode.momentumRatio
                  const s = t.velocity * e
                  let p = t.translate + s
                  o && (p = -p)
                  let u,
                    m = !1
                  const h = 20 * Math.abs(t.velocity) * r.freeMode.momentumBounceRatio
                  let f
                  if (p < t.maxTranslate())
                    r.freeMode.momentumBounce
                      ? (p + t.maxTranslate() < -h && (p = t.maxTranslate() - h),
                        (u = t.maxTranslate()),
                        (m = !0),
                        (c.allowMomentumBounce = !0))
                      : (p = t.maxTranslate()),
                      r.loop && r.centeredSlides && (f = !0)
                  else if (p > t.minTranslate())
                    r.freeMode.momentumBounce
                      ? (p - t.minTranslate() > h && (p = t.minTranslate() + h),
                        (u = t.minTranslate()),
                        (m = !0),
                        (c.allowMomentumBounce = !0))
                      : (p = t.minTranslate()),
                      r.loop && r.centeredSlides && (f = !0)
                  else if (r.freeMode.sticky) {
                    let e
                    for (let t = 0; t < d.length; t += 1)
                      if (d[t] > -p) {
                        e = t
                        break
                      }
                    ;(p = Math.abs(d[e] - p) < Math.abs(d[e - 1] - p) || "next" === t.swipeDirection ? d[e] : d[e - 1]),
                      (p = -p)
                  }
                  if (
                    (f &&
                      i("transitionEnd", () => {
                        t.loopFix()
                      }),
                    0 !== t.velocity)
                  ) {
                    if (
                      ((e = o ? Math.abs((-p - t.translate) / t.velocity) : Math.abs((p - t.translate) / t.velocity)),
                      r.freeMode.sticky)
                    ) {
                      const s = Math.abs((o ? -p : p) - t.translate),
                        a = t.slidesSizesGrid[t.activeIndex]
                      e = s < a ? r.speed : s < 2 * a ? 1.5 * r.speed : 2.5 * r.speed
                    }
                  } else if (r.freeMode.sticky) return void t.slideToClosest()
                  r.freeMode.momentumBounce && m
                    ? (t.updateProgress(u),
                      t.setTransition(e),
                      t.setTranslate(p),
                      t.transitionStart(!0, t.swipeDirection),
                      (t.animating = !0),
                      y(n, () => {
                        t &&
                          !t.destroyed &&
                          c.allowMomentumBounce &&
                          (a("momentumBounce"),
                          t.setTransition(r.speed),
                          setTimeout(() => {
                            t.setTranslate(u),
                              y(n, () => {
                                t && !t.destroyed && t.transitionEnd()
                              })
                          }, 0))
                      }))
                    : t.velocity
                      ? (a("_freeModeNoMomentumRelease"),
                        t.updateProgress(p),
                        t.setTransition(e),
                        t.setTranslate(p),
                        t.transitionStart(!0, t.swipeDirection),
                        t.animating ||
                          ((t.animating = !0),
                          y(n, () => {
                            t && !t.destroyed && t.transitionEnd()
                          })))
                      : t.updateProgress(p),
                    t.updateActiveIndex(),
                    t.updateSlidesClasses()
                } else {
                  if (r.freeMode.sticky) return void t.slideToClosest()
                  r.freeMode && a("_freeModeNoMomentumRelease")
                }
                ;(!r.freeMode.momentum || p >= r.longSwipesMs) &&
                  (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses())
              }
            },
          },
        })
    },
    function (e) {
      let t,
        s,
        a,
        i,
        { swiper: r, extendParams: n, on: l } = e
      n({ grid: { rows: 1, fill: "column" } })
      const o = () => {
        let e = r.params.spaceBetween
        return (
          "string" == typeof e && e.indexOf("%") >= 0
            ? (e = (parseFloat(e.replace("%", "")) / 100) * r.size)
            : "string" == typeof e && (e = parseFloat(e)),
          e
        )
      }
      l("init", () => {
        i = r.params.grid && r.params.grid.rows > 1
      }),
        l("update", () => {
          const { params: e, el: t } = r,
            s = e.grid && e.grid.rows > 1
          i && !s
            ? (t.classList.remove(`${e.containerModifierClass}grid`, `${e.containerModifierClass}grid-column`),
              (a = 1),
              r.emitContainerClasses())
            : !i &&
              s &&
              (t.classList.add(`${e.containerModifierClass}grid`),
              "column" === e.grid.fill && t.classList.add(`${e.containerModifierClass}grid-column`),
              r.emitContainerClasses()),
            (i = s)
        }),
        (r.grid = {
          initSlides: (e) => {
            const { slidesPerView: i } = r.params,
              { rows: n, fill: l } = r.params.grid
            ;(a = Math.floor(e / n)),
              (t = Math.floor(e / n) === e / n ? e : Math.ceil(e / n) * n),
              "auto" !== i && "row" === l && (t = Math.max(t, i * n)),
              (s = t / n)
          },
          updateSlide: (e, i, n, l) => {
            const { slidesPerGroup: d } = r.params,
              c = o(),
              { rows: p, fill: u } = r.params.grid
            let m, h, f
            if ("row" === u && d > 1) {
              const s = Math.floor(e / (d * p)),
                a = e - p * d * s,
                r = 0 === s ? d : Math.min(Math.ceil((n - s * p * d) / p), d)
              ;(f = Math.floor(a / r)), (h = a - f * r + s * d), (m = h + (f * t) / p), (i.style.order = m)
            } else
              "column" === u
                ? ((h = Math.floor(e / p)),
                  (f = e - h * p),
                  (h > a || (h === a && f === p - 1)) && ((f += 1), f >= p && ((f = 0), (h += 1))))
                : ((f = Math.floor(e / s)), (h = e - f * s))
            ;(i.row = f), (i.column = h), (i.style[l("margin-top")] = 0 !== f ? c && `${c}px` : "")
          },
          updateWrapperSize: (e, s, a) => {
            const { centeredSlides: i, roundLengths: n } = r.params,
              l = o(),
              { rows: d } = r.params.grid
            if (
              ((r.virtualSize = (e + l) * t),
              (r.virtualSize = Math.ceil(r.virtualSize / d) - l),
              (r.wrapperEl.style[a("width")] = `${r.virtualSize + l}px`),
              i)
            ) {
              const e = []
              for (let t = 0; t < s.length; t += 1) {
                let a = s[t]
                n && (a = Math.floor(a)), s[t] < r.virtualSize + s[0] && e.push(a)
              }
              s.splice(0, s.length), s.push(...e)
            }
          },
        })
    },
    function (e) {
      let { swiper: t } = e
      Object.assign(t, {
        appendSlide: te.bind(t),
        prependSlide: se.bind(t),
        addSlide: ae.bind(t),
        removeSlide: ie.bind(t),
        removeAllSlides: re.bind(t),
      })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e
      s({ fadeEffect: { crossFade: !1 } }),
        ne({
          effect: "fade",
          swiper: t,
          on: a,
          setTranslate: () => {
            const { slides: e } = t
            t.params.fadeEffect
            for (let s = 0; s < e.length; s += 1) {
              const e = t.slides[s]
              let a = -e.swiperSlideOffset
              t.params.virtualTranslate || (a -= t.translate)
              let i = 0
              t.isHorizontal() || ((i = a), (a = 0))
              const r = t.params.fadeEffect.crossFade
                  ? Math.max(1 - Math.abs(e.progress), 0)
                  : 1 + Math.min(Math.max(e.progress, -1), 0),
                n = le(0, e)
              ;(n.style.opacity = r), (n.style.transform = `translate3d(${a}px, ${i}px, 0px)`)
            }
          },
          setTransition: (e) => {
            const s = t.slides.map((e) => m(e))
            s.forEach((t) => {
              t.style.transitionDuration = `${e}ms`
            }),
              oe({ swiper: t, duration: e, transformElements: s, allSlides: !0 })
          },
          overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            spaceBetween: 0,
            virtualTranslate: !t.params.cssMode,
          }),
        })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e
      s({ cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: 0.94 } })
      const i = (e, t, s) => {
        let a = s ? e.querySelector(".swiper-slide-shadow-left") : e.querySelector(".swiper-slide-shadow-top"),
          i = s ? e.querySelector(".swiper-slide-shadow-right") : e.querySelector(".swiper-slide-shadow-bottom")
        a ||
          ((a = f("div", ("swiper-slide-shadow-cube swiper-slide-shadow-" + (s ? "left" : "top")).split(" "))),
          e.append(a)),
          i ||
            ((i = f("div", ("swiper-slide-shadow-cube swiper-slide-shadow-" + (s ? "right" : "bottom")).split(" "))),
            e.append(i)),
          a && (a.style.opacity = Math.max(-t, 0)),
          i && (i.style.opacity = Math.max(t, 0))
      }
      ne({
        effect: "cube",
        swiper: t,
        on: a,
        setTranslate: () => {
          const { el: e, wrapperEl: s, slides: a, width: r, height: n, rtlTranslate: l, size: o, browser: d } = t,
            c = t.params.cubeEffect,
            p = t.isHorizontal(),
            u = t.virtual && t.params.virtual.enabled
          let m,
            h = 0
          c.shadow &&
            (p
              ? ((m = t.wrapperEl.querySelector(".swiper-cube-shadow")),
                m || ((m = f("div", "swiper-cube-shadow")), t.wrapperEl.append(m)),
                (m.style.height = `${r}px`))
              : ((m = e.querySelector(".swiper-cube-shadow")),
                m || ((m = f("div", "swiper-cube-shadow")), e.append(m))))
          for (let e = 0; e < a.length; e += 1) {
            const t = a[e]
            let s = e
            u && (s = parseInt(t.getAttribute("data-swiper-slide-index"), 10))
            let r = 90 * s,
              n = Math.floor(r / 360)
            l && ((r = -r), (n = Math.floor(-r / 360)))
            const d = Math.max(Math.min(t.progress, 1), -1)
            let m = 0,
              f = 0,
              g = 0
            s % 4 == 0
              ? ((m = 4 * -n * o), (g = 0))
              : (s - 1) % 4 == 0
                ? ((m = 0), (g = 4 * -n * o))
                : (s - 2) % 4 == 0
                  ? ((m = o + 4 * n * o), (g = o))
                  : (s - 3) % 4 == 0 && ((m = -o), (g = 3 * o + 4 * o * n)),
              l && (m = -m),
              p || ((f = m), (m = 0))
            const v = `rotateX(${p ? 0 : -r}deg) rotateY(${p ? r : 0}deg) translate3d(${m}px, ${f}px, ${g}px)`
            d <= 1 && d > -1 && ((h = 90 * s + 90 * d), l && (h = 90 * -s - 90 * d)),
              (t.style.transform = v),
              c.slideShadows && i(t, d, p)
          }
          if (
            ((s.style.transformOrigin = `50% 50% -${o / 2}px`),
            (s.style["-webkit-transform-origin"] = `50% 50% -${o / 2}px`),
            c.shadow)
          )
            if (p)
              m.style.transform = `translate3d(0px, ${r / 2 + c.shadowOffset}px, ${-r / 2}px) rotateX(90deg) rotateZ(0deg) scale(${c.shadowScale})`
            else {
              const e = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90),
                t = 1.5 - (Math.sin((2 * e * Math.PI) / 360) / 2 + Math.cos((2 * e * Math.PI) / 360) / 2),
                s = c.shadowScale,
                a = c.shadowScale / t,
                i = c.shadowOffset
              m.style.transform = `scale3d(${s}, 1, ${a}) translate3d(0px, ${n / 2 + i}px, ${-n / 2 / a}px) rotateX(-90deg)`
            }
          const g = (d.isSafari || d.isWebView) && d.needPerspectiveFix ? -o / 2 : 0
          ;(s.style.transform = `translate3d(0px,0,${g}px) rotateX(${t.isHorizontal() ? 0 : h}deg) rotateY(${t.isHorizontal() ? -h : 0}deg)`),
            s.style.setProperty("--swiper-cube-translate-z", `${g}px`)
        },
        setTransition: (e) => {
          const { el: s, slides: a } = t
          if (
            (a.forEach((t) => {
              ;(t.style.transitionDuration = `${e}ms`),
                t
                  .querySelectorAll(
                    ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left",
                  )
                  .forEach((t) => {
                    t.style.transitionDuration = `${e}ms`
                  })
            }),
            t.params.cubeEffect.shadow && !t.isHorizontal())
          ) {
            const t = s.querySelector(".swiper-cube-shadow")
            t && (t.style.transitionDuration = `${e}ms`)
          }
        },
        recreateShadows: () => {
          const e = t.isHorizontal()
          t.slides.forEach((t) => {
            const s = Math.max(Math.min(t.progress, 1), -1)
            i(t, s, e)
          })
        },
        getEffectParams: () => t.params.cubeEffect,
        perspective: () => !0,
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: !0,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: !1,
          virtualTranslate: !0,
        }),
      })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e
      s({ flipEffect: { slideShadows: !0, limitRotation: !0 } })
      const i = (e, s) => {
        let a = t.isHorizontal()
            ? e.querySelector(".swiper-slide-shadow-left")
            : e.querySelector(".swiper-slide-shadow-top"),
          i = t.isHorizontal()
            ? e.querySelector(".swiper-slide-shadow-right")
            : e.querySelector(".swiper-slide-shadow-bottom")
        a || (a = de("flip", e, t.isHorizontal() ? "left" : "top")),
          i || (i = de("flip", e, t.isHorizontal() ? "right" : "bottom")),
          a && (a.style.opacity = Math.max(-s, 0)),
          i && (i.style.opacity = Math.max(s, 0))
      }
      ne({
        effect: "flip",
        swiper: t,
        on: a,
        setTranslate: () => {
          const { slides: e, rtlTranslate: s } = t,
            a = t.params.flipEffect
          for (let r = 0; r < e.length; r += 1) {
            const n = e[r]
            let l = n.progress
            t.params.flipEffect.limitRotation && (l = Math.max(Math.min(n.progress, 1), -1))
            const o = n.swiperSlideOffset
            let d = -180 * l,
              c = 0,
              p = t.params.cssMode ? -o - t.translate : -o,
              u = 0
            t.isHorizontal() ? s && (d = -d) : ((u = p), (p = 0), (c = -d), (d = 0)),
              (n.style.zIndex = -Math.abs(Math.round(l)) + e.length),
              a.slideShadows && i(n, l)
            const m = `translate3d(${p}px, ${u}px, 0px) rotateX(${c}deg) rotateY(${d}deg)`
            le(0, n).style.transform = m
          }
        },
        setTransition: (e) => {
          const s = t.slides.map((e) => m(e))
          s.forEach((t) => {
            ;(t.style.transitionDuration = `${e}ms`),
              t
                .querySelectorAll(
                  ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left",
                )
                .forEach((t) => {
                  t.style.transitionDuration = `${e}ms`
                })
          }),
            oe({ swiper: t, duration: e, transformElements: s })
        },
        recreateShadows: () => {
          t.params.flipEffect,
            t.slides.forEach((e) => {
              let s = e.progress
              t.params.flipEffect.limitRotation && (s = Math.max(Math.min(e.progress, 1), -1)), i(e, s)
            })
        },
        getEffectParams: () => t.params.flipEffect,
        perspective: () => !0,
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: !0,
          spaceBetween: 0,
          virtualTranslate: !t.params.cssMode,
        }),
      })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e
      s({ coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: !0 } }),
        ne({
          effect: "coverflow",
          swiper: t,
          on: a,
          setTranslate: () => {
            const { width: e, height: s, slides: a, slidesSizesGrid: i } = t,
              r = t.params.coverflowEffect,
              n = t.isHorizontal(),
              l = t.translate,
              o = n ? e / 2 - l : s / 2 - l,
              d = n ? r.rotate : -r.rotate,
              c = r.depth
            for (let e = 0, t = a.length; e < t; e += 1) {
              const t = a[e],
                s = i[e],
                l = (o - t.swiperSlideOffset - s / 2) / s,
                p = "function" == typeof r.modifier ? r.modifier(l) : l * r.modifier
              let u = n ? d * p : 0,
                m = n ? 0 : d * p,
                h = -c * Math.abs(p),
                f = r.stretch
              "string" == typeof f && -1 !== f.indexOf("%") && (f = (parseFloat(r.stretch) / 100) * s)
              let g = n ? 0 : f * p,
                v = n ? f * p : 0,
                w = 1 - (1 - r.scale) * Math.abs(p)
              Math.abs(v) < 0.001 && (v = 0),
                Math.abs(g) < 0.001 && (g = 0),
                Math.abs(h) < 0.001 && (h = 0),
                Math.abs(u) < 0.001 && (u = 0),
                Math.abs(m) < 0.001 && (m = 0),
                Math.abs(w) < 0.001 && (w = 0)
              const b = `translate3d(${v}px,${g}px,${h}px)  rotateX(${m}deg) rotateY(${u}deg) scale(${w})`
              if (((le(0, t).style.transform = b), (t.style.zIndex = 1 - Math.abs(Math.round(p))), r.slideShadows)) {
                let e = n ? t.querySelector(".swiper-slide-shadow-left") : t.querySelector(".swiper-slide-shadow-top"),
                  s = n ? t.querySelector(".swiper-slide-shadow-right") : t.querySelector(".swiper-slide-shadow-bottom")
                e || (e = de("coverflow", t, n ? "left" : "top")),
                  s || (s = de("coverflow", t, n ? "right" : "bottom")),
                  e && (e.style.opacity = p > 0 ? p : 0),
                  s && (s.style.opacity = -p > 0 ? -p : 0)
              }
            }
          },
          setTransition: (e) => {
            t.slides
              .map((e) => m(e))
              .forEach((t) => {
                ;(t.style.transitionDuration = `${e}ms`),
                  t
                    .querySelectorAll(
                      ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left",
                    )
                    .forEach((t) => {
                      t.style.transitionDuration = `${e}ms`
                    })
              })
          },
          perspective: () => !0,
          overwriteParams: () => ({ watchSlidesProgress: !0 }),
        })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e
      s({
        creativeEffect: {
          limitProgress: 1,
          shadowPerProgress: !1,
          progressMultiplier: 1,
          perspective: !0,
          prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
          next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
        },
      })
      const i = (e) => ("string" == typeof e ? e : `${e}px`)
      ne({
        effect: "creative",
        swiper: t,
        on: a,
        setTranslate: () => {
          const { slides: e, wrapperEl: s, slidesSizesGrid: a } = t,
            r = t.params.creativeEffect,
            { progressMultiplier: n } = r,
            l = t.params.centeredSlides
          if (l) {
            const e = a[0] / 2 - t.params.slidesOffsetBefore || 0
            s.style.transform = `translateX(calc(50% - ${e}px))`
          }
          for (let s = 0; s < e.length; s += 1) {
            const a = e[s],
              o = a.progress,
              d = Math.min(Math.max(a.progress, -r.limitProgress), r.limitProgress)
            let c = d
            l || (c = Math.min(Math.max(a.originalProgress, -r.limitProgress), r.limitProgress))
            const p = a.swiperSlideOffset,
              u = [t.params.cssMode ? -p - t.translate : -p, 0, 0],
              m = [0, 0, 0]
            let h = !1
            t.isHorizontal() || ((u[1] = u[0]), (u[0] = 0))
            let f = { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 }
            d < 0 ? ((f = r.next), (h = !0)) : d > 0 && ((f = r.prev), (h = !0)),
              u.forEach((e, t) => {
                u[t] = `calc(${e}px + (${i(f.translate[t])} * ${Math.abs(d * n)}))`
              }),
              m.forEach((e, t) => {
                m[t] = f.rotate[t] * Math.abs(d * n)
              }),
              (a.style.zIndex = -Math.abs(Math.round(o)) + e.length)
            const g = u.join(", "),
              v = `rotateX(${m[0]}deg) rotateY(${m[1]}deg) rotateZ(${m[2]}deg)`,
              w = c < 0 ? `scale(${1 + (1 - f.scale) * c * n})` : `scale(${1 - (1 - f.scale) * c * n})`,
              b = c < 0 ? 1 + (1 - f.opacity) * c * n : 1 - (1 - f.opacity) * c * n,
              y = `translate3d(${g}) ${v} ${w}`
            if ((h && f.shadow) || !h) {
              let e = a.querySelector(".swiper-slide-shadow")
              if ((!e && f.shadow && (e = de("creative", a)), e)) {
                const t = r.shadowPerProgress ? d * (1 / r.limitProgress) : d
                e.style.opacity = Math.min(Math.max(Math.abs(t), 0), 1)
              }
            }
            const E = le(0, a)
            ;(E.style.transform = y), (E.style.opacity = b), f.origin && (E.style.transformOrigin = f.origin)
          }
        },
        setTransition: (e) => {
          const s = t.slides.map((e) => m(e))
          s.forEach((t) => {
            ;(t.style.transitionDuration = `${e}ms`),
              t.querySelectorAll(".swiper-slide-shadow").forEach((t) => {
                t.style.transitionDuration = `${e}ms`
              })
          }),
            oe({ swiper: t, duration: e, transformElements: s, allSlides: !0 })
        },
        perspective: () => t.params.creativeEffect.perspective,
        overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !t.params.cssMode }),
      })
    },
    function (e) {
      let { swiper: t, extendParams: s, on: a } = e
      s({ cardsEffect: { slideShadows: !0, rotate: !0, perSlideRotate: 2, perSlideOffset: 8 } }),
        ne({
          effect: "cards",
          swiper: t,
          on: a,
          setTranslate: () => {
            const { slides: e, activeIndex: s, rtlTranslate: a } = t,
              i = t.params.cardsEffect,
              { startTranslate: r, isTouched: n } = t.touchEventsData,
              l = a ? -t.translate : t.translate
            for (let o = 0; o < e.length; o += 1) {
              const d = e[o],
                c = d.progress,
                p = Math.min(Math.max(c, -4), 4)
              let u = d.swiperSlideOffset
              t.params.centeredSlides &&
                !t.params.cssMode &&
                (t.wrapperEl.style.transform = `translateX(${t.minTranslate()}px)`),
                t.params.centeredSlides && t.params.cssMode && (u -= e[0].swiperSlideOffset)
              let m = t.params.cssMode ? -u - t.translate : -u,
                h = 0
              const f = -100 * Math.abs(p)
              let g = 1,
                v = -i.perSlideRotate * p,
                w = i.perSlideOffset - 0.75 * Math.abs(p)
              const b = t.virtual && t.params.virtual.enabled ? t.virtual.from + o : o,
                y = (b === s || b === s - 1) && p > 0 && p < 1 && (n || t.params.cssMode) && l < r,
                E = (b === s || b === s + 1) && p < 0 && p > -1 && (n || t.params.cssMode) && l > r
              if (y || E) {
                const e = (1 - Math.abs((Math.abs(p) - 0.5) / 0.5)) ** 0.5
                ;(v += -28 * p * e), (g += -0.5 * e), (w += 96 * e), (h = -25 * e * Math.abs(p) + "%")
              }
              if (
                ((m =
                  p < 0
                    ? `calc(${m}px ${a ? "-" : "+"} (${w * Math.abs(p)}%))`
                    : p > 0
                      ? `calc(${m}px ${a ? "-" : "+"} (-${w * Math.abs(p)}%))`
                      : `${m}px`),
                !t.isHorizontal())
              ) {
                const e = h
                ;(h = m), (m = e)
              }
              const x = p < 0 ? "" + (1 + (1 - g) * p) : "" + (1 - (1 - g) * p),
                S = `\n        translate3d(${m}, ${h}, ${f}px)\n        rotateZ(${i.rotate ? (a ? -v : v) : 0}deg)\n        scale(${x})\n      `
              if (i.slideShadows) {
                let e = d.querySelector(".swiper-slide-shadow")
                e || (e = de("cards", d)), e && (e.style.opacity = Math.min(Math.max((Math.abs(p) - 0.5) / 0.5, 0), 1))
              }
              d.style.zIndex = -Math.abs(Math.round(c)) + e.length
              le(0, d).style.transform = S
            }
          },
          setTransition: (e) => {
            const s = t.slides.map((e) => m(e))
            s.forEach((t) => {
              ;(t.style.transitionDuration = `${e}ms`),
                t.querySelectorAll(".swiper-slide-shadow").forEach((t) => {
                  t.style.transitionDuration = `${e}ms`
                })
            }),
              oe({ swiper: t, duration: e, transformElements: s })
          },
          perspective: () => !0,
          overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !t.params.cssMode }),
        })
    },
  ]
  return Q.use(ce), Q
})()

/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!(function () {
  "use strict"
  function t(o) {
    if (!o) throw new Error("No options passed to Waypoint constructor")
    if (!o.element) throw new Error("No element option passed to Waypoint constructor")
    if (!o.handler) throw new Error("No handler option passed to Waypoint constructor")
    ;(this.key = "waypoint-" + e),
      (this.options = t.Adapter.extend({}, t.defaults, o)),
      (this.element = this.options.element),
      (this.adapter = new t.Adapter(this.element)),
      (this.callback = o.handler),
      (this.axis = this.options.horizontal ? "horizontal" : "vertical"),
      (this.enabled = this.options.enabled),
      (this.triggerPoint = null),
      (this.group = t.Group.findOrCreate({ name: this.options.group, axis: this.axis })),
      (this.context = t.Context.findOrCreateByElement(this.options.context)),
      t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]),
      this.group.add(this),
      this.context.add(this),
      (i[this.key] = this),
      (e += 1)
  }
  var e = 0,
    i = {}
  ;(t.prototype.queueTrigger = function (t) {
    this.group.queueTrigger(this, t)
  }),
    (t.prototype.trigger = function (t) {
      this.enabled && this.callback && this.callback.apply(this, t)
    }),
    (t.prototype.destroy = function () {
      this.context.remove(this), this.group.remove(this), delete i[this.key]
    }),
    (t.prototype.disable = function () {
      return (this.enabled = !1), this
    }),
    (t.prototype.enable = function () {
      return this.context.refresh(), (this.enabled = !0), this
    }),
    (t.prototype.next = function () {
      return this.group.next(this)
    }),
    (t.prototype.previous = function () {
      return this.group.previous(this)
    }),
    (t.invokeAll = function (t) {
      var e = []
      for (var o in i) e.push(i[o])
      for (var n = 0, r = e.length; r > n; n++) e[n][t]()
    }),
    (t.destroyAll = function () {
      t.invokeAll("destroy")
    }),
    (t.disableAll = function () {
      t.invokeAll("disable")
    }),
    (t.enableAll = function () {
      t.Context.refreshAll()
      for (var e in i) i[e].enabled = !0
      return this
    }),
    (t.refreshAll = function () {
      t.Context.refreshAll()
    }),
    (t.viewportHeight = function () {
      return window.innerHeight || document.documentElement.clientHeight
    }),
    (t.viewportWidth = function () {
      return document.documentElement.clientWidth
    }),
    (t.adapters = []),
    (t.defaults = { context: window, continuous: !0, enabled: !0, group: "default", horizontal: !1, offset: 0 }),
    (t.offsetAliases = {
      "bottom-in-view": function () {
        return this.context.innerHeight() - this.adapter.outerHeight()
      },
      "right-in-view": function () {
        return this.context.innerWidth() - this.adapter.outerWidth()
      },
    }),
    (window.Waypoint = t)
})(),
  (function () {
    "use strict"
    function t(t) {
      window.setTimeout(t, 1e3 / 60)
    }
    function e(t) {
      ;(this.element = t),
        (this.Adapter = n.Adapter),
        (this.adapter = new this.Adapter(t)),
        (this.key = "waypoint-context-" + i),
        (this.didScroll = !1),
        (this.didResize = !1),
        (this.oldScroll = { x: this.adapter.scrollLeft(), y: this.adapter.scrollTop() }),
        (this.waypoints = { vertical: {}, horizontal: {} }),
        (t.waypointContextKey = this.key),
        (o[t.waypointContextKey] = this),
        (i += 1),
        n.windowContext || ((n.windowContext = !0), (n.windowContext = new e(window))),
        this.createThrottledScrollHandler(),
        this.createThrottledResizeHandler()
    }
    var i = 0,
      o = {},
      n = window.Waypoint,
      r = window.onload
    ;(e.prototype.add = function (t) {
      var e = t.options.horizontal ? "horizontal" : "vertical"
      ;(this.waypoints[e][t.key] = t), this.refresh()
    }),
      (e.prototype.checkEmpty = function () {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
          e = this.Adapter.isEmptyObject(this.waypoints.vertical),
          i = this.element == this.element.window
        t && e && !i && (this.adapter.off(".waypoints"), delete o[this.key])
      }),
      (e.prototype.createThrottledResizeHandler = function () {
        function t() {
          e.handleResize(), (e.didResize = !1)
        }
        var e = this
        this.adapter.on("resize.waypoints", function () {
          e.didResize || ((e.didResize = !0), n.requestAnimationFrame(t))
        })
      }),
      (e.prototype.createThrottledScrollHandler = function () {
        function t() {
          e.handleScroll(), (e.didScroll = !1)
        }
        var e = this
        this.adapter.on("scroll.waypoints", function () {
          ;(!e.didScroll || n.isTouch) && ((e.didScroll = !0), n.requestAnimationFrame(t))
        })
      }),
      (e.prototype.handleResize = function () {
        n.Context.refreshAll()
      }),
      (e.prototype.handleScroll = function () {
        var t = {},
          e = {
            horizontal: {
              newScroll: this.adapter.scrollLeft(),
              oldScroll: this.oldScroll.x,
              forward: "right",
              backward: "left",
            },
            vertical: {
              newScroll: this.adapter.scrollTop(),
              oldScroll: this.oldScroll.y,
              forward: "down",
              backward: "up",
            },
          }
        for (var i in e) {
          var o = e[i],
            n = o.newScroll > o.oldScroll,
            r = n ? o.forward : o.backward
          for (var s in this.waypoints[i]) {
            var a = this.waypoints[i][s]
            if (null !== a.triggerPoint) {
              var l = o.oldScroll < a.triggerPoint,
                h = o.newScroll >= a.triggerPoint,
                p = l && h,
                u = !l && !h
              ;(p || u) && (a.queueTrigger(r), (t[a.group.id] = a.group))
            }
          }
        }
        for (var c in t) t[c].flushTriggers()
        this.oldScroll = { x: e.horizontal.newScroll, y: e.vertical.newScroll }
      }),
      (e.prototype.innerHeight = function () {
        return this.element == this.element.window ? n.viewportHeight() : this.adapter.innerHeight()
      }),
      (e.prototype.remove = function (t) {
        delete this.waypoints[t.axis][t.key], this.checkEmpty()
      }),
      (e.prototype.innerWidth = function () {
        return this.element == this.element.window ? n.viewportWidth() : this.adapter.innerWidth()
      }),
      (e.prototype.destroy = function () {
        var t = []
        for (var e in this.waypoints) for (var i in this.waypoints[e]) t.push(this.waypoints[e][i])
        for (var o = 0, n = t.length; n > o; o++) t[o].destroy()
      }),
      (e.prototype.refresh = function () {
        var t,
          e = this.element == this.element.window,
          i = e ? void 0 : this.adapter.offset(),
          o = {}
        this.handleScroll(),
          (t = {
            horizontal: {
              contextOffset: e ? 0 : i.left,
              contextScroll: e ? 0 : this.oldScroll.x,
              contextDimension: this.innerWidth(),
              oldScroll: this.oldScroll.x,
              forward: "right",
              backward: "left",
              offsetProp: "left",
            },
            vertical: {
              contextOffset: e ? 0 : i.top,
              contextScroll: e ? 0 : this.oldScroll.y,
              contextDimension: this.innerHeight(),
              oldScroll: this.oldScroll.y,
              forward: "down",
              backward: "up",
              offsetProp: "top",
            },
          })
        for (var r in t) {
          var s = t[r]
          for (var a in this.waypoints[r]) {
            var l,
              h,
              p,
              u,
              c,
              d = this.waypoints[r][a],
              f = d.options.offset,
              w = d.triggerPoint,
              y = 0,
              g = null == w
            d.element !== d.element.window && (y = d.adapter.offset()[s.offsetProp]),
              "function" == typeof f
                ? (f = f.apply(d))
                : "string" == typeof f &&
                  ((f = parseFloat(f)),
                  d.options.offset.indexOf("%") > -1 && (f = Math.ceil((s.contextDimension * f) / 100))),
              (l = s.contextScroll - s.contextOffset),
              (d.triggerPoint = Math.floor(y + l - f)),
              (h = w < s.oldScroll),
              (p = d.triggerPoint >= s.oldScroll),
              (u = h && p),
              (c = !h && !p),
              !g && u
                ? (d.queueTrigger(s.backward), (o[d.group.id] = d.group))
                : !g && c
                  ? (d.queueTrigger(s.forward), (o[d.group.id] = d.group))
                  : g && s.oldScroll >= d.triggerPoint && (d.queueTrigger(s.forward), (o[d.group.id] = d.group))
          }
        }
        return (
          n.requestAnimationFrame(function () {
            for (var t in o) o[t].flushTriggers()
          }),
          this
        )
      }),
      (e.findOrCreateByElement = function (t) {
        return e.findByElement(t) || new e(t)
      }),
      (e.refreshAll = function () {
        for (var t in o) o[t].refresh()
      }),
      (e.findByElement = function (t) {
        return o[t.waypointContextKey]
      }),
      (window.onload = function () {
        r && r(), e.refreshAll()
      }),
      (n.requestAnimationFrame = function (e) {
        var i =
          window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t
        i.call(window, e)
      }),
      (n.Context = e)
  })(),
  (function () {
    "use strict"
    function t(t, e) {
      return t.triggerPoint - e.triggerPoint
    }
    function e(t, e) {
      return e.triggerPoint - t.triggerPoint
    }
    function i(t) {
      ;(this.name = t.name),
        (this.axis = t.axis),
        (this.id = this.name + "-" + this.axis),
        (this.waypoints = []),
        this.clearTriggerQueues(),
        (o[this.axis][this.name] = this)
    }
    var o = { vertical: {}, horizontal: {} },
      n = window.Waypoint
    ;(i.prototype.add = function (t) {
      this.waypoints.push(t)
    }),
      (i.prototype.clearTriggerQueues = function () {
        this.triggerQueues = { up: [], down: [], left: [], right: [] }
      }),
      (i.prototype.flushTriggers = function () {
        for (var i in this.triggerQueues) {
          var o = this.triggerQueues[i],
            n = "up" === i || "left" === i
          o.sort(n ? e : t)
          for (var r = 0, s = o.length; s > r; r += 1) {
            var a = o[r]
            ;(a.options.continuous || r === o.length - 1) && a.trigger([i])
          }
        }
        this.clearTriggerQueues()
      }),
      (i.prototype.next = function (e) {
        this.waypoints.sort(t)
        var i = n.Adapter.inArray(e, this.waypoints),
          o = i === this.waypoints.length - 1
        return o ? null : this.waypoints[i + 1]
      }),
      (i.prototype.previous = function (e) {
        this.waypoints.sort(t)
        var i = n.Adapter.inArray(e, this.waypoints)
        return i ? this.waypoints[i - 1] : null
      }),
      (i.prototype.queueTrigger = function (t, e) {
        this.triggerQueues[e].push(t)
      }),
      (i.prototype.remove = function (t) {
        var e = n.Adapter.inArray(t, this.waypoints)
        e > -1 && this.waypoints.splice(e, 1)
      }),
      (i.prototype.first = function () {
        return this.waypoints[0]
      }),
      (i.prototype.last = function () {
        return this.waypoints[this.waypoints.length - 1]
      }),
      (i.findOrCreate = function (t) {
        return o[t.axis][t.name] || new i(t)
      }),
      (n.Group = i)
  })(),
  (function () {
    "use strict"
    function t(t) {
      this.$element = e(t)
    }
    var e = window.jQuery,
      i = window.Waypoint
    e.each(
      ["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"],
      function (e, i) {
        t.prototype[i] = function () {
          var t = Array.prototype.slice.call(arguments)
          return this.$element[i].apply(this.$element, t)
        }
      },
    ),
      e.each(["extend", "inArray", "isEmptyObject"], function (i, o) {
        t[o] = e[o]
      }),
      i.adapters.push({ name: "jquery", Adapter: t }),
      (i.Adapter = t)
  })(),
  (function () {
    "use strict"
    function t(t) {
      return function () {
        var i = [],
          o = arguments[0]
        return (
          t.isFunction(arguments[0]) && ((o = t.extend({}, arguments[1])), (o.handler = arguments[0])),
          this.each(function () {
            var n = t.extend({}, o, { element: this })
            "string" == typeof n.context && (n.context = t(this).closest(n.context)[0]), i.push(new e(n))
          }),
          i
        )
      }
    }
    var e = window.Waypoint
    window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)),
      window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto))
  })()

/*
 * anime.js v3.2.1
 * (c) 2020 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */

!(function (n, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
      ? define(e)
      : (n.anime = e())
})(this, function () {
  "use strict"
  var n = {
      update: null,
      begin: null,
      loopBegin: null,
      changeBegin: null,
      change: null,
      changeComplete: null,
      loopComplete: null,
      complete: null,
      loop: 1,
      direction: "normal",
      autoplay: !0,
      timelineOffset: 0,
    },
    e = { duration: 1e3, delay: 0, endDelay: 0, easing: "easeOutElastic(1, .5)", round: 0 },
    t = [
      "translateX",
      "translateY",
      "translateZ",
      "rotate",
      "rotateX",
      "rotateY",
      "rotateZ",
      "scale",
      "scaleX",
      "scaleY",
      "scaleZ",
      "skew",
      "skewX",
      "skewY",
      "perspective",
      "matrix",
      "matrix3d",
    ],
    r = { CSS: {}, springs: {} }
  function a(n, e, t) {
    return Math.min(Math.max(n, e), t)
  }
  function o(n, e) {
    return n.indexOf(e) > -1
  }
  function u(n, e) {
    return n.apply(null, e)
  }
  var i = {
    arr: function (n) {
      return Array.isArray(n)
    },
    obj: function (n) {
      return o(Object.prototype.toString.call(n), "Object")
    },
    pth: function (n) {
      return i.obj(n) && n.hasOwnProperty("totalLength")
    },
    svg: function (n) {
      return n instanceof SVGElement
    },
    inp: function (n) {
      return n instanceof HTMLInputElement
    },
    dom: function (n) {
      return n.nodeType || i.svg(n)
    },
    str: function (n) {
      return "string" == typeof n
    },
    fnc: function (n) {
      return "function" == typeof n
    },
    und: function (n) {
      return void 0 === n
    },
    nil: function (n) {
      return i.und(n) || null === n
    },
    hex: function (n) {
      return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(n)
    },
    rgb: function (n) {
      return /^rgb/.test(n)
    },
    hsl: function (n) {
      return /^hsl/.test(n)
    },
    col: function (n) {
      return i.hex(n) || i.rgb(n) || i.hsl(n)
    },
    key: function (t) {
      return !n.hasOwnProperty(t) && !e.hasOwnProperty(t) && "targets" !== t && "keyframes" !== t
    },
  }
  function c(n) {
    var e = /\(([^)]+)\)/.exec(n)
    return e
      ? e[1].split(",").map(function (n) {
          return parseFloat(n)
        })
      : []
  }
  function s(n, e) {
    var t = c(n),
      o = a(i.und(t[0]) ? 1 : t[0], 0.1, 100),
      u = a(i.und(t[1]) ? 100 : t[1], 0.1, 100),
      s = a(i.und(t[2]) ? 10 : t[2], 0.1, 100),
      f = a(i.und(t[3]) ? 0 : t[3], 0.1, 100),
      l = Math.sqrt(u / o),
      d = s / (2 * Math.sqrt(u * o)),
      p = d < 1 ? l * Math.sqrt(1 - d * d) : 0,
      v = 1,
      h = d < 1 ? (d * l - f) / p : -f + l
    function g(n) {
      var t = e ? (e * n) / 1e3 : n
      return (
        (t =
          d < 1 ? Math.exp(-t * d * l) * (v * Math.cos(p * t) + h * Math.sin(p * t)) : (v + h * t) * Math.exp(-t * l)),
        0 === n || 1 === n ? n : 1 - t
      )
    }
    return e
      ? g
      : function () {
          var e = r.springs[n]
          if (e) return e
          for (var t = 0, a = 0; ; )
            if (1 === g((t += 1 / 6))) {
              if (++a >= 16) break
            } else a = 0
          var o = t * (1 / 6) * 1e3
          return (r.springs[n] = o), o
        }
  }
  function f(n) {
    return (
      void 0 === n && (n = 10),
      function (e) {
        return Math.ceil(a(e, 1e-6, 1) * n) * (1 / n)
      }
    )
  }
  var l,
    d,
    p = (function () {
      var n = 11,
        e = 1 / (n - 1)
      function t(n, e) {
        return 1 - 3 * e + 3 * n
      }
      function r(n, e) {
        return 3 * e - 6 * n
      }
      function a(n) {
        return 3 * n
      }
      function o(n, e, o) {
        return ((t(e, o) * n + r(e, o)) * n + a(e)) * n
      }
      function u(n, e, o) {
        return 3 * t(e, o) * n * n + 2 * r(e, o) * n + a(e)
      }
      return function (t, r, a, i) {
        if (0 <= t && t <= 1 && 0 <= a && a <= 1) {
          var c = new Float32Array(n)
          if (t !== r || a !== i) for (var s = 0; s < n; ++s) c[s] = o(s * e, t, a)
          return function (n) {
            return t === r && a === i ? n : 0 === n || 1 === n ? n : o(f(n), r, i)
          }
        }
        function f(r) {
          for (var i = 0, s = 1, f = n - 1; s !== f && c[s] <= r; ++s) i += e
          var l = i + ((r - c[--s]) / (c[s + 1] - c[s])) * e,
            d = u(l, t, a)
          return d >= 0.001
            ? (function (n, e, t, r) {
                for (var a = 0; a < 4; ++a) {
                  var i = u(e, t, r)
                  if (0 === i) return e
                  e -= (o(e, t, r) - n) / i
                }
                return e
              })(r, l, t, a)
            : 0 === d
              ? l
              : (function (n, e, t, r, a) {
                  for (
                    var u, i, c = 0;
                    (u = o((i = e + (t - e) / 2), r, a) - n) > 0 ? (t = i) : (e = i), Math.abs(u) > 1e-7 && ++c < 10;

                  );
                  return i
                })(r, i, i + e, t, a)
        }
      }
    })(),
    v =
      ((l = {
        linear: function () {
          return function (n) {
            return n
          }
        },
      }),
      (d = {
        Sine: function () {
          return function (n) {
            return 1 - Math.cos((n * Math.PI) / 2)
          }
        },
        Circ: function () {
          return function (n) {
            return 1 - Math.sqrt(1 - n * n)
          }
        },
        Back: function () {
          return function (n) {
            return n * n * (3 * n - 2)
          }
        },
        Bounce: function () {
          return function (n) {
            for (var e, t = 4; n < ((e = Math.pow(2, --t)) - 1) / 11; );
            return 1 / Math.pow(4, 3 - t) - 7.5625 * Math.pow((3 * e - 2) / 22 - n, 2)
          }
        },
        Elastic: function (n, e) {
          void 0 === n && (n = 1), void 0 === e && (e = 0.5)
          var t = a(n, 1, 10),
            r = a(e, 0.1, 2)
          return function (n) {
            return 0 === n || 1 === n
              ? n
              : -t *
                  Math.pow(2, 10 * (n - 1)) *
                  Math.sin(((n - 1 - (r / (2 * Math.PI)) * Math.asin(1 / t)) * (2 * Math.PI)) / r)
          }
        },
      }),
      ["Quad", "Cubic", "Quart", "Quint", "Expo"].forEach(function (n, e) {
        d[n] = function () {
          return function (n) {
            return Math.pow(n, e + 2)
          }
        }
      }),
      Object.keys(d).forEach(function (n) {
        var e = d[n]
        ;(l["easeIn" + n] = e),
          (l["easeOut" + n] = function (n, t) {
            return function (r) {
              return 1 - e(n, t)(1 - r)
            }
          }),
          (l["easeInOut" + n] = function (n, t) {
            return function (r) {
              return r < 0.5 ? e(n, t)(2 * r) / 2 : 1 - e(n, t)(-2 * r + 2) / 2
            }
          }),
          (l["easeOutIn" + n] = function (n, t) {
            return function (r) {
              return r < 0.5 ? (1 - e(n, t)(1 - 2 * r)) / 2 : (e(n, t)(2 * r - 1) + 1) / 2
            }
          })
      }),
      l)
  function h(n, e) {
    if (i.fnc(n)) return n
    var t = n.split("(")[0],
      r = v[t],
      a = c(n)
    switch (t) {
      case "spring":
        return s(n, e)
      case "cubicBezier":
        return u(p, a)
      case "steps":
        return u(f, a)
      default:
        return u(r, a)
    }
  }
  function g(n) {
    try {
      return document.querySelectorAll(n)
    } catch (n) {
      return
    }
  }
  function m(n, e) {
    for (var t = n.length, r = arguments.length >= 2 ? arguments[1] : void 0, a = [], o = 0; o < t; o++)
      if (o in n) {
        var u = n[o]
        e.call(r, u, o, n) && a.push(u)
      }
    return a
  }
  function y(n) {
    return n.reduce(function (n, e) {
      return n.concat(i.arr(e) ? y(e) : e)
    }, [])
  }
  function b(n) {
    return i.arr(n)
      ? n
      : (i.str(n) && (n = g(n) || n), n instanceof NodeList || n instanceof HTMLCollection ? [].slice.call(n) : [n])
  }
  function M(n, e) {
    return n.some(function (n) {
      return n === e
    })
  }
  function x(n) {
    var e = {}
    for (var t in n) e[t] = n[t]
    return e
  }
  function w(n, e) {
    var t = x(n)
    for (var r in n) t[r] = e.hasOwnProperty(r) ? e[r] : n[r]
    return t
  }
  function k(n, e) {
    var t = x(n)
    for (var r in e) t[r] = i.und(n[r]) ? e[r] : n[r]
    return t
  }
  function O(n) {
    return i.rgb(n)
      ? (t = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec((e = n)))
        ? "rgba(" + t[1] + ",1)"
        : e
      : i.hex(n)
        ? ((r = n.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (n, e, t, r) {
            return e + e + t + t + r + r
          })),
          (a = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(r)),
          "rgba(" + parseInt(a[1], 16) + "," + parseInt(a[2], 16) + "," + parseInt(a[3], 16) + ",1)")
        : i.hsl(n)
          ? (function (n) {
              var e,
                t,
                r,
                a =
                  /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(n) ||
                  /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(n),
                o = parseInt(a[1], 10) / 360,
                u = parseInt(a[2], 10) / 100,
                i = parseInt(a[3], 10) / 100,
                c = a[4] || 1
              function s(n, e, t) {
                return (
                  t < 0 && (t += 1),
                  t > 1 && (t -= 1),
                  t < 1 / 6 ? n + 6 * (e - n) * t : t < 0.5 ? e : t < 2 / 3 ? n + (e - n) * (2 / 3 - t) * 6 : n
                )
              }
              if (0 == u) e = t = r = i
              else {
                var f = i < 0.5 ? i * (1 + u) : i + u - i * u,
                  l = 2 * i - f
                ;(e = s(l, f, o + 1 / 3)), (t = s(l, f, o)), (r = s(l, f, o - 1 / 3))
              }
              return "rgba(" + 255 * e + "," + 255 * t + "," + 255 * r + "," + c + ")"
            })(n)
          : void 0
    var e, t, r, a
  }
  function C(n) {
    var e =
      /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(
        n,
      )
    if (e) return e[1]
  }
  function P(n, e) {
    return i.fnc(n) ? n(e.target, e.id, e.total) : n
  }
  function I(n, e) {
    return n.getAttribute(e)
  }
  function D(n, e, t) {
    if (M([t, "deg", "rad", "turn"], C(e))) return e
    var a = r.CSS[e + t]
    if (!i.und(a)) return a
    var o = document.createElement(n.tagName),
      u = n.parentNode && n.parentNode !== document ? n.parentNode : document.body
    u.appendChild(o), (o.style.position = "absolute"), (o.style.width = 100 + t)
    var c = 100 / o.offsetWidth
    u.removeChild(o)
    var s = c * parseFloat(e)
    return (r.CSS[e + t] = s), s
  }
  function B(n, e, t) {
    if (e in n.style) {
      var r = e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(),
        a = n.style[e] || getComputedStyle(n).getPropertyValue(r) || "0"
      return t ? D(n, a, t) : a
    }
  }
  function T(n, e) {
    return i.dom(n) && !i.inp(n) && (!i.nil(I(n, e)) || (i.svg(n) && n[e]))
      ? "attribute"
      : i.dom(n) && M(t, e)
        ? "transform"
        : i.dom(n) && "transform" !== e && B(n, e)
          ? "css"
          : null != n[e]
            ? "object"
            : void 0
  }
  function E(n) {
    if (i.dom(n)) {
      for (var e, t = n.style.transform || "", r = /(\w+)\(([^)]*)\)/g, a = new Map(); (e = r.exec(t)); )
        a.set(e[1], e[2])
      return a
    }
  }
  function F(n, e, t, r) {
    var a,
      u = o(e, "scale")
        ? 1
        : 0 + (o((a = e), "translate") || "perspective" === a ? "px" : o(a, "rotate") || o(a, "skew") ? "deg" : void 0),
      i = E(n).get(e) || u
    return t && (t.transforms.list.set(e, i), (t.transforms.last = e)), r ? D(n, i, r) : i
  }
  function A(n, e, t, r) {
    switch (T(n, e)) {
      case "transform":
        return F(n, e, r, t)
      case "css":
        return B(n, e, t)
      case "attribute":
        return I(n, e)
      default:
        return n[e] || 0
    }
  }
  function N(n, e) {
    var t = /^(\*=|\+=|-=)/.exec(n)
    if (!t) return n
    var r = C(n) || 0,
      a = parseFloat(e),
      o = parseFloat(n.replace(t[0], ""))
    switch (t[0][0]) {
      case "+":
        return a + o + r
      case "-":
        return a - o + r
      case "*":
        return a * o + r
    }
  }
  function S(n, e) {
    if (i.col(n)) return O(n)
    if (/\s/g.test(n)) return n
    var t = C(n),
      r = t ? n.substr(0, n.length - t.length) : n
    return e ? r + e : r
  }
  function L(n, e) {
    return Math.sqrt(Math.pow(e.x - n.x, 2) + Math.pow(e.y - n.y, 2))
  }
  function j(n) {
    for (var e, t = n.points, r = 0, a = 0; a < t.numberOfItems; a++) {
      var o = t.getItem(a)
      a > 0 && (r += L(e, o)), (e = o)
    }
    return r
  }
  function q(n) {
    if (n.getTotalLength) return n.getTotalLength()
    switch (n.tagName.toLowerCase()) {
      case "circle":
        return (o = n), 2 * Math.PI * I(o, "r")
      case "rect":
        return 2 * I((a = n), "width") + 2 * I(a, "height")
      case "line":
        return L({ x: I((r = n), "x1"), y: I(r, "y1") }, { x: I(r, "x2"), y: I(r, "y2") })
      case "polyline":
        return j(n)
      case "polygon":
        return (t = (e = n).points), j(e) + L(t.getItem(t.numberOfItems - 1), t.getItem(0))
    }
    var e, t, r, a, o
  }
  function H(n, e) {
    var t = e || {},
      r =
        t.el ||
        (function (n) {
          for (var e = n.parentNode; i.svg(e) && i.svg(e.parentNode); ) e = e.parentNode
          return e
        })(n),
      a = r.getBoundingClientRect(),
      o = I(r, "viewBox"),
      u = a.width,
      c = a.height,
      s = t.viewBox || (o ? o.split(" ") : [0, 0, u, c])
    return { el: r, viewBox: s, x: s[0] / 1, y: s[1] / 1, w: u, h: c, vW: s[2], vH: s[3] }
  }
  function V(n, e, t) {
    function r(t) {
      void 0 === t && (t = 0)
      var r = e + t >= 1 ? e + t : 0
      return n.el.getPointAtLength(r)
    }
    var a = H(n.el, n.svg),
      o = r(),
      u = r(-1),
      i = r(1),
      c = t ? 1 : a.w / a.vW,
      s = t ? 1 : a.h / a.vH
    switch (n.property) {
      case "x":
        return (o.x - a.x) * c
      case "y":
        return (o.y - a.y) * s
      case "angle":
        return (180 * Math.atan2(i.y - u.y, i.x - u.x)) / Math.PI
    }
  }
  function $(n, e) {
    var t = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g,
      r = S(i.pth(n) ? n.totalLength : n, e) + ""
    return { original: r, numbers: r.match(t) ? r.match(t).map(Number) : [0], strings: i.str(n) || e ? r.split(t) : [] }
  }
  function W(n) {
    return m(n ? y(i.arr(n) ? n.map(b) : b(n)) : [], function (n, e, t) {
      return t.indexOf(n) === e
    })
  }
  function X(n) {
    var e = W(n)
    return e.map(function (n, t) {
      return { target: n, id: t, total: e.length, transforms: { list: E(n) } }
    })
  }
  function Y(n, e) {
    var t = x(e)
    if ((/^spring/.test(t.easing) && (t.duration = s(t.easing)), i.arr(n))) {
      var r = n.length
      2 === r && !i.obj(n[0]) ? (n = { value: n }) : i.fnc(e.duration) || (t.duration = e.duration / r)
    }
    var a = i.arr(n) ? n : [n]
    return a
      .map(function (n, t) {
        var r = i.obj(n) && !i.pth(n) ? n : { value: n }
        return (
          i.und(r.delay) && (r.delay = t ? 0 : e.delay),
          i.und(r.endDelay) && (r.endDelay = t === a.length - 1 ? e.endDelay : 0),
          r
        )
      })
      .map(function (n) {
        return k(n, t)
      })
  }
  function Z(n, e) {
    var t = [],
      r = e.keyframes
    for (var a in (r &&
      (e = k(
        (function (n) {
          for (
            var e = m(
                y(
                  n.map(function (n) {
                    return Object.keys(n)
                  }),
                ),
                function (n) {
                  return i.key(n)
                },
              ).reduce(function (n, e) {
                return n.indexOf(e) < 0 && n.push(e), n
              }, []),
              t = {},
              r = function (r) {
                var a = e[r]
                t[a] = n.map(function (n) {
                  var e = {}
                  for (var t in n) i.key(t) ? t == a && (e.value = n[t]) : (e[t] = n[t])
                  return e
                })
              },
              a = 0;
            a < e.length;
            a++
          )
            r(a)
          return t
        })(r),
        e,
      )),
    e))
      i.key(a) && t.push({ name: a, tweens: Y(e[a], n) })
    return t
  }
  function G(n, e) {
    var t
    return n.tweens.map(function (r) {
      var a = (function (n, e) {
          var t = {}
          for (var r in n) {
            var a = P(n[r], e)
            i.arr(a) &&
              1 ===
                (a = a.map(function (n) {
                  return P(n, e)
                })).length &&
              (a = a[0]),
              (t[r] = a)
          }
          return (t.duration = parseFloat(t.duration)), (t.delay = parseFloat(t.delay)), t
        })(r, e),
        o = a.value,
        u = i.arr(o) ? o[1] : o,
        c = C(u),
        s = A(e.target, n.name, c, e),
        f = t ? t.to.original : s,
        l = i.arr(o) ? o[0] : f,
        d = C(l) || C(s),
        p = c || d
      return (
        i.und(u) && (u = f),
        (a.from = $(l, p)),
        (a.to = $(N(u, l), p)),
        (a.start = t ? t.end : 0),
        (a.end = a.start + a.delay + a.duration + a.endDelay),
        (a.easing = h(a.easing, a.duration)),
        (a.isPath = i.pth(o)),
        (a.isPathTargetInsideSVG = a.isPath && i.svg(e.target)),
        (a.isColor = i.col(a.from.original)),
        a.isColor && (a.round = 1),
        (t = a),
        a
      )
    })
  }
  var Q = {
    css: function (n, e, t) {
      return (n.style[e] = t)
    },
    attribute: function (n, e, t) {
      return n.setAttribute(e, t)
    },
    object: function (n, e, t) {
      return (n[e] = t)
    },
    transform: function (n, e, t, r, a) {
      if ((r.list.set(e, t), e === r.last || a)) {
        var o = ""
        r.list.forEach(function (n, e) {
          o += e + "(" + n + ") "
        }),
          (n.style.transform = o)
      }
    },
  }
  function z(n, e) {
    X(n).forEach(function (n) {
      for (var t in e) {
        var r = P(e[t], n),
          a = n.target,
          o = C(r),
          u = A(a, t, o, n),
          i = N(S(r, o || C(u)), u),
          c = T(a, t)
        Q[c](a, t, i, n.transforms, !0)
      }
    })
  }
  function _(n, e) {
    return m(
      y(
        n.map(function (n) {
          return e.map(function (e) {
            return (function (n, e) {
              var t = T(n.target, e.name)
              if (t) {
                var r = G(e, n),
                  a = r[r.length - 1]
                return {
                  type: t,
                  property: e.name,
                  animatable: n,
                  tweens: r,
                  duration: a.end,
                  delay: r[0].delay,
                  endDelay: a.endDelay,
                }
              }
            })(n, e)
          })
        }),
      ),
      function (n) {
        return !i.und(n)
      },
    )
  }
  function R(n, e) {
    var t = n.length,
      r = function (n) {
        return n.timelineOffset ? n.timelineOffset : 0
      },
      a = {}
    return (
      (a.duration = t
        ? Math.max.apply(
            Math,
            n.map(function (n) {
              return r(n) + n.duration
            }),
          )
        : e.duration),
      (a.delay = t
        ? Math.min.apply(
            Math,
            n.map(function (n) {
              return r(n) + n.delay
            }),
          )
        : e.delay),
      (a.endDelay = t
        ? a.duration -
          Math.max.apply(
            Math,
            n.map(function (n) {
              return r(n) + n.duration - n.endDelay
            }),
          )
        : e.endDelay),
      a
    )
  }
  var J = 0
  var K = [],
    U = (function () {
      var n
      function e(t) {
        for (var r = K.length, a = 0; a < r; ) {
          var o = K[a]
          o.paused ? (K.splice(a, 1), r--) : (o.tick(t), a++)
        }
        n = a > 0 ? requestAnimationFrame(e) : void 0
      }
      return (
        "undefined" != typeof document &&
          document.addEventListener("visibilitychange", function () {
            en.suspendWhenDocumentHidden &&
              (nn()
                ? (n = cancelAnimationFrame(n))
                : (K.forEach(function (n) {
                    return n._onDocumentVisibility()
                  }),
                  U()))
          }),
        function () {
          n || (nn() && en.suspendWhenDocumentHidden) || !(K.length > 0) || (n = requestAnimationFrame(e))
        }
      )
    })()
  function nn() {
    return !!document && document.hidden
  }
  function en(t) {
    void 0 === t && (t = {})
    var r,
      o = 0,
      u = 0,
      i = 0,
      c = 0,
      s = null
    function f(n) {
      var e =
        window.Promise &&
        new Promise(function (n) {
          return (s = n)
        })
      return (n.finished = e), e
    }
    var l,
      d,
      p,
      v,
      h,
      g,
      y,
      b,
      M =
        ((d = w(n, (l = t))),
        (p = w(e, l)),
        (v = Z(p, l)),
        (h = X(l.targets)),
        (g = _(h, v)),
        (y = R(g, p)),
        (b = J),
        J++,
        k(d, {
          id: b,
          children: [],
          animatables: h,
          animations: g,
          duration: y.duration,
          delay: y.delay,
          endDelay: y.endDelay,
        }))
    f(M)
    function x() {
      var n = M.direction
      "alternate" !== n && (M.direction = "normal" !== n ? "normal" : "reverse"),
        (M.reversed = !M.reversed),
        r.forEach(function (n) {
          return (n.reversed = M.reversed)
        })
    }
    function O(n) {
      return M.reversed ? M.duration - n : n
    }
    function C() {
      ;(o = 0), (u = O(M.currentTime) * (1 / en.speed))
    }
    function P(n, e) {
      e && e.seek(n - e.timelineOffset)
    }
    function I(n) {
      for (var e = 0, t = M.animations, r = t.length; e < r; ) {
        var o = t[e],
          u = o.animatable,
          i = o.tweens,
          c = i.length - 1,
          s = i[c]
        c &&
          (s =
            m(i, function (e) {
              return n < e.end
            })[0] || s)
        for (
          var f = a(n - s.start - s.delay, 0, s.duration) / s.duration,
            l = isNaN(f) ? 1 : s.easing(f),
            d = s.to.strings,
            p = s.round,
            v = [],
            h = s.to.numbers.length,
            g = void 0,
            y = 0;
          y < h;
          y++
        ) {
          var b = void 0,
            x = s.to.numbers[y],
            w = s.from.numbers[y] || 0
          ;(b = s.isPath ? V(s.value, l * x, s.isPathTargetInsideSVG) : w + l * (x - w)),
            p && ((s.isColor && y > 2) || (b = Math.round(b * p) / p)),
            v.push(b)
        }
        var k = d.length
        if (k) {
          g = d[0]
          for (var O = 0; O < k; O++) {
            d[O]
            var C = d[O + 1],
              P = v[O]
            isNaN(P) || (g += C ? P + C : P + " ")
          }
        } else g = v[0]
        Q[o.type](u.target, o.property, g, u.transforms), (o.currentValue = g), e++
      }
    }
    function D(n) {
      M[n] && !M.passThrough && M[n](M)
    }
    function B(n) {
      var e = M.duration,
        t = M.delay,
        l = e - M.endDelay,
        d = O(n)
      ;(M.progress = a((d / e) * 100, 0, 100)),
        (M.reversePlayback = d < M.currentTime),
        r &&
          (function (n) {
            if (M.reversePlayback) for (var e = c; e--; ) P(n, r[e])
            else for (var t = 0; t < c; t++) P(n, r[t])
          })(d),
        !M.began && M.currentTime > 0 && ((M.began = !0), D("begin")),
        !M.loopBegan && M.currentTime > 0 && ((M.loopBegan = !0), D("loopBegin")),
        d <= t && 0 !== M.currentTime && I(0),
        ((d >= l && M.currentTime !== e) || !e) && I(e),
        d > t && d < l
          ? (M.changeBegan || ((M.changeBegan = !0), (M.changeCompleted = !1), D("changeBegin")), D("change"), I(d))
          : M.changeBegan && ((M.changeCompleted = !0), (M.changeBegan = !1), D("changeComplete")),
        (M.currentTime = a(d, 0, e)),
        M.began && D("update"),
        n >= e &&
          ((u = 0),
          M.remaining && !0 !== M.remaining && M.remaining--,
          M.remaining
            ? ((o = i), D("loopComplete"), (M.loopBegan = !1), "alternate" === M.direction && x())
            : ((M.paused = !0),
              M.completed ||
                ((M.completed = !0),
                D("loopComplete"),
                D("complete"),
                !M.passThrough && "Promise" in window && (s(), f(M)))))
    }
    return (
      (M.reset = function () {
        var n = M.direction
        ;(M.passThrough = !1),
          (M.currentTime = 0),
          (M.progress = 0),
          (M.paused = !0),
          (M.began = !1),
          (M.loopBegan = !1),
          (M.changeBegan = !1),
          (M.completed = !1),
          (M.changeCompleted = !1),
          (M.reversePlayback = !1),
          (M.reversed = "reverse" === n),
          (M.remaining = M.loop),
          (r = M.children)
        for (var e = (c = r.length); e--; ) M.children[e].reset()
        ;((M.reversed && !0 !== M.loop) || ("alternate" === n && 1 === M.loop)) && M.remaining++,
          I(M.reversed ? M.duration : 0)
      }),
      (M._onDocumentVisibility = C),
      (M.set = function (n, e) {
        return z(n, e), M
      }),
      (M.tick = function (n) {
        ;(i = n), o || (o = i), B((i + (u - o)) * en.speed)
      }),
      (M.seek = function (n) {
        B(O(n))
      }),
      (M.pause = function () {
        ;(M.paused = !0), C()
      }),
      (M.play = function () {
        M.paused && (M.completed && M.reset(), (M.paused = !1), K.push(M), C(), U())
      }),
      (M.reverse = function () {
        x(), (M.completed = !M.reversed), C()
      }),
      (M.restart = function () {
        M.reset(), M.play()
      }),
      (M.remove = function (n) {
        rn(W(n), M)
      }),
      M.reset(),
      M.autoplay && M.play(),
      M
    )
  }
  function tn(n, e) {
    for (var t = e.length; t--; ) M(n, e[t].animatable.target) && e.splice(t, 1)
  }
  function rn(n, e) {
    var t = e.animations,
      r = e.children
    tn(n, t)
    for (var a = r.length; a--; ) {
      var o = r[a],
        u = o.animations
      tn(n, u), u.length || o.children.length || r.splice(a, 1)
    }
    t.length || r.length || e.pause()
  }
  return (
    (en.version = "3.2.1"),
    (en.speed = 1),
    (en.suspendWhenDocumentHidden = !0),
    (en.running = K),
    (en.remove = function (n) {
      for (var e = W(n), t = K.length; t--; ) rn(e, K[t])
    }),
    (en.get = A),
    (en.set = z),
    (en.convertPx = D),
    (en.path = function (n, e) {
      var t = i.str(n) ? g(n)[0] : n,
        r = e || 100
      return function (n) {
        return { property: n, el: t, svg: H(t), totalLength: q(t) * (r / 100) }
      }
    }),
    (en.setDashoffset = function (n) {
      var e = q(n)
      return n.setAttribute("stroke-dasharray", e), e
    }),
    (en.stagger = function (n, e) {
      void 0 === e && (e = {})
      var t = e.direction || "normal",
        r = e.easing ? h(e.easing) : null,
        a = e.grid,
        o = e.axis,
        u = e.from || 0,
        c = "first" === u,
        s = "center" === u,
        f = "last" === u,
        l = i.arr(n),
        d = l ? parseFloat(n[0]) : parseFloat(n),
        p = l ? parseFloat(n[1]) : 0,
        v = C(l ? n[1] : n) || 0,
        g = e.start || 0 + (l ? d : 0),
        m = [],
        y = 0
      return function (n, e, i) {
        if ((c && (u = 0), s && (u = (i - 1) / 2), f && (u = i - 1), !m.length)) {
          for (var h = 0; h < i; h++) {
            if (a) {
              var b = s ? (a[0] - 1) / 2 : u % a[0],
                M = s ? (a[1] - 1) / 2 : Math.floor(u / a[0]),
                x = b - (h % a[0]),
                w = M - Math.floor(h / a[0]),
                k = Math.sqrt(x * x + w * w)
              "x" === o && (k = -x), "y" === o && (k = -w), m.push(k)
            } else m.push(Math.abs(u - h))
            y = Math.max.apply(Math, m)
          }
          r &&
            (m = m.map(function (n) {
              return r(n / y) * y
            })),
            "reverse" === t &&
              (m = m.map(function (n) {
                return o ? (n < 0 ? -1 * n : -n) : Math.abs(y - n)
              }))
        }
        return g + (l ? (p - d) / y : d) * (Math.round(100 * m[e]) / 100) + v
      }
    }),
    (en.timeline = function (n) {
      void 0 === n && (n = {})
      var t = en(n)
      return (
        (t.duration = 0),
        (t.add = function (r, a) {
          var o = K.indexOf(t),
            u = t.children
          function c(n) {
            n.passThrough = !0
          }
          o > -1 && K.splice(o, 1)
          for (var s = 0; s < u.length; s++) c(u[s])
          var f = k(r, w(e, n))
          f.targets = f.targets || n.targets
          var l = t.duration
          ;(f.autoplay = !1),
            (f.direction = t.direction),
            (f.timelineOffset = i.und(a) ? l : N(a, l)),
            c(t),
            t.seek(f.timelineOffset)
          var d = en(f)
          c(d), u.push(d)
          var p = R(u, n)
          return (
            (t.delay = p.delay),
            (t.endDelay = p.endDelay),
            (t.duration = p.duration),
            t.seek(0),
            t.reset(),
            t.autoplay && t.play(),
            t
          )
        }),
        t
      )
    }),
    (en.easing = h),
    (en.penner = v),
    (en.random = function (n, e) {
      return Math.floor(Math.random() * (e - n + 1)) + n
    }),
    en
  )
})

/*!
 * perfect-scrollbar v1.5.3
 * Copyright 2021 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */ ;(function (a, b) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = b())
    : "function" == typeof define && define.amd
      ? define(b)
      : ((a = a || self), (a.PerfectScrollbar = b()))
})(this, function () {
  "use strict"
  var u = Math.abs,
    v = Math.floor
  function a(a) {
    return getComputedStyle(a)
  }
  function b(a, b) {
    for (var c in b) {
      var d = b[c]
      "number" == typeof d && (d += "px"), (a.style[c] = d)
    }
    return a
  }
  function c(a) {
    var b = document.createElement("div")
    return (b.className = a), b
  }
  function d(a, b) {
    if (!w) throw new Error("No element matching method supported")
    return w.call(a, b)
  }
  function e(a) {
    a.remove ? a.remove() : a.parentNode && a.parentNode.removeChild(a)
  }
  function f(a, b) {
    return Array.prototype.filter.call(a.children, function (a) {
      return d(a, b)
    })
  }
  function g(a, b) {
    var c = a.element.classList,
      d = z.state.scrolling(b)
    c.contains(d) ? clearTimeout(A[b]) : c.add(d)
  }
  function h(a, b) {
    A[b] = setTimeout(function () {
      return a.isAlive && a.element.classList.remove(z.state.scrolling(b))
    }, a.settings.scrollingThreshold)
  }
  function j(a, b) {
    g(a, b), h(a, b)
  }
  function k(a) {
    if ("function" == typeof window.CustomEvent) return new CustomEvent(a)
    var b = document.createEvent("CustomEvent")
    return b.initCustomEvent(a, !1, !1, void 0), b
  }
  function l(a, b, c, d, e) {
    void 0 === d && (d = !0), void 0 === e && (e = !1)
    var f
    if ("top" === b) f = ["contentHeight", "containerHeight", "scrollTop", "y", "up", "down"]
    else if ("left" === b) f = ["contentWidth", "containerWidth", "scrollLeft", "x", "left", "right"]
    else throw new Error("A proper axis should be provided")
    m(a, c, f, d, e)
  }
  function m(a, b, c, d, e) {
    var f = c[0],
      g = c[1],
      h = c[2],
      i = c[3],
      l = c[4],
      m = c[5]
    void 0 === d && (d = !0), void 0 === e && (e = !1)
    var n = a.element // reset reach
    ;(a.reach[i] = null),
      1 > n[h] && (a.reach[i] = "start"),
      n[h] > a[f] - a[g] - 1 && (a.reach[i] = "end"),
      b &&
        (n.dispatchEvent(k("ps-scroll-" + i)),
        0 > b ? n.dispatchEvent(k("ps-scroll-" + l)) : 0 < b && n.dispatchEvent(k("ps-scroll-" + m)),
        d && j(a, i)),
      a.reach[i] && (b || e) && n.dispatchEvent(k("ps-" + i + "-reach-" + a.reach[i]))
  }
  function n(a) {
    return parseInt(a, 10) || 0
  }
  function o(a) {
    return (
      d(a, "input,[contenteditable]") ||
      d(a, "select,[contenteditable]") ||
      d(a, "textarea,[contenteditable]") ||
      d(a, "button,[contenteditable]")
    )
  }
  function p(b) {
    var c = a(b)
    return n(c.width) + n(c.paddingLeft) + n(c.paddingRight) + n(c.borderLeftWidth) + n(c.borderRightWidth)
  }
  function q(a) {
    var b = Math.round,
      c = a.element,
      d = v(c.scrollTop),
      g = c.getBoundingClientRect()
    ;(a.containerWidth = b(g.width)),
      (a.containerHeight = b(g.height)),
      (a.contentWidth = c.scrollWidth),
      (a.contentHeight = c.scrollHeight),
      c.contains(a.scrollbarXRail) ||
        (f(c, z.element.rail("x")).forEach(function (a) {
          return e(a)
        }),
        c.appendChild(a.scrollbarXRail)),
      c.contains(a.scrollbarYRail) ||
        (f(c, z.element.rail("y")).forEach(function (a) {
          return e(a)
        }),
        c.appendChild(a.scrollbarYRail)),
      !a.settings.suppressScrollX && a.containerWidth + a.settings.scrollXMarginOffset < a.contentWidth
        ? ((a.scrollbarXActive = !0),
          (a.railXWidth = a.containerWidth - a.railXMarginWidth),
          (a.railXRatio = a.containerWidth / a.railXWidth),
          (a.scrollbarXWidth = r(a, n((a.railXWidth * a.containerWidth) / a.contentWidth))),
          (a.scrollbarXLeft = n(
            ((a.negativeScrollAdjustment + c.scrollLeft) * (a.railXWidth - a.scrollbarXWidth)) /
              (a.contentWidth - a.containerWidth),
          )))
        : (a.scrollbarXActive = !1),
      !a.settings.suppressScrollY && a.containerHeight + a.settings.scrollYMarginOffset < a.contentHeight
        ? ((a.scrollbarYActive = !0),
          (a.railYHeight = a.containerHeight - a.railYMarginHeight),
          (a.railYRatio = a.containerHeight / a.railYHeight),
          (a.scrollbarYHeight = r(a, n((a.railYHeight * a.containerHeight) / a.contentHeight))),
          (a.scrollbarYTop = n((d * (a.railYHeight - a.scrollbarYHeight)) / (a.contentHeight - a.containerHeight))))
        : (a.scrollbarYActive = !1),
      a.scrollbarXLeft >= a.railXWidth - a.scrollbarXWidth && (a.scrollbarXLeft = a.railXWidth - a.scrollbarXWidth),
      a.scrollbarYTop >= a.railYHeight - a.scrollbarYHeight && (a.scrollbarYTop = a.railYHeight - a.scrollbarYHeight),
      s(c, a),
      a.scrollbarXActive
        ? c.classList.add(z.state.active("x"))
        : (c.classList.remove(z.state.active("x")),
          (a.scrollbarXWidth = 0),
          (a.scrollbarXLeft = 0),
          (c.scrollLeft = !0 === a.isRtl ? a.contentWidth : 0)),
      a.scrollbarYActive
        ? c.classList.add(z.state.active("y"))
        : (c.classList.remove(z.state.active("y")), (a.scrollbarYHeight = 0), (a.scrollbarYTop = 0), (c.scrollTop = 0))
  }
  function r(a, b) {
    var c = Math.min,
      d = Math.max
    return (
      a.settings.minScrollbarLength && (b = d(b, a.settings.minScrollbarLength)),
      a.settings.maxScrollbarLength && (b = c(b, a.settings.maxScrollbarLength)),
      b
    )
  }
  function s(a, c) {
    var d = { width: c.railXWidth },
      e = v(a.scrollTop)
    ;(d.left = c.isRtl ? c.negativeScrollAdjustment + a.scrollLeft + c.containerWidth - c.contentWidth : a.scrollLeft),
      c.isScrollbarXUsingBottom ? (d.bottom = c.scrollbarXBottom - e) : (d.top = c.scrollbarXTop + e),
      b(c.scrollbarXRail, d)
    var f = { top: e, height: c.railYHeight }
    c.isScrollbarYUsingRight
      ? c.isRtl
        ? (f.right =
            c.contentWidth -
            (c.negativeScrollAdjustment + a.scrollLeft) -
            c.scrollbarYRight -
            c.scrollbarYOuterWidth -
            9)
        : (f.right = c.scrollbarYRight - a.scrollLeft)
      : c.isRtl
        ? (f.left =
            c.negativeScrollAdjustment +
            a.scrollLeft +
            2 * c.containerWidth -
            c.contentWidth -
            c.scrollbarYLeft -
            c.scrollbarYOuterWidth)
        : (f.left = c.scrollbarYLeft + a.scrollLeft),
      b(c.scrollbarYRail, f),
      b(c.scrollbarX, { left: c.scrollbarXLeft, width: c.scrollbarXWidth - c.railBorderXWidth }),
      b(c.scrollbarY, { top: c.scrollbarYTop, height: c.scrollbarYHeight - c.railBorderYWidth })
  }
  function t(a, b) {
    function c(b) {
      b.touches && b.touches[0] && (b[k] = b.touches[0].pageY),
        (s[o] = t + v * (b[k] - u)),
        g(a, p),
        q(a),
        b.stopPropagation(),
        b.type.startsWith("touch") && 1 < b.changedTouches.length && b.preventDefault()
    }
    function d() {
      h(a, p), a[r].classList.remove(z.state.clicking), a.event.unbind(a.ownerDocument, "mousemove", c)
    }
    function f(b, e) {
      ;(t = s[o]),
        e && b.touches && (b[k] = b.touches[0].pageY),
        (u = b[k]),
        (v = (a[j] - a[i]) / (a[l] - a[n])),
        e
          ? a.event.bind(a.ownerDocument, "touchmove", c)
          : (a.event.bind(a.ownerDocument, "mousemove", c),
            a.event.once(a.ownerDocument, "mouseup", d),
            b.preventDefault()),
        a[r].classList.add(z.state.clicking),
        b.stopPropagation()
    }
    var i = b[0],
      j = b[1],
      k = b[2],
      l = b[3],
      m = b[4],
      n = b[5],
      o = b[6],
      p = b[7],
      r = b[8],
      s = a.element,
      t = null,
      u = null,
      v = null
    a.event.bind(a[m], "mousedown", function (a) {
      f(a)
    }),
      a.event.bind(a[m], "touchstart", function (a) {
        f(a, !0)
      })
  }
  var w =
      "undefined" != typeof Element &&
      (Element.prototype.matches ||
        Element.prototype.webkitMatchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector),
    z = {
      main: "ps",
      rtl: "ps__rtl",
      element: {
        thumb: function (a) {
          return "ps__thumb-" + a
        },
        rail: function (a) {
          return "ps__rail-" + a
        },
        consuming: "ps__child--consume",
      },
      state: {
        focus: "ps--focus",
        clicking: "ps--clicking",
        active: function (a) {
          return "ps--active-" + a
        },
        scrolling: function (a) {
          return "ps--scrolling-" + a
        },
      },
    },
    A = { x: null, y: null },
    B = function (a) {
      ;(this.element = a), (this.handlers = {})
    },
    C = { isEmpty: { configurable: !0 } }
  ;(B.prototype.bind = function (a, b) {
    "undefined" == typeof this.handlers[a] && (this.handlers[a] = []),
      this.handlers[a].push(b),
      this.element.addEventListener(a, b, !1)
  }),
    (B.prototype.unbind = function (a, b) {
      var c = this
      this.handlers[a] = this.handlers[a].filter(function (d) {
        return !!(b && d !== b) || (c.element.removeEventListener(a, d, !1), !1)
      })
    }),
    (B.prototype.unbindAll = function () {
      for (var a in this.handlers) this.unbind(a)
    }),
    (C.isEmpty.get = function () {
      var a = this
      return Object.keys(this.handlers).every(function (b) {
        return 0 === a.handlers[b].length
      })
    }),
    Object.defineProperties(B.prototype, C)
  var D = function () {
    this.eventElements = []
  }
  ;(D.prototype.eventElement = function (a) {
    var b = this.eventElements.filter(function (b) {
      return b.element === a
    })[0]
    return b || ((b = new B(a)), this.eventElements.push(b)), b
  }),
    (D.prototype.bind = function (a, b, c) {
      this.eventElement(a).bind(b, c)
    }),
    (D.prototype.unbind = function (a, b, c) {
      var d = this.eventElement(a)
      d.unbind(b, c), d.isEmpty && this.eventElements.splice(this.eventElements.indexOf(d), 1)
    }),
    (D.prototype.unbindAll = function () {
      this.eventElements.forEach(function (a) {
        return a.unbindAll()
      }),
        (this.eventElements = [])
    }),
    (D.prototype.once = function (a, b, c) {
      var d = this.eventElement(a),
        e = function (a) {
          d.unbind(b, e), c(a)
        }
      d.bind(b, e)
    })
  var E = {
      isWebKit: "undefined" != typeof document && "WebkitAppearance" in document.documentElement.style,
      supportsTouch:
        "undefined" != typeof window &&
        ("ontouchstart" in window ||
          ("maxTouchPoints" in window.navigator && 0 < window.navigator.maxTouchPoints) ||
          (window.DocumentTouch && document instanceof window.DocumentTouch)),
      supportsIePointer: "undefined" != typeof navigator && navigator.msMaxTouchPoints,
      isChrome: "undefined" != typeof navigator && /Chrome/i.test(navigator && navigator.userAgent),
    },
    F = function () {
      return {
        handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
        maxScrollbarLength: null,
        minScrollbarLength: null,
        scrollingThreshold: 1e3,
        scrollXMarginOffset: 0,
        scrollYMarginOffset: 0,
        suppressScrollX: !1,
        suppressScrollY: !1,
        swipeEasing: !0,
        useBothWheelAxes: !1,
        wheelPropagation: !0,
        wheelSpeed: 1,
      }
    },
    G = {
      "click-rail": function (a) {
        a.element
        a.event.bind(a.scrollbarY, "mousedown", function (a) {
          return a.stopPropagation()
        }),
          a.event.bind(a.scrollbarYRail, "mousedown", function (b) {
            var c = b.pageY - window.pageYOffset - a.scrollbarYRail.getBoundingClientRect().top,
              d = c > a.scrollbarYTop ? 1 : -1
            ;(a.element.scrollTop += d * a.containerHeight), q(a), b.stopPropagation()
          }),
          a.event.bind(a.scrollbarX, "mousedown", function (a) {
            return a.stopPropagation()
          }),
          a.event.bind(a.scrollbarXRail, "mousedown", function (b) {
            var c = b.pageX - window.pageXOffset - a.scrollbarXRail.getBoundingClientRect().left,
              d = c > a.scrollbarXLeft ? 1 : -1
            ;(a.element.scrollLeft += d * a.containerWidth), q(a), b.stopPropagation()
          })
      },
      "drag-thumb": function (a) {
        t(a, [
          "containerWidth",
          "contentWidth",
          "pageX",
          "railXWidth",
          "scrollbarX",
          "scrollbarXWidth",
          "scrollLeft",
          "x",
          "scrollbarXRail",
        ]),
          t(a, [
            "containerHeight",
            "contentHeight",
            "pageY",
            "railYHeight",
            "scrollbarY",
            "scrollbarYHeight",
            "scrollTop",
            "y",
            "scrollbarYRail",
          ])
      },
      keyboard: function (a) {
        function b(b, d) {
          var e = v(c.scrollTop)
          if (0 === b) {
            if (!a.scrollbarYActive) return !1
            if ((0 === e && 0 < d) || (e >= a.contentHeight - a.containerHeight && 0 > d))
              return !a.settings.wheelPropagation
          }
          var f = c.scrollLeft
          if (0 === d) {
            if (!a.scrollbarXActive) return !1
            if ((0 === f && 0 > b) || (f >= a.contentWidth - a.containerWidth && 0 < b))
              return !a.settings.wheelPropagation
          }
          return !0
        }
        var c = a.element,
          f = function () {
            return d(c, ":hover")
          },
          g = function () {
            return d(a.scrollbarX, ":focus") || d(a.scrollbarY, ":focus")
          }
        a.event.bind(a.ownerDocument, "keydown", function (d) {
          if (!((d.isDefaultPrevented && d.isDefaultPrevented()) || d.defaultPrevented) && (f() || g())) {
            var e = document.activeElement ? document.activeElement : a.ownerDocument.activeElement
            if (e) {
              if ("IFRAME" === e.tagName)
                e = e.contentDocument.activeElement // go deeper if element is a webcomponent
              else for (; e.shadowRoot; ) e = e.shadowRoot.activeElement
              if (o(e)) return
            }
            var h = 0,
              i = 0
            switch (d.which) {
              case 37:
                h = d.metaKey ? -a.contentWidth : d.altKey ? -a.containerWidth : -30
                break
              case 38:
                i = d.metaKey ? a.contentHeight : d.altKey ? a.containerHeight : 30
                break
              case 39:
                h = d.metaKey ? a.contentWidth : d.altKey ? a.containerWidth : 30
                break
              case 40:
                i = d.metaKey ? -a.contentHeight : d.altKey ? -a.containerHeight : -30
                break
              case 32:
                i = d.shiftKey ? a.containerHeight : -a.containerHeight
                break
              case 33:
                i = a.containerHeight
                break
              case 34:
                i = -a.containerHeight
                break
              case 36:
                i = a.contentHeight
                break
              case 35:
                i = -a.contentHeight
                break
              default:
                return
            }
            ;(a.settings.suppressScrollX && 0 !== h) ||
              (a.settings.suppressScrollY && 0 !== i) ||
              ((c.scrollTop -= i), (c.scrollLeft += h), q(a), b(h, i) && d.preventDefault())
          }
        })
      },
      wheel: function (b) {
        function c(a, c) {
          var d,
            e = v(h.scrollTop),
            f = 0 === h.scrollTop,
            g = e + h.offsetHeight === h.scrollHeight,
            i = 0 === h.scrollLeft,
            j = h.scrollLeft + h.offsetWidth === h.scrollWidth
          return (d = u(c) > u(a) ? f || g : i || j), !d || !b.settings.wheelPropagation
        }
        function d(a) {
          var b = a.deltaX,
            c = -1 * a.deltaY
          return (
            ("undefined" == typeof b || "undefined" == typeof c) &&
              ((b = (-1 * a.wheelDeltaX) / 6), (c = a.wheelDeltaY / 6)),
            a.deltaMode && 1 === a.deltaMode && ((b *= 10), (c *= 10)),
            b !== b && c !== c /* NaN checks */ && ((b = 0), (c = a.wheelDelta)),
            a.shiftKey ? [-c, -b] : [b, c]
          )
        }
        function f(b, c, d) {
          // FIXME: this is a workaround for <select> issue in FF and IE #571
          if (!E.isWebKit && h.querySelector("select:focus")) return !0
          if (!h.contains(b)) return !1
          for (var e = b; e && e !== h; ) {
            if (e.classList.contains(z.element.consuming)) return !0
            var f = a(e) // if deltaY && vertical scrollable
            if (d && f.overflowY.match(/(scroll|auto)/)) {
              var g = e.scrollHeight - e.clientHeight
              if (0 < g && ((0 < e.scrollTop && 0 > d) || (e.scrollTop < g && 0 < d))) return !0
            } // if deltaX && horizontal scrollable
            if (c && f.overflowX.match(/(scroll|auto)/)) {
              var i = e.scrollWidth - e.clientWidth
              if (0 < i && ((0 < e.scrollLeft && 0 > c) || (e.scrollLeft < i && 0 < c))) return !0
            }
            e = e.parentNode
          }
          return !1
        }
        function g(a) {
          var e = d(a),
            g = e[0],
            i = e[1]
          if (!f(a.target, g, i)) {
            var j = !1
            b.settings.useBothWheelAxes
              ? b.scrollbarYActive && !b.scrollbarXActive
                ? (i ? (h.scrollTop -= i * b.settings.wheelSpeed) : (h.scrollTop += g * b.settings.wheelSpeed),
                  (j = !0))
                : b.scrollbarXActive &&
                  !b.scrollbarYActive &&
                  (g ? (h.scrollLeft += g * b.settings.wheelSpeed) : (h.scrollLeft -= i * b.settings.wheelSpeed),
                  (j = !0))
              : ((h.scrollTop -= i * b.settings.wheelSpeed), (h.scrollLeft += g * b.settings.wheelSpeed)),
              q(b),
              (j = j || c(g, i)),
              j && !a.ctrlKey && (a.stopPropagation(), a.preventDefault())
          }
        }
        var h = b.element
        "undefined" == typeof window.onwheel
          ? "undefined" != typeof window.onmousewheel && b.event.bind(h, "mousewheel", g)
          : b.event.bind(h, "wheel", g)
      },
      touch: function (b) {
        function c(a, c) {
          var d = v(l.scrollTop),
            e = l.scrollLeft,
            f = u(a),
            g = u(c)
          if (g > f) {
            // user is perhaps trying to swipe up/down the page
            if ((0 > c && d === b.contentHeight - b.containerHeight) || (0 < c && 0 === d))
              // set prevent for mobile Chrome refresh
              return 0 === window.scrollY && 0 < c && E.isChrome
          } else if (f > g && ((0 > a && e === b.contentWidth - b.containerWidth) || (0 < a && 0 === e)))
            // user is perhaps trying to swipe left/right across the page
            return !0
          return !0
        }
        function d(a, c) {
          ;(l.scrollTop -= c), (l.scrollLeft -= a), q(b)
        }
        function f(a) {
          return a.targetTouches ? a.targetTouches[0] : a
        }
        function g(a) {
          return (
            !(a.pointerType && "pen" === a.pointerType && 0 === a.buttons) &&
            (!!(a.targetTouches && 1 === a.targetTouches.length) ||
              !!(a.pointerType && "mouse" !== a.pointerType && a.pointerType !== a.MSPOINTER_TYPE_MOUSE))
          )
        }
        function h(a) {
          if (g(a)) {
            var b = f(a)
            ;(m.pageX = b.pageX), (m.pageY = b.pageY), (n = new Date().getTime()), null !== p && clearInterval(p)
          }
        }
        function i(b, c, d) {
          if (!l.contains(b)) return !1
          for (var e = b; e && e !== l; ) {
            if (e.classList.contains(z.element.consuming)) return !0
            var f = a(e) // if deltaY && vertical scrollable
            if (d && f.overflowY.match(/(scroll|auto)/)) {
              var g = e.scrollHeight - e.clientHeight
              if (0 < g && ((0 < e.scrollTop && 0 > d) || (e.scrollTop < g && 0 < d))) return !0
            } // if deltaX && horizontal scrollable
            if (c && f.overflowX.match(/(scroll|auto)/)) {
              var h = e.scrollWidth - e.clientWidth
              if (0 < h && ((0 < e.scrollLeft && 0 > c) || (e.scrollLeft < h && 0 < c))) return !0
            }
            e = e.parentNode
          }
          return !1
        }
        function j(a) {
          if (g(a)) {
            var b = f(a),
              e = { pageX: b.pageX, pageY: b.pageY },
              h = e.pageX - m.pageX,
              j = e.pageY - m.pageY
            if (i(a.target, h, j)) return
            d(h, j), (m = e)
            var k = new Date().getTime(),
              l = k - n
            0 < l && ((o.x = h / l), (o.y = j / l), (n = k)), c(h, j) && a.preventDefault()
          }
        }
        function k() {
          b.settings.swipeEasing &&
            (clearInterval(p),
            (p = setInterval(function () {
              return b.isInitialized
                ? void clearInterval(p)
                : o.x || o.y
                  ? 0.01 > u(o.x) && 0.01 > u(o.y)
                    ? void clearInterval(p)
                    : b.element
                      ? void (d(30 * o.x, 30 * o.y), (o.x *= 0.8), (o.y *= 0.8))
                      : void clearInterval(p)
                  : void clearInterval(p)
            }, 10)))
        }
        if (E.supportsTouch || E.supportsIePointer) {
          var l = b.element,
            m = {},
            n = 0,
            o = {},
            p = null
          E.supportsTouch
            ? (b.event.bind(l, "touchstart", h), b.event.bind(l, "touchmove", j), b.event.bind(l, "touchend", k))
            : E.supportsIePointer &&
              (window.PointerEvent
                ? (b.event.bind(l, "pointerdown", h),
                  b.event.bind(l, "pointermove", j),
                  b.event.bind(l, "pointerup", k))
                : window.MSPointerEvent &&
                  (b.event.bind(l, "MSPointerDown", h),
                  b.event.bind(l, "MSPointerMove", j),
                  b.event.bind(l, "MSPointerUp", k)))
        }
      },
    },
    H = function (d, e) {
      var f = this
      if ((void 0 === e && (e = {}), "string" == typeof d && (d = document.querySelector(d)), !d || !d.nodeName))
        throw new Error("no element is specified to initialize PerfectScrollbar")
      for (var g in ((this.element = d), d.classList.add(z.main), (this.settings = F()), e)) this.settings[g] = e[g]
      ;(this.containerWidth = null),
        (this.containerHeight = null),
        (this.contentWidth = null),
        (this.contentHeight = null)
      var h = function () {
          return d.classList.add(z.state.focus)
        },
        i = function () {
          return d.classList.remove(z.state.focus)
        }
      ;(this.isRtl = "rtl" === a(d).direction),
        !0 === this.isRtl && d.classList.add(z.rtl),
        (this.isNegativeScroll = (function () {
          var a = d.scrollLeft,
            b = null
          return (d.scrollLeft = -1), (b = 0 > d.scrollLeft), (d.scrollLeft = a), b
        })()),
        (this.negativeScrollAdjustment = this.isNegativeScroll ? d.scrollWidth - d.clientWidth : 0),
        (this.event = new D()),
        (this.ownerDocument = d.ownerDocument || document),
        (this.scrollbarXRail = c(z.element.rail("x"))),
        d.appendChild(this.scrollbarXRail),
        (this.scrollbarX = c(z.element.thumb("x"))),
        this.scrollbarXRail.appendChild(this.scrollbarX),
        this.scrollbarX.setAttribute("tabindex", 0),
        this.event.bind(this.scrollbarX, "focus", h),
        this.event.bind(this.scrollbarX, "blur", i),
        (this.scrollbarXActive = null),
        (this.scrollbarXWidth = null),
        (this.scrollbarXLeft = null)
      var j = a(this.scrollbarXRail)
      ;(this.scrollbarXBottom = parseInt(j.bottom, 10)),
        isNaN(this.scrollbarXBottom)
          ? ((this.isScrollbarXUsingBottom = !1), (this.scrollbarXTop = n(j.top)))
          : (this.isScrollbarXUsingBottom = !0),
        (this.railBorderXWidth = n(j.borderLeftWidth) + n(j.borderRightWidth)),
        b(this.scrollbarXRail, { display: "block" }),
        (this.railXMarginWidth = n(j.marginLeft) + n(j.marginRight)),
        b(this.scrollbarXRail, { display: "" }),
        (this.railXWidth = null),
        (this.railXRatio = null),
        (this.scrollbarYRail = c(z.element.rail("y"))),
        d.appendChild(this.scrollbarYRail),
        (this.scrollbarY = c(z.element.thumb("y"))),
        this.scrollbarYRail.appendChild(this.scrollbarY),
        this.scrollbarY.setAttribute("tabindex", 0),
        this.event.bind(this.scrollbarY, "focus", h),
        this.event.bind(this.scrollbarY, "blur", i),
        (this.scrollbarYActive = null),
        (this.scrollbarYHeight = null),
        (this.scrollbarYTop = null)
      var k = a(this.scrollbarYRail)
      ;(this.scrollbarYRight = parseInt(k.right, 10)),
        isNaN(this.scrollbarYRight)
          ? ((this.isScrollbarYUsingRight = !1), (this.scrollbarYLeft = n(k.left)))
          : (this.isScrollbarYUsingRight = !0),
        (this.scrollbarYOuterWidth = this.isRtl ? p(this.scrollbarY) : null),
        (this.railBorderYWidth = n(k.borderTopWidth) + n(k.borderBottomWidth)),
        b(this.scrollbarYRail, { display: "block" }),
        (this.railYMarginHeight = n(k.marginTop) + n(k.marginBottom)),
        b(this.scrollbarYRail, { display: "" }),
        (this.railYHeight = null),
        (this.railYRatio = null),
        (this.reach = {
          x: 0 >= d.scrollLeft ? "start" : d.scrollLeft >= this.contentWidth - this.containerWidth ? "end" : null,
          y: 0 >= d.scrollTop ? "start" : d.scrollTop >= this.contentHeight - this.containerHeight ? "end" : null,
        }),
        (this.isAlive = !0),
        this.settings.handlers.forEach(function (a) {
          return G[a](f)
        }),
        (this.lastScrollTop = v(d.scrollTop)),
        (this.lastScrollLeft = d.scrollLeft),
        this.event.bind(this.element, "scroll", function (a) {
          return f.onScroll(a)
        }),
        q(this)
    }
  return (
    (H.prototype.update = function () {
      this.isAlive && // Recalcuate negative scrollLeft adjustment
        // Recalculate rail margins
        // Hide scrollbars not to affect scrollWidth and scrollHeight
        ((this.negativeScrollAdjustment = this.isNegativeScroll
          ? this.element.scrollWidth - this.element.clientWidth
          : 0),
        b(this.scrollbarXRail, { display: "block" }),
        b(this.scrollbarYRail, { display: "block" }),
        (this.railXMarginWidth = n(a(this.scrollbarXRail).marginLeft) + n(a(this.scrollbarXRail).marginRight)),
        (this.railYMarginHeight = n(a(this.scrollbarYRail).marginTop) + n(a(this.scrollbarYRail).marginBottom)),
        b(this.scrollbarXRail, { display: "none" }),
        b(this.scrollbarYRail, { display: "none" }),
        q(this),
        l(this, "top", 0, !1, !0),
        l(this, "left", 0, !1, !0),
        b(this.scrollbarXRail, { display: "" }),
        b(this.scrollbarYRail, { display: "" }))
    }),
    (H.prototype.onScroll = function () {
      this.isAlive &&
        (q(this),
        l(this, "top", this.element.scrollTop - this.lastScrollTop),
        l(this, "left", this.element.scrollLeft - this.lastScrollLeft),
        (this.lastScrollTop = v(this.element.scrollTop)),
        (this.lastScrollLeft = this.element.scrollLeft))
    }),
    (H.prototype.destroy = function () {
      this.isAlive && // unset elements
        (this.event.unbindAll(),
        e(this.scrollbarX),
        e(this.scrollbarY),
        e(this.scrollbarXRail),
        e(this.scrollbarYRail),
        this.removePsClasses(),
        (this.element = null),
        (this.scrollbarX = null),
        (this.scrollbarY = null),
        (this.scrollbarXRail = null),
        (this.scrollbarYRail = null),
        (this.isAlive = !1))
    }),
    (H.prototype.removePsClasses = function () {
      this.element.className = this.element.className
        .split(" ")
        .filter(function (a) {
          return !a.match(/^ps([-_].+|)$/)
        })
        .join(" ")
    }),
    H
  )
})

/*
 * This combined file was created by the DataTables downloader builder:
 *   https://datatables.net/download
 *
 * To rebuild or modify this file with the latest versions of the included
 * software please visit:
 *   https://datatables.net/download/#dt/dt-1.13.6/fh-3.4.0/r-2.5.0
 *
 * Included libraries:
 *   DataTables 1.13.6, FixedHeader 3.4.0, Responsive 2.5.0
 */

/*! DataTables 1.13.6
 * ©2008-2023 SpryMedia Ltd - datatables.net/license
 */
!(function (n) {
  "use strict"
  var a
  "function" == typeof define && define.amd
    ? define(["jquery"], function (t) {
        return n(t, window, document)
      })
    : "object" == typeof exports
      ? ((a = require("jquery")),
        "undefined" == typeof window
          ? (module.exports = function (t, e) {
              return (t = t || window), (e = e || a(t)), n(e, t, t.document)
            })
          : n(a, window, window.document))
      : (window.DataTable = n(jQuery, window, document))
})(function (P, j, v, H) {
  "use strict"
  function d(t) {
    var e = parseInt(t, 10)
    return !isNaN(e) && isFinite(t) ? e : null
  }
  function l(t, e, n) {
    var a = typeof t,
      r = "string" == a
    return (
      "number" == a ||
      "bigint" == a ||
      !!h(t) ||
      (e && r && (t = $(t, e)), n && r && (t = t.replace(q, "")), !isNaN(parseFloat(t)) && isFinite(t))
    )
  }
  function a(t, e, n) {
    var a
    return (
      !!h(t) || ((h((a = t)) || "string" == typeof a) && !!l(t.replace(V, "").replace(/<script/i, ""), e, n)) || null
    )
  }
  function m(t, e, n, a) {
    var r = [],
      o = 0,
      i = e.length
    if (a !== H) for (; o < i; o++) t[e[o]][n] && r.push(t[e[o]][n][a])
    else for (; o < i; o++) r.push(t[e[o]][n])
    return r
  }
  function f(t, e) {
    var n,
      a = []
    e === H ? ((e = 0), (n = t)) : ((n = e), (e = t))
    for (var r = e; r < n; r++) a.push(r)
    return a
  }
  function _(t) {
    for (var e = [], n = 0, a = t.length; n < a; n++) t[n] && e.push(t[n])
    return e
  }
  function s(t, e) {
    return -1 !== this.indexOf(t, (e = e === H ? 0 : e))
  }
  var p,
    e,
    t,
    w = function (t, v) {
      if (w.factory(t, v)) return w
      if (this instanceof w) return P(t).DataTable(v)
      ;(v = t),
        (this.$ = function (t, e) {
          return this.api(!0).$(t, e)
        }),
        (this._ = function (t, e) {
          return this.api(!0).rows(t, e).data()
        }),
        (this.api = function (t) {
          return new B(t ? ge(this[p.iApiIndex]) : this)
        }),
        (this.fnAddData = function (t, e) {
          var n = this.api(!0),
            t = (Array.isArray(t) && (Array.isArray(t[0]) || P.isPlainObject(t[0])) ? n.rows : n.row).add(t)
          return (e !== H && !e) || n.draw(), t.flatten().toArray()
        }),
        (this.fnAdjustColumnSizing = function (t) {
          var e = this.api(!0).columns.adjust(),
            n = e.settings()[0],
            a = n.oScroll
          t === H || t ? e.draw(!1) : ("" === a.sX && "" === a.sY) || Qt(n)
        }),
        (this.fnClearTable = function (t) {
          var e = this.api(!0).clear()
          ;(t !== H && !t) || e.draw()
        }),
        (this.fnClose = function (t) {
          this.api(!0).row(t).child.hide()
        }),
        (this.fnDeleteRow = function (t, e, n) {
          var a = this.api(!0),
            t = a.rows(t),
            r = t.settings()[0],
            o = r.aoData[t[0][0]]
          return t.remove(), e && e.call(this, r, o), (n !== H && !n) || a.draw(), o
        }),
        (this.fnDestroy = function (t) {
          this.api(!0).destroy(t)
        }),
        (this.fnDraw = function (t) {
          this.api(!0).draw(t)
        }),
        (this.fnFilter = function (t, e, n, a, r, o) {
          var i = this.api(!0)
          ;(null === e || e === H ? i : i.column(e)).search(t, n, a, o), i.draw()
        }),
        (this.fnGetData = function (t, e) {
          var n,
            a = this.api(!0)
          return t !== H
            ? ((n = t.nodeName ? t.nodeName.toLowerCase() : ""),
              e !== H || "td" == n || "th" == n ? a.cell(t, e).data() : a.row(t).data() || null)
            : a.data().toArray()
        }),
        (this.fnGetNodes = function (t) {
          var e = this.api(!0)
          return t !== H ? e.row(t).node() : e.rows().nodes().flatten().toArray()
        }),
        (this.fnGetPosition = function (t) {
          var e = this.api(!0),
            n = t.nodeName.toUpperCase()
          return "TR" == n
            ? e.row(t).index()
            : "TD" == n || "TH" == n
              ? [(n = e.cell(t).index()).row, n.columnVisible, n.column]
              : null
        }),
        (this.fnIsOpen = function (t) {
          return this.api(!0).row(t).child.isShown()
        }),
        (this.fnOpen = function (t, e, n) {
          return this.api(!0).row(t).child(e, n).show().child()[0]
        }),
        (this.fnPageChange = function (t, e) {
          t = this.api(!0).page(t)
          ;(e !== H && !e) || t.draw(!1)
        }),
        (this.fnSetColumnVis = function (t, e, n) {
          t = this.api(!0).column(t).visible(e)
          ;(n !== H && !n) || t.columns.adjust().draw()
        }),
        (this.fnSettings = function () {
          return ge(this[p.iApiIndex])
        }),
        (this.fnSort = function (t) {
          this.api(!0).order(t).draw()
        }),
        (this.fnSortListener = function (t, e, n) {
          this.api(!0).order.listener(t, e, n)
        }),
        (this.fnUpdate = function (t, e, n, a, r) {
          var o = this.api(!0)
          return (
            (n === H || null === n ? o.row(e) : o.cell(e, n)).data(t),
            (r !== H && !r) || o.columns.adjust(),
            (a !== H && !a) || o.draw(),
            0
          )
        }),
        (this.fnVersionCheck = p.fnVersionCheck)
      var e,
        y = this,
        D = v === H,
        _ = this.length
      for (e in (D && (v = {}), (this.oApi = this.internal = p.internal), w.ext.internal)) e && (this[e] = $e(e))
      return (
        this.each(function () {
          var r = 1 < _ ? be({}, v, !0) : v,
            o = 0,
            t = this.getAttribute("id"),
            i = !1,
            e = w.defaults,
            l = P(this)
          if ("table" != this.nodeName.toLowerCase())
            W(null, 0, "Non-table node initialisation (" + this.nodeName + ")", 2)
          else {
            K(e), Q(e.column), C(e, e, !0), C(e.column, e.column, !0), C(e, P.extend(r, l.data()), !0)
            for (var n = w.settings, o = 0, s = n.length; o < s; o++) {
              var a = n[o]
              if (
                a.nTable == this ||
                (a.nTHead && a.nTHead.parentNode == this) ||
                (a.nTFoot && a.nTFoot.parentNode == this)
              ) {
                var u = (r.bRetrieve !== H ? r : e).bRetrieve,
                  c = (r.bDestroy !== H ? r : e).bDestroy
                if (D || u) return a.oInstance
                if (c) {
                  a.oInstance.fnDestroy()
                  break
                }
                return void W(a, 0, "Cannot reinitialise DataTable", 3)
              }
              if (a.sTableId == this.id) {
                n.splice(o, 1)
                break
              }
            }
            ;(null !== t && "" !== t) || ((t = "DataTables_Table_" + w.ext._unique++), (this.id = t))
            var f,
              d,
              h = P.extend(!0, {}, w.models.oSettings, { sDestroyWidth: l[0].style.width, sInstance: t, sTableId: t }),
              p =
                ((h.nTable = this),
                (h.oApi = y.internal),
                (h.oInit = r),
                n.push(h),
                (h.oInstance = 1 === y.length ? y : l.dataTable()),
                K(r),
                Z(r.oLanguage),
                r.aLengthMenu &&
                  !r.iDisplayLength &&
                  (r.iDisplayLength = (Array.isArray(r.aLengthMenu[0]) ? r.aLengthMenu[0] : r.aLengthMenu)[0]),
                (r = be(P.extend(!0, {}, e), r)),
                F(h.oFeatures, r, [
                  "bPaginate",
                  "bLengthChange",
                  "bFilter",
                  "bSort",
                  "bSortMulti",
                  "bInfo",
                  "bProcessing",
                  "bAutoWidth",
                  "bSortClasses",
                  "bServerSide",
                  "bDeferRender",
                ]),
                F(h, r, [
                  "asStripeClasses",
                  "ajax",
                  "fnServerData",
                  "fnFormatNumber",
                  "sServerMethod",
                  "aaSorting",
                  "aaSortingFixed",
                  "aLengthMenu",
                  "sPaginationType",
                  "sAjaxSource",
                  "sAjaxDataProp",
                  "iStateDuration",
                  "sDom",
                  "bSortCellsTop",
                  "iTabIndex",
                  "fnStateLoadCallback",
                  "fnStateSaveCallback",
                  "renderer",
                  "searchDelay",
                  "rowId",
                  ["iCookieDuration", "iStateDuration"],
                  ["oSearch", "oPreviousSearch"],
                  ["aoSearchCols", "aoPreSearchCols"],
                  ["iDisplayLength", "_iDisplayLength"],
                ]),
                F(h.oScroll, r, [
                  ["sScrollX", "sX"],
                  ["sScrollXInner", "sXInner"],
                  ["sScrollY", "sY"],
                  ["bScrollCollapse", "bCollapse"],
                ]),
                F(h.oLanguage, r, "fnInfoCallback"),
                L(h, "aoDrawCallback", r.fnDrawCallback, "user"),
                L(h, "aoServerParams", r.fnServerParams, "user"),
                L(h, "aoStateSaveParams", r.fnStateSaveParams, "user"),
                L(h, "aoStateLoadParams", r.fnStateLoadParams, "user"),
                L(h, "aoStateLoaded", r.fnStateLoaded, "user"),
                L(h, "aoRowCallback", r.fnRowCallback, "user"),
                L(h, "aoRowCreatedCallback", r.fnCreatedRow, "user"),
                L(h, "aoHeaderCallback", r.fnHeaderCallback, "user"),
                L(h, "aoFooterCallback", r.fnFooterCallback, "user"),
                L(h, "aoInitComplete", r.fnInitComplete, "user"),
                L(h, "aoPreDrawCallback", r.fnPreDrawCallback, "user"),
                (h.rowIdFn = A(r.rowId)),
                tt(h),
                h.oClasses),
              g =
                (P.extend(p, w.ext.classes, r.oClasses),
                l.addClass(p.sTable),
                h.iInitDisplayStart === H &&
                  ((h.iInitDisplayStart = r.iDisplayStart), (h._iDisplayStart = r.iDisplayStart)),
                null !== r.iDeferLoading &&
                  ((h.bDeferLoading = !0),
                  (t = Array.isArray(r.iDeferLoading)),
                  (h._iRecordsDisplay = t ? r.iDeferLoading[0] : r.iDeferLoading),
                  (h._iRecordsTotal = t ? r.iDeferLoading[1] : r.iDeferLoading)),
                h.oLanguage),
              t =
                (P.extend(!0, g, r.oLanguage),
                g.sUrl
                  ? (P.ajax({
                      dataType: "json",
                      url: g.sUrl,
                      success: function (t) {
                        C(e.oLanguage, t), Z(t), P.extend(!0, g, t, h.oInit.oLanguage), R(h, null, "i18n", [h]), Jt(h)
                      },
                      error: function () {
                        Jt(h)
                      },
                    }),
                    (i = !0))
                  : R(h, null, "i18n", [h]),
                null === r.asStripeClasses && (h.asStripeClasses = [p.sStripeOdd, p.sStripeEven]),
                h.asStripeClasses),
              b = l.children("tbody").find("tr").eq(0),
              m =
                (-1 !==
                  P.inArray(
                    !0,
                    P.map(t, function (t, e) {
                      return b.hasClass(t)
                    }),
                  ) && (P("tbody tr", this).removeClass(t.join(" ")), (h.asDestroyStripes = t.slice())),
                []),
              t = this.getElementsByTagName("thead")
            if ((0 !== t.length && (wt(h.aoHeader, t[0]), (m = Ct(h))), null === r.aoColumns))
              for (f = [], o = 0, s = m.length; o < s; o++) f.push(null)
            else f = r.aoColumns
            for (o = 0, s = f.length; o < s; o++) nt(h, m ? m[o] : null)
            st(h, r.aoColumnDefs, f, function (t, e) {
              at(h, t, e)
            }),
              b.length &&
                ((d = function (t, e) {
                  return null !== t.getAttribute("data-" + e) ? e : null
                }),
                P(b[0])
                  .children("th, td")
                  .each(function (t, e) {
                    var n,
                      a = h.aoColumns[t]
                    a || W(h, 0, "Incorrect column count", 18),
                      a.mData === t &&
                        ((n = d(e, "sort") || d(e, "order")),
                        (e = d(e, "filter") || d(e, "search")),
                        (null === n && null === e) ||
                          ((a.mData = {
                            _: t + ".display",
                            sort: null !== n ? t + ".@data-" + n : H,
                            type: null !== n ? t + ".@data-" + n : H,
                            filter: null !== e ? t + ".@data-" + e : H,
                          }),
                          (a._isArrayHost = !0),
                          at(h, t)))
                  }))
            var S = h.oFeatures,
              t = function () {
                if (r.aaSorting === H) {
                  var t = h.aaSorting
                  for (o = 0, s = t.length; o < s; o++) t[o][1] = h.aoColumns[o].asSorting[0]
                }
                ce(h),
                  S.bSort &&
                    L(h, "aoDrawCallback", function () {
                      var t, n
                      h.bSorted &&
                        ((t = I(h)),
                        (n = {}),
                        P.each(t, function (t, e) {
                          n[e.src] = e.dir
                        }),
                        R(h, null, "order", [h, t, n]),
                        le(h))
                    }),
                  L(
                    h,
                    "aoDrawCallback",
                    function () {
                      ;(h.bSorted || "ssp" === E(h) || S.bDeferRender) && ce(h)
                    },
                    "sc",
                  )
                var e = l.children("caption").each(function () {
                    this._captionSide = P(this).css("caption-side")
                  }),
                  n = l.children("thead"),
                  a = (0 === n.length && (n = P("<thead/>").appendTo(l)), (h.nTHead = n[0]), l.children("tbody")),
                  n = (0 === a.length && (a = P("<tbody/>").insertAfter(n)), (h.nTBody = a[0]), l.children("tfoot"))
                if (
                  (0 ===
                    (n =
                      0 === n.length && 0 < e.length && ("" !== h.oScroll.sX || "" !== h.oScroll.sY)
                        ? P("<tfoot/>").appendTo(l)
                        : n).length || 0 === n.children().length
                    ? l.addClass(p.sNoFooter)
                    : 0 < n.length && ((h.nTFoot = n[0]), wt(h.aoFooter, h.nTFoot)),
                  r.aaData)
                )
                  for (o = 0; o < r.aaData.length; o++) x(h, r.aaData[o])
                else (!h.bDeferLoading && "dom" != E(h)) || ut(h, P(h.nTBody).children("tr"))
                ;(h.aiDisplay = h.aiDisplayMaster.slice()), !(h.bInitialised = !0) === i && Jt(h)
              }
            L(h, "aoDrawCallback", de, "state_save"), r.bStateSave ? ((S.bStateSave = !0), he(h, 0, t)) : t()
          }
        }),
        (y = null),
        this
      )
    },
    c = {},
    U = /[\r\n\u2028]/g,
    V = /<.*?>/g,
    X = /^\d{2,4}[\.\/\-]\d{1,2}[\.\/\-]\d{1,2}([T ]{1}\d{1,2}[:\.]\d{2}([\.:]\d{2})?)?$/,
    J = new RegExp(
      "(\\" + ["/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^", "-"].join("|\\") + ")",
      "g",
    ),
    q = /['\u00A0,$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi,
    h = function (t) {
      return !t || !0 === t || "-" === t
    },
    $ = function (t, e) {
      return (
        c[e] || (c[e] = new RegExp(Ot(e), "g")),
        "string" == typeof t && "." !== e ? t.replace(/\./g, "").replace(c[e], ".") : t
      )
    },
    N = function (t, e, n) {
      var a = [],
        r = 0,
        o = t.length
      if (n !== H) for (; r < o; r++) t[r] && t[r][e] && a.push(t[r][e][n])
      else for (; r < o; r++) t[r] && a.push(t[r][e])
      return a
    },
    G = function (t) {
      if (!(t.length < 2))
        for (var e = t.slice().sort(), n = e[0], a = 1, r = e.length; a < r; a++) {
          if (e[a] === n) return !1
          n = e[a]
        }
      return !0
    },
    z = function (t) {
      if (G(t)) return t.slice()
      var e,
        n,
        a,
        r = [],
        o = t.length,
        i = 0
      t: for (n = 0; n < o; n++) {
        for (e = t[n], a = 0; a < i; a++) if (r[a] === e) continue t
        r.push(e), i++
      }
      return r
    },
    Y = function (t, e) {
      if (Array.isArray(e)) for (var n = 0; n < e.length; n++) Y(t, e[n])
      else t.push(e)
      return t
    }
  function i(n) {
    var a,
      r,
      o = {}
    P.each(n, function (t, e) {
      ;(a = t.match(/^([^A-Z]+?)([A-Z])/)) &&
        -1 !== "a aa ai ao as b fn i m o s ".indexOf(a[1] + " ") &&
        ((r = t.replace(a[0], a[2].toLowerCase())), (o[r] = t), "o" === a[1]) &&
        i(n[t])
    }),
      (n._hungarianMap = o)
  }
  function C(n, a, r) {
    var o
    n._hungarianMap || i(n),
      P.each(a, function (t, e) {
        ;(o = n._hungarianMap[t]) === H ||
          (!r && a[o] !== H) ||
          ("o" === o.charAt(0) ? (a[o] || (a[o] = {}), P.extend(!0, a[o], a[t]), C(n[o], a[o], r)) : (a[o] = a[t]))
      })
  }
  function Z(t) {
    var e,
      n = w.defaults.oLanguage,
      a = n.sDecimal
    a && Me(a),
      t &&
        ((e = t.sZeroRecords),
        !t.sEmptyTable && e && "No data available in table" === n.sEmptyTable && F(t, t, "sZeroRecords", "sEmptyTable"),
        !t.sLoadingRecords && e && "Loading..." === n.sLoadingRecords && F(t, t, "sZeroRecords", "sLoadingRecords"),
        t.sInfoThousands && (t.sThousands = t.sInfoThousands),
        (e = t.sDecimal)) &&
        a !== e &&
        Me(e)
  }
  Array.isArray ||
    (Array.isArray = function (t) {
      return "[object Array]" === Object.prototype.toString.call(t)
    }),
    Array.prototype.includes || (Array.prototype.includes = s),
    String.prototype.trim ||
      (String.prototype.trim = function () {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "")
      }),
    String.prototype.includes || (String.prototype.includes = s),
    (w.util = {
      throttle: function (a, t) {
        var r,
          o,
          i = t !== H ? t : 200
        return function () {
          var t = this,
            e = +new Date(),
            n = arguments
          r && e < r + i
            ? (clearTimeout(o),
              (o = setTimeout(function () {
                ;(r = H), a.apply(t, n)
              }, i)))
            : ((r = e), a.apply(t, n))
        }
      },
      escapeRegex: function (t) {
        return t.replace(J, "\\$1")
      },
      set: function (a) {
        var d
        return P.isPlainObject(a)
          ? w.util.set(a._)
          : null === a
            ? function () {}
            : "function" == typeof a
              ? function (t, e, n) {
                  a(t, "set", e, n)
                }
              : "string" != typeof a || (-1 === a.indexOf(".") && -1 === a.indexOf("[") && -1 === a.indexOf("("))
                ? function (t, e) {
                    t[a] = e
                  }
                : ((d = function (t, e, n) {
                    for (var a, r, o, i, l = dt(n), n = l[l.length - 1], s = 0, u = l.length - 1; s < u; s++) {
                      if ("__proto__" === l[s] || "constructor" === l[s]) throw new Error("Cannot set prototype values")
                      if (((a = l[s].match(ft)), (r = l[s].match(g)), a)) {
                        if (
                          ((l[s] = l[s].replace(ft, "")),
                          (t[l[s]] = []),
                          (a = l.slice()).splice(0, s + 1),
                          (i = a.join(".")),
                          Array.isArray(e))
                        )
                          for (var c = 0, f = e.length; c < f; c++) d((o = {}), e[c], i), t[l[s]].push(o)
                        else t[l[s]] = e
                        return
                      }
                      r && ((l[s] = l[s].replace(g, "")), (t = t[l[s]](e))),
                        (null !== t[l[s]] && t[l[s]] !== H) || (t[l[s]] = {}),
                        (t = t[l[s]])
                    }
                    n.match(g) ? t[n.replace(g, "")](e) : (t[n.replace(ft, "")] = e)
                  }),
                  function (t, e) {
                    return d(t, e, a)
                  })
      },
      get: function (r) {
        var o, d
        return P.isPlainObject(r)
          ? ((o = {}),
            P.each(r, function (t, e) {
              e && (o[t] = w.util.get(e))
            }),
            function (t, e, n, a) {
              var r = o[e] || o._
              return r !== H ? r(t, e, n, a) : t
            })
          : null === r
            ? function (t) {
                return t
              }
            : "function" == typeof r
              ? function (t, e, n, a) {
                  return r(t, e, n, a)
                }
              : "string" != typeof r || (-1 === r.indexOf(".") && -1 === r.indexOf("[") && -1 === r.indexOf("("))
                ? function (t, e) {
                    return t[r]
                  }
                : ((d = function (t, e, n) {
                    var a, r, o
                    if ("" !== n)
                      for (var i = dt(n), l = 0, s = i.length; l < s; l++) {
                        if (((f = i[l].match(ft)), (a = i[l].match(g)), f)) {
                          if (
                            ((i[l] = i[l].replace(ft, "")),
                            "" !== i[l] && (t = t[i[l]]),
                            (r = []),
                            i.splice(0, l + 1),
                            (o = i.join(".")),
                            Array.isArray(t))
                          )
                            for (var u = 0, c = t.length; u < c; u++) r.push(d(t[u], e, o))
                          var f = f[0].substring(1, f[0].length - 1)
                          t = "" === f ? r : r.join(f)
                          break
                        }
                        if (a) (i[l] = i[l].replace(g, "")), (t = t[i[l]]())
                        else {
                          if (null === t || null === t[i[l]]) return null
                          if (t === H || t[i[l]] === H) return H
                          t = t[i[l]]
                        }
                      }
                    return t
                  }),
                  function (t, e) {
                    return d(t, e, r)
                  })
      },
    })
  var r = function (t, e, n) {
    t[e] !== H && (t[n] = t[e])
  }
  function K(t) {
    r(t, "ordering", "bSort"),
      r(t, "orderMulti", "bSortMulti"),
      r(t, "orderClasses", "bSortClasses"),
      r(t, "orderCellsTop", "bSortCellsTop"),
      r(t, "order", "aaSorting"),
      r(t, "orderFixed", "aaSortingFixed"),
      r(t, "paging", "bPaginate"),
      r(t, "pagingType", "sPaginationType"),
      r(t, "pageLength", "iDisplayLength"),
      r(t, "searching", "bFilter"),
      "boolean" == typeof t.sScrollX && (t.sScrollX = t.sScrollX ? "100%" : ""),
      "boolean" == typeof t.scrollX && (t.scrollX = t.scrollX ? "100%" : "")
    var e = t.aoSearchCols
    if (e) for (var n = 0, a = e.length; n < a; n++) e[n] && C(w.models.oSearch, e[n])
  }
  function Q(t) {
    r(t, "orderable", "bSortable"),
      r(t, "orderData", "aDataSort"),
      r(t, "orderSequence", "asSorting"),
      r(t, "orderDataType", "sortDataType")
    var e = t.aDataSort
    "number" != typeof e || Array.isArray(e) || (t.aDataSort = [e])
  }
  function tt(t) {
    var e, n, a, r
    w.__browser ||
      ((w.__browser = e = {}),
      (r = (a = (n = P("<div/>")
        .css({ position: "fixed", top: 0, left: -1 * P(j).scrollLeft(), height: 1, width: 1, overflow: "hidden" })
        .append(
          P("<div/>")
            .css({ position: "absolute", top: 1, left: 1, width: 100, overflow: "scroll" })
            .append(P("<div/>").css({ width: "100%", height: 10 })),
        )
        .appendTo("body")).children()).children()),
      (e.barWidth = a[0].offsetWidth - a[0].clientWidth),
      (e.bScrollOversize = 100 === r[0].offsetWidth && 100 !== a[0].clientWidth),
      (e.bScrollbarLeft = 1 !== Math.round(r.offset().left)),
      (e.bBounding = !!n[0].getBoundingClientRect().width),
      n.remove()),
      P.extend(t.oBrowser, w.__browser),
      (t.oScroll.iBarWidth = w.__browser.barWidth)
  }
  function et(t, e, n, a, r, o) {
    var i,
      l = a,
      s = !1
    for (n !== H && ((i = n), (s = !0)); l !== r; )
      t.hasOwnProperty(l) && ((i = s ? e(i, t[l], l, t) : t[l]), (s = !0), (l += o))
    return i
  }
  function nt(t, e) {
    var n = w.defaults.column,
      a = t.aoColumns.length,
      n = P.extend({}, w.models.oColumn, n, {
        nTh: e || v.createElement("th"),
        sTitle: n.sTitle || (e ? e.innerHTML : ""),
        aDataSort: n.aDataSort || [a],
        mData: n.mData || a,
        idx: a,
      }),
      n = (t.aoColumns.push(n), t.aoPreSearchCols)
    ;(n[a] = P.extend({}, w.models.oSearch, n[a])), at(t, a, P(e).data())
  }
  function at(t, e, n) {
    function a(t) {
      return "string" == typeof t && -1 !== t.indexOf("@")
    }
    var e = t.aoColumns[e],
      r = t.oClasses,
      o = P(e.nTh),
      i =
        (!e.sWidthOrig &&
          ((e.sWidthOrig = o.attr("width") || null), (u = (o.attr("style") || "").match(/width:\s*(\d+[pxem%]+)/))) &&
          (e.sWidthOrig = u[1]),
        n !== H &&
          null !== n &&
          (Q(n),
          C(w.defaults.column, n, !0),
          n.mDataProp === H || n.mData || (n.mData = n.mDataProp),
          n.sType && (e._sManualType = n.sType),
          n.className && !n.sClass && (n.sClass = n.className),
          n.sClass && o.addClass(n.sClass),
          (u = e.sClass),
          P.extend(e, n),
          F(e, n, "sWidth", "sWidthOrig"),
          u !== e.sClass && (e.sClass = u + " " + e.sClass),
          n.iDataSort !== H && (e.aDataSort = [n.iDataSort]),
          F(e, n, "aDataSort"),
          e.ariaTitle || (e.ariaTitle = o.attr("aria-label"))),
        e.mData),
      l = A(i),
      s = e.mRender ? A(e.mRender) : null,
      u =
        ((e._bAttrSrc = P.isPlainObject(i) && (a(i.sort) || a(i.type) || a(i.filter))),
        (e._setter = null),
        (e.fnGetData = function (t, e, n) {
          var a = l(t, e, H, n)
          return s && e ? s(a, e, t, n) : a
        }),
        (e.fnSetData = function (t, e, n) {
          return b(i)(t, e, n)
        }),
        "number" == typeof i || e._isArrayHost || (t._rowReadObject = !0),
        t.oFeatures.bSort || ((e.bSortable = !1), o.addClass(r.sSortableNone)),
        -1 !== P.inArray("asc", e.asSorting)),
      n = -1 !== P.inArray("desc", e.asSorting)
    e.bSortable && (u || n)
      ? u && !n
        ? ((e.sSortingClass = r.sSortableAsc), (e.sSortingClassJUI = r.sSortJUIAscAllowed))
        : !u && n
          ? ((e.sSortingClass = r.sSortableDesc), (e.sSortingClassJUI = r.sSortJUIDescAllowed))
          : ((e.sSortingClass = r.sSortable), (e.sSortingClassJUI = r.sSortJUI))
      : ((e.sSortingClass = r.sSortableNone), (e.sSortingClassJUI = ""))
  }
  function O(t) {
    if (!1 !== t.oFeatures.bAutoWidth) {
      var e = t.aoColumns
      ee(t)
      for (var n = 0, a = e.length; n < a; n++) e[n].nTh.style.width = e[n].sWidth
    }
    var r = t.oScroll
    ;("" === r.sY && "" === r.sX) || Qt(t), R(t, null, "column-sizing", [t])
  }
  function rt(t, e) {
    t = it(t, "bVisible")
    return "number" == typeof t[e] ? t[e] : null
  }
  function ot(t, e) {
    ;(t = it(t, "bVisible")), (e = P.inArray(e, t))
    return -1 !== e ? e : null
  }
  function T(t) {
    var n = 0
    return (
      P.each(t.aoColumns, function (t, e) {
        e.bVisible && "none" !== P(e.nTh).css("display") && n++
      }),
      n
    )
  }
  function it(t, n) {
    var a = []
    return (
      P.map(t.aoColumns, function (t, e) {
        t[n] && a.push(e)
      }),
      a
    )
  }
  function lt(t) {
    for (var e, n, a, r, o, i, l, s = t.aoColumns, u = t.aoData, c = w.ext.type.detect, f = 0, d = s.length; f < d; f++)
      if (((l = []), !(o = s[f]).sType && o._sManualType)) o.sType = o._sManualType
      else if (!o.sType) {
        for (e = 0, n = c.length; e < n; e++) {
          for (
            a = 0, r = u.length;
            a < r &&
            (l[a] === H && (l[a] = S(t, a, f, "type")), (i = c[e](l[a], t)) || e === c.length - 1) &&
            ("html" !== i || h(l[a]));
            a++
          );
          if (i) {
            o.sType = i
            break
          }
        }
        o.sType || (o.sType = "string")
      }
  }
  function st(t, e, n, a) {
    var r,
      o,
      i,
      l,
      s = t.aoColumns
    if (e)
      for (r = e.length - 1; 0 <= r; r--)
        for (
          var u,
            c = (u = e[r]).target !== H ? u.target : u.targets !== H ? u.targets : u.aTargets,
            f = 0,
            d = (c = Array.isArray(c) ? c : [c]).length;
          f < d;
          f++
        )
          if ("number" == typeof c[f] && 0 <= c[f]) {
            for (; s.length <= c[f]; ) nt(t)
            a(c[f], u)
          } else if ("number" == typeof c[f] && c[f] < 0) a(s.length + c[f], u)
          else if ("string" == typeof c[f])
            for (i = 0, l = s.length; i < l; i++) ("_all" != c[f] && !P(s[i].nTh).hasClass(c[f])) || a(i, u)
    if (n) for (r = 0, o = n.length; r < o; r++) a(r, n[r])
  }
  function x(t, e, n, a) {
    for (
      var r = t.aoData.length,
        o = P.extend(!0, {}, w.models.oRow, { src: n ? "dom" : "data", idx: r }),
        i = ((o._aData = e), t.aoData.push(o), t.aoColumns),
        l = 0,
        s = i.length;
      l < s;
      l++
    )
      i[l].sType = null
    t.aiDisplayMaster.push(r)
    e = t.rowIdFn(e)
    return e !== H && (t.aIds[e] = o), (!n && t.oFeatures.bDeferRender) || St(t, r, n, a), r
  }
  function ut(n, t) {
    var a
    return (t = t instanceof P ? t : P(t)).map(function (t, e) {
      return (a = mt(n, e)), x(n, a.data, e, a.cells)
    })
  }
  function S(t, e, n, a) {
    "search" === a ? (a = "filter") : "order" === a && (a = "sort")
    var r = t.iDraw,
      o = t.aoColumns[n],
      i = t.aoData[e]._aData,
      l = o.sDefaultContent,
      s = o.fnGetData(i, a, { settings: t, row: e, col: n })
    if (s === H)
      return (
        t.iDrawError != r &&
          null === l &&
          (W(
            t,
            0,
            "Requested unknown parameter " +
              ("function" == typeof o.mData ? "{function}" : "'" + o.mData + "'") +
              " for row " +
              e +
              ", column " +
              n,
            4,
          ),
          (t.iDrawError = r)),
        l
      )
    if ((s !== i && null !== s) || null === l || a === H) {
      if ("function" == typeof s) return s.call(i)
    } else s = l
    return null === s && "display" === a ? "" : "filter" === a && (e = w.ext.type.search)[o.sType] ? e[o.sType](s) : s
  }
  function ct(t, e, n, a) {
    var r = t.aoColumns[n],
      o = t.aoData[e]._aData
    r.fnSetData(o, a, { settings: t, row: e, col: n })
  }
  var ft = /\[.*?\]$/,
    g = /\(\)$/
  function dt(t) {
    return P.map(t.match(/(\\.|[^\.])+/g) || [""], function (t) {
      return t.replace(/\\\./g, ".")
    })
  }
  var A = w.util.get,
    b = w.util.set
  function ht(t) {
    return N(t.aoData, "_aData")
  }
  function pt(t) {
    ;(t.aoData.length = 0), (t.aiDisplayMaster.length = 0), (t.aiDisplay.length = 0), (t.aIds = {})
  }
  function gt(t, e, n) {
    for (var a = -1, r = 0, o = t.length; r < o; r++) t[r] == e ? (a = r) : t[r] > e && t[r]--
    ;-1 != a && n === H && t.splice(a, 1)
  }
  function bt(n, a, t, e) {
    function r(t, e) {
      for (; t.childNodes.length; ) t.removeChild(t.firstChild)
      t.innerHTML = S(n, a, e, "display")
    }
    var o,
      i,
      l = n.aoData[a]
    if ("dom" !== t && ((t && "auto" !== t) || "dom" !== l.src)) {
      var s = l.anCells
      if (s)
        if (e !== H) r(s[e], e)
        else for (o = 0, i = s.length; o < i; o++) r(s[o], o)
    } else l._aData = mt(n, l, e, e === H ? H : l._aData).data
    ;(l._aSortData = null), (l._aFilterData = null)
    var u = n.aoColumns
    if (e !== H) u[e].sType = null
    else {
      for (o = 0, i = u.length; o < i; o++) u[o].sType = null
      vt(n, l)
    }
  }
  function mt(t, e, n, a) {
    function r(t, e) {
      var n
      "string" == typeof t && -1 !== (n = t.indexOf("@")) && ((n = t.substring(n + 1)), b(t)(a, e.getAttribute(n)))
    }
    function o(t) {
      ;(n !== H && n !== f) ||
        ((l = d[f]),
        (s = t.innerHTML.trim()),
        l && l._bAttrSrc
          ? (b(l.mData._)(a, s), r(l.mData.sort, t), r(l.mData.type, t), r(l.mData.filter, t))
          : h
            ? (l._setter || (l._setter = b(l.mData)), l._setter(a, s))
            : (a[f] = s)),
        f++
    }
    var i,
      l,
      s,
      u = [],
      c = e.firstChild,
      f = 0,
      d = t.aoColumns,
      h = t._rowReadObject
    a = a !== H ? a : h ? {} : []
    if (c) for (; c; ) ("TD" != (i = c.nodeName.toUpperCase()) && "TH" != i) || (o(c), u.push(c)), (c = c.nextSibling)
    else for (var p = 0, g = (u = e.anCells).length; p < g; p++) o(u[p])
    var e = e.firstChild ? e : e.nTr
    return e && (e = e.getAttribute("id")) && b(t.rowId)(a, e), { data: a, cells: u }
  }
  function St(t, e, n, a) {
    var r,
      o,
      i,
      l,
      s,
      u,
      c = t.aoData[e],
      f = c._aData,
      d = []
    if (null === c.nTr) {
      for (
        r = n || v.createElement("tr"),
          c.nTr = r,
          c.anCells = d,
          r._DT_RowIndex = e,
          vt(t, c),
          l = 0,
          s = t.aoColumns.length;
        l < s;
        l++
      )
        (i = t.aoColumns[l]),
          (o = (u = !n) ? v.createElement(i.sCellType) : a[l]) || W(t, 0, "Incorrect column count", 18),
          (o._DT_CellIndex = { row: e, column: l }),
          d.push(o),
          (!u && ((!i.mRender && i.mData === l) || (P.isPlainObject(i.mData) && i.mData._ === l + ".display"))) ||
            (o.innerHTML = S(t, e, l, "display")),
          i.sClass && (o.className += " " + i.sClass),
          i.bVisible && !n ? r.appendChild(o) : !i.bVisible && n && o.parentNode.removeChild(o),
          i.fnCreatedCell && i.fnCreatedCell.call(t.oInstance, o, S(t, e, l), f, e, l)
      R(t, "aoRowCreatedCallback", null, [r, f, e, d])
    }
  }
  function vt(t, e) {
    var n = e.nTr,
      a = e._aData
    n &&
      ((t = t.rowIdFn(a)) && (n.id = t),
      a.DT_RowClass &&
        ((t = a.DT_RowClass.split(" ")),
        (e.__rowc = e.__rowc ? z(e.__rowc.concat(t)) : t),
        P(n).removeClass(e.__rowc.join(" ")).addClass(a.DT_RowClass)),
      a.DT_RowAttr && P(n).attr(a.DT_RowAttr),
      a.DT_RowData) &&
      P(n).data(a.DT_RowData)
  }
  function yt(t) {
    var e,
      n,
      a,
      r = t.nTHead,
      o = t.nTFoot,
      i = 0 === P("th, td", r).length,
      l = t.oClasses,
      s = t.aoColumns
    for (i && (n = P("<tr/>").appendTo(r)), c = 0, f = s.length; c < f; c++)
      (a = s[c]),
        (e = P(a.nTh).addClass(a.sClass)),
        i && e.appendTo(n),
        t.oFeatures.bSort &&
          (e.addClass(a.sSortingClass), !1 !== a.bSortable) &&
          (e.attr("tabindex", t.iTabIndex).attr("aria-controls", t.sTableId), ue(t, a.nTh, c)),
        a.sTitle != e[0].innerHTML && e.html(a.sTitle),
        ve(t, "header")(t, e, a, l)
    if (
      (i && wt(t.aoHeader, r),
      P(r).children("tr").children("th, td").addClass(l.sHeaderTH),
      P(o).children("tr").children("th, td").addClass(l.sFooterTH),
      null !== o)
    )
      for (var u = t.aoFooter[0], c = 0, f = u.length; c < f; c++)
        (a = s[c])
          ? ((a.nTf = u[c].cell), a.sClass && P(a.nTf).addClass(a.sClass))
          : W(t, 0, "Incorrect column count", 18)
  }
  function Dt(t, e, n) {
    var a,
      r,
      o,
      i,
      l,
      s,
      u,
      c,
      f,
      d = [],
      h = [],
      p = t.aoColumns.length
    if (e) {
      for (n === H && (n = !1), a = 0, r = e.length; a < r; a++) {
        for (d[a] = e[a].slice(), d[a].nTr = e[a].nTr, o = p - 1; 0 <= o; o--)
          t.aoColumns[o].bVisible || n || d[a].splice(o, 1)
        h.push([])
      }
      for (a = 0, r = d.length; a < r; a++) {
        if ((u = d[a].nTr)) for (; (s = u.firstChild); ) u.removeChild(s)
        for (o = 0, i = d[a].length; o < i; o++)
          if (((f = c = 1), h[a][o] === H)) {
            for (u.appendChild(d[a][o].cell), h[a][o] = 1; d[a + c] !== H && d[a][o].cell == d[a + c][o].cell; )
              (h[a + c][o] = 1), c++
            for (; d[a][o + f] !== H && d[a][o].cell == d[a][o + f].cell; ) {
              for (l = 0; l < c; l++) h[a + l][o + f] = 1
              f++
            }
            P(d[a][o].cell).attr("rowspan", c).attr("colspan", f)
          }
      }
    }
  }
  function y(t, e) {
    ;(n = "ssp" == E((s = t))),
      (l = s.iInitDisplayStart) !== H &&
        -1 !== l &&
        ((s._iDisplayStart = !n && l >= s.fnRecordsDisplay() ? 0 : l), (s.iInitDisplayStart = -1))
    var n = R(t, "aoPreDrawCallback", "preDraw", [t])
    if (-1 !== P.inArray(!1, n)) D(t, !1)
    else {
      var a = [],
        r = 0,
        o = t.asStripeClasses,
        i = o.length,
        l = t.oLanguage,
        s = "ssp" == E(t),
        u = t.aiDisplay,
        n = t._iDisplayStart,
        c = t.fnDisplayEnd()
      if (((t.bDrawing = !0), t.bDeferLoading)) (t.bDeferLoading = !1), t.iDraw++, D(t, !1)
      else if (s) {
        if (!t.bDestroying && !e) return void xt(t)
      } else t.iDraw++
      if (0 !== u.length)
        for (var f = s ? t.aoData.length : c, d = s ? 0 : n; d < f; d++) {
          var h,
            p = u[d],
            g = t.aoData[p],
            b = (null === g.nTr && St(t, p), g.nTr)
          0 !== i &&
            ((h = o[r % i]), g._sRowStripe != h) &&
            (P(b).removeClass(g._sRowStripe).addClass(h), (g._sRowStripe = h)),
            R(t, "aoRowCallback", null, [b, g._aData, r, d, p]),
            a.push(b),
            r++
        }
      else {
        e = l.sZeroRecords
        1 == t.iDraw && "ajax" == E(t)
          ? (e = l.sLoadingRecords)
          : l.sEmptyTable && 0 === t.fnRecordsTotal() && (e = l.sEmptyTable),
          (a[0] = P("<tr/>", { class: i ? o[0] : "" }).append(
            P("<td />", { valign: "top", colSpan: T(t), class: t.oClasses.sRowEmpty }).html(e),
          )[0])
      }
      R(t, "aoHeaderCallback", "header", [P(t.nTHead).children("tr")[0], ht(t), n, c, u]),
        R(t, "aoFooterCallback", "footer", [P(t.nTFoot).children("tr")[0], ht(t), n, c, u])
      s = P(t.nTBody)
      s.children().detach(),
        s.append(P(a)),
        R(t, "aoDrawCallback", "draw", [t]),
        (t.bSorted = !1),
        (t.bFiltered = !1),
        (t.bDrawing = !1)
    }
  }
  function u(t, e) {
    var n = t.oFeatures,
      a = n.bSort,
      n = n.bFilter
    a && ie(t),
      n ? Rt(t, t.oPreviousSearch) : (t.aiDisplay = t.aiDisplayMaster.slice()),
      !0 !== e && (t._iDisplayStart = 0),
      (t._drawHold = e),
      y(t),
      (t._drawHold = !1)
  }
  function _t(t) {
    for (
      var e,
        n,
        a,
        r,
        o,
        i,
        l,
        s = t.oClasses,
        u = P(t.nTable),
        u = P("<div/>").insertBefore(u),
        c = t.oFeatures,
        f = P("<div/>", { id: t.sTableId + "_wrapper", class: s.sWrapper + (t.nTFoot ? "" : " " + s.sNoFooter) }),
        d =
          ((t.nHolding = u[0]),
          (t.nTableWrapper = f[0]),
          (t.nTableReinsertBefore = t.nTable.nextSibling),
          t.sDom.split("")),
        h = 0;
      h < d.length;
      h++
    ) {
      if (((e = null), "<" == (n = d[h]))) {
        if (((a = P("<div/>")[0]), "'" == (r = d[h + 1]) || '"' == r)) {
          for (o = "", i = 2; d[h + i] != r; ) (o += d[h + i]), i++
          "H" == o ? (o = s.sJUIHeader) : "F" == o && (o = s.sJUIFooter),
            -1 != o.indexOf(".")
              ? ((l = o.split(".")), (a.id = l[0].substr(1, l[0].length - 1)), (a.className = l[1]))
              : "#" == o.charAt(0)
                ? (a.id = o.substr(1, o.length - 1))
                : (a.className = o),
            (h += i)
        }
        f.append(a), (f = P(a))
      } else if (">" == n) f = f.parent()
      else if ("l" == n && c.bPaginate && c.bLengthChange) e = Gt(t)
      else if ("f" == n && c.bFilter) e = Lt(t)
      else if ("r" == n && c.bProcessing) e = Zt(t)
      else if ("t" == n) e = Kt(t)
      else if ("i" == n && c.bInfo) e = Ut(t)
      else if ("p" == n && c.bPaginate) e = zt(t)
      else if (0 !== w.ext.feature.length)
        for (var p = w.ext.feature, g = 0, b = p.length; g < b; g++)
          if (n == p[g].cFeature) {
            e = p[g].fnInit(t)
            break
          }
      e && ((l = t.aanFeatures)[n] || (l[n] = []), l[n].push(e), f.append(e))
    }
    u.replaceWith(f), (t.nHolding = null)
  }
  function wt(t, e) {
    var n,
      a,
      r,
      o,
      i,
      l,
      s,
      u,
      c,
      f,
      d = P(e).children("tr")
    for (t.splice(0, t.length), r = 0, l = d.length; r < l; r++) t.push([])
    for (r = 0, l = d.length; r < l; r++)
      for (a = (n = d[r]).firstChild; a; ) {
        if ("TD" == a.nodeName.toUpperCase() || "TH" == a.nodeName.toUpperCase())
          for (
            u = (u = +a.getAttribute("colspan")) && 0 != u && 1 != u ? u : 1,
              c = (c = +a.getAttribute("rowspan")) && 0 != c && 1 != c ? c : 1,
              s = (function (t, e, n) {
                for (var a = t[e]; a[n]; ) n++
                return n
              })(t, r, 0),
              f = 1 == u,
              i = 0;
            i < u;
            i++
          )
            for (o = 0; o < c; o++) (t[r + o][s + i] = { cell: a, unique: f }), (t[r + o].nTr = n)
        a = a.nextSibling
      }
  }
  function Ct(t, e, n) {
    var a = []
    n || ((n = t.aoHeader), e && wt((n = []), e))
    for (var r = 0, o = n.length; r < o; r++)
      for (var i = 0, l = n[r].length; i < l; i++) !n[r][i].unique || (a[i] && t.bSortCellsTop) || (a[i] = n[r][i].cell)
    return a
  }
  function Tt(r, t, n) {
    function e(t) {
      var e = r.jqXHR ? r.jqXHR.status : null
      ;(null === t || ("number" == typeof e && 204 == e)) && Ft(r, (t = {}), []),
        (e = t.error || t.sError) && W(r, 0, e),
        (r.json = t),
        R(r, null, "xhr", [r, t, r.jqXHR]),
        n(t)
    }
    R(r, "aoServerParams", "serverParams", [t]),
      t &&
        Array.isArray(t) &&
        ((a = {}),
        (o = /(.*?)\[\]$/),
        P.each(t, function (t, e) {
          var n = e.name.match(o)
          n ? ((n = n[0]), a[n] || (a[n] = []), a[n].push(e.value)) : (a[e.name] = e.value)
        }),
        (t = a))
    var a,
      o,
      i,
      l = r.ajax,
      s = r.oInstance,
      u =
        (P.isPlainObject(l) &&
          l.data &&
          ((u = "function" == typeof (i = l.data) ? i(t, r) : i),
          (t = "function" == typeof i && u ? u : P.extend(!0, t, u)),
          delete l.data),
        {
          data: t,
          success: e,
          dataType: "json",
          cache: !1,
          type: r.sServerMethod,
          error: function (t, e, n) {
            var a = R(r, null, "xhr", [r, null, r.jqXHR])
            ;-1 === P.inArray(!0, a) &&
              ("parsererror" == e
                ? W(r, 0, "Invalid JSON response", 1)
                : 4 === t.readyState && W(r, 0, "Ajax error", 7)),
              D(r, !1)
          },
        })
    ;(r.oAjaxData = t),
      R(r, null, "preXhr", [r, t]),
      r.fnServerData
        ? r.fnServerData.call(
            s,
            r.sAjaxSource,
            P.map(t, function (t, e) {
              return { name: e, value: t }
            }),
            e,
            r,
          )
        : r.sAjaxSource || "string" == typeof l
          ? (r.jqXHR = P.ajax(P.extend(u, { url: l || r.sAjaxSource })))
          : "function" == typeof l
            ? (r.jqXHR = l.call(s, t, e, r))
            : ((r.jqXHR = P.ajax(P.extend(u, l))), (l.data = i))
  }
  function xt(e) {
    e.iDraw++, D(e, !0)
    var n = e._drawHold
    Tt(e, At(e), function (t) {
      ;(e._drawHold = n), It(e, t), (e._drawHold = !1)
    })
  }
  function At(t) {
    for (
      var e,
        n,
        a,
        r = t.aoColumns,
        o = r.length,
        i = t.oFeatures,
        l = t.oPreviousSearch,
        s = t.aoPreSearchCols,
        u = [],
        c = I(t),
        f = t._iDisplayStart,
        d = !1 !== i.bPaginate ? t._iDisplayLength : -1,
        h = function (t, e) {
          u.push({ name: t, value: e })
        },
        p =
          (h("sEcho", t.iDraw),
          h("iColumns", o),
          h("sColumns", N(r, "sName").join(",")),
          h("iDisplayStart", f),
          h("iDisplayLength", d),
          {
            draw: t.iDraw,
            columns: [],
            order: [],
            start: f,
            length: d,
            search: { value: l.sSearch, regex: l.bRegex },
          }),
        g = 0;
      g < o;
      g++
    )
      (n = r[g]),
        (a = s[g]),
        (e = "function" == typeof n.mData ? "function" : n.mData),
        p.columns.push({
          data: e,
          name: n.sName,
          searchable: n.bSearchable,
          orderable: n.bSortable,
          search: { value: a.sSearch, regex: a.bRegex },
        }),
        h("mDataProp_" + g, e),
        i.bFilter && (h("sSearch_" + g, a.sSearch), h("bRegex_" + g, a.bRegex), h("bSearchable_" + g, n.bSearchable)),
        i.bSort && h("bSortable_" + g, n.bSortable)
    i.bFilter && (h("sSearch", l.sSearch), h("bRegex", l.bRegex)),
      i.bSort &&
        (P.each(c, function (t, e) {
          p.order.push({ column: e.col, dir: e.dir }), h("iSortCol_" + t, e.col), h("sSortDir_" + t, e.dir)
        }),
        h("iSortingCols", c.length))
    f = w.ext.legacy.ajax
    return null === f ? (t.sAjaxSource ? u : p) : f ? u : p
  }
  function It(t, n) {
    function e(t, e) {
      return n[t] !== H ? n[t] : n[e]
    }
    var a = Ft(t, n),
      r = e("sEcho", "draw"),
      o = e("iTotalRecords", "recordsTotal"),
      i = e("iTotalDisplayRecords", "recordsFiltered")
    if (r !== H) {
      if (+r < t.iDraw) return
      t.iDraw = +r
    }
    ;(a = a || []), pt(t), (t._iRecordsTotal = parseInt(o, 10)), (t._iRecordsDisplay = parseInt(i, 10))
    for (var l = 0, s = a.length; l < s; l++) x(t, a[l])
    ;(t.aiDisplay = t.aiDisplayMaster.slice()), y(t, !0), t._bInitComplete || qt(t, n), D(t, !1)
  }
  function Ft(t, e, n) {
    t = P.isPlainObject(t.ajax) && t.ajax.dataSrc !== H ? t.ajax.dataSrc : t.sAjaxDataProp
    if (!n) return "data" === t ? e.aaData || e[t] : "" !== t ? A(t)(e) : e
    b(t)(e, n)
  }
  function Lt(n) {
    function e(t) {
      i.f
      var e = this.value || ""
      ;(o.return && "Enter" !== t.key) ||
        (e != o.sSearch &&
          (Rt(n, {
            sSearch: e,
            bRegex: o.bRegex,
            bSmart: o.bSmart,
            bCaseInsensitive: o.bCaseInsensitive,
            return: o.return,
          }),
          (n._iDisplayStart = 0),
          y(n)))
    }
    var t = n.oClasses,
      a = n.sTableId,
      r = n.oLanguage,
      o = n.oPreviousSearch,
      i = n.aanFeatures,
      l = '<input type="search" class="' + t.sFilterInput + '"/>',
      s = (s = r.sSearch).match(/_INPUT_/) ? s.replace("_INPUT_", l) : s + l,
      l = P("<div/>", { id: i.f ? null : a + "_filter", class: t.sFilter }).append(P("<label/>").append(s)),
      t = null !== n.searchDelay ? n.searchDelay : "ssp" === E(n) ? 400 : 0,
      u = P("input", l)
        .val(o.sSearch)
        .attr("placeholder", r.sSearchPlaceholder)
        .on("keyup.DT search.DT input.DT paste.DT cut.DT", t ? ne(e, t) : e)
        .on("mouseup.DT", function (t) {
          setTimeout(function () {
            e.call(u[0], t)
          }, 10)
        })
        .on("keypress.DT", function (t) {
          if (13 == t.keyCode) return !1
        })
        .attr("aria-controls", a)
    return (
      P(n.nTable).on("search.dt.DT", function (t, e) {
        if (n === e)
          try {
            u[0] !== v.activeElement && u.val(o.sSearch)
          } catch (t) {}
      }),
      l[0]
    )
  }
  function Rt(t, e, n) {
    function a(t) {
      ;(o.sSearch = t.sSearch),
        (o.bRegex = t.bRegex),
        (o.bSmart = t.bSmart),
        (o.bCaseInsensitive = t.bCaseInsensitive),
        (o.return = t.return)
    }
    function r(t) {
      return t.bEscapeRegex !== H ? !t.bEscapeRegex : t.bRegex
    }
    var o = t.oPreviousSearch,
      i = t.aoPreSearchCols
    if ((lt(t), "ssp" != E(t))) {
      Ht(t, e.sSearch, n, r(e), e.bSmart, e.bCaseInsensitive), a(e)
      for (var l = 0; l < i.length; l++) jt(t, i[l].sSearch, l, r(i[l]), i[l].bSmart, i[l].bCaseInsensitive)
      Pt(t)
    } else a(e)
    ;(t.bFiltered = !0), R(t, null, "search", [t])
  }
  function Pt(t) {
    for (var e, n, a = w.ext.search, r = t.aiDisplay, o = 0, i = a.length; o < i; o++) {
      for (var l = [], s = 0, u = r.length; s < u; s++)
        (n = r[s]), (e = t.aoData[n]), a[o](t, e._aFilterData, n, e._aData, s) && l.push(n)
      ;(r.length = 0), P.merge(r, l)
    }
  }
  function jt(t, e, n, a, r, o) {
    if ("" !== e) {
      for (var i, l = [], s = t.aiDisplay, u = Nt(e, a, r, o), c = 0; c < s.length; c++)
        (i = t.aoData[s[c]]._aFilterData[n]), u.test(i) && l.push(s[c])
      t.aiDisplay = l
    }
  }
  function Ht(t, e, n, a, r, o) {
    var i,
      l,
      s,
      u = Nt(e, a, r, o),
      r = t.oPreviousSearch.sSearch,
      o = t.aiDisplayMaster,
      c = []
    if ((0 !== w.ext.search.length && (n = !0), (l = Wt(t)), e.length <= 0)) t.aiDisplay = o.slice()
    else {
      for (
        (l || n || a || r.length > e.length || 0 !== e.indexOf(r) || t.bSorted) && (t.aiDisplay = o.slice()),
          i = t.aiDisplay,
          s = 0;
        s < i.length;
        s++
      )
        u.test(t.aoData[i[s]]._sFilterRow) && c.push(i[s])
      t.aiDisplay = c
    }
  }
  function Nt(t, e, n, a) {
    return (
      (t = e ? t : Ot(t)),
      n &&
        (t =
          "^(?=.*?" +
          P.map(t.match(/["\u201C][^"\u201D]+["\u201D]|[^ ]+/g) || [""], function (t) {
            var e
            return (
              '"' === t.charAt(0)
                ? (t = (e = t.match(/^"(.*)"$/)) ? e[1] : t)
                : "“" === t.charAt(0) && (t = (e = t.match(/^\u201C(.*)\u201D$/)) ? e[1] : t),
              t.replace('"', "")
            )
          }).join(")(?=.*?") +
          ").*$"),
      new RegExp(t, a ? "i" : "")
    )
  }
  var Ot = w.util.escapeRegex,
    kt = P("<div>")[0],
    Mt = kt.textContent !== H
  function Wt(t) {
    for (var e, n, a, r, o, i = t.aoColumns, l = !1, s = 0, u = t.aoData.length; s < u; s++)
      if (!(o = t.aoData[s])._aFilterData) {
        for (a = [], e = 0, n = i.length; e < n; e++)
          i[e].bSearchable
            ? "string" != typeof (r = null === (r = S(t, s, e, "filter")) ? "" : r) && r.toString && (r = r.toString())
            : (r = ""),
            r.indexOf && -1 !== r.indexOf("&") && ((kt.innerHTML = r), (r = Mt ? kt.textContent : kt.innerText)),
            r.replace && (r = r.replace(/[\r\n\u2028]/g, "")),
            a.push(r)
        ;(o._aFilterData = a), (o._sFilterRow = a.join("  ")), (l = !0)
      }
    return l
  }
  function Et(t) {
    return { search: t.sSearch, smart: t.bSmart, regex: t.bRegex, caseInsensitive: t.bCaseInsensitive }
  }
  function Bt(t) {
    return { sSearch: t.search, bSmart: t.smart, bRegex: t.regex, bCaseInsensitive: t.caseInsensitive }
  }
  function Ut(t) {
    var e = t.sTableId,
      n = t.aanFeatures.i,
      a = P("<div/>", { class: t.oClasses.sInfo, id: n ? null : e + "_info" })
    return (
      n ||
        (t.aoDrawCallback.push({ fn: Vt, sName: "information" }),
        a.attr("role", "status").attr("aria-live", "polite"),
        P(t.nTable).attr("aria-describedby", e + "_info")),
      a[0]
    )
  }
  function Vt(t) {
    var e,
      n,
      a,
      r,
      o,
      i,
      l = t.aanFeatures.i
    0 !== l.length &&
      ((i = t.oLanguage),
      (e = t._iDisplayStart + 1),
      (n = t.fnDisplayEnd()),
      (a = t.fnRecordsTotal()),
      (o = (r = t.fnRecordsDisplay()) ? i.sInfo : i.sInfoEmpty),
      r !== a && (o += " " + i.sInfoFiltered),
      (o = Xt(t, (o += i.sInfoPostFix))),
      null !== (i = i.fnInfoCallback) && (o = i.call(t.oInstance, t, e, n, a, r, o)),
      P(l).html(o))
  }
  function Xt(t, e) {
    var n = t.fnFormatNumber,
      a = t._iDisplayStart + 1,
      r = t._iDisplayLength,
      o = t.fnRecordsDisplay(),
      i = -1 === r
    return e
      .replace(/_START_/g, n.call(t, a))
      .replace(/_END_/g, n.call(t, t.fnDisplayEnd()))
      .replace(/_MAX_/g, n.call(t, t.fnRecordsTotal()))
      .replace(/_TOTAL_/g, n.call(t, o))
      .replace(/_PAGE_/g, n.call(t, i ? 1 : Math.ceil(a / r)))
      .replace(/_PAGES_/g, n.call(t, i ? 1 : Math.ceil(o / r)))
  }
  function Jt(n) {
    var a,
      t,
      e,
      r = n.iInitDisplayStart,
      o = n.aoColumns,
      i = n.oFeatures,
      l = n.bDeferLoading
    if (n.bInitialised) {
      for (
        _t(n), yt(n), Dt(n, n.aoHeader), Dt(n, n.aoFooter), D(n, !0), i.bAutoWidth && ee(n), a = 0, t = o.length;
        a < t;
        a++
      )
        (e = o[a]).sWidth && (e.nTh.style.width = M(e.sWidth))
      R(n, null, "preInit", [n]), u(n)
      i = E(n)
      ;("ssp" == i && !l) ||
        ("ajax" == i
          ? Tt(n, [], function (t) {
              var e = Ft(n, t)
              for (a = 0; a < e.length; a++) x(n, e[a])
              ;(n.iInitDisplayStart = r), u(n), D(n, !1), qt(n, t)
            })
          : (D(n, !1), qt(n)))
    } else
      setTimeout(function () {
        Jt(n)
      }, 200)
  }
  function qt(t, e) {
    ;(t._bInitComplete = !0),
      (e || t.oInit.aaData) && O(t),
      R(t, null, "plugin-init", [t, e]),
      R(t, "aoInitComplete", "init", [t, e])
  }
  function $t(t, e) {
    e = parseInt(e, 10)
    ;(t._iDisplayLength = e), Se(t), R(t, null, "length", [t, e])
  }
  function Gt(a) {
    for (
      var t = a.oClasses,
        e = a.sTableId,
        n = a.aLengthMenu,
        r = Array.isArray(n[0]),
        o = r ? n[0] : n,
        i = r ? n[1] : n,
        l = P("<select/>", { name: e + "_length", "aria-controls": e, class: t.sLengthSelect }),
        s = 0,
        u = o.length;
      s < u;
      s++
    )
      l[0][s] = new Option("number" == typeof i[s] ? a.fnFormatNumber(i[s]) : i[s], o[s])
    var c = P("<div><label/></div>").addClass(t.sLength)
    return (
      a.aanFeatures.l || (c[0].id = e + "_length"),
      c.children().append(a.oLanguage.sLengthMenu.replace("_MENU_", l[0].outerHTML)),
      P("select", c)
        .val(a._iDisplayLength)
        .on("change.DT", function (t) {
          $t(a, P(this).val()), y(a)
        }),
      P(a.nTable).on("length.dt.DT", function (t, e, n) {
        a === e && P("select", c).val(n)
      }),
      c[0]
    )
  }
  function zt(t) {
    function c(t) {
      y(t)
    }
    var e = t.sPaginationType,
      f = w.ext.pager[e],
      d = "function" == typeof f,
      e = P("<div/>").addClass(t.oClasses.sPaging + e)[0],
      h = t.aanFeatures
    return (
      d || f.fnInit(t, e, c),
      h.p ||
        ((e.id = t.sTableId + "_paginate"),
        t.aoDrawCallback.push({
          fn: function (t) {
            if (d)
              for (
                var e = t._iDisplayStart,
                  n = t._iDisplayLength,
                  a = t.fnRecordsDisplay(),
                  r = -1 === n,
                  o = r ? 0 : Math.ceil(e / n),
                  i = r ? 1 : Math.ceil(a / n),
                  l = f(o, i),
                  s = 0,
                  u = h.p.length;
                s < u;
                s++
              )
                ve(t, "pageButton")(t, h.p[s], s, l, o, i)
            else f.fnUpdate(t, c)
          },
          sName: "pagination",
        })),
      e
    )
  }
  function Yt(t, e, n) {
    var a = t._iDisplayStart,
      r = t._iDisplayLength,
      o = t.fnRecordsDisplay(),
      o =
        (0 === o || -1 === r
          ? (a = 0)
          : "number" == typeof e
            ? o < (a = e * r) && (a = 0)
            : "first" == e
              ? (a = 0)
              : "previous" == e
                ? (a = 0 <= r ? a - r : 0) < 0 && (a = 0)
                : "next" == e
                  ? a + r < o && (a += r)
                  : "last" == e
                    ? (a = Math.floor((o - 1) / r) * r)
                    : W(t, 0, "Unknown paging action: " + e, 5),
        t._iDisplayStart !== a)
    return (t._iDisplayStart = a), o ? (R(t, null, "page", [t]), n && y(t)) : R(t, null, "page-nc", [t]), o
  }
  function Zt(t) {
    return P("<div/>", {
      id: t.aanFeatures.r ? null : t.sTableId + "_processing",
      class: t.oClasses.sProcessing,
      role: "status",
    })
      .html(t.oLanguage.sProcessing)
      .append("<div><div></div><div></div><div></div><div></div></div>")
      .insertBefore(t.nTable)[0]
  }
  function D(t, e) {
    t.oFeatures.bProcessing && P(t.aanFeatures.r).css("display", e ? "block" : "none"), R(t, null, "processing", [t, e])
  }
  function Kt(t) {
    var e,
      n,
      a,
      r,
      o,
      i,
      l,
      s,
      u,
      c,
      f,
      d,
      h = P(t.nTable),
      p = t.oScroll
    return "" === p.sX && "" === p.sY
      ? t.nTable
      : ((e = p.sX),
        (n = p.sY),
        (a = t.oClasses),
        (o = (r = h.children("caption")).length ? r[0]._captionSide : null),
        (s = P(h[0].cloneNode(!1))),
        (i = P(h[0].cloneNode(!1))),
        (u = function (t) {
          return t ? M(t) : null
        }),
        (l = h.children("tfoot")).length || (l = null),
        (s = P((f = "<div/>"), { class: a.sScrollWrapper })
          .append(
            P(f, { class: a.sScrollHead })
              .css({ overflow: "hidden", position: "relative", border: 0, width: e ? u(e) : "100%" })
              .append(
                P(f, { class: a.sScrollHeadInner })
                  .css({ "box-sizing": "content-box", width: p.sXInner || "100%" })
                  .append(
                    s
                      .removeAttr("id")
                      .css("margin-left", 0)
                      .append("top" === o ? r : null)
                      .append(h.children("thead")),
                  ),
              ),
          )
          .append(
            P(f, { class: a.sScrollBody })
              .css({ position: "relative", overflow: "auto", width: u(e) })
              .append(h),
          )),
        l &&
          s.append(
            P(f, { class: a.sScrollFoot })
              .css({ overflow: "hidden", border: 0, width: e ? u(e) : "100%" })
              .append(
                P(f, { class: a.sScrollFootInner }).append(
                  i
                    .removeAttr("id")
                    .css("margin-left", 0)
                    .append("bottom" === o ? r : null)
                    .append(h.children("tfoot")),
                ),
              ),
          ),
        (u = s.children()),
        (c = u[0]),
        (f = u[1]),
        (d = l ? u[2] : null),
        e &&
          P(f).on("scroll.DT", function (t) {
            var e = this.scrollLeft
            ;(c.scrollLeft = e), l && (d.scrollLeft = e)
          }),
        P(f).css("max-height", n),
        p.bCollapse || P(f).css("height", n),
        (t.nScrollHead = c),
        (t.nScrollBody = f),
        (t.nScrollFoot = d),
        t.aoDrawCallback.push({ fn: Qt, sName: "scrolling" }),
        s[0])
  }
  function Qt(n) {
    function t(t) {
      ;((t = t.style).paddingTop = "0"),
        (t.paddingBottom = "0"),
        (t.borderTopWidth = "0"),
        (t.borderBottomWidth = "0"),
        (t.height = 0)
    }
    var e,
      a,
      r,
      o,
      i,
      l = n.oScroll,
      s = l.sX,
      u = l.sXInner,
      c = l.sY,
      l = l.iBarWidth,
      f = P(n.nScrollHead),
      d = f[0].style,
      h = f.children("div"),
      p = h[0].style,
      h = h.children("table"),
      g = n.nScrollBody,
      b = P(g),
      m = g.style,
      S = P(n.nScrollFoot).children("div"),
      v = S.children("table"),
      y = P(n.nTHead),
      D = P(n.nTable),
      _ = D[0],
      w = _.style,
      C = n.nTFoot ? P(n.nTFoot) : null,
      T = n.oBrowser,
      x = T.bScrollOversize,
      A = (N(n.aoColumns, "nTh"), []),
      I = [],
      F = [],
      L = [],
      R = g.scrollHeight > g.clientHeight
    n.scrollBarVis !== R && n.scrollBarVis !== H
      ? ((n.scrollBarVis = R), O(n))
      : ((n.scrollBarVis = R),
        D.children("thead, tfoot").remove(),
        C && ((R = C.clone().prependTo(D)), (i = C.find("tr")), (a = R.find("tr")), R.find("[id]").removeAttr("id")),
        (R = y.clone().prependTo(D)),
        (y = y.find("tr")),
        (e = R.find("tr")),
        R.find("th, td").removeAttr("tabindex"),
        R.find("[id]").removeAttr("id"),
        s || ((m.width = "100%"), (f[0].style.width = "100%")),
        P.each(Ct(n, R), function (t, e) {
          ;(r = rt(n, t)), (e.style.width = n.aoColumns[r].sWidth)
        }),
        C &&
          k(function (t) {
            t.style.width = ""
          }, a),
        (f = D.outerWidth()),
        "" === s
          ? ((w.width = "100%"),
            x &&
              (D.find("tbody").height() > g.offsetHeight || "scroll" == b.css("overflow-y")) &&
              (w.width = M(D.outerWidth() - l)),
            (f = D.outerWidth()))
          : "" !== u && ((w.width = M(u)), (f = D.outerWidth())),
        k(t, e),
        k(function (t) {
          var e = j.getComputedStyle ? j.getComputedStyle(t).width : M(P(t).width())
          F.push(t.innerHTML), A.push(e)
        }, e),
        k(function (t, e) {
          t.style.width = A[e]
        }, y),
        P(e).css("height", 0),
        C &&
          (k(t, a),
          k(function (t) {
            L.push(t.innerHTML), I.push(M(P(t).css("width")))
          }, a),
          k(function (t, e) {
            t.style.width = I[e]
          }, i),
          P(a).height(0)),
        k(function (t, e) {
          ;(t.innerHTML = '<div class="dataTables_sizing">' + F[e] + "</div>"),
            (t.childNodes[0].style.height = "0"),
            (t.childNodes[0].style.overflow = "hidden"),
            (t.style.width = A[e])
        }, e),
        C &&
          k(function (t, e) {
            ;(t.innerHTML = '<div class="dataTables_sizing">' + L[e] + "</div>"),
              (t.childNodes[0].style.height = "0"),
              (t.childNodes[0].style.overflow = "hidden"),
              (t.style.width = I[e])
          }, a),
        Math.round(D.outerWidth()) < Math.round(f)
          ? ((o = g.scrollHeight > g.offsetHeight || "scroll" == b.css("overflow-y") ? f + l : f),
            x && (g.scrollHeight > g.offsetHeight || "scroll" == b.css("overflow-y")) && (w.width = M(o - l)),
            ("" !== s && "" === u) || W(n, 1, "Possible column misalignment", 6))
          : (o = "100%"),
        (m.width = M(o)),
        (d.width = M(o)),
        C && (n.nScrollFoot.style.width = M(o)),
        c || (x && (m.height = M(_.offsetHeight + l))),
        (R = D.outerWidth()),
        (h[0].style.width = M(R)),
        (p.width = M(R)),
        (y = D.height() > g.clientHeight || "scroll" == b.css("overflow-y")),
        (p[(i = "padding" + (T.bScrollbarLeft ? "Left" : "Right"))] = y ? l + "px" : "0px"),
        C && ((v[0].style.width = M(R)), (S[0].style.width = M(R)), (S[0].style[i] = y ? l + "px" : "0px")),
        D.children("colgroup").insertBefore(D.children("thead")),
        b.trigger("scroll"),
        (!n.bSorted && !n.bFiltered) || n._drawHold || (g.scrollTop = 0))
  }
  function k(t, e, n) {
    for (var a, r, o = 0, i = 0, l = e.length; i < l; ) {
      for (a = e[i].firstChild, r = n ? n[i].firstChild : null; a; )
        1 === a.nodeType && (n ? t(a, r, o) : t(a, o), o++), (a = a.nextSibling), (r = n ? r.nextSibling : null)
      i++
    }
  }
  var te = /<.*?>/g
  function ee(t) {
    var e,
      n,
      a = t.nTable,
      r = t.aoColumns,
      o = t.oScroll,
      i = o.sY,
      l = o.sX,
      o = o.sXInner,
      s = r.length,
      u = it(t, "bVisible"),
      c = P("th", t.nTHead),
      f = a.getAttribute("width"),
      d = a.parentNode,
      h = !1,
      p = t.oBrowser,
      g = p.bScrollOversize,
      b = a.style.width
    for (b && -1 !== b.indexOf("%") && (f = b), D = 0; D < u.length; D++)
      null !== (e = r[u[D]]).sWidth && ((e.sWidth = ae(e.sWidthOrig, d)), (h = !0))
    if (g || (!h && !l && !i && s == T(t) && s == c.length))
      for (D = 0; D < s; D++) {
        var m = rt(t, D)
        null !== m && (r[m].sWidth = M(c.eq(D).width()))
      }
    else {
      var b = P(a).clone().css("visibility", "hidden").removeAttr("id"),
        S = (b.find("tbody tr").remove(), P("<tr/>").appendTo(b.find("tbody")))
      for (
        b.find("thead, tfoot").remove(),
          b.append(P(t.nTHead).clone()).append(P(t.nTFoot).clone()),
          b.find("tfoot th, tfoot td").css("width", ""),
          c = Ct(t, b.find("thead")[0]),
          D = 0;
        D < u.length;
        D++
      )
        (e = r[u[D]]),
          (c[D].style.width = null !== e.sWidthOrig && "" !== e.sWidthOrig ? M(e.sWidthOrig) : ""),
          e.sWidthOrig &&
            l &&
            P(c[D]).append(P("<div/>").css({ width: e.sWidthOrig, margin: 0, padding: 0, border: 0, height: 1 }))
      if (t.aoData.length)
        for (D = 0; D < u.length; D++) (e = r[(n = u[D])]), P(re(t, n)).clone(!1).append(e.sContentPadding).appendTo(S)
      P("[name]", b).removeAttr("name")
      for (
        var v = P("<div/>")
            .css(l || i ? { position: "absolute", top: 0, left: 0, height: 1, right: 0, overflow: "hidden" } : {})
            .append(b)
            .appendTo(d),
          y =
            (l && o
              ? b.width(o)
              : l
                ? (b.css("width", "auto"),
                  b.removeAttr("width"),
                  b.width() < d.clientWidth && f && b.width(d.clientWidth))
                : i
                  ? b.width(d.clientWidth)
                  : f && b.width(f),
            0),
          D = 0;
        D < u.length;
        D++
      ) {
        var _ = P(c[D]),
          w = _.outerWidth() - _.width(),
          _ = p.bBounding ? Math.ceil(c[D].getBoundingClientRect().width) : _.outerWidth()
        ;(y += _), (r[u[D]].sWidth = M(_ - w))
      }
      ;(a.style.width = M(y)), v.remove()
    }
    f && (a.style.width = M(f)),
      (!f && !l) ||
        t._reszEvt ||
        ((o = function () {
          P(j).on(
            "resize.DT-" + t.sInstance,
            ne(function () {
              O(t)
            }),
          )
        }),
        g ? setTimeout(o, 1e3) : o(),
        (t._reszEvt = !0))
  }
  var ne = w.util.throttle
  function ae(t, e) {
    return t
      ? ((e = (t = P("<div/>")
          .css("width", M(t))
          .appendTo(e || v.body))[0].offsetWidth),
        t.remove(),
        e)
      : 0
  }
  function re(t, e) {
    var n,
      a = oe(t, e)
    return a < 0 ? null : (n = t.aoData[a]).nTr ? n.anCells[e] : P("<td/>").html(S(t, a, e, "display"))[0]
  }
  function oe(t, e) {
    for (var n, a = -1, r = -1, o = 0, i = t.aoData.length; o < i; o++)
      (n = (n = (n = S(t, o, e, "display") + "").replace(te, "")).replace(/&nbsp;/g, " ")).length > a &&
        ((a = n.length), (r = o))
    return r
  }
  function M(t) {
    return null === t ? "0px" : "number" == typeof t ? (t < 0 ? "0px" : t + "px") : t.match(/\d$/) ? t + "px" : t
  }
  function I(t) {
    function e(t) {
      t.length && !Array.isArray(t[0]) ? h.push(t) : P.merge(h, t)
    }
    var n,
      a,
      r,
      o,
      i,
      l,
      s,
      u = [],
      c = t.aoColumns,
      f = t.aaSortingFixed,
      d = P.isPlainObject(f),
      h = []
    for (
      Array.isArray(f) && e(f), d && f.pre && e(f.pre), e(t.aaSorting), d && f.post && e(f.post), n = 0;
      n < h.length;
      n++
    )
      for (r = (o = c[(s = h[n][(a = 0)])].aDataSort).length; a < r; a++)
        (l = c[(i = o[a])].sType || "string"),
          h[n]._idx === H && (h[n]._idx = P.inArray(h[n][1], c[i].asSorting)),
          u.push({ src: s, col: i, dir: h[n][1], index: h[n]._idx, type: l, formatter: w.ext.type.order[l + "-pre"] })
    return u
  }
  function ie(t) {
    var e,
      n,
      a,
      r,
      c,
      f = [],
      u = w.ext.type.order,
      d = t.aoData,
      o = (t.aoColumns, 0),
      i = t.aiDisplayMaster
    for (lt(t), e = 0, n = (c = I(t)).length; e < n; e++) (r = c[e]).formatter && o++, fe(t, r.col)
    if ("ssp" != E(t) && 0 !== c.length) {
      for (e = 0, a = i.length; e < a; e++) f[i[e]] = e
      o === c.length
        ? i.sort(function (t, e) {
            for (var n, a, r, o, i = c.length, l = d[t]._aSortData, s = d[e]._aSortData, u = 0; u < i; u++)
              if (0 != (r = (n = l[(o = c[u]).col]) < (a = s[o.col]) ? -1 : a < n ? 1 : 0))
                return "asc" === o.dir ? r : -r
            return (n = f[t]) < (a = f[e]) ? -1 : a < n ? 1 : 0
          })
        : i.sort(function (t, e) {
            for (var n, a, r, o = c.length, i = d[t]._aSortData, l = d[e]._aSortData, s = 0; s < o; s++)
              if (
                ((n = i[(r = c[s]).col]),
                (a = l[r.col]),
                0 !== (r = (u[r.type + "-" + r.dir] || u["string-" + r.dir])(n, a)))
              )
                return r
            return (n = f[t]) < (a = f[e]) ? -1 : a < n ? 1 : 0
          })
    }
    t.bSorted = !0
  }
  function le(t) {
    for (var e = t.aoColumns, n = I(t), a = t.oLanguage.oAria, r = 0, o = e.length; r < o; r++) {
      var i = e[r],
        l = i.asSorting,
        s = i.ariaTitle || i.sTitle.replace(/<.*?>/g, ""),
        u = i.nTh
      u.removeAttribute("aria-sort"),
        (i = i.bSortable
          ? s +
            ("asc" ===
            ((0 < n.length &&
              n[0].col == r &&
              (u.setAttribute("aria-sort", "asc" == n[0].dir ? "ascending" : "descending"), l[n[0].index + 1])) ||
              l[0])
              ? a.sSortAscending
              : a.sSortDescending)
          : s),
        u.setAttribute("aria-label", i)
    }
  }
  function se(t, e, n, a) {
    function r(t, e) {
      var n = t._idx
      return (n = n === H ? P.inArray(t[1], s) : n) + 1 < s.length ? n + 1 : e ? null : 0
    }
    var o,
      i = t.aoColumns[e],
      l = t.aaSorting,
      s = i.asSorting
    "number" == typeof l[0] && (l = t.aaSorting = [l]),
      n && t.oFeatures.bSortMulti
        ? -1 !== (i = P.inArray(e, N(l, "0")))
          ? null === (o = null === (o = r(l[i], !0)) && 1 === l.length ? 0 : o)
            ? l.splice(i, 1)
            : ((l[i][1] = s[o]), (l[i]._idx = o))
          : (l.push([e, s[0], 0]), (l[l.length - 1]._idx = 0))
        : l.length && l[0][0] == e
          ? ((o = r(l[0])), (l.length = 1), (l[0][1] = s[o]), (l[0]._idx = o))
          : ((l.length = 0), l.push([e, s[0]]), (l[0]._idx = 0)),
      u(t),
      "function" == typeof a && a(t)
  }
  function ue(e, t, n, a) {
    var r = e.aoColumns[n]
    me(t, {}, function (t) {
      !1 !== r.bSortable &&
        (e.oFeatures.bProcessing
          ? (D(e, !0),
            setTimeout(function () {
              se(e, n, t.shiftKey, a), "ssp" !== E(e) && D(e, !1)
            }, 0))
          : se(e, n, t.shiftKey, a))
    })
  }
  function ce(t) {
    var e,
      n,
      a,
      r = t.aLastSort,
      o = t.oClasses.sSortColumn,
      i = I(t),
      l = t.oFeatures
    if (l.bSort && l.bSortClasses) {
      for (e = 0, n = r.length; e < n; e++)
        (a = r[e].src), P(N(t.aoData, "anCells", a)).removeClass(o + (e < 2 ? e + 1 : 3))
      for (e = 0, n = i.length; e < n; e++)
        (a = i[e].src), P(N(t.aoData, "anCells", a)).addClass(o + (e < 2 ? e + 1 : 3))
    }
    t.aLastSort = i
  }
  function fe(t, e) {
    for (
      var n,
        a,
        r,
        o = t.aoColumns[e],
        i = w.ext.order[o.sSortDataType],
        l = (i && (n = i.call(t.oInstance, t, e, ot(t, e))), w.ext.type.order[o.sType + "-pre"]),
        s = 0,
        u = t.aoData.length;
      s < u;
      s++
    )
      (a = t.aoData[s])._aSortData || (a._aSortData = []),
        (a._aSortData[e] && !i) || ((r = i ? n[s] : S(t, s, e, "sort")), (a._aSortData[e] = l ? l(r) : r))
  }
  function de(n) {
    var t
    n._bLoadingState ||
      ((t = {
        time: +new Date(),
        start: n._iDisplayStart,
        length: n._iDisplayLength,
        order: P.extend(!0, [], n.aaSorting),
        search: Et(n.oPreviousSearch),
        columns: P.map(n.aoColumns, function (t, e) {
          return { visible: t.bVisible, search: Et(n.aoPreSearchCols[e]) }
        }),
      }),
      (n.oSavedState = t),
      R(n, "aoStateSaveParams", "stateSaveParams", [n, t]),
      n.oFeatures.bStateSave && !n.bDestroying && n.fnStateSaveCallback.call(n.oInstance, n, t))
  }
  function he(e, t, n) {
    var a
    if (e.oFeatures.bStateSave)
      return (
        (a = e.fnStateLoadCallback.call(e.oInstance, e, function (t) {
          pe(e, t, n)
        })) !== H && pe(e, a, n),
        !0
      )
    n()
  }
  function pe(n, t, e) {
    var a,
      r,
      o = n.aoColumns,
      i = ((n._bLoadingState = !0), n._bInitComplete ? new w.Api(n) : null)
    if (t && t.time) {
      var l = R(n, "aoStateLoadParams", "stateLoadParams", [n, t])
      if (-1 !== P.inArray(!1, l)) n._bLoadingState = !1
      else {
        l = n.iStateDuration
        if (0 < l && t.time < +new Date() - 1e3 * l) n._bLoadingState = !1
        else if (t.columns && o.length !== t.columns.length) n._bLoadingState = !1
        else {
          if (
            ((n.oLoadedState = P.extend(!0, {}, t)),
            t.length !== H && (i ? i.page.len(t.length) : (n._iDisplayLength = t.length)),
            t.start !== H &&
              (null === i
                ? ((n._iDisplayStart = t.start), (n.iInitDisplayStart = t.start))
                : Yt(n, t.start / n._iDisplayLength)),
            t.order !== H &&
              ((n.aaSorting = []),
              P.each(t.order, function (t, e) {
                n.aaSorting.push(e[0] >= o.length ? [0, e[1]] : e)
              })),
            t.search !== H && P.extend(n.oPreviousSearch, Bt(t.search)),
            t.columns)
          ) {
            for (a = 0, r = t.columns.length; a < r; a++) {
              var s = t.columns[a]
              s.visible !== H && (i ? i.column(a).visible(s.visible, !1) : (o[a].bVisible = s.visible)),
                s.search !== H && P.extend(n.aoPreSearchCols[a], Bt(s.search))
            }
            i && i.columns.adjust()
          }
          ;(n._bLoadingState = !1), R(n, "aoStateLoaded", "stateLoaded", [n, t])
        }
      }
    } else n._bLoadingState = !1
    e()
  }
  function ge(t) {
    var e = w.settings,
      t = P.inArray(t, N(e, "nTable"))
    return -1 !== t ? e[t] : null
  }
  function W(t, e, n, a) {
    if (
      ((n = "DataTables warning: " + (t ? "table id=" + t.sTableId + " - " : "") + n),
      a && (n += ". For more information about this error, please see http://datatables.net/tn/" + a),
      e)
    )
      j.console && console.log && console.log(n)
    else {
      ;(e = w.ext), (e = e.sErrMode || e.errMode)
      if ((t && R(t, null, "error", [t, a, n]), "alert" == e)) alert(n)
      else {
        if ("throw" == e) throw new Error(n)
        "function" == typeof e && e(t, a, n)
      }
    }
  }
  function F(n, a, t, e) {
    Array.isArray(t)
      ? P.each(t, function (t, e) {
          Array.isArray(e) ? F(n, a, e[0], e[1]) : F(n, a, e)
        })
      : (e === H && (e = t), a[t] !== H && (n[e] = a[t]))
  }
  function be(t, e, n) {
    var a, r
    for (r in e)
      e.hasOwnProperty(r) &&
        ((a = e[r]),
        P.isPlainObject(a)
          ? (P.isPlainObject(t[r]) || (t[r] = {}), P.extend(!0, t[r], a))
          : n && "data" !== r && "aaData" !== r && Array.isArray(a)
            ? (t[r] = a.slice())
            : (t[r] = a))
    return t
  }
  function me(e, t, n) {
    P(e)
      .on("click.DT", t, function (t) {
        P(e).trigger("blur"), n(t)
      })
      .on("keypress.DT", t, function (t) {
        13 === t.which && (t.preventDefault(), n(t))
      })
      .on("selectstart.DT", function () {
        return !1
      })
  }
  function L(t, e, n, a) {
    n && t[e].push({ fn: n, sName: a })
  }
  function R(n, t, e, a) {
    var r = []
    return (
      t &&
        (r = P.map(n[t].slice().reverse(), function (t, e) {
          return t.fn.apply(n.oInstance, a)
        })),
      null !== e &&
        ((t = P.Event(e + ".dt")),
        (e = P(n.nTable)).trigger(t, a),
        0 === e.parents("body").length && P("body").trigger(t, a),
        r.push(t.result)),
      r
    )
  }
  function Se(t) {
    var e = t._iDisplayStart,
      n = t.fnDisplayEnd(),
      a = t._iDisplayLength
    n <= e && (e = n - a), (e -= e % a), (t._iDisplayStart = e = -1 === a || e < 0 ? 0 : e)
  }
  function ve(t, e) {
    var t = t.renderer,
      n = w.ext.renderer[e]
    return P.isPlainObject(t) && t[e] ? n[t[e]] || n._ : ("string" == typeof t && n[t]) || n._
  }
  function E(t) {
    return t.oFeatures.bServerSide ? "ssp" : t.ajax || t.sAjaxSource ? "ajax" : "dom"
  }
  function ye(t, n) {
    var a
    return Array.isArray(t)
      ? P.map(t, function (t) {
          return ye(t, n)
        })
      : "number" == typeof t
        ? [n[t]]
        : ((a = P.map(n, function (t, e) {
            return t.nTable
          })),
          P(a)
            .filter(t)
            .map(function (t) {
              var e = P.inArray(this, a)
              return n[e]
            })
            .toArray())
  }
  function De(r, o, t) {
    var e, n
    t &&
      (e = new B(r)).one("draw", function () {
        t(e.ajax.json())
      }),
      "ssp" == E(r)
        ? u(r, o)
        : (D(r, !0),
          (n = r.jqXHR) && 4 !== n.readyState && n.abort(),
          Tt(r, [], function (t) {
            pt(r)
            for (var e = Ft(r, t), n = 0, a = e.length; n < a; n++) x(r, e[n])
            u(r, o), D(r, !1)
          }))
  }
  function _e(t, e, n, a, r) {
    for (
      var o,
        i,
        l,
        s,
        u = [],
        c = typeof e,
        f = 0,
        d = (e = e && "string" != c && "function" != c && e.length !== H ? e : [e]).length;
      f < d;
      f++
    )
      for (l = 0, s = (i = e[f] && e[f].split && !e[f].match(/[\[\(:]/) ? e[f].split(",") : [e[f]]).length; l < s; l++)
        (o = n("string" == typeof i[l] ? i[l].trim() : i[l])) && o.length && (u = u.concat(o))
    var h = p.selector[t]
    if (h.length) for (f = 0, d = h.length; f < d; f++) u = h[f](a, r, u)
    return z(u)
  }
  function we(t) {
    return (
      (t = t || {}).filter && t.search === H && (t.search = t.filter),
      P.extend({ search: "none", order: "current", page: "all" }, t)
    )
  }
  function Ce(t) {
    for (var e = 0, n = t.length; e < n; e++)
      if (0 < t[e].length) return (t[0] = t[e]), (t[0].length = 1), (t.length = 1), (t.context = [t.context[e]]), t
    return (t.length = 0), t
  }
  function Te(o, t, e, n) {
    function i(t, e) {
      var n
      if (Array.isArray(t) || t instanceof P) for (var a = 0, r = t.length; a < r; a++) i(t[a], e)
      else
        t.nodeName && "tr" === t.nodeName.toLowerCase()
          ? l.push(t)
          : ((n = P("<tr><td></td></tr>").addClass(e)),
            (P("td", n).addClass(e).html(t)[0].colSpan = T(o)),
            l.push(n[0]))
    }
    var l = []
    i(e, n), t._details && t._details.detach(), (t._details = P(l)), t._detailsShow && t._details.insertAfter(t.nTr)
  }
  function xe(t, e) {
    var n = t.context
    if (n.length && t.length) {
      var a = n[0].aoData[t[0]]
      if (a._details) {
        ;(a._detailsShow = e)
          ? (a._details.insertAfter(a.nTr), P(a.nTr).addClass("dt-hasChild"))
          : (a._details.detach(), P(a.nTr).removeClass("dt-hasChild")),
          R(n[0], null, "childRow", [e, t.row(t[0])])
        var s = n[0],
          r = new B(s),
          a = ".dt.DT_details",
          e = "draw" + a,
          t = "column-sizing" + a,
          a = "destroy" + a,
          u = s.aoData
        if ((r.off(e + " " + t + " " + a), N(u, "_details").length > 0)) {
          r.on(e, function (t, e) {
            if (s !== e) return
            r.rows({ page: "current" })
              .eq(0)
              .each(function (t) {
                var e = u[t]
                if (e._detailsShow) e._details.insertAfter(e.nTr)
              })
          })
          r.on(t, function (t, e, n, a) {
            if (s !== e) return
            var r,
              o = T(e)
            for (var i = 0, l = u.length; i < l; i++) {
              r = u[i]
              if (r._details) r._details.children("td[colspan]").attr("colspan", o)
            }
          })
          r.on(a, function (t, e) {
            if (s !== e) return
            for (var n = 0, a = u.length; n < a; n++) if (u[n]._details) Re(r, n)
          })
        }
        Le(n)
      }
    }
  }
  function Ae(t, e, n, a, r) {
    for (var o = [], i = 0, l = r.length; i < l; i++) o.push(S(t, r[i], e))
    return o
  }
  var Ie = [],
    o = Array.prototype,
    B = function (t, e) {
      if (!(this instanceof B)) return new B(t, e)
      function n(t) {
        var e, n, a, r
        ;(t = t),
          (a = w.settings),
          (r = P.map(a, function (t, e) {
            return t.nTable
          })),
          (t = t
            ? t.nTable && t.oApi
              ? [t]
              : t.nodeName && "table" === t.nodeName.toLowerCase()
                ? -1 !== (e = P.inArray(t, r))
                  ? [a[e]]
                  : null
                : t && "function" == typeof t.settings
                  ? t.settings().toArray()
                  : ("string" == typeof t ? (n = P(t)) : t instanceof P && (n = t),
                    n
                      ? n
                          .map(function (t) {
                            return -1 !== (e = P.inArray(this, r)) ? a[e] : null
                          })
                          .toArray()
                      : void 0)
            : []) && o.push.apply(o, t)
      }
      var o = []
      if (Array.isArray(t)) for (var a = 0, r = t.length; a < r; a++) n(t[a])
      else n(t)
      ;(this.context = z(o)),
        e && P.merge(this, e),
        (this.selector = { rows: null, cols: null, opts: null }),
        B.extend(this, this, Ie)
    },
    Fe =
      ((w.Api = B),
      P.extend(B.prototype, {
        any: function () {
          return 0 !== this.count()
        },
        concat: o.concat,
        context: [],
        count: function () {
          return this.flatten().length
        },
        each: function (t) {
          for (var e = 0, n = this.length; e < n; e++) t.call(this, this[e], e, this)
          return this
        },
        eq: function (t) {
          var e = this.context
          return e.length > t ? new B(e[t], this[t]) : null
        },
        filter: function (t) {
          var e = []
          if (o.filter) e = o.filter.call(this, t, this)
          else for (var n = 0, a = this.length; n < a; n++) t.call(this, this[n], n, this) && e.push(this[n])
          return new B(this.context, e)
        },
        flatten: function () {
          var t = []
          return new B(this.context, t.concat.apply(t, this.toArray()))
        },
        join: o.join,
        indexOf:
          o.indexOf ||
          function (t, e) {
            for (var n = e || 0, a = this.length; n < a; n++) if (this[n] === t) return n
            return -1
          },
        iterator: function (t, e, n, a) {
          var r,
            o,
            i,
            l,
            s,
            u,
            c,
            f,
            d = [],
            h = this.context,
            p = this.selector
          for ("string" == typeof t && ((a = n), (n = e), (e = t), (t = !1)), o = 0, i = h.length; o < i; o++) {
            var g = new B(h[o])
            if ("table" === e) (r = n.call(g, h[o], o)) !== H && d.push(r)
            else if ("columns" === e || "rows" === e) (r = n.call(g, h[o], this[o], o)) !== H && d.push(r)
            else if ("column" === e || "column-rows" === e || "row" === e || "cell" === e)
              for (c = this[o], "column-rows" === e && (u = Fe(h[o], p.opts)), l = 0, s = c.length; l < s; l++)
                (f = c[l]),
                  (r = "cell" === e ? n.call(g, h[o], f.row, f.column, o, l) : n.call(g, h[o], f, o, l, u)) !== H &&
                    d.push(r)
          }
          return d.length || a
            ? (((t = (a = new B(h, t ? d.concat.apply([], d) : d)).selector).rows = p.rows),
              (t.cols = p.cols),
              (t.opts = p.opts),
              a)
            : this
        },
        lastIndexOf:
          o.lastIndexOf ||
          function (t, e) {
            return this.indexOf.apply(this.toArray.reverse(), arguments)
          },
        length: 0,
        map: function (t) {
          var e = []
          if (o.map) e = o.map.call(this, t, this)
          else for (var n = 0, a = this.length; n < a; n++) e.push(t.call(this, this[n], n))
          return new B(this.context, e)
        },
        pluck: function (t) {
          var e = w.util.get(t)
          return this.map(function (t) {
            return e(t)
          })
        },
        pop: o.pop,
        push: o.push,
        reduce:
          o.reduce ||
          function (t, e) {
            return et(this, t, e, 0, this.length, 1)
          },
        reduceRight:
          o.reduceRight ||
          function (t, e) {
            return et(this, t, e, this.length - 1, -1, -1)
          },
        reverse: o.reverse,
        selector: null,
        shift: o.shift,
        slice: function () {
          return new B(this.context, this)
        },
        sort: o.sort,
        splice: o.splice,
        toArray: function () {
          return o.slice.call(this)
        },
        to$: function () {
          return P(this)
        },
        toJQuery: function () {
          return P(this)
        },
        unique: function () {
          return new B(this.context, z(this))
        },
        unshift: o.unshift,
      }),
      (B.extend = function (t, e, n) {
        if (n.length && e && (e instanceof B || e.__dt_wrapper))
          for (var a, r = 0, o = n.length; r < o; r++)
            (e[(a = n[r]).name] =
              "function" === a.type
                ? (function (e, n, a) {
                    return function () {
                      var t = n.apply(e, arguments)
                      return B.extend(t, t, a.methodExt), t
                    }
                  })(t, a.val, a)
                : "object" === a.type
                  ? {}
                  : a.val),
              (e[a.name].__dt_wrapper = !0),
              B.extend(t, e[a.name], a.propExt)
      }),
      (B.register = e =
        function (t, e) {
          if (Array.isArray(t)) for (var n = 0, a = t.length; n < a; n++) B.register(t[n], e)
          else
            for (var r = t.split("."), o = Ie, i = 0, l = r.length; i < l; i++) {
              var s,
                u,
                c = (function (t, e) {
                  for (var n = 0, a = t.length; n < a; n++) if (t[n].name === e) return t[n]
                  return null
                })(o, (u = (s = -1 !== r[i].indexOf("()")) ? r[i].replace("()", "") : r[i]))
              c || o.push((c = { name: u, val: {}, methodExt: [], propExt: [], type: "object" })),
                i === l - 1
                  ? ((c.val = e),
                    (c.type = "function" == typeof e ? "function" : P.isPlainObject(e) ? "object" : "other"))
                  : (o = s ? c.methodExt : c.propExt)
            }
        }),
      (B.registerPlural = t =
        function (t, e, n) {
          B.register(t, n),
            B.register(e, function () {
              var t = n.apply(this, arguments)
              return t === this
                ? this
                : t instanceof B
                  ? t.length
                    ? Array.isArray(t[0])
                      ? new B(t.context, t[0])
                      : t[0]
                    : H
                  : t
            })
        }),
      e("tables()", function (t) {
        return t !== H && null !== t ? new B(ye(t, this.context)) : this
      }),
      e("table()", function (t) {
        var t = this.tables(t),
          e = t.context
        return e.length ? new B(e[0]) : t
      }),
      t("tables().nodes()", "table().node()", function () {
        return this.iterator(
          "table",
          function (t) {
            return t.nTable
          },
          1,
        )
      }),
      t("tables().body()", "table().body()", function () {
        return this.iterator(
          "table",
          function (t) {
            return t.nTBody
          },
          1,
        )
      }),
      t("tables().header()", "table().header()", function () {
        return this.iterator(
          "table",
          function (t) {
            return t.nTHead
          },
          1,
        )
      }),
      t("tables().footer()", "table().footer()", function () {
        return this.iterator(
          "table",
          function (t) {
            return t.nTFoot
          },
          1,
        )
      }),
      t("tables().containers()", "table().container()", function () {
        return this.iterator(
          "table",
          function (t) {
            return t.nTableWrapper
          },
          1,
        )
      }),
      e("draw()", function (e) {
        return this.iterator("table", function (t) {
          "page" === e ? y(t) : u(t, !1 === (e = "string" == typeof e ? "full-hold" !== e : e))
        })
      }),
      e("page()", function (e) {
        return e === H
          ? this.page.info().page
          : this.iterator("table", function (t) {
              Yt(t, e)
            })
      }),
      e("page.info()", function (t) {
        var e, n, a, r, o
        return 0 === this.context.length
          ? H
          : ((n = (e = this.context[0])._iDisplayStart),
            (a = e.oFeatures.bPaginate ? e._iDisplayLength : -1),
            (r = e.fnRecordsDisplay()),
            {
              page: (o = -1 === a) ? 0 : Math.floor(n / a),
              pages: o ? 1 : Math.ceil(r / a),
              start: n,
              end: e.fnDisplayEnd(),
              length: a,
              recordsTotal: e.fnRecordsTotal(),
              recordsDisplay: r,
              serverSide: "ssp" === E(e),
            })
      }),
      e("page.len()", function (e) {
        return e === H
          ? 0 !== this.context.length
            ? this.context[0]._iDisplayLength
            : H
          : this.iterator("table", function (t) {
              $t(t, e)
            })
      }),
      e("ajax.json()", function () {
        var t = this.context
        if (0 < t.length) return t[0].json
      }),
      e("ajax.params()", function () {
        var t = this.context
        if (0 < t.length) return t[0].oAjaxData
      }),
      e("ajax.reload()", function (e, n) {
        return this.iterator("table", function (t) {
          De(t, !1 === n, e)
        })
      }),
      e("ajax.url()", function (e) {
        var t = this.context
        return e === H
          ? 0 === t.length
            ? H
            : (t = t[0]).ajax
              ? P.isPlainObject(t.ajax)
                ? t.ajax.url
                : t.ajax
              : t.sAjaxSource
          : this.iterator("table", function (t) {
              P.isPlainObject(t.ajax) ? (t.ajax.url = e) : (t.ajax = e)
            })
      }),
      e("ajax.url().load()", function (e, n) {
        return this.iterator("table", function (t) {
          De(t, !1 === n, e)
        })
      }),
      function (t, e) {
        var n,
          a = [],
          r = t.aiDisplay,
          o = t.aiDisplayMaster,
          i = e.search,
          l = e.order,
          e = e.page
        if ("ssp" == E(t)) return "removed" === i ? [] : f(0, o.length)
        if ("current" == e) for (u = t._iDisplayStart, c = t.fnDisplayEnd(); u < c; u++) a.push(r[u])
        else if ("current" == l || "applied" == l) {
          if ("none" == i) a = o.slice()
          else if ("applied" == i) a = r.slice()
          else if ("removed" == i) {
            for (var s = {}, u = 0, c = r.length; u < c; u++) s[r[u]] = null
            a = P.map(o, function (t) {
              return s.hasOwnProperty(t) ? null : t
            })
          }
        } else if ("index" == l || "original" == l)
          for (u = 0, c = t.aoData.length; u < c; u++)
            ("none" == i || (-1 === (n = P.inArray(u, r)) && "removed" == i) || (0 <= n && "applied" == i)) && a.push(u)
        return a
      }),
    Le =
      (e("rows()", function (e, n) {
        e === H ? (e = "") : P.isPlainObject(e) && ((n = e), (e = "")), (n = we(n))
        var t = this.iterator(
          "table",
          function (t) {
            return _e(
              "row",
              e,
              function (n) {
                var t = d(n),
                  a = r.aoData
                if (null !== t && !o) return [t]
                if (((i = i || Fe(r, o)), null !== t && -1 !== P.inArray(t, i))) return [t]
                if (null === n || n === H || "" === n) return i
                if ("function" == typeof n)
                  return P.map(i, function (t) {
                    var e = a[t]
                    return n(t, e._aData, e.nTr) ? t : null
                  })
                if (n.nodeName)
                  return (
                    (t = n._DT_RowIndex),
                    (e = n._DT_CellIndex),
                    t !== H
                      ? a[t] && a[t].nTr === n
                        ? [t]
                        : []
                      : e
                        ? a[e.row] && a[e.row].nTr === n.parentNode
                          ? [e.row]
                          : []
                        : (t = P(n).closest("*[data-dt-row]")).length
                          ? [t.data("dt-row")]
                          : []
                  )
                if ("string" == typeof n && "#" === n.charAt(0)) {
                  var e = r.aIds[n.replace(/^#/, "")]
                  if (e !== H) return [e.idx]
                }
                t = _(m(r.aoData, i, "nTr"))
                return P(t)
                  .filter(n)
                  .map(function () {
                    return this._DT_RowIndex
                  })
                  .toArray()
              },
              (r = t),
              (o = n),
            )
            var r, o, i
          },
          1,
        )
        return (t.selector.rows = e), (t.selector.opts = n), t
      }),
      e("rows().nodes()", function () {
        return this.iterator(
          "row",
          function (t, e) {
            return t.aoData[e].nTr || H
          },
          1,
        )
      }),
      e("rows().data()", function () {
        return this.iterator(
          !0,
          "rows",
          function (t, e) {
            return m(t.aoData, e, "_aData")
          },
          1,
        )
      }),
      t("rows().cache()", "row().cache()", function (n) {
        return this.iterator(
          "row",
          function (t, e) {
            t = t.aoData[e]
            return "search" === n ? t._aFilterData : t._aSortData
          },
          1,
        )
      }),
      t("rows().invalidate()", "row().invalidate()", function (n) {
        return this.iterator("row", function (t, e) {
          bt(t, e, n)
        })
      }),
      t("rows().indexes()", "row().index()", function () {
        return this.iterator(
          "row",
          function (t, e) {
            return e
          },
          1,
        )
      }),
      t("rows().ids()", "row().id()", function (t) {
        for (var e = [], n = this.context, a = 0, r = n.length; a < r; a++)
          for (var o = 0, i = this[a].length; o < i; o++) {
            var l = n[a].rowIdFn(n[a].aoData[this[a][o]]._aData)
            e.push((!0 === t ? "#" : "") + l)
          }
        return new B(n, e)
      }),
      t("rows().remove()", "row().remove()", function () {
        var f = this
        return (
          this.iterator("row", function (t, e, n) {
            var a,
              r,
              o,
              i,
              l,
              s,
              u = t.aoData,
              c = u[e]
            for (u.splice(e, 1), a = 0, r = u.length; a < r; a++)
              if (((s = (l = u[a]).anCells), null !== l.nTr && (l.nTr._DT_RowIndex = a), null !== s))
                for (o = 0, i = s.length; o < i; o++) s[o]._DT_CellIndex.row = a
            gt(t.aiDisplayMaster, e),
              gt(t.aiDisplay, e),
              gt(f[n], e, !1),
              0 < t._iRecordsDisplay && t._iRecordsDisplay--,
              Se(t)
            n = t.rowIdFn(c._aData)
            n !== H && delete t.aIds[n]
          }),
          this.iterator("table", function (t) {
            for (var e = 0, n = t.aoData.length; e < n; e++) t.aoData[e].idx = e
          }),
          this
        )
      }),
      e("rows.add()", function (o) {
        var t = this.iterator(
            "table",
            function (t) {
              for (var e, n = [], a = 0, r = o.length; a < r; a++)
                (e = o[a]).nodeName && "TR" === e.nodeName.toUpperCase() ? n.push(ut(t, e)[0]) : n.push(x(t, e))
              return n
            },
            1,
          ),
          e = this.rows(-1)
        return e.pop(), P.merge(e, t), e
      }),
      e("row()", function (t, e) {
        return Ce(this.rows(t, e))
      }),
      e("row().data()", function (t) {
        var e,
          n = this.context
        return t === H
          ? n.length && this.length
            ? n[0].aoData[this[0]]._aData
            : H
          : (((e = n[0].aoData[this[0]])._aData = t),
            Array.isArray(t) && e.nTr && e.nTr.id && b(n[0].rowId)(t, e.nTr.id),
            bt(n[0], this[0], "data"),
            this)
      }),
      e("row().node()", function () {
        var t = this.context
        return (t.length && this.length && t[0].aoData[this[0]].nTr) || null
      }),
      e("row.add()", function (e) {
        e instanceof P && e.length && (e = e[0])
        var t = this.iterator("table", function (t) {
          return e.nodeName && "TR" === e.nodeName.toUpperCase() ? ut(t, e)[0] : x(t, e)
        })
        return this.row(t[0])
      }),
      P(v).on("plugin-init.dt", function (t, e) {
        var n = new B(e),
          a = "on-plugin-init",
          r = "stateSaveParams." + a,
          o = "destroy. " + a,
          a =
            (n.on(r, function (t, e, n) {
              for (var a = e.rowIdFn, r = e.aoData, o = [], i = 0; i < r.length; i++)
                r[i]._detailsShow && o.push("#" + a(r[i]._aData))
              n.childRows = o
            }),
            n.on(o, function () {
              n.off(r + " " + o)
            }),
            n.state.loaded())
        a &&
          a.childRows &&
          n
            .rows(
              P.map(a.childRows, function (t) {
                return t.replace(/:/g, "\\:")
              }),
            )
            .every(function () {
              R(e, null, "requestChild", [this])
            })
      }),
      w.util.throttle(function (t) {
        de(t[0])
      }, 500)),
    Re = function (t, e) {
      var n = t.context
      n.length &&
        (e = n[0].aoData[e !== H ? e : t[0]]) &&
        e._details &&
        (e._details.remove(), (e._detailsShow = H), (e._details = H), P(e.nTr).removeClass("dt-hasChild"), Le(n))
    },
    Pe = "row().child",
    je = Pe + "()",
    He =
      (e(je, function (t, e) {
        var n = this.context
        return t === H
          ? n.length && this.length
            ? n[0].aoData[this[0]]._details
            : H
          : (!0 === t
              ? this.child.show()
              : !1 === t
                ? Re(this)
                : n.length && this.length && Te(n[0], n[0].aoData[this[0]], t, e),
            this)
      }),
      e([Pe + ".show()", je + ".show()"], function (t) {
        return xe(this, !0), this
      }),
      e([Pe + ".hide()", je + ".hide()"], function () {
        return xe(this, !1), this
      }),
      e([Pe + ".remove()", je + ".remove()"], function () {
        return Re(this), this
      }),
      e(Pe + ".isShown()", function () {
        var t = this.context
        return (t.length && this.length && t[0].aoData[this[0]]._detailsShow) || !1
      }),
      /^([^:]+):(name|visIdx|visible)$/),
    Ne =
      (e("columns()", function (n, a) {
        n === H ? (n = "") : P.isPlainObject(n) && ((a = n), (n = "")), (a = we(a))
        var t = this.iterator(
          "table",
          function (t) {
            return (
              (e = n),
              (l = a),
              (s = (i = t).aoColumns),
              (u = N(s, "sName")),
              (c = N(s, "nTh")),
              _e(
                "column",
                e,
                function (n) {
                  var a,
                    t = d(n)
                  if ("" === n) return f(s.length)
                  if (null !== t) return [0 <= t ? t : s.length + t]
                  if ("function" == typeof n)
                    return (
                      (a = Fe(i, l)),
                      P.map(s, function (t, e) {
                        return n(e, Ae(i, e, 0, 0, a), c[e]) ? e : null
                      })
                    )
                  var r = "string" == typeof n ? n.match(He) : ""
                  if (r)
                    switch (r[2]) {
                      case "visIdx":
                      case "visible":
                        var e,
                          o = parseInt(r[1], 10)
                        return o < 0
                          ? [
                              (e = P.map(s, function (t, e) {
                                return t.bVisible ? e : null
                              }))[e.length + o],
                            ]
                          : [rt(i, o)]
                      case "name":
                        return P.map(u, function (t, e) {
                          return t === r[1] ? e : null
                        })
                      default:
                        return []
                    }
                  return n.nodeName && n._DT_CellIndex
                    ? [n._DT_CellIndex.column]
                    : (t = P(c)
                          .filter(n)
                          .map(function () {
                            return P.inArray(this, c)
                          })
                          .toArray()).length || !n.nodeName
                      ? t
                      : (t = P(n).closest("*[data-dt-column]")).length
                        ? [t.data("dt-column")]
                        : []
                },
                i,
                l,
              )
            )
            var i, e, l, s, u, c
          },
          1,
        )
        return (t.selector.cols = n), (t.selector.opts = a), t
      }),
      t("columns().header()", "column().header()", function (t, e) {
        return this.iterator(
          "column",
          function (t, e) {
            return t.aoColumns[e].nTh
          },
          1,
        )
      }),
      t("columns().footer()", "column().footer()", function (t, e) {
        return this.iterator(
          "column",
          function (t, e) {
            return t.aoColumns[e].nTf
          },
          1,
        )
      }),
      t("columns().data()", "column().data()", function () {
        return this.iterator("column-rows", Ae, 1)
      }),
      t("columns().dataSrc()", "column().dataSrc()", function () {
        return this.iterator(
          "column",
          function (t, e) {
            return t.aoColumns[e].mData
          },
          1,
        )
      }),
      t("columns().cache()", "column().cache()", function (o) {
        return this.iterator(
          "column-rows",
          function (t, e, n, a, r) {
            return m(t.aoData, r, "search" === o ? "_aFilterData" : "_aSortData", e)
          },
          1,
        )
      }),
      t("columns().nodes()", "column().nodes()", function () {
        return this.iterator(
          "column-rows",
          function (t, e, n, a, r) {
            return m(t.aoData, r, "anCells", e)
          },
          1,
        )
      }),
      t("columns().visible()", "column().visible()", function (f, n) {
        var e = this,
          t = this.iterator("column", function (t, e) {
            if (f === H) return t.aoColumns[e].bVisible
            var n,
              a,
              r = e,
              e = f,
              o = t.aoColumns,
              i = o[r],
              l = t.aoData
            if (e === H) i.bVisible
            else if (i.bVisible !== e) {
              if (e)
                for (var s = P.inArray(!0, N(o, "bVisible"), r + 1), u = 0, c = l.length; u < c; u++)
                  (a = l[u].nTr), (n = l[u].anCells), a && a.insertBefore(n[r], n[s] || null)
              else P(N(t.aoData, "anCells", r)).detach()
              i.bVisible = e
            }
          })
        return (
          f !== H &&
            this.iterator("table", function (t) {
              Dt(t, t.aoHeader),
                Dt(t, t.aoFooter),
                t.aiDisplay.length || P(t.nTBody).find("td[colspan]").attr("colspan", T(t)),
                de(t),
                e.iterator("column", function (t, e) {
                  R(t, null, "column-visibility", [t, e, f, n])
                }),
                (n !== H && !n) || e.columns.adjust()
            }),
          t
        )
      }),
      t("columns().indexes()", "column().index()", function (n) {
        return this.iterator(
          "column",
          function (t, e) {
            return "visible" === n ? ot(t, e) : e
          },
          1,
        )
      }),
      e("columns.adjust()", function () {
        return this.iterator(
          "table",
          function (t) {
            O(t)
          },
          1,
        )
      }),
      e("column.index()", function (t, e) {
        var n
        if (0 !== this.context.length)
          return (
            (n = this.context[0]),
            "fromVisible" === t || "toData" === t ? rt(n, e) : "fromData" === t || "toVisible" === t ? ot(n, e) : void 0
          )
      }),
      e("column()", function (t, e) {
        return Ce(this.columns(t, e))
      }),
      e("cells()", function (g, t, b) {
        var a, r, o, i, l, s, e
        return (
          P.isPlainObject(g) && (g.row === H ? ((b = g), (g = null)) : ((b = t), (t = null))),
          P.isPlainObject(t) && ((b = t), (t = null)),
          null === t || t === H
            ? this.iterator("table", function (t) {
                return (
                  (a = t),
                  (t = g),
                  (e = we(b)),
                  (f = a.aoData),
                  (d = Fe(a, e)),
                  (n = _(m(f, d, "anCells"))),
                  (h = P(Y([], n))),
                  (p = a.aoColumns.length),
                  _e(
                    "cell",
                    t,
                    function (t) {
                      var e,
                        n = "function" == typeof t
                      if (null === t || t === H || n) {
                        for (o = [], i = 0, l = d.length; i < l; i++)
                          for (r = d[i], s = 0; s < p; s++)
                            (u = { row: r, column: s }),
                              (!n || ((c = f[r]), t(u, S(a, r, s), c.anCells ? c.anCells[s] : null))) && o.push(u)
                        return o
                      }
                      return P.isPlainObject(t)
                        ? t.column !== H && t.row !== H && -1 !== P.inArray(t.row, d)
                          ? [t]
                          : []
                        : (e = h
                              .filter(t)
                              .map(function (t, e) {
                                return { row: e._DT_CellIndex.row, column: e._DT_CellIndex.column }
                              })
                              .toArray()).length || !t.nodeName
                          ? e
                          : (c = P(t).closest("*[data-dt-row]")).length
                            ? [{ row: c.data("dt-row"), column: c.data("dt-column") }]
                            : []
                    },
                    a,
                    e,
                  )
                )
                var a, e, r, o, i, l, s, u, c, f, d, n, h, p
              })
            : ((e = b ? { page: b.page, order: b.order, search: b.search } : {}),
              (a = this.columns(t, e)),
              (r = this.rows(g, e)),
              (e = this.iterator(
                "table",
                function (t, e) {
                  var n = []
                  for (o = 0, i = r[e].length; o < i; o++)
                    for (l = 0, s = a[e].length; l < s; l++) n.push({ row: r[e][o], column: a[e][l] })
                  return n
                },
                1,
              )),
              (e = b && b.selected ? this.cells(e, b) : e),
              P.extend(e.selector, { cols: t, rows: g, opts: b }),
              e)
        )
      }),
      t("cells().nodes()", "cell().node()", function () {
        return this.iterator(
          "cell",
          function (t, e, n) {
            t = t.aoData[e]
            return t && t.anCells ? t.anCells[n] : H
          },
          1,
        )
      }),
      e("cells().data()", function () {
        return this.iterator(
          "cell",
          function (t, e, n) {
            return S(t, e, n)
          },
          1,
        )
      }),
      t("cells().cache()", "cell().cache()", function (a) {
        return (
          (a = "search" === a ? "_aFilterData" : "_aSortData"),
          this.iterator(
            "cell",
            function (t, e, n) {
              return t.aoData[e][a][n]
            },
            1,
          )
        )
      }),
      t("cells().render()", "cell().render()", function (a) {
        return this.iterator(
          "cell",
          function (t, e, n) {
            return S(t, e, n, a)
          },
          1,
        )
      }),
      t("cells().indexes()", "cell().index()", function () {
        return this.iterator(
          "cell",
          function (t, e, n) {
            return { row: e, column: n, columnVisible: ot(t, n) }
          },
          1,
        )
      }),
      t("cells().invalidate()", "cell().invalidate()", function (a) {
        return this.iterator("cell", function (t, e, n) {
          bt(t, e, a, n)
        })
      }),
      e("cell()", function (t, e, n) {
        return Ce(this.cells(t, e, n))
      }),
      e("cell().data()", function (t) {
        var e = this.context,
          n = this[0]
        return t === H
          ? e.length && n.length
            ? S(e[0], n[0].row, n[0].column)
            : H
          : (ct(e[0], n[0].row, n[0].column, t), bt(e[0], n[0].row, "data", n[0].column), this)
      }),
      e("order()", function (e, t) {
        var n = this.context
        return e === H
          ? 0 !== n.length
            ? n[0].aaSorting
            : H
          : ("number" == typeof e
              ? (e = [[e, t]])
              : e.length && !Array.isArray(e[0]) && (e = Array.prototype.slice.call(arguments)),
            this.iterator("table", function (t) {
              t.aaSorting = e.slice()
            }))
      }),
      e("order.listener()", function (e, n, a) {
        return this.iterator("table", function (t) {
          ue(t, e, n, a)
        })
      }),
      e("order.fixed()", function (e) {
        var t
        return e
          ? this.iterator("table", function (t) {
              t.aaSortingFixed = P.extend(!0, {}, e)
            })
          : ((t = (t = this.context).length ? t[0].aaSortingFixed : H), Array.isArray(t) ? { pre: t } : t)
      }),
      e(["columns().order()", "column().order()"], function (a) {
        var r = this
        return this.iterator("table", function (t, e) {
          var n = []
          P.each(r[e], function (t, e) {
            n.push([e, a])
          }),
            (t.aaSorting = n)
        })
      }),
      e("search()", function (e, n, a, r) {
        var t = this.context
        return e === H
          ? 0 !== t.length
            ? t[0].oPreviousSearch.sSearch
            : H
          : this.iterator("table", function (t) {
              t.oFeatures.bFilter &&
                Rt(
                  t,
                  P.extend({}, t.oPreviousSearch, {
                    sSearch: e + "",
                    bRegex: null !== n && n,
                    bSmart: null === a || a,
                    bCaseInsensitive: null === r || r,
                  }),
                  1,
                )
            })
      }),
      t("columns().search()", "column().search()", function (a, r, o, i) {
        return this.iterator("column", function (t, e) {
          var n = t.aoPreSearchCols
          if (a === H) return n[e].sSearch
          t.oFeatures.bFilter &&
            (P.extend(n[e], {
              sSearch: a + "",
              bRegex: null !== r && r,
              bSmart: null === o || o,
              bCaseInsensitive: null === i || i,
            }),
            Rt(t, t.oPreviousSearch, 1))
        })
      }),
      e("state()", function () {
        return this.context.length ? this.context[0].oSavedState : null
      }),
      e("state.clear()", function () {
        return this.iterator("table", function (t) {
          t.fnStateSaveCallback.call(t.oInstance, t, {})
        })
      }),
      e("state.loaded()", function () {
        return this.context.length ? this.context[0].oLoadedState : null
      }),
      e("state.save()", function () {
        return this.iterator("table", function (t) {
          de(t)
        })
      }),
      (w.use = function (t, e) {
        "lib" === e || t.fn
          ? (P = t)
          : "win" == e || t.document
            ? (v = (j = t).document)
            : ("datetime" !== e && "DateTime" !== t.type) || (w.DateTime = t)
      }),
      (w.factory = function (t, e) {
        var n = !1
        return t && t.document && (v = (j = t).document), e && e.fn && e.fn.jquery && ((P = e), (n = !0)), n
      }),
      (w.versionCheck = w.fnVersionCheck =
        function (t) {
          for (var e, n, a = w.version.split("."), r = t.split("."), o = 0, i = r.length; o < i; o++)
            if ((e = parseInt(a[o], 10) || 0) !== (n = parseInt(r[o], 10) || 0)) return n < e
          return !0
        }),
      (w.isDataTable = w.fnIsDataTable =
        function (t) {
          var r = P(t).get(0),
            o = !1
          return (
            t instanceof w.Api ||
            (P.each(w.settings, function (t, e) {
              var n = e.nScrollHead ? P("table", e.nScrollHead)[0] : null,
                a = e.nScrollFoot ? P("table", e.nScrollFoot)[0] : null
              ;(e.nTable !== r && n !== r && a !== r) || (o = !0)
            }),
            o)
          )
        }),
      (w.tables = w.fnTables =
        function (e) {
          var t = !1,
            n =
              (P.isPlainObject(e) && ((t = e.api), (e = e.visible)),
              P.map(w.settings, function (t) {
                if (!e || P(t.nTable).is(":visible")) return t.nTable
              }))
          return t ? new B(n) : n
        }),
      (w.camelToHungarian = C),
      e("$()", function (t, e) {
        ;(e = this.rows(e).nodes()), (e = P(e))
        return P([].concat(e.filter(t).toArray(), e.find(t).toArray()))
      }),
      P.each(["on", "one", "off"], function (t, n) {
        e(n + "()", function () {
          var t = Array.prototype.slice.call(arguments),
            e =
              ((t[0] = P.map(t[0].split(/\s/), function (t) {
                return t.match(/\.dt\b/) ? t : t + ".dt"
              }).join(" ")),
              P(this.tables().nodes()))
          return e[n].apply(e, t), this
        })
      }),
      e("clear()", function () {
        return this.iterator("table", function (t) {
          pt(t)
        })
      }),
      e("settings()", function () {
        return new B(this.context, this.context)
      }),
      e("init()", function () {
        var t = this.context
        return t.length ? t[0].oInit : null
      }),
      e("data()", function () {
        return this.iterator("table", function (t) {
          return N(t.aoData, "_aData")
        }).flatten()
      }),
      e("destroy()", function (c) {
        return (
          (c = c || !1),
          this.iterator("table", function (e) {
            var n,
              t = e.oClasses,
              a = e.nTable,
              r = e.nTBody,
              o = e.nTHead,
              i = e.nTFoot,
              l = P(a),
              r = P(r),
              s = P(e.nTableWrapper),
              u = P.map(e.aoData, function (t) {
                return t.nTr
              }),
              i =
                ((e.bDestroying = !0),
                R(e, "aoDestroyCallback", "destroy", [e]),
                c || new B(e).columns().visible(!0),
                s.off(".DT").find(":not(tbody *)").off(".DT"),
                P(j).off(".DT-" + e.sInstance),
                a != o.parentNode && (l.children("thead").detach(), l.append(o)),
                i && a != i.parentNode && (l.children("tfoot").detach(), l.append(i)),
                (e.aaSorting = []),
                (e.aaSortingFixed = []),
                ce(e),
                P(u).removeClass(e.asStripeClasses.join(" ")),
                P("th, td", o).removeClass(
                  t.sSortable + " " + t.sSortableAsc + " " + t.sSortableDesc + " " + t.sSortableNone,
                ),
                r.children().detach(),
                r.append(u),
                e.nTableWrapper.parentNode),
              o = c ? "remove" : "detach",
              u =
                (l[o](),
                s[o](),
                !c &&
                  i &&
                  (i.insertBefore(a, e.nTableReinsertBefore),
                  l.css("width", e.sDestroyWidth).removeClass(t.sTable),
                  (n = e.asDestroyStripes.length)) &&
                  r.children().each(function (t) {
                    P(this).addClass(e.asDestroyStripes[t % n])
                  }),
                P.inArray(e, w.settings))
            ;-1 !== u && w.settings.splice(u, 1)
          })
        )
      }),
      P.each(["column", "row", "cell"], function (t, s) {
        e(s + "s().every()", function (o) {
          var i = this.selector.opts,
            l = this
          return this.iterator(s, function (t, e, n, a, r) {
            o.call(l[s](e, "cell" === s ? n : i, "cell" === s ? i : H), e, n, a, r)
          })
        })
      }),
      e("i18n()", function (t, e, n) {
        var a = this.context[0],
          t = A(t)(a.oLanguage)
        return (
          t === H && (t = e),
          "string" == typeof (t = n !== H && P.isPlainObject(t) ? (t[n] !== H ? t[n] : t._) : t)
            ? t.replace("%d", n)
            : t
        )
      }),
      (w.version = "1.13.6"),
      (w.settings = []),
      (w.models = {}),
      (w.models.oSearch = { bCaseInsensitive: !0, sSearch: "", bRegex: !1, bSmart: !0, return: !1 }),
      (w.models.oRow = {
        nTr: null,
        anCells: null,
        _aData: [],
        _aSortData: null,
        _aFilterData: null,
        _sFilterRow: null,
        _sRowStripe: "",
        src: null,
        idx: -1,
      }),
      (w.models.oColumn = {
        idx: null,
        aDataSort: null,
        asSorting: null,
        bSearchable: null,
        bSortable: null,
        bVisible: null,
        _sManualType: null,
        _bAttrSrc: !1,
        fnCreatedCell: null,
        fnGetData: null,
        fnSetData: null,
        mData: null,
        mRender: null,
        nTh: null,
        nTf: null,
        sClass: null,
        sContentPadding: null,
        sDefaultContent: null,
        sName: null,
        sSortDataType: "std",
        sSortingClass: null,
        sSortingClassJUI: null,
        sTitle: null,
        sType: null,
        sWidth: null,
        sWidthOrig: null,
      }),
      (w.defaults = {
        aaData: null,
        aaSorting: [[0, "asc"]],
        aaSortingFixed: [],
        ajax: null,
        aLengthMenu: [10, 25, 50, 100],
        aoColumns: null,
        aoColumnDefs: null,
        aoSearchCols: [],
        asStripeClasses: null,
        bAutoWidth: !0,
        bDeferRender: !1,
        bDestroy: !1,
        bFilter: !0,
        bInfo: !0,
        bLengthChange: !0,
        bPaginate: !0,
        bProcessing: !1,
        bRetrieve: !1,
        bScrollCollapse: !1,
        bServerSide: !1,
        bSort: !0,
        bSortMulti: !0,
        bSortCellsTop: !1,
        bSortClasses: !0,
        bStateSave: !1,
        fnCreatedRow: null,
        fnDrawCallback: null,
        fnFooterCallback: null,
        fnFormatNumber: function (t) {
          return t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.oLanguage.sThousands)
        },
        fnHeaderCallback: null,
        fnInfoCallback: null,
        fnInitComplete: null,
        fnPreDrawCallback: null,
        fnRowCallback: null,
        fnServerData: null,
        fnServerParams: null,
        fnStateLoadCallback: function (t) {
          try {
            return JSON.parse(
              (-1 === t.iStateDuration ? sessionStorage : localStorage).getItem(
                "DataTables_" + t.sInstance + "_" + location.pathname,
              ),
            )
          } catch (t) {
            return {}
          }
        },
        fnStateLoadParams: null,
        fnStateLoaded: null,
        fnStateSaveCallback: function (t, e) {
          try {
            ;(-1 === t.iStateDuration ? sessionStorage : localStorage).setItem(
              "DataTables_" + t.sInstance + "_" + location.pathname,
              JSON.stringify(e),
            )
          } catch (t) {}
        },
        fnStateSaveParams: null,
        iStateDuration: 7200,
        iDeferLoading: null,
        iDisplayLength: 10,
        iDisplayStart: 0,
        iTabIndex: 0,
        oClasses: {},
        oLanguage: {
          oAria: {
            sSortAscending: ": activate to sort column ascending",
            sSortDescending: ": activate to sort column descending",
          },
          oPaginate: { sFirst: "First", sLast: "Last", sNext: "Next", sPrevious: "Previous" },
          sEmptyTable: "No data available in table",
          sInfo: "Showing _START_ to _END_ of _TOTAL_ entries",
          sInfoEmpty: "Showing 0 to 0 of 0 entries",
          sInfoFiltered: "(filtered from _MAX_ total entries)",
          sInfoPostFix: "",
          sDecimal: "",
          sThousands: ",",
          sLengthMenu: "Show _MENU_ entries",
          sLoadingRecords: "Loading...",
          sProcessing: "",
          sSearch: "Search:",
          sSearchPlaceholder: "",
          sUrl: "",
          sZeroRecords: "No matching records found",
        },
        oSearch: P.extend({}, w.models.oSearch),
        sAjaxDataProp: "data",
        sAjaxSource: null,
        sDom: "lfrtip",
        searchDelay: null,
        sPaginationType: "simple_numbers",
        sScrollX: "",
        sScrollXInner: "",
        sScrollY: "",
        sServerMethod: "GET",
        renderer: null,
        rowId: "DT_RowId",
      }),
      i(w.defaults),
      (w.defaults.column = {
        aDataSort: null,
        iDataSort: -1,
        asSorting: ["asc", "desc"],
        bSearchable: !0,
        bSortable: !0,
        bVisible: !0,
        fnCreatedCell: null,
        mData: null,
        mRender: null,
        sCellType: "td",
        sClass: "",
        sContentPadding: "",
        sDefaultContent: null,
        sName: "",
        sSortDataType: "std",
        sTitle: null,
        sType: null,
        sWidth: null,
      }),
      i(w.defaults.column),
      (w.models.oSettings = {
        oFeatures: {
          bAutoWidth: null,
          bDeferRender: null,
          bFilter: null,
          bInfo: null,
          bLengthChange: null,
          bPaginate: null,
          bProcessing: null,
          bServerSide: null,
          bSort: null,
          bSortMulti: null,
          bSortClasses: null,
          bStateSave: null,
        },
        oScroll: { bCollapse: null, iBarWidth: 0, sX: null, sXInner: null, sY: null },
        oLanguage: { fnInfoCallback: null },
        oBrowser: { bScrollOversize: !1, bScrollbarLeft: !1, bBounding: !1, barWidth: 0 },
        ajax: null,
        aanFeatures: [],
        aoData: [],
        aiDisplay: [],
        aiDisplayMaster: [],
        aIds: {},
        aoColumns: [],
        aoHeader: [],
        aoFooter: [],
        oPreviousSearch: {},
        aoPreSearchCols: [],
        aaSorting: null,
        aaSortingFixed: [],
        asStripeClasses: null,
        asDestroyStripes: [],
        sDestroyWidth: 0,
        aoRowCallback: [],
        aoHeaderCallback: [],
        aoFooterCallback: [],
        aoDrawCallback: [],
        aoRowCreatedCallback: [],
        aoPreDrawCallback: [],
        aoInitComplete: [],
        aoStateSaveParams: [],
        aoStateLoadParams: [],
        aoStateLoaded: [],
        sTableId: "",
        nTable: null,
        nTHead: null,
        nTFoot: null,
        nTBody: null,
        nTableWrapper: null,
        bDeferLoading: !1,
        bInitialised: !1,
        aoOpenRows: [],
        sDom: null,
        searchDelay: null,
        sPaginationType: "two_button",
        iStateDuration: 0,
        aoStateSave: [],
        aoStateLoad: [],
        oSavedState: null,
        oLoadedState: null,
        sAjaxSource: null,
        sAjaxDataProp: null,
        jqXHR: null,
        json: H,
        oAjaxData: H,
        fnServerData: null,
        aoServerParams: [],
        sServerMethod: null,
        fnFormatNumber: null,
        aLengthMenu: null,
        iDraw: 0,
        bDrawing: !1,
        iDrawError: -1,
        _iDisplayLength: 10,
        _iDisplayStart: 0,
        _iRecordsTotal: 0,
        _iRecordsDisplay: 0,
        oClasses: {},
        bFiltered: !1,
        bSorted: !1,
        bSortCellsTop: null,
        oInit: null,
        aoDestroyCallback: [],
        fnRecordsTotal: function () {
          return "ssp" == E(this) ? +this._iRecordsTotal : this.aiDisplayMaster.length
        },
        fnRecordsDisplay: function () {
          return "ssp" == E(this) ? +this._iRecordsDisplay : this.aiDisplay.length
        },
        fnDisplayEnd: function () {
          var t = this._iDisplayLength,
            e = this._iDisplayStart,
            n = e + t,
            a = this.aiDisplay.length,
            r = this.oFeatures,
            o = r.bPaginate
          return r.bServerSide
            ? !1 === o || -1 === t
              ? e + a
              : Math.min(e + t, this._iRecordsDisplay)
            : !o || a < n || -1 === t
              ? a
              : n
        },
        oInstance: null,
        sInstance: null,
        iTabIndex: 0,
        nScrollHead: null,
        nScrollFoot: null,
        aLastSort: [],
        oPlugins: {},
        rowIdFn: null,
        rowId: null,
      }),
      (w.ext = p =
        {
          buttons: {},
          classes: {},
          build: "dt/dt-1.13.6/fh-3.4.0/r-2.5.0",
          errMode: "alert",
          feature: [],
          search: [],
          selector: { cell: [], column: [], row: [] },
          internal: {},
          legacy: { ajax: null },
          pager: {},
          renderer: { pageButton: {}, header: {} },
          order: {},
          type: { detect: [], search: {}, order: {} },
          _unique: 0,
          fnVersionCheck: w.fnVersionCheck,
          iApiIndex: 0,
          oJUIClasses: {},
          sVersion: w.version,
        }),
      P.extend(p, {
        afnFiltering: p.search,
        aTypes: p.type.detect,
        ofnSearch: p.type.search,
        oSort: p.type.order,
        afnSortData: p.order,
        aoFeatures: p.feature,
        oApi: p.internal,
        oStdClasses: p.classes,
        oPagination: p.pager,
      }),
      P.extend(w.ext.classes, {
        sTable: "dataTable",
        sNoFooter: "no-footer",
        sPageButton: "paginate_button",
        sPageButtonActive: "current",
        sPageButtonDisabled: "disabled",
        sStripeOdd: "odd",
        sStripeEven: "even",
        sRowEmpty: "dataTables_empty",
        sWrapper: "dataTables_wrapper",
        sFilter: "dataTables_filter",
        sInfo: "dataTables_info",
        sPaging: "dataTables_paginate paging_",
        sLength: "dataTables_length",
        sProcessing: "dataTables_processing",
        sSortAsc: "sorting_asc",
        sSortDesc: "sorting_desc",
        sSortable: "sorting",
        sSortableAsc: "sorting_desc_disabled",
        sSortableDesc: "sorting_asc_disabled",
        sSortableNone: "sorting_disabled",
        sSortColumn: "sorting_",
        sFilterInput: "",
        sLengthSelect: "",
        sScrollWrapper: "dataTables_scroll",
        sScrollHead: "dataTables_scrollHead",
        sScrollHeadInner: "dataTables_scrollHeadInner",
        sScrollBody: "dataTables_scrollBody",
        sScrollFoot: "dataTables_scrollFoot",
        sScrollFootInner: "dataTables_scrollFootInner",
        sHeaderTH: "",
        sFooterTH: "",
        sSortJUIAsc: "",
        sSortJUIDesc: "",
        sSortJUI: "",
        sSortJUIAscAllowed: "",
        sSortJUIDescAllowed: "",
        sSortJUIWrapper: "",
        sSortIcon: "",
        sJUIHeader: "",
        sJUIFooter: "",
      }),
      w.ext.pager)
  function Oe(t, e) {
    var n = [],
      a = Ne.numbers_length,
      r = Math.floor(a / 2)
    return (
      e <= a
        ? (n = f(0, e))
        : t <= r
          ? ((n = f(0, a - 2)).push("ellipsis"), n.push(e - 1))
          : ((e - 1 - r <= t
              ? (n = f(e - (a - 2), e))
              : ((n = f(t - r + 2, t + r - 1)).push("ellipsis"), n.push(e - 1), n)
            ).splice(0, 0, "ellipsis"),
            n.splice(0, 0, 0)),
      (n.DT_el = "span"),
      n
    )
  }
  P.extend(Ne, {
    simple: function (t, e) {
      return ["previous", "next"]
    },
    full: function (t, e) {
      return ["first", "previous", "next", "last"]
    },
    numbers: function (t, e) {
      return [Oe(t, e)]
    },
    simple_numbers: function (t, e) {
      return ["previous", Oe(t, e), "next"]
    },
    full_numbers: function (t, e) {
      return ["first", "previous", Oe(t, e), "next", "last"]
    },
    first_last_numbers: function (t, e) {
      return ["first", Oe(t, e), "last"]
    },
    _numbers: Oe,
    numbers_length: 7,
  }),
    P.extend(!0, w.ext.renderer, {
      pageButton: {
        _: function (u, t, c, e, f, d) {
          function h(t, e) {
            for (
              var n,
                a = b.sPageButtonDisabled,
                r = function (t) {
                  Yt(u, t.data.action, !0)
                },
                o = 0,
                i = e.length;
              o < i;
              o++
            )
              if (((n = e[o]), Array.isArray(n))) {
                var l = P("<" + (n.DT_el || "div") + "/>").appendTo(t)
                h(l, n)
              } else {
                var s = !1
                switch (((p = null), (g = n))) {
                  case "ellipsis":
                    t.append('<span class="ellipsis">&#x2026;</span>')
                    break
                  case "first":
                    ;(p = m.sFirst), 0 === f && (s = !0)
                    break
                  case "previous":
                    ;(p = m.sPrevious), 0 === f && (s = !0)
                    break
                  case "next":
                    ;(p = m.sNext), (0 !== d && f !== d - 1) || (s = !0)
                    break
                  case "last":
                    ;(p = m.sLast), (0 !== d && f !== d - 1) || (s = !0)
                    break
                  default:
                    ;(p = u.fnFormatNumber(n + 1)), (g = f === n ? b.sPageButtonActive : "")
                }
                null !== p &&
                  ((l = u.oInit.pagingTag || "a"),
                  s && (g += " " + a),
                  me(
                    P("<" + l + ">", {
                      class: b.sPageButton + " " + g,
                      "aria-controls": u.sTableId,
                      "aria-disabled": s ? "true" : null,
                      "aria-label": S[n],
                      role: "link",
                      "aria-current": g === b.sPageButtonActive ? "page" : null,
                      "data-dt-idx": n,
                      tabindex: s ? -1 : u.iTabIndex,
                      id: 0 === c && "string" == typeof n ? u.sTableId + "_" + n : null,
                    })
                      .html(p)
                      .appendTo(t),
                    { action: n },
                    r,
                  ))
              }
          }
          var p,
            g,
            n,
            b = u.oClasses,
            m = u.oLanguage.oPaginate,
            S = u.oLanguage.oAria.paginate || {}
          try {
            n = P(t).find(v.activeElement).data("dt-idx")
          } catch (t) {}
          h(P(t).empty(), e),
            n !== H &&
              P(t)
                .find("[data-dt-idx=" + n + "]")
                .trigger("focus")
        },
      },
    }),
    P.extend(w.ext.type.detect, [
      function (t, e) {
        e = e.oLanguage.sDecimal
        return l(t, e) ? "num" + e : null
      },
      function (t, e) {
        var n
        return (!t || t instanceof Date || X.test(t)) && ((null !== (n = Date.parse(t)) && !isNaN(n)) || h(t))
          ? "date"
          : null
      },
      function (t, e) {
        e = e.oLanguage.sDecimal
        return l(t, e, !0) ? "num-fmt" + e : null
      },
      function (t, e) {
        e = e.oLanguage.sDecimal
        return a(t, e) ? "html-num" + e : null
      },
      function (t, e) {
        e = e.oLanguage.sDecimal
        return a(t, e, !0) ? "html-num-fmt" + e : null
      },
      function (t, e) {
        return h(t) || ("string" == typeof t && -1 !== t.indexOf("<")) ? "html" : null
      },
    ]),
    P.extend(w.ext.type.search, {
      html: function (t) {
        return h(t) ? t : "string" == typeof t ? t.replace(U, " ").replace(V, "") : ""
      },
      string: function (t) {
        return !h(t) && "string" == typeof t ? t.replace(U, " ") : t
      },
    })
  function ke(t, e, n, a) {
    var r
    return 0 === t || (t && "-" !== t)
      ? "number" == (r = typeof t) || "bigint" == r
        ? t
        : +(t = (t = e ? $(t, e) : t).replace && (n && (t = t.replace(n, "")), a) ? t.replace(a, "") : t)
      : -1 / 0
  }
  function Me(n) {
    P.each(
      {
        num: function (t) {
          return ke(t, n)
        },
        "num-fmt": function (t) {
          return ke(t, n, q)
        },
        "html-num": function (t) {
          return ke(t, n, V)
        },
        "html-num-fmt": function (t) {
          return ke(t, n, V, q)
        },
      },
      function (t, e) {
        ;(p.type.order[t + n + "-pre"] = e), t.match(/^html\-/) && (p.type.search[t + n] = p.type.search.html)
      },
    )
  }
  P.extend(p.type.order, {
    "date-pre": function (t) {
      t = Date.parse(t)
      return isNaN(t) ? -1 / 0 : t
    },
    "html-pre": function (t) {
      return h(t) ? "" : t.replace ? t.replace(/<.*?>/g, "").toLowerCase() : t + ""
    },
    "string-pre": function (t) {
      return h(t) ? "" : "string" == typeof t ? t.toLowerCase() : t.toString ? t.toString() : ""
    },
    "string-asc": function (t, e) {
      return t < e ? -1 : e < t ? 1 : 0
    },
    "string-desc": function (t, e) {
      return t < e ? 1 : e < t ? -1 : 0
    },
  }),
    Me(""),
    P.extend(!0, w.ext.renderer, {
      header: {
        _: function (r, o, i, l) {
          P(r.nTable).on("order.dt.DT", function (t, e, n, a) {
            r === e &&
              ((e = i.idx),
              o
                .removeClass(l.sSortAsc + " " + l.sSortDesc)
                .addClass("asc" == a[e] ? l.sSortAsc : "desc" == a[e] ? l.sSortDesc : i.sSortingClass))
          })
        },
        jqueryui: function (r, o, i, l) {
          P("<div/>")
            .addClass(l.sSortJUIWrapper)
            .append(o.contents())
            .append(P("<span/>").addClass(l.sSortIcon + " " + i.sSortingClassJUI))
            .appendTo(o),
            P(r.nTable).on("order.dt.DT", function (t, e, n, a) {
              r === e &&
                ((e = i.idx),
                o
                  .removeClass(l.sSortAsc + " " + l.sSortDesc)
                  .addClass("asc" == a[e] ? l.sSortAsc : "desc" == a[e] ? l.sSortDesc : i.sSortingClass),
                o
                  .find("span." + l.sSortIcon)
                  .removeClass(
                    l.sSortJUIAsc +
                      " " +
                      l.sSortJUIDesc +
                      " " +
                      l.sSortJUI +
                      " " +
                      l.sSortJUIAscAllowed +
                      " " +
                      l.sSortJUIDescAllowed,
                  )
                  .addClass("asc" == a[e] ? l.sSortJUIAsc : "desc" == a[e] ? l.sSortJUIDesc : i.sSortingClassJUI))
            })
        },
      },
    })
  function We(t) {
    return "string" == typeof (t = Array.isArray(t) ? t.join(",") : t)
      ? t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
      : t
  }
  function Ee(t, e, n, a, r) {
    return j.moment ? t[e](r) : j.luxon ? t[n](r) : a ? t[a](r) : t
  }
  var Be = !1
  function Ue(t, e, n) {
    var a
    if (j.moment) {
      if (!(a = j.moment.utc(t, e, n, !0)).isValid()) return null
    } else if (j.luxon) {
      if (!(a = e && "string" == typeof t ? j.luxon.DateTime.fromFormat(t, e) : j.luxon.DateTime.fromISO(t)).isValid)
        return null
      a.setLocale(n)
    } else
      e
        ? (Be || alert("DataTables warning: Formatted date without Moment.js or Luxon - https://datatables.net/tn/17"),
          (Be = !0))
        : (a = new Date(t))
    return a
  }
  function Ve(s) {
    return function (a, r, o, i) {
      0 === arguments.length
        ? ((o = "en"), (a = r = null))
        : 1 === arguments.length
          ? ((o = "en"), (r = a), (a = null))
          : 2 === arguments.length && ((o = r), (r = a), (a = null))
      var l = "datetime-" + r
      return (
        w.ext.type.order[l] ||
          (w.ext.type.detect.unshift(function (t) {
            return t === l && l
          }),
          (w.ext.type.order[l + "-asc"] = function (t, e) {
            ;(t = t.valueOf()), (e = e.valueOf())
            return t === e ? 0 : t < e ? -1 : 1
          }),
          (w.ext.type.order[l + "-desc"] = function (t, e) {
            ;(t = t.valueOf()), (e = e.valueOf())
            return t === e ? 0 : e < t ? -1 : 1
          })),
        function (t, e) {
          var n
          return (
            (null !== t && t !== H) ||
              (t =
                "--now" === i
                  ? ((n = new Date()),
                    new Date(
                      Date.UTC(
                        n.getFullYear(),
                        n.getMonth(),
                        n.getDate(),
                        n.getHours(),
                        n.getMinutes(),
                        n.getSeconds(),
                      ),
                    ))
                  : ""),
            "type" === e
              ? l
              : "" === t
                ? "sort" !== e
                  ? ""
                  : Ue("0000-01-01 00:00:00", null, o)
                : !(null === r || a !== r || "sort" === e || "type" === e || t instanceof Date) ||
                    null === (n = Ue(t, a, o))
                  ? t
                  : "sort" === e
                    ? n
                    : ((t =
                        null === r
                          ? Ee(n, "toDate", "toJSDate", "")[s]()
                          : Ee(n, "format", "toFormat", "toISOString", r)),
                      "display" === e ? We(t) : t)
          )
        }
      )
    }
  }
  var Xe = ",",
    Je = "."
  if (j.Intl !== H)
    try {
      for (var qe = new Intl.NumberFormat().formatToParts(100000.1), n = 0; n < qe.length; n++)
        "group" === qe[n].type ? (Xe = qe[n].value) : "decimal" === qe[n].type && (Je = qe[n].value)
    } catch (t) {}
  function $e(e) {
    return function () {
      var t = [ge(this[w.ext.iApiIndex])].concat(Array.prototype.slice.call(arguments))
      return w.ext.internal[e].apply(this, t)
    }
  }
  return (
    (w.datetime = function (n, a) {
      var r = "datetime-detect-" + n
      ;(a = a || "en"),
        w.ext.type.order[r] ||
          (w.ext.type.detect.unshift(function (t) {
            var e = Ue(t, n, a)
            return !("" !== t && !e) && r
          }),
          (w.ext.type.order[r + "-pre"] = function (t) {
            return Ue(t, n, a) || 0
          }))
    }),
    (w.render = {
      date: Ve("toLocaleDateString"),
      datetime: Ve("toLocaleString"),
      time: Ve("toLocaleTimeString"),
      number: function (a, r, o, i, l) {
        return (
          (null !== a && a !== H) || (a = Xe),
          (null !== r && r !== H) || (r = Je),
          {
            display: function (t) {
              if ("number" != typeof t && "string" != typeof t) return t
              if ("" === t || null === t) return t
              var e = t < 0 ? "-" : "",
                n = parseFloat(t)
              if (isNaN(n)) return We(t)
              ;(n = n.toFixed(o)), (t = Math.abs(n))
              ;(n = parseInt(t, 10)), (t = o ? r + (t - n).toFixed(o).substring(2) : "")
              return (
                (e = 0 === n && 0 === parseFloat(t) ? "" : e) +
                (i || "") +
                n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, a) +
                t +
                (l || "")
              )
            },
          }
        )
      },
      text: function () {
        return { display: We, filter: We }
      },
    }),
    P.extend(w.ext.internal, {
      _fnExternApiFunc: $e,
      _fnBuildAjax: Tt,
      _fnAjaxUpdate: xt,
      _fnAjaxParameters: At,
      _fnAjaxUpdateDraw: It,
      _fnAjaxDataSrc: Ft,
      _fnAddColumn: nt,
      _fnColumnOptions: at,
      _fnAdjustColumnSizing: O,
      _fnVisibleToColumnIndex: rt,
      _fnColumnIndexToVisible: ot,
      _fnVisbleColumns: T,
      _fnGetColumns: it,
      _fnColumnTypes: lt,
      _fnApplyColumnDefs: st,
      _fnHungarianMap: i,
      _fnCamelToHungarian: C,
      _fnLanguageCompat: Z,
      _fnBrowserDetect: tt,
      _fnAddData: x,
      _fnAddTr: ut,
      _fnNodeToDataIndex: function (t, e) {
        return e._DT_RowIndex !== H ? e._DT_RowIndex : null
      },
      _fnNodeToColumnIndex: function (t, e, n) {
        return P.inArray(n, t.aoData[e].anCells)
      },
      _fnGetCellData: S,
      _fnSetCellData: ct,
      _fnSplitObjNotation: dt,
      _fnGetObjectDataFn: A,
      _fnSetObjectDataFn: b,
      _fnGetDataMaster: ht,
      _fnClearTable: pt,
      _fnDeleteIndex: gt,
      _fnInvalidate: bt,
      _fnGetRowElements: mt,
      _fnCreateTr: St,
      _fnBuildHead: yt,
      _fnDrawHead: Dt,
      _fnDraw: y,
      _fnReDraw: u,
      _fnAddOptionsHtml: _t,
      _fnDetectHeader: wt,
      _fnGetUniqueThs: Ct,
      _fnFeatureHtmlFilter: Lt,
      _fnFilterComplete: Rt,
      _fnFilterCustom: Pt,
      _fnFilterColumn: jt,
      _fnFilter: Ht,
      _fnFilterCreateSearch: Nt,
      _fnEscapeRegex: Ot,
      _fnFilterData: Wt,
      _fnFeatureHtmlInfo: Ut,
      _fnUpdateInfo: Vt,
      _fnInfoMacros: Xt,
      _fnInitialise: Jt,
      _fnInitComplete: qt,
      _fnLengthChange: $t,
      _fnFeatureHtmlLength: Gt,
      _fnFeatureHtmlPaginate: zt,
      _fnPageChange: Yt,
      _fnFeatureHtmlProcessing: Zt,
      _fnProcessingDisplay: D,
      _fnFeatureHtmlTable: Kt,
      _fnScrollDraw: Qt,
      _fnApplyToChildren: k,
      _fnCalculateColumnWidths: ee,
      _fnThrottle: ne,
      _fnConvertToWidth: ae,
      _fnGetWidestNode: re,
      _fnGetMaxLenString: oe,
      _fnStringToCss: M,
      _fnSortFlatten: I,
      _fnSort: ie,
      _fnSortAria: le,
      _fnSortListener: se,
      _fnSortAttachListener: ue,
      _fnSortingClasses: ce,
      _fnSortData: fe,
      _fnSaveState: de,
      _fnLoadState: he,
      _fnImplementState: pe,
      _fnSettingsFromNode: ge,
      _fnLog: W,
      _fnMap: F,
      _fnBindAction: me,
      _fnCallbackReg: L,
      _fnCallbackFire: R,
      _fnLengthOverflow: Se,
      _fnRenderer: ve,
      _fnDataSource: E,
      _fnRowAttributes: vt,
      _fnExtend: be,
      _fnCalculateEnd: function () {},
    }),
    (((P.fn.dataTable = w).$ = P).fn.dataTableSettings = w.settings),
    (P.fn.dataTableExt = w.ext),
    (P.fn.DataTable = function (t) {
      return P(this).dataTable(t).api()
    }),
    P.each(w, function (t, e) {
      P.fn.DataTable[t] = e
    }),
    w
  )
})

/*! DataTables styling integration
 * ©2018 SpryMedia Ltd - datatables.net/license
 */
!(function (t) {
  var o, d
  "function" == typeof define && define.amd
    ? define(["jquery", "datatables.net"], function (e) {
        return t(e, window, document)
      })
    : "object" == typeof exports
      ? ((o = require("jquery")),
        (d = function (e, n) {
          n.fn.dataTable || require("datatables.net")(e, n)
        }),
        "undefined" == typeof window
          ? (module.exports = function (e, n) {
              return (e = e || window), (n = n || o(e)), d(e, n), t(n, 0, e.document)
            })
          : (d(window, o), (module.exports = t(o, window, window.document))))
      : t(jQuery, window, document)
})(function (e, n, t, o) {
  "use strict"
  return e.fn.dataTable
})

/*! Responsive 2.5.0
 * © SpryMedia Ltd - datatables.net/license
 */
!(function (n) {
  var i, r
  "function" == typeof define && define.amd
    ? define(["jquery", "datatables.net"], function (e) {
        return n(e, window, document)
      })
    : "object" == typeof exports
      ? ((i = require("jquery")),
        (r = function (e, t) {
          t.fn.dataTable || require("datatables.net")(e, t)
        }),
        "undefined" == typeof window
          ? (module.exports = function (e, t) {
              return (e = e || window), (t = t || i(e)), r(e, t), n(t, e, e.document)
            })
          : (r(window, i), (module.exports = n(i, window, window.document))))
      : n(jQuery, window, document)
})(function (f, m, d, h) {
  "use strict"
  function a(e, t) {
    if (!r.versionCheck || !r.versionCheck("1.10.10"))
      throw "DataTables Responsive requires DataTables 1.10.10 or newer"
    ;(this.s = { childNodeStore: {}, columns: [], current: [], dt: new r.Api(e) }),
      this.s.dt.settings()[0].responsive ||
        (t && "string" == typeof t.details
          ? (t.details = { type: t.details })
          : t && !1 === t.details
            ? (t.details = { type: !1 })
            : t && !0 === t.details && (t.details = { type: "inline" }),
        (this.c = f.extend(!0, {}, a.defaults, r.defaults.responsive, t)),
        (e.responsive = this)._constructor())
  }
  var r = f.fn.dataTable,
    e =
      (f.extend(a.prototype, {
        _constructor: function () {
          var s = this,
            i = this.s.dt,
            e = i.settings()[0],
            t = f(m).innerWidth(),
            e =
              ((i.settings()[0]._responsive = this),
              f(m).on(
                "resize.dtr orientationchange.dtr",
                r.util.throttle(function () {
                  var e = f(m).innerWidth()
                  e !== t && (s._resize(), (t = e))
                }),
              ),
              e.oApi._fnCallbackReg(e, "aoRowCreatedCallback", function (e, t, n) {
                ;-1 !== f.inArray(!1, s.s.current) &&
                  f(">td, >th", e).each(function (e) {
                    e = i.column.index("toData", e)
                    !1 === s.s.current[e] && f(this).css("display", "none")
                  })
              }),
              i.on("destroy.dtr", function () {
                i.off(".dtr"),
                  f(i.table().body()).off(".dtr"),
                  f(m).off("resize.dtr orientationchange.dtr"),
                  i.cells(".dtr-control").nodes().to$().removeClass("dtr-control"),
                  f.each(s.s.current, function (e, t) {
                    !1 === t && s._setColumnVis(e, !0)
                  })
              }),
              this.c.breakpoints.sort(function (e, t) {
                return e.width < t.width ? 1 : e.width > t.width ? -1 : 0
              }),
              this._classLogic(),
              this._resizeAuto(),
              this.c.details)
          !1 !== e.type &&
            (s._detailsInit(),
            i.on("column-visibility.dtr", function () {
              s._timer && clearTimeout(s._timer),
                (s._timer = setTimeout(function () {
                  ;(s._timer = null), s._classLogic(), s._resizeAuto(), s._resize(!0), s._redrawChildren()
                }, 100))
            }),
            i.on("draw.dtr", function () {
              s._redrawChildren()
            }),
            f(i.table().node()).addClass("dtr-" + e.type)),
            i.on("column-reorder.dtr", function (e, t, n) {
              s._classLogic(), s._resizeAuto(), s._resize(!0)
            }),
            i.on("column-sizing.dtr", function () {
              s._resizeAuto(), s._resize()
            }),
            i.on("column-calc.dt", function (e, t) {
              for (var n = s.s.current, i = 0; i < n.length; i++) {
                var r = t.visible.indexOf(i)
                !1 === n[i] && 0 <= r && t.visible.splice(r, 1)
              }
            }),
            i.on("preXhr.dtr", function () {
              var e = []
              i.rows().every(function () {
                this.child.isShown() && e.push(this.id(!0))
              }),
                i.one("draw.dtr", function () {
                  s._resizeAuto(),
                    s._resize(),
                    i.rows(e).every(function () {
                      s._detailsDisplay(this, !1)
                    })
                })
            }),
            i
              .on("draw.dtr", function () {
                s._controlClass()
              })
              .on("init.dtr", function (e, t, n) {
                "dt" === e.namespace && (s._resizeAuto(), s._resize(), f.inArray(!1, s.s.current)) && i.columns.adjust()
              }),
            this._resize()
        },
        _childNodes: function (e, t, n) {
          var i = t + "-" + n
          if (this.s.childNodeStore[i]) return this.s.childNodeStore[i]
          for (var r = [], s = e.cell(t, n).node().childNodes, o = 0, d = s.length; o < d; o++) r.push(s[o])
          return (this.s.childNodeStore[i] = r)
        },
        _childNodesRestore: function (e, t, n) {
          var i = t + "-" + n
          if (this.s.childNodeStore[i]) {
            for (
              var r = e.cell(t, n).node(),
                s = this.s.childNodeStore[i][0].parentNode.childNodes,
                o = [],
                d = 0,
                a = s.length;
              d < a;
              d++
            )
              o.push(s[d])
            for (var l = 0, c = o.length; l < c; l++) r.appendChild(o[l])
            this.s.childNodeStore[i] = h
          }
        },
        _columnsVisiblity: function (n) {
          for (
            var i = this.s.dt,
              e = this.s.columns,
              t = e
                .map(function (e, t) {
                  return { columnIdx: t, priority: e.priority }
                })
                .sort(function (e, t) {
                  return e.priority !== t.priority ? e.priority - t.priority : e.columnIdx - t.columnIdx
                }),
              r = f.map(e, function (e, t) {
                return !1 === i.column(t).visible()
                  ? "not-visible"
                  : (!e.auto || null !== e.minWidth) && (!0 === e.auto ? "-" : -1 !== f.inArray(n, e.includeIn))
              }),
              s = 0,
              o = 0,
              d = r.length;
            o < d;
            o++
          )
            !0 === r[o] && (s += e[o].minWidth)
          var a = i.settings()[0].oScroll,
            a = a.sY || a.sX ? a.iBarWidth : 0,
            l = i.table().container().offsetWidth - a - s
          for (o = 0, d = r.length; o < d; o++) e[o].control && (l -= e[o].minWidth)
          var c = !1
          for (o = 0, d = t.length; o < d; o++) {
            var u = t[o].columnIdx
            "-" === r[u] &&
              !e[u].control &&
              e[u].minWidth &&
              (c || l - e[u].minWidth < 0 ? (r[u] = !(c = !0)) : (r[u] = !0), (l -= e[u].minWidth))
          }
          var h = !1
          for (o = 0, d = e.length; o < d; o++)
            if (!e[o].control && !e[o].never && !1 === r[o]) {
              h = !0
              break
            }
          for (o = 0, d = e.length; o < d; o++) e[o].control && (r[o] = h), "not-visible" === r[o] && (r[o] = !1)
          return -1 === f.inArray(!0, r) && (r[0] = !0), r
        },
        _classLogic: function () {
          function d(e, t, n, i) {
            var r, s, o
            if (n) {
              if ("max-" === n)
                for (r = a._find(t).width, s = 0, o = l.length; s < o; s++) l[s].width <= r && u(e, l[s].name)
              else if ("min-" === n)
                for (r = a._find(t).width, s = 0, o = l.length; s < o; s++) l[s].width >= r && u(e, l[s].name)
              else if ("not-" === n)
                for (s = 0, o = l.length; s < o; s++) -1 === l[s].name.indexOf(i) && u(e, l[s].name)
            } else c[e].includeIn.push(t)
          }
          var a = this,
            l = this.c.breakpoints,
            i = this.s.dt,
            c = i
              .columns()
              .eq(0)
              .map(function (e) {
                var t = this.column(e),
                  n = t.header().className,
                  e = i.settings()[0].aoColumns[e].responsivePriority,
                  t = t.header().getAttribute("data-priority")
                return (
                  e === h && (e = t === h || null === t ? 1e4 : +t),
                  {
                    className: n,
                    includeIn: [],
                    auto: !1,
                    control: !1,
                    never: !!n.match(/\b(dtr\-)?never\b/),
                    priority: e,
                  }
                )
              }),
            u = function (e, t) {
              e = c[e].includeIn
              ;-1 === f.inArray(t, e) && e.push(t)
            }
          c.each(function (e, r) {
            for (var t = e.className.split(" "), s = !1, n = 0, i = t.length; n < i; n++) {
              var o = t[n].trim()
              if ("all" === o || "dtr-all" === o)
                return (
                  (s = !0),
                  void (e.includeIn = f.map(l, function (e) {
                    return e.name
                  }))
                )
              if ("none" === o || "dtr-none" === o || e.never) return void (s = !0)
              if ("control" === o || "dtr-control" === o) return (s = !0), void (e.control = !0)
              f.each(l, function (e, t) {
                var n = t.name.split("-"),
                  i = new RegExp("(min\\-|max\\-|not\\-)?(" + n[0] + ")(\\-[_a-zA-Z0-9])?"),
                  i = o.match(i)
                i &&
                  ((s = !0),
                  i[2] === n[0] && i[3] === "-" + n[1]
                    ? d(r, t.name, i[1], i[2] + i[3])
                    : i[2] !== n[0] || i[3] || d(r, t.name, i[1], i[2]))
              })
            }
            s || (e.auto = !0)
          }),
            (this.s.columns = c)
        },
        _controlClass: function () {
          var e, t, n
          "inline" === this.c.details.type &&
            ((e = this.s.dt),
            (t = this.s.current),
            (n = f.inArray(!0, t)),
            e
              .cells(
                null,
                function (e) {
                  return e !== n
                },
                { page: "current" },
              )
              .nodes()
              .to$()
              .filter(".dtr-control")
              .removeClass("dtr-control"),
            e.cells(null, n, { page: "current" }).nodes().to$().addClass("dtr-control"))
        },
        _detailsDisplay: function (t, n) {
          function e(e) {
            f(t.node()).toggleClass("parent", !1 !== e),
              f(s.table().node()).triggerHandler("responsive-display.dt", [s, t, e, n])
          }
          var i,
            r = this,
            s = this.s.dt,
            o = this.c.details
          o &&
            !1 !== o.type &&
            ((i = "string" == typeof o.renderer ? a.renderer[o.renderer]() : o.renderer),
            "boolean" ==
              typeof (o = o.display(
                t,
                n,
                function () {
                  return i.call(r, s, t[0], r._detailsObj(t[0]))
                },
                function () {
                  e(!1)
                },
              ))) &&
            e(o)
        },
        _detailsInit: function () {
          var n = this,
            i = this.s.dt,
            e = this.c.details,
            r =
              ("inline" === e.type && (e.target = "td.dtr-control, th.dtr-control"),
              i.on("draw.dtr", function () {
                n._tabIndexes()
              }),
              n._tabIndexes(),
              f(i.table().body()).on("keyup.dtr", "td, th", function (e) {
                13 === e.keyCode && f(this).data("dtr-keyboard") && f(this).click()
              }),
              e.target),
            e = "string" == typeof r ? r : "td, th"
          ;(r === h && null === r) ||
            f(i.table().body()).on("click.dtr mousedown.dtr mouseup.dtr", e, function (e) {
              if (
                f(i.table().node()).hasClass("collapsed") &&
                -1 !== f.inArray(f(this).closest("tr").get(0), i.rows().nodes().toArray())
              ) {
                if ("number" == typeof r) {
                  var t = r < 0 ? i.columns().eq(0).length + r : r
                  if (i.cell(this).index().column !== t) return
                }
                t = i.row(f(this).closest("tr"))
                "click" === e.type
                  ? n._detailsDisplay(t, !1)
                  : "mousedown" === e.type
                    ? f(this).css("outline", "none")
                    : "mouseup" === e.type && f(this).trigger("blur").css("outline", "")
              }
            })
        },
        _detailsObj: function (n) {
          var i = this,
            r = this.s.dt
          return f.map(this.s.columns, function (e, t) {
            if (!e.never && !e.control)
              return {
                className: (e = r.settings()[0].aoColumns[t]).sClass,
                columnIndex: t,
                data: r.cell(n, t).render(i.c.orthogonal),
                hidden: r.column(t).visible() && !i.s.current[t],
                rowIndex: n,
                title: null !== e.sTitle ? e.sTitle : f(r.column(t).header()).text(),
              }
          })
        },
        _find: function (e) {
          for (var t = this.c.breakpoints, n = 0, i = t.length; n < i; n++) if (t[n].name === e) return t[n]
        },
        _redrawChildren: function () {
          var n = this,
            i = this.s.dt
          i.rows({ page: "current" }).iterator("row", function (e, t) {
            n._detailsDisplay(i.row(t), !0)
          })
        },
        _resize: function (n) {
          for (
            var e,
              i = this,
              t = this.s.dt,
              r = f(m).innerWidth(),
              s = this.c.breakpoints,
              o = s[0].name,
              d = this.s.columns,
              a = this.s.current.slice(),
              l = s.length - 1;
            0 <= l;
            l--
          )
            if (r <= s[l].width) {
              o = s[l].name
              break
            }
          var c = this._columnsVisiblity(o),
            u = ((this.s.current = c), !1)
          for (l = 0, e = d.length; l < e; l++)
            if (!1 === c[l] && !d[l].never && !d[l].control && !1 == !t.column(l).visible()) {
              u = !0
              break
            }
          f(t.table().node()).toggleClass("collapsed", u)
          var h = !1,
            p = 0
          t
            .columns()
            .eq(0)
            .each(function (e, t) {
              !0 === c[t] && p++, (!n && c[t] === a[t]) || ((h = !0), i._setColumnVis(e, c[t]))
            }),
            this._redrawChildren(),
            h &&
              (f(t.table().node()).trigger("responsive-resize.dt", [t, this.s.current]),
              0 === t.page.info().recordsDisplay) &&
              f("td", t.table().body()).eq(0).attr("colspan", p),
            i._controlClass()
        },
        _resizeAuto: function () {
          var e,
            t,
            n,
            i,
            r,
            s = this.s.dt,
            o = this.s.columns,
            d = this
          this.c.auto &&
            -1 !==
              f.inArray(
                !0,
                f.map(o, function (e) {
                  return e.auto
                }),
              ) &&
            (f.isEmptyObject(this.s.childNodeStore) ||
              f.each(this.s.childNodeStore, function (e) {
                e = e.split("-")
                d._childNodesRestore(s, +e[0], +e[1])
              }),
            s.table().node().offsetWidth,
            s.columns,
            (e = s.table().node().cloneNode(!1)),
            (t = f(s.table().header().cloneNode(!1)).appendTo(e)),
            (i = f(s.table().body()).clone(!1, !1).empty().appendTo(e)),
            (e.style.width = "auto"),
            (n = s
              .columns()
              .header()
              .filter(function (e) {
                return s.column(e).visible()
              })
              .to$()
              .clone(!1)
              .css("display", "table-cell")
              .css("width", "auto")
              .css("min-width", 0)),
            f(i)
              .append(f(s.rows({ page: "current" }).nodes()).clone(!1))
              .find("th, td")
              .css("display", ""),
            (i = s.table().footer()) &&
              ((i = f(i.cloneNode(!1)).appendTo(e)),
              (r = s
                .columns()
                .footer()
                .filter(function (e) {
                  return s.column(e).visible()
                })
                .to$()
                .clone(!1)
                .css("display", "table-cell")),
              f("<tr/>").append(r).appendTo(i)),
            f("<tr/>").append(n).appendTo(t),
            "inline" === this.c.details.type && f(e).addClass("dtr-inline collapsed"),
            f(e).find("[name]").removeAttr("name"),
            f(e).css("position", "relative"),
            (r = f("<div/>").css({ width: 1, height: 1, overflow: "hidden", clear: "both" }).append(e)).insertBefore(
              s.table().node(),
            ),
            n.each(function (e) {
              e = s.column.index("fromVisible", e)
              o[e].minWidth = this.offsetWidth || 0
            }),
            r.remove())
        },
        _responsiveOnlyHidden: function () {
          var n = this.s.dt
          return f.map(this.s.current, function (e, t) {
            return !1 === n.column(t).visible() || e
          })
        },
        _setColumnVis: function (e, t) {
          var n = this,
            i = this.s.dt,
            r = t ? "" : "none"
          f(i.column(e).header()).css("display", r).toggleClass("dtr-hidden", !t),
            f(i.column(e).footer()).css("display", r).toggleClass("dtr-hidden", !t),
            i.column(e).nodes().to$().css("display", r).toggleClass("dtr-hidden", !t),
            f.isEmptyObject(this.s.childNodeStore) ||
              i
                .cells(null, e)
                .indexes()
                .each(function (e) {
                  n._childNodesRestore(i, e.row, e.column)
                })
        },
        _tabIndexes: function () {
          var e = this.s.dt,
            t = e.cells({ page: "current" }).nodes().to$(),
            n = e.settings()[0],
            i = this.c.details.target
          t.filter("[data-dtr-keyboard]").removeData("[data-dtr-keyboard]"),
            ("number" == typeof i
              ? e.cells(null, i, { page: "current" }).nodes().to$()
              : f(
                  (i = "td:first-child, th:first-child" === i ? ">td:first-child, >th:first-child" : i),
                  e.rows({ page: "current" }).nodes(),
                )
            )
              .attr("tabIndex", n.iTabIndex)
              .data("dtr-keyboard", 1)
        },
      }),
      (a.defaults = {
        breakpoints: (a.breakpoints = [
          { name: "desktop", width: 1 / 0 },
          { name: "tablet-l", width: 1024 },
          { name: "tablet-p", width: 768 },
          { name: "mobile-l", width: 480 },
          { name: "mobile-p", width: 320 },
        ]),
        auto: !0,
        details: {
          display: (a.display = {
            childRow: function (e, t, n) {
              return t
                ? f(e.node()).hasClass("parent")
                  ? (e.child(n(), "child").show(), !0)
                  : void 0
                : e.child.isShown()
                  ? (e.child(!1), !1)
                  : (e.child(n(), "child").show(), !0)
            },
            childRowImmediate: function (e, t, n) {
              return (!t && e.child.isShown()) || !e.responsive.hasHidden()
                ? (e.child(!1), !1)
                : (e.child(n(), "child").show(), !0)
            },
            modal: function (o) {
              return function (e, t, n, i) {
                if (t) {
                  if (!(s = f("div.dtr-modal-content")).length || e.index() !== s.data("dtr-row-idx")) return null
                  s.empty().append(n())
                } else {
                  var r = function () {
                      s.remove(), f(d).off("keypress.dtr"), f(e.node()).removeClass("parent"), i()
                    },
                    s = f('<div class="dtr-modal"/>')
                      .append(
                        f('<div class="dtr-modal-display"/>')
                          .append(f('<div class="dtr-modal-content"/>').data("dtr-row-idx", e.index()).append(n()))
                          .append(
                            f('<div class="dtr-modal-close">&times;</div>').click(function () {
                              r()
                            }),
                          ),
                      )
                      .append(
                        f('<div class="dtr-modal-background"/>').click(function () {
                          r()
                        }),
                      )
                      .appendTo("body")
                  f(e.node()).addClass("parent"),
                    f(d).on("keyup.dtr", function (e) {
                      27 === e.keyCode && (e.stopPropagation(), r())
                    })
                }
                return o && o.header && f("div.dtr-modal-content").prepend("<h2>" + o.header(e) + "</h2>"), !0
              }
            },
          }).childRow,
          renderer: (a.renderer = {
            listHiddenNodes: function () {
              return function (i, e, t) {
                var r = this,
                  s = f('<ul data-dtr-index="' + e + '" class="dtr-details"/>'),
                  o = !1
                f.each(t, function (e, t) {
                  var n
                  t.hidden &&
                    ((n = t.className ? 'class="' + t.className + '"' : ""),
                    f(
                      "<li " +
                        n +
                        ' data-dtr-index="' +
                        t.columnIndex +
                        '" data-dt-row="' +
                        t.rowIndex +
                        '" data-dt-column="' +
                        t.columnIndex +
                        '"><span class="dtr-title">' +
                        t.title +
                        "</span> </li>",
                    )
                      .append(f('<span class="dtr-data"/>').append(r._childNodes(i, t.rowIndex, t.columnIndex)))
                      .appendTo(s),
                    (o = !0))
                })
                return !!o && s
              }
            },
            listHidden: function () {
              return function (e, t, n) {
                n = f
                  .map(n, function (e) {
                    var t = e.className ? 'class="' + e.className + '"' : ""
                    return e.hidden
                      ? "<li " +
                          t +
                          ' data-dtr-index="' +
                          e.columnIndex +
                          '" data-dt-row="' +
                          e.rowIndex +
                          '" data-dt-column="' +
                          e.columnIndex +
                          '"><span class="dtr-title">' +
                          e.title +
                          '</span> <span class="dtr-data">' +
                          e.data +
                          "</span></li>"
                      : ""
                  })
                  .join("")
                return !!n && f('<ul data-dtr-index="' + t + '" class="dtr-details"/>').append(n)
              }
            },
            tableAll: function (i) {
              return (
                (i = f.extend({ tableClass: "" }, i)),
                function (e, t, n) {
                  n = f
                    .map(n, function (e) {
                      return (
                        "<tr " +
                        (e.className ? 'class="' + e.className + '"' : "") +
                        ' data-dt-row="' +
                        e.rowIndex +
                        '" data-dt-column="' +
                        e.columnIndex +
                        '"><td>' +
                        e.title +
                        ":</td> <td>" +
                        e.data +
                        "</td></tr>"
                      )
                    })
                    .join("")
                  return f('<table class="' + i.tableClass + ' dtr-details" width="100%"/>').append(n)
                }
              )
            },
          }).listHidden(),
          target: 0,
          type: "inline",
        },
        orthogonal: "display",
      }),
      f.fn.dataTable.Api)
  return (
    e.register("responsive()", function () {
      return this
    }),
    e.register("responsive.index()", function (e) {
      return { column: (e = f(e)).data("dtr-index"), row: e.parent().data("dtr-index") }
    }),
    e.register("responsive.rebuild()", function () {
      return this.iterator("table", function (e) {
        e._responsive && e._responsive._classLogic()
      })
    }),
    e.register("responsive.recalc()", function () {
      return this.iterator("table", function (e) {
        e._responsive && (e._responsive._resizeAuto(), e._responsive._resize())
      })
    }),
    e.register("responsive.hasHidden()", function () {
      var e = this.context[0]
      return !!e._responsive && -1 !== f.inArray(!1, e._responsive._responsiveOnlyHidden())
    }),
    e.registerPlural("columns().responsiveHidden()", "column().responsiveHidden()", function () {
      return this.iterator(
        "column",
        function (e, t) {
          return !!e._responsive && e._responsive._responsiveOnlyHidden()[t]
        },
        1,
      )
    }),
    (a.version = "2.5.0"),
    (f.fn.dataTable.Responsive = a),
    (f.fn.DataTable.Responsive = a),
    f(d).on("preInit.dt.dtr", function (e, t, n) {
      "dt" === e.namespace &&
        (f(t.nTable).hasClass("responsive") ||
          f(t.nTable).hasClass("dt-responsive") ||
          t.oInit.responsive ||
          r.defaults.responsive) &&
        !1 !== (e = t.oInit.responsive) &&
        new a(t, f.isPlainObject(e) ? e : {})
    }),
    r
  )
})

/*! DataTables styling wrapper for Responsive
 * © SpryMedia Ltd - datatables.net/license
 */

;(function (factory) {
  if (typeof define === "function" && define.amd) {
    // AMD
    define(["jquery", "datatables.net-dt", "datatables.net-responsive"], function ($) {
      return factory($, window, document)
    })
  } else if (typeof exports === "object") {
    // CommonJS
    var jq = require("jquery")
    var cjsRequires = function (root, $) {
      if (!$.fn.dataTable) {
        require("datatables.net-dt")(root, $)
      }

      if (!$.fn.dataTable.Responsive) {
        require("datatables.net-responsive")(root, $)
      }
    }

    if (typeof window === "undefined") {
      module.exports = function (root, $) {
        if (!root) {
          // CommonJS environments without a window global must pass a
          // root. This will give an error otherwise
          root = window
        }

        if (!$) {
          $ = jq(root)
        }

        cjsRequires(root, $)
        return factory($, root, root.document)
      }
    } else {
      cjsRequires(window, jq)
      module.exports = factory(jq, window, window.document)
    }
  } else {
    // Browser
    factory(jQuery, window, document)
  }
})(function ($, window, document, undefined) {
  "use strict"
  var DataTable = $.fn.dataTable
  return DataTable
})
